{
  "level": "mt05",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt05",
    "objects": "AREAS.E3:mt05.e3",
    "mesh": "TREES.E3:mt05.e3"
  },
  "spawn_point": {
    "position": [
      -300.2530424855392,
      -2136.4733506831885,
      33.88512420654297
    ],
    "facing_rad": 0.0,
    "look_point": [
      -300.2530424855392,
      -2036.4733506831885,
      33.88512420654297
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3714.02392578125,
      -3172.2548828125,
      9.885124206542969
    ],
    "bbox_max": [
      154.52288818359375,
      -1894.5,
      1479.6412353515625
    ],
    "vertex_count": 2892,
    "vertices": [
      [
        -3714.02392578125,
        -2323.554931640625,
        1179.126953125
      ],
      [
        -699.1730346679688,
        -2333.705078125,
        73.73089599609375
      ],
      [
        -704.1276245117188,
        -2329.093994140625,
        74.91236877441406
      ],
      [
        -699.1730346679688,
        -2333.705078125,
        73.73088836669922
      ],
      [
        -694.7417602539062,
        -2341.75634765625,
        73.21707153320312
      ],
      [
        -506.6939697265625,
        -2420.46630859375,
        15.06225299835205
      ],
      [
        -485.10174560546875,
        -2440.358154296875,
        9.885124206542969
      ],
      [
        -508.5000305175781,
        -2419.364501953125,
        15.572943687438965
      ],
      [
        -506.6939697265625,
        -2420.46630859375,
        15.062255859375
      ],
      [
        -758.4019775390625,
        -2314.277587890625,
        639.3778686523438
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.38037109375
      ],
      [
        -714.7833862304688,
        -2350.402099609375,
        639.3530883789062
      ],
      [
        -714.5018920898438,
        -2350.78662109375,
        639.3538208007812
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.38037109375
      ],
      [
        -754.6053466796875,
        -2319.914306640625,
        686.6563720703125
      ],
      [
        -930.0518798828125,
        -2560.52392578125,
        688.0962524414062
      ],
      [
        -946.35205078125,
        -2579.038818359375,
        688.1981811523438
      ],
      [
        -879.5546264648438,
        -2495.927001953125,
        687.720458984375
      ],
      [
        -879.5546264648438,
        -2495.927001953125,
        687.720458984375
      ],
      [
        -902.8463745117188,
        -2520.06982421875,
        687.8468627929688
      ],
      [
        -930.0518798828125,
        -2560.52392578125,
        688.0962524414062
      ],
      [
        -902.8463745117188,
        -2520.06982421875,
        687.846923828125
      ],
      [
        -859.7777099609375,
        -2482.40234375,
        689.4432983398438
      ],
      [
        -812.6871337890625,
        -2427.213134765625,
        687.3624877929688
      ],
      [
        -873.96923828125,
        -2499.0419921875,
        690.078125
      ],
      [
        -859.77783203125,
        -2482.402587890625,
        689.4432983398438
      ],
      [
        -802.5723876953125,
        -2439.763427734375,
        687.4988403320312
      ],
      [
        -804.64013671875,
        -2437.5029296875,
        687.4735107421875
      ],
      [
        -804.638427734375,
        -2437.50146484375,
        687.4734497070312
      ],
      [
        -980.0184326171875,
        -2645.0,
        695.36572265625
      ],
      [
        -958.9133911132812,
        -2598.63916015625,
        693.8779907226562
      ],
      [
        -975.183349609375,
        -2645.0,
        688.6541137695312
      ],
      [
        -946.35205078125,
        -2579.038818359375,
        688.1981811523438
      ],
      [
        -762.5053100585938,
        -2311.39697265625,
        649.1970825195312
      ],
      [
        -763.1380615234375,
        -2310.982666015625,
        651.2776489257812
      ],
      [
        -754.6053466796875,
        -2319.914306640625,
        686.6563720703125
      ],
      [
        -754.98779296875,
        -2319.55615234375,
        685.8677978515625
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -754.98779296875,
        -2319.55615234375,
        685.8677978515625
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -764.5123291015625,
        -2310.63232421875,
        666.228759765625
      ],
      [
        -879.8209228515625,
        -2495.801513671875,
        687.4075927734375
      ],
      [
        -974.9632568359375,
        -2645.0,
        688.3485717773438
      ],
      [
        -945.1063232421875,
        -2577.094970703125,
        687.6348876953125
      ],
      [
        -972.4475708007812,
        -2640.122802734375,
        687.7821044921875
      ],
      [
        -930.3886108398438,
        -2560.419189453125,
        687.586669921875
      ],
      [
        -902.7665405273438,
        -2519.517333984375,
        687.478759765625
      ],
      [
        -930.3886108398438,
        -2560.419189453125,
        687.586669921875
      ],
      [
        -945.1063232421875,
        -2577.094970703125,
        687.6348876953125
      ],
      [
        -879.8209228515625,
        -2495.801513671875,
        687.4075927734375
      ],
      [
        -902.7665405273438,
        -2519.517333984375,
        687.478759765625
      ],
      [
        -974.5633544921875,
        -2645.0,
        687.7935180664062
      ],
      [
        -763.1380615234375,
        -2310.982421875,
        651.2776489257812
      ],
      [
        -758.4019775390625,
        -2314.277587890625,
        639.3778686523438
      ],
      [
        -762.5053100585938,
        -2311.39697265625,
        649.1970825195312
      ],
      [
        -711.36962890625,
        -2355.322998046875,
        648.9346923828125
      ],
      [
        -860.5833740234375,
        -2509.036865234375,
        641.796875
      ],
      [
        -933.0162353515625,
        -2581.620849609375,
        656.4391479492188
      ],
      [
        -920.5997314453125,
        -2569.142822265625,
        654.24609375
      ],
      [
        -915.73583984375,
        -2564.302001953125,
        652.96875
      ],
      [
        -920.5996704101562,
        -2569.14306640625,
        654.24609375
      ],
      [
        -860.5833740234375,
        -2509.036865234375,
        641.796875
      ],
      [
        -881.0743408203125,
        -2529.48095703125,
        646.7396850585938
      ],
      [
        -881.0743408203125,
        -2529.48095703125,
        646.7396850585938
      ],
      [
        -915.73583984375,
        -2564.302001953125,
        652.96875
      ],
      [
        -760.2183837890625,
        -2402.696044921875,
        672.8593139648438
      ],
      [
        -934.8543701171875,
        -2585.9384765625,
        657.1979370117188
      ],
      [
        -942.9855346679688,
        -2589.50048828125,
        677.25
      ],
      [
        -934.0123901367188,
        -2582.408447265625,
        658.5185546875
      ],
      [
        -955.5763549804688,
        -2601.230712890625,
        687.6912841796875
      ],
      [
        -942.985595703125,
        -2589.50048828125,
        677.25
      ],
      [
        -933.0162963867188,
        -2581.62109375,
        656.4391479492188
      ],
      [
        -932.1755981445312,
        -2559.8056640625,
        677.4135131835938
      ],
      [
        -943.8311767578125,
        -2584.6416015625,
        681.3382568359375
      ],
      [
        -949.4379272460938,
        -2595.51171875,
        682.6007690429688
      ],
      [
        -940.8788452148438,
        -2572.30517578125,
        687.6210327148438
      ],
      [
        -938.0741577148438,
        -2573.47998046875,
        680.0419311523438
      ],
      [
        -932.1755981445312,
        -2559.8056640625,
        677.4135131835938
      ],
      [
        -938.0740966796875,
        -2573.47998046875,
        680.0419311523438
      ],
      [
        -947.4171752929688,
        -2593.629150390625,
        680.9249877929688
      ],
      [
        -943.8311767578125,
        -2584.6416015625,
        681.3382568359375
      ],
      [
        -928.8388671875,
        -2560.71826171875,
        666.63330078125
      ],
      [
        -934.0123901367188,
        -2582.408447265625,
        658.5185546875
      ],
      [
        -698.2745361328125,
        -2408.3671875,
        1479.6412353515625
      ],
      [
        -502.130126953125,
        -2816.75732421875,
        1479.110595703125
      ],
      [
        -495.6847229003906,
        -2819.0322265625,
        1478.0430908203125
      ],
      [
        -729.6846313476562,
        -2337.886474609375,
        930.5113525390625
      ],
      [
        -770.8287353515625,
        -2309.62939453125,
        1413.1082763671875
      ],
      [
        -760.3704223632812,
        -2307.621826171875,
        650.8119506835938
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -752.9869384765625,
        -2315.81494140625,
        685.6275634765625
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -752.5239868164062,
        -2317.117431640625,
        686.5301513671875
      ],
      [
        -752.4957885742188,
        -2317.2001953125,
        686.6405639648438
      ],
      [
        -752.5239868164062,
        -2317.117431640625,
        686.5301513671875
      ],
      [
        -752.4957885742188,
        -2317.2001953125,
        686.6405639648438
      ],
      [
        -754.2664184570312,
        -2320.1953125,
        686.6597900390625
      ],
      [
        -752.467041015625,
        -2317.27783203125,
        686.6412963867188
      ],
      [
        -756.3106689453125,
        -2311.61328125,
        639.3507080078125
      ],
      [
        -760.0313720703125,
        -2307.94970703125,
        649.5208740234375
      ],
      [
        -750.1141967773438,
        -2323.63623046875,
        686.7015380859375
      ],
      [
        -749.987060546875,
        -2321.2470703125,
        639.377197265625
      ],
      [
        -753.7207641601562,
        -2314.28271484375,
        639.3558349609375
      ],
      [
        -751.8519897460938,
        -2316.208740234375,
        639.3568725585938
      ],
      [
        -756.3106689453125,
        -2311.61328125,
        639.3507080078125
      ],
      [
        -753.7208251953125,
        -2314.28271484375,
        639.3558349609375
      ],
      [
        -760.0313720703125,
        -2307.94970703125,
        649.5208740234375
      ],
      [
        -760.3703002929688,
        -2307.621826171875,
        650.8118896484375
      ],
      [
        -757.4639282226562,
        -2322.2109375,
        1342.0321044921875
      ],
      [
        -734.5374145507812,
        -2347.266357421875,
        1427.1370849609375
      ],
      [
        -729.0043334960938,
        -2352.36181640625,
        1390.9632568359375
      ],
      [
        -729.0043334960938,
        -2352.36181640625,
        1390.9632568359375
      ],
      [
        -724.2152099609375,
        -2356.54345703125,
        1345.9888916015625
      ],
      [
        -749.2035522460938,
        -2332.043701171875,
        1420.7086181640625
      ],
      [
        -757.4644165039062,
        -2322.210693359375,
        1342.0352783203125
      ],
      [
        -734.5928344726562,
        -2333.996337890625,
        639.3666381835938
      ],
      [
        -827.1680297851562,
        -2208.30810546875,
        1063.432373046875
      ],
      [
        -834.5742797851562,
        -2190.765625,
        787.6206665039062
      ],
      [
        -729.6846313476562,
        -2337.886474609375,
        930.5113525390625
      ],
      [
        -741.8722534179688,
        -2326.51611328125,
        1126.51953125
      ],
      [
        -774.5052490234375,
        -2299.1416015625,
        1403.452880859375
      ],
      [
        -742.3389282226562,
        -2328.6416015625,
        1229.1395263671875
      ],
      [
        -741.8722534179688,
        -2326.51611328125,
        1126.5194091796875
      ],
      [
        -737.9234008789062,
        -2338.6396484375,
        1376.4813232421875
      ],
      [
        -742.3389282226562,
        -2328.6416015625,
        1229.1395263671875
      ],
      [
        -737.9234008789062,
        -2338.6396484375,
        1376.4813232421875
      ],
      [
        -769.68017578125,
        -2285.218505859375,
        1003.4503173828125
      ],
      [
        -765.1951904296875,
        -2286.7568359375,
        833.0510864257812
      ],
      [
        -774.9254760742188,
        -2297.94287109375,
        1402.3492431640625
      ],
      [
        -781.3869018554688,
        -2279.5107421875,
        1385.3800048828125
      ],
      [
        -778.7415771484375,
        -2280.03857421875,
        1270.78173828125
      ],
      [
        -819.0064086914062,
        -2224.93505859375,
        1266.92431640625
      ],
      [
        -827.1676025390625,
        -2208.30859375,
        1063.431396484375
      ],
      [
        -757.1021728515625,
        -2302.95263671875,
        655.3711547851562
      ],
      [
        -770.0617065429688,
        -2280.2109375,
        836.8139038085938
      ],
      [
        -768.256591796875,
        -2282.130859375,
        816.5458984375
      ],
      [
        -756.84716796875,
        -2303.34375,
        650.2191162109375
      ],
      [
        -757.1021728515625,
        -2302.95263671875,
        655.3711547851562
      ],
      [
        -759.2738037109375,
        -2308.695556640625,
        647.4500732421875
      ],
      [
        -756.8021850585938,
        -2303.449951171875,
        649.943603515625
      ],
      [
        -756.6925659179688,
        -2303.717529296875,
        649.45166015625
      ],
      [
        -756.8021850585938,
        -2303.449951171875,
        649.943603515625
      ],
      [
        -756.84716796875,
        -2303.34375,
        650.2191162109375
      ],
      [
        -761.9382934570312,
        -2306.4140625,
        675.1514892578125
      ],
      [
        -753.0465087890625,
        -2315.6474609375,
        685.511474609375
      ],
      [
        -768.7000732421875,
        -2282.04248046875,
        835.7608032226562
      ],
      [
        -770.0617065429688,
        -2280.2109375,
        836.8139038085938
      ],
      [
        -753.0465087890625,
        -2315.6474609375,
        685.511474609375
      ],
      [
        -752.9869384765625,
        -2315.81494140625,
        685.6275634765625
      ],
      [
        -754.4367065429688,
        -2309.225830078125,
        639.3263549804688
      ],
      [
        -751.8521118164062,
        -2316.208740234375,
        639.35693359375
      ],
      [
        -753.2120361328125,
        -2312.5341796875,
        639.3421020507812
      ],
      [
        -754.4367065429688,
        -2309.225830078125,
        639.3263549804688
      ],
      [
        -753.2120361328125,
        -2312.5341796875,
        639.3421020507812
      ],
      [
        -778.7415771484375,
        -2280.03857421875,
        1270.78173828125
      ],
      [
        -769.68017578125,
        -2285.218505859375,
        1003.4503173828125
      ],
      [
        -765.195068359375,
        -2286.757080078125,
        833.050048828125
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -763.294189453125,
        -2287.4091796875,
        760.8279418945312
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -756.6925659179688,
        -2303.7177734375,
        649.4514770507812
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -750.8490600585938,
        -2317.242431640625,
        639.3574829101562
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -763.2392578125,
        -2287.467529296875,
        760.21142578125
      ],
      [
        -757.6132202148438,
        -2294.22802734375,
        634.0618286132812
      ],
      [
        -763.2392578125,
        -2287.467529296875,
        760.21142578125
      ],
      [
        -761.0557861328125,
        -2288.81787109375,
        699.5836791992188
      ],
      [
        -757.6132202148438,
        -2294.22802734375,
        634.0618286132812
      ],
      [
        -753.3262329101562,
        -2300.94140625,
        637.1535034179688
      ],
      [
        -753.8310546875,
        -2300.702880859375,
        641.6248779296875
      ],
      [
        -753.8582153320312,
        -2300.75,
        641.6248779296875
      ],
      [
        -750.7191162109375,
        -2305.024169921875,
        639.28125
      ],
      [
        -729.5592041015625,
        -2338.1650390625,
        639.3632202148438
      ],
      [
        -750.8943481445312,
        -2304.749755859375,
        639.28125
      ],
      [
        -750.7191162109375,
        -2305.024169921875,
        639.28125
      ],
      [
        -750.7191162109375,
        -2305.024169921875,
        639.28125
      ],
      [
        -750.8164672851562,
        -2304.8720703125,
        637.5435791015625
      ],
      [
        -751.0501708984375,
        -2304.505859375,
        638.794921875
      ],
      [
        -753.7503051757812,
        -2301.1484375,
        639.27490234375
      ],
      [
        -753.5884399414062,
        -2300.52978515625,
        641.6248779296875
      ],
      [
        -750.8941040039062,
        -2304.749755859375,
        641.6248779296875
      ],
      [
        -750.8941040039062,
        -2304.749755859375,
        641.6248779296875
      ],
      [
        -750.8943481445312,
        -2304.749755859375,
        639.28125
      ],
      [
        -837.989501953125,
        -2183.863525390625,
        704.5286254882812
      ],
      [
        -846.7315063476562,
        -2167.271728515625,
        531.78662109375
      ],
      [
        -834.5742797851562,
        -2190.765625,
        787.6206665039062
      ],
      [
        -837.989501953125,
        -2183.863525390625,
        704.5286254882812
      ],
      [
        -953.9031982421875,
        -2116.968017578125,
        306.42681884765625
      ],
      [
        -847.845703125,
        -2165.156982421875,
        509.7704772949219
      ],
      [
        -847.6062622070312,
        -2162.234619140625,
        389.07147216796875
      ],
      [
        -847.845703125,
        -2165.156982421875,
        509.7704772949219
      ],
      [
        -847.6853637695312,
        -2162.010986328125,
        384.78607177734375
      ],
      [
        -847.6062622070312,
        -2162.234619140625,
        389.07147216796875
      ],
      [
        -742.028076171875,
        -2313.18505859375,
        639.28125
      ],
      [
        -743.6647338867188,
        -2308.58251953125,
        551.3601684570312
      ],
      [
        -742.0281372070312,
        -2313.18505859375,
        639.28125
      ],
      [
        -758.4227294921875,
        -2290.446044921875,
        626.47314453125
      ],
      [
        -753.1447143554688,
        -2297.6806640625,
        627.40771484375
      ],
      [
        -758.4227294921875,
        -2290.446044921875,
        626.47314453125
      ],
      [
        -749.1293334960938,
        -2303.485107421875,
        639.28125
      ],
      [
        -742.0281372070312,
        -2313.18505859375,
        639.28125
      ],
      [
        -752.1113891601562,
        -2299.47509765625,
        641.6248779296875
      ],
      [
        -749.15966796875,
        -2303.5068359375,
        641.6248779296875
      ],
      [
        -749.15966796875,
        -2303.5068359375,
        641.6248779296875
      ],
      [
        -749.1293334960938,
        -2303.485107421875,
        639.28125
      ],
      [
        -779.0326538085938,
        -2261.742919921875,
        1062.6336669921875
      ],
      [
        -775.6287231445312,
        -2264.03369140625,
        966.3355712890625
      ],
      [
        -779.0326538085938,
        -2261.742919921875,
        1062.6337890625
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.5385131835938
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.53857421875
      ],
      [
        -781.3290405273438,
        -2254.945068359375,
        946.2814331054688
      ],
      [
        -761.4224853515625,
        -2276.431640625,
        598.3528442382812
      ],
      [
        -774.7032470703125,
        -2264.4326171875,
        932.4193725585938
      ],
      [
        -769.1553344726562,
        -2268.39013671875,
        783.2012939453125
      ],
      [
        -774.7032470703125,
        -2264.4326171875,
        932.4193115234375
      ],
      [
        -775.706787109375,
        -2263.27197265625,
        944.060791015625
      ],
      [
        -775.0944213867188,
        -2264.15380859375,
        942.9473876953125
      ],
      [
        -775.706787109375,
        -2263.27197265625,
        944.060791015625
      ],
      [
        -765.8814697265625,
        -2285.833740234375,
        833.5809326171875
      ],
      [
        -775.6287231445312,
        -2264.03369140625,
        966.3355712890625
      ],
      [
        -774.9893798828125,
        -2264.304931640625,
        942.7564697265625
      ],
      [
        -774.9893798828125,
        -2264.304931640625,
        942.7564697265625
      ],
      [
        -756.9111938476562,
        -2292.517822265625,
        626.7407836914062
      ],
      [
        -761.4224853515625,
        -2276.431640625,
        598.3528442382812
      ],
      [
        -795.1211547851562,
        -2227.39990234375,
        619.3200073242188
      ],
      [
        -845.5904541015625,
        -2163.380126953125,
        405.04217529296875
      ],
      [
        -845.5904541015625,
        -2163.380126953125,
        405.04217529296875
      ],
      [
        -845.2881469726562,
        -2163.03515625,
        386.7197570800781
      ],
      [
        -845.2899780273438,
        -2163.02685546875,
        386.55322265625
      ],
      [
        -845.2881469726562,
        -2163.03515625,
        386.7197570800781
      ],
      [
        -781.3290405273438,
        -2254.945068359375,
        946.2814331054688
      ],
      [
        -795.1060791015625,
        -2227.415283203125,
        619.2900390625
      ],
      [
        -784.2568969726562,
        -2246.891845703125,
        819.130615234375
      ],
      [
        -789.1319580078125,
        -2233.482421875,
        607.4153442382812
      ],
      [
        -789.1319580078125,
        -2233.482421875,
        607.4153442382812
      ],
      [
        -792.2164916992188,
        -2225.827880859375,
        502.0954895019531
      ],
      [
        -732.7146606445312,
        -2333.08203125,
        1138.8836669921875
      ],
      [
        -732.7146606445312,
        -2333.08203125,
        1138.8836669921875
      ],
      [
        -733.7013549804688,
        -2332.134033203125,
        1156.9886474609375
      ],
      [
        -733.4500122070312,
        -2333.14013671875,
        1178.7674560546875
      ],
      [
        -733.4500122070312,
        -2333.14013671875,
        1178.7674560546875
      ],
      [
        -733.7513427734375,
        -2332.292724609375,
        1165.042236328125
      ],
      [
        -733.7513427734375,
        -2332.292724609375,
        1165.042236328125
      ],
      [
        -733.7013549804688,
        -2332.134033203125,
        1156.9886474609375
      ],
      [
        -726.7144165039062,
        -2327.564697265625,
        639.28125
      ],
      [
        -729.4752807617188,
        -2315.94384765625,
        380.368408203125
      ],
      [
        -710.5648193359375,
        -2352.47119140625,
        666.9879760742188
      ],
      [
        -726.714599609375,
        -2327.564453125,
        639.28125
      ],
      [
        -712.6065063476562,
        -2348.622802734375,
        639.3294677734375
      ],
      [
        -709.5630493164062,
        -2353.44921875,
        649.135009765625
      ],
      [
        -710.5648193359375,
        -2352.47119140625,
        666.9879760742188
      ],
      [
        -762.0603637695312,
        -2273.451416015625,
        592.373046875
      ],
      [
        -759.3041381835938,
        -2277.610107421875,
        593.9215087890625
      ],
      [
        -762.0603637695312,
        -2273.451416015625,
        592.373046875
      ],
      [
        -744.8853759765625,
        -2300.444091796875,
        639.28125
      ],
      [
        -726.714599609375,
        -2327.564453125,
        639.28125
      ],
      [
        -747.6936645507812,
        -2296.32080078125,
        641.6248779296875
      ],
      [
        -744.9161987304688,
        -2300.46630859375,
        641.6248779296875
      ],
      [
        -744.9161987304688,
        -2300.46630859375,
        641.6248779296875
      ],
      [
        -744.8853759765625,
        -2300.444091796875,
        639.28125
      ],
      [
        -762.185791015625,
        -2272.865478515625,
        591.1971435546875
      ],
      [
        -775.2893676757812,
        -2263.2548828125,
        941.2239379882812
      ],
      [
        -779.7763061523438,
        -2256.816650390625,
        950.908203125
      ],
      [
        -788.0037841796875,
        -2234.628173828125,
        605.1729125976562
      ],
      [
        -775.2893676757812,
        -2263.2548828125,
        941.223876953125
      ],
      [
        -775.980712890625,
        -2262.449951171875,
        949.2652587890625
      ],
      [
        -775.5611572265625,
        -2263.055419921875,
        948.4865112304688
      ],
      [
        -775.980712890625,
        -2262.449951171875,
        949.2652587890625
      ],
      [
        -775.0944213867188,
        -2264.15380859375,
        942.9473876953125
      ],
      [
        -788.0037841796875,
        -2234.628173828125,
        605.1729125976562
      ],
      [
        -791.0175170898438,
        -2227.248291015625,
        504.7087707519531
      ],
      [
        -779.2199096679688,
        -2261.210693359375,
        1053.9071044921875
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -778.3212280273438,
        -2261.03125,
        1022.2198486328125
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -779.7763061523438,
        -2256.816650390625,
        950.908203125
      ],
      [
        -726.2781372070312,
        -2327.974365234375,
        639.28125
      ],
      [
        -729.2386474609375,
        -2316.066650390625,
        377.5164794921875
      ],
      [
        -710.4673461914062,
        -2352.415283203125,
        666.59521484375
      ],
      [
        -726.2783203125,
        -2327.97412109375,
        639.28125
      ],
      [
        -712.535400390625,
        -2348.54150390625,
        639.3285522460938
      ],
      [
        -709.4921875,
        -2353.375732421875,
        649.1428833007812
      ],
      [
        -710.4673461914062,
        -2352.415283203125,
        666.59521484375
      ],
      [
        -718.0741577148438,
        -2355.997802734375,
        1190.5146484375
      ],
      [
        -720.0994262695312,
        -2352.8271484375,
        1185.6201171875
      ],
      [
        -721.0750122070312,
        -2351.303955078125,
        1168.208984375
      ],
      [
        -720.7385864257812,
        -2352.72216796875,
        1199.8267822265625
      ],
      [
        -720.0845336914062,
        -2352.88818359375,
        1186.9747314453125
      ],
      [
        -718.07421875,
        -2355.997802734375,
        1190.5146484375
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -775.4889526367188,
        -2263.15966796875,
        948.3524780273438
      ],
      [
        -775.4889526367188,
        -2263.15966796875,
        948.3524780273438
      ],
      [
        -732.9429321289062,
        -2332.72021484375,
        1154.580322265625
      ],
      [
        -733.1165161132812,
        -2332.730224609375,
        1164.02734375
      ],
      [
        -732.9429321289062,
        -2332.72021484375,
        1154.580322265625
      ],
      [
        -733.1771850585938,
        -2332.494384765625,
        1158.943359375
      ],
      [
        -733.1165161132812,
        -2332.730224609375,
        1164.02734375
      ],
      [
        -733.18798828125,
        -2332.5322265625,
        1160.837646484375
      ],
      [
        -733.18798828125,
        -2332.5322265625,
        1160.837646484375
      ],
      [
        -733.1771850585938,
        -2332.494384765625,
        1158.943359375
      ],
      [
        -744.742919921875,
        -2300.342041015625,
        639.28125
      ],
      [
        -726.2783203125,
        -2327.97412109375,
        639.28125
      ],
      [
        -759.5247802734375,
        -2276.89111328125,
        592.7221069335938
      ],
      [
        -762.185791015625,
        -2272.865478515625,
        591.1971435546875
      ],
      [
        -747.5454711914062,
        -2296.215087890625,
        641.6248779296875
      ],
      [
        -744.7731323242188,
        -2300.36376953125,
        641.6248779296875
      ],
      [
        -744.7731323242188,
        -2300.36376953125,
        641.6248779296875
      ],
      [
        -744.742919921875,
        -2300.342041015625,
        639.28125
      ],
      [
        -720.05517578125,
        -2352.896240234375,
        1186.40869140625
      ],
      [
        -720.0993041992188,
        -2352.827392578125,
        1185.6202392578125
      ],
      [
        -720.0557250976562,
        -2352.8955078125,
        1186.40771484375
      ],
      [
        -720.0845336914062,
        -2352.88818359375,
        1186.9747314453125
      ],
      [
        -775.5611572265625,
        -2263.055419921875,
        948.4865112304688
      ],
      [
        -778.3212280273438,
        -2261.03125,
        1022.2198486328125
      ],
      [
        -736.3060302734375,
        -2294.296630859375,
        639.28125
      ],
      [
        -738.759521484375,
        -2289.942138671875,
        641.6248779296875
      ],
      [
        -736.3522338867188,
        -2294.329833984375,
        641.6248779296875
      ],
      [
        -736.3522338867188,
        -2294.329833984375,
        641.6248779296875
      ],
      [
        -736.3060302734375,
        -2294.296630859375,
        639.28125
      ],
      [
        -689.3812255859375,
        -2260.673583984375,
        639.28125
      ],
      [
        -668.7909545898438,
        -2314.91064453125,
        639.28125
      ],
      [
        -666.5949096679688,
        -2320.252197265625,
        630.2252807617188
      ],
      [
        -705.815185546875,
        -2349.337158203125,
        639.2811889648438
      ],
      [
        -666.7262573242188,
        -2320.349609375,
        639.2811889648438
      ],
      [
        -668.8250732421875,
        -2314.935791015625,
        641.6248779296875
      ],
      [
        -666.76025390625,
        -2320.374755859375,
        641.6248779296875
      ],
      [
        -691.2036743164062,
        -2255.988037109375,
        641.6248779296875
      ],
      [
        -689.41552734375,
        -2260.6982421875,
        641.6248779296875
      ],
      [
        -689.41552734375,
        -2260.6982421875,
        641.6248779296875
      ],
      [
        -689.3812255859375,
        -2260.673583984375,
        639.28125
      ],
      [
        -668.8250732421875,
        -2314.935791015625,
        641.6248779296875
      ],
      [
        -668.7909545898438,
        -2314.91064453125,
        639.28125
      ],
      [
        -666.76025390625,
        -2320.374755859375,
        641.6248779296875
      ],
      [
        -495.3401794433594,
        -2807.683837890625,
        1372.5606689453125
      ],
      [
        -492.5638427734375,
        -2820.1337890625,
        1477.5262451171875
      ],
      [
        -495.4368591308594,
        -2808.2001953125,
        1388.3187255859375
      ],
      [
        -495.48614501953125,
        -2807.910400390625,
        1385.04638671875
      ],
      [
        -495.3401794433594,
        -2807.683837890625,
        1372.5606689453125
      ],
      [
        -495.48614501953125,
        -2807.910400390625,
        1385.04638671875
      ],
      [
        -495.4368591308594,
        -2808.2001953125,
        1388.3187255859375
      ],
      [
        -42.06678009033203,
        -3172.2548828125,
        1444.156494140625
      ],
      [
        -57.122589111328125,
        -3161.155517578125,
        1429.8426513671875
      ],
      [
        -246.2596893310547,
        -3025.32958984375,
        1363.6724853515625
      ],
      [
        -57.122589111328125,
        -3161.155517578125,
        1429.8426513671875
      ],
      [
        -246.2596893310547,
        -3025.32958984375,
        1363.6724853515625
      ],
      [
        -301.69952392578125,
        -2988.336181640625,
        1433.0771484375
      ],
      [
        -306.4407653808594,
        -2983.163818359375,
        1431.28369140625
      ],
      [
        -230.98553466796875,
        -3014.869140625,
        707.403076171875
      ],
      [
        -306.5943603515625,
        -2982.996337890625,
        1431.2255859375
      ],
      [
        -230.98553466796875,
        -3014.869140625,
        707.403076171875
      ],
      [
        -230.6397247314453,
        -3014.8623046875,
        699.0181884765625
      ],
      [
        -325.2165222167969,
        -2956.982421875,
        1402.2528076171875
      ],
      [
        -322.748779296875,
        -2965.373291015625,
        1425.114990234375
      ],
      [
        -325.2165222167969,
        -2956.982421875,
        1402.2528076171875
      ],
      [
        -321.0329284667969,
        -2940.999267578125,
        1249.1214599609375
      ],
      [
        -313.454833984375,
        -2966.85888671875,
        1395.3326416015625
      ],
      [
        -322.1067199707031,
        -2943.16455078125,
        1321.677978515625
      ],
      [
        -307.68621826171875,
        -2981.80517578125,
        1430.8126220703125
      ],
      [
        -313.454833984375,
        -2966.85888671875,
        1395.3326416015625
      ],
      [
        -322.5382995605469,
        -2941.982666015625,
        1318.00390625
      ],
      [
        -321.032958984375,
        -2940.999267578125,
        1249.1214599609375
      ],
      [
        -322.5382995605469,
        -2941.982666015625,
        1318.00390625
      ],
      [
        -266.6285705566406,
        -2674.623046875,
        885.4474487304688
      ],
      [
        -208.74124145507812,
        -2623.136962890625,
        112.62752532958984
      ],
      [
        -54.583152770996094,
        -1975.8736572265625,
        809.252685546875
      ],
      [
        -55.977264404296875,
        -1975.318359375,
        798.23974609375
      ],
      [
        -118.56556701660156,
        -1950.3873291015625,
        813.3817138671875
      ],
      [
        -129.07843017578125,
        -1946.1995849609375,
        862.9803466796875
      ],
      [
        -118.56555938720703,
        -1950.38720703125,
        813.3817138671875
      ],
      [
        -55.977264404296875,
        -1975.3182373046875,
        798.23974609375
      ],
      [
        -57.60731506347656,
        -1976.0809326171875,
        786.18359375
      ],
      [
        -98.83558654785156,
        -1969.0758056640625,
        713.1172485351562
      ],
      [
        -68.91596221923828,
        -1979.4873046875,
        701.4473876953125
      ],
      [
        -98.47842407226562,
        -1969.3336181640625,
        711.3555297851562
      ],
      [
        -98.83558654785156,
        -1969.0758056640625,
        713.1172485351562
      ],
      [
        -57.60731506347656,
        -1976.0809326171875,
        786.18359375
      ],
      [
        -98.47756958007812,
        -1969.4150390625,
        711.2977905273438
      ],
      [
        -98.47842407226562,
        -1969.3336181640625,
        711.3555297851562
      ],
      [
        -68.91596221923828,
        -1979.4873046875,
        701.4473876953125
      ],
      [
        -69.2557601928711,
        -1981.531005859375,
        700.0296020507812
      ],
      [
        -78.00985717773438,
        -2034.18310546875,
        663.50390625
      ],
      [
        -97.80717468261719,
        -2033.1204833984375,
        666.0718383789062
      ],
      [
        -83.65811157226562,
        -2063.563720703125,
        637.2685546875
      ],
      [
        -96.1117172241211,
        -2063.324462890625,
        638.4939575195312
      ],
      [
        -97.80717468261719,
        -2033.1204833984375,
        666.0718383789062
      ],
      [
        -78.00985717773438,
        -2034.18310546875,
        663.50390625
      ],
      [
        -85.13462829589844,
        -2046.7047119140625,
        652.7044067382812
      ],
      [
        -90.278564453125,
        -2044.573974609375,
        624.9468383789062
      ],
      [
        -88.89671325683594,
        -2045.1463623046875,
        618.412841796875
      ],
      [
        -84.84825134277344,
        -2046.8233642578125,
        618.412841796875
      ],
      [
        -80.76506042480469,
        -2048.5146484375,
        650.7062377929688
      ],
      [
        -90.278564453125,
        -2044.573974609375,
        624.9468383789062
      ],
      [
        -96.92052459716797,
        -2047.3251953125,
        652.7044067382812
      ],
      [
        -96.92052459716797,
        -2047.3251953125,
        652.7044067382812
      ],
      [
        -90.278564453125,
        -2045.8577880859375,
        653.890380859375
      ],
      [
        -96.99676513671875,
        -2047.5574951171875,
        652.889892578125
      ],
      [
        -85.13462829589844,
        -2046.7047119140625,
        652.7044067382812
      ],
      [
        -90.278564453125,
        -2045.8577880859375,
        653.890380859375
      ],
      [
        -80.51241302490234,
        -2048.619384765625,
        652.7044067382812
      ],
      [
        -80.4915542602539,
        -2049.109375,
        653.1491088867188
      ],
      [
        -90.278564453125,
        -2047.364990234375,
        655.2828369140625
      ],
      [
        -90.278564453125,
        -2047.364990234375,
        655.2828369140625
      ],
      [
        -97.63473510742188,
        -2049.501953125,
        654.4420776367188
      ],
      [
        -80.51241302490234,
        -2048.619384765625,
        652.7044067382812
      ],
      [
        -80.46389770507812,
        -2049.75927734375,
        653.7388916015625
      ],
      [
        -80.46389770507812,
        -2049.75927734375,
        653.7388916015625
      ],
      [
        -98.30575561523438,
        -2051.547119140625,
        656.0746459960938
      ],
      [
        -98.30575561523438,
        -2051.547119140625,
        656.0746459960938
      ],
      [
        -156.78652954101562,
        -1941.345947265625,
        768.1051025390625
      ],
      [
        -144.57403564453125,
        -1940.0272216796875,
        819.6739501953125
      ],
      [
        -170.0,
        -1922.3160400390625,
        770.0
      ],
      [
        -170.0,
        -1924.089111328125,
        765.0
      ],
      [
        -172.9431915283203,
        -1920.0,
        765.0
      ],
      [
        -170.0,
        -1924.089111328125,
        765.0
      ],
      [
        -98.47756958007812,
        -1969.4150390625,
        711.2977905273438
      ],
      [
        -156.78652954101562,
        -1941.345947265625,
        768.1051025390625
      ],
      [
        -148.03103637695312,
        -1974.707275390625,
        708.326904296875
      ],
      [
        -119.99136352539062,
        -2026.7135009765625,
        671.52490234375
      ],
      [
        -148.03103637695312,
        -1974.707275390625,
        708.326904296875
      ],
      [
        -102.00392150878906,
        -2063.211181640625,
        639.07373046875
      ],
      [
        -108.52902221679688,
        -2049.560791015625,
        652.0034790039062
      ],
      [
        -98.24210357666016,
        -2047.8726806640625,
        652.7044067382812
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        651.923583984375
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        651.923583984375
      ],
      [
        -104.56549835205078,
        -2057.8525390625,
        644.1494750976562
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        636.500732421875
      ],
      [
        -98.24210357666016,
        -2047.8726806640625,
        652.7044067382812
      ],
      [
        -96.99676513671875,
        -2047.5576171875,
        652.889892578125
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        636.500732421875
      ],
      [
        -107.73072052001953,
        -2062.580810546875,
        618.412841796875
      ],
      [
        -108.52902221679688,
        -2049.560791015625,
        652.0034790039062
      ],
      [
        -118.06175231933594,
        -2031.7244873046875,
        664.9536743164062
      ],
      [
        -119.99136352539062,
        -2026.7135009765625,
        671.52490234375
      ],
      [
        -118.06175231933594,
        -2031.7244873046875,
        664.9536743164062
      ],
      [
        -102.37579345703125,
        -2052.56591796875,
        652.7044067382812
      ],
      [
        -104.0156021118164,
        -2056.52490234375,
        650.0479736328125
      ],
      [
        -102.37576293945312,
        -2052.56591796875,
        652.7044067382812
      ],
      [
        -99.73948669433594,
        -2050.113525390625,
        654.201416015625
      ],
      [
        -97.63469696044922,
        -2049.501953125,
        654.4420166015625
      ],
      [
        -99.73948669433594,
        -2050.113525390625,
        654.201416015625
      ],
      [
        -102.66072845458984,
        -2053.25390625,
        652.7044067382812
      ],
      [
        -103.97335052490234,
        -2056.4228515625,
        650.5011596679688
      ],
      [
        -102.6607894897461,
        -2053.254150390625,
        652.7044067382812
      ],
      [
        -99.41008758544922,
        -2050.44287109375,
        654.6317749023438
      ],
      [
        -97.81600952148438,
        -2050.054443359375,
        654.8831176757812
      ],
      [
        -99.41008758544922,
        -2050.44287109375,
        654.6317749023438
      ],
      [
        -144.57403564453125,
        -1940.0272216796875,
        819.6739501953125
      ],
      [
        -103.76795196533203,
        -2055.927001953125,
        652.7044067382812
      ],
      [
        -103.76795196533203,
        -2055.927001953125,
        652.7044067382812
      ],
      [
        -58.14104080200195,
        -1983.1881103515625,
        697.8360595703125
      ],
      [
        -55.010284423828125,
        -1976.522216796875,
        790.7861328125
      ],
      [
        -54.71514129638672,
        -1975.821044921875,
        797.9343872070312
      ],
      [
        -55.010284423828125,
        -1976.522216796875,
        790.7861328125
      ],
      [
        -54.68634796142578,
        -1975.83251953125,
        800.4033203125
      ],
      [
        -54.71514129638672,
        -1975.821044921875,
        797.9343872070312
      ],
      [
        -55.58918380737305,
        -1975.472900390625,
        801.305419921875
      ],
      [
        -73.37274932861328,
        -2034.4320068359375,
        662.9024047851562
      ],
      [
        -58.14103698730469,
        -1983.1881103515625,
        697.8360595703125
      ],
      [
        -82.11737060546875,
        -2063.59326171875,
        637.116943359375
      ],
      [
        -73.37274169921875,
        -2034.4320068359375,
        662.9024047851562
      ],
      [
        -79.672119140625,
        -2048.967529296875,
        650.2064208984375
      ],
      [
        -80.76506042480469,
        -2048.5146484375,
        650.7062377929688
      ],
      [
        -79.672119140625,
        -2048.967529296875,
        650.2064208984375
      ],
      [
        -78.77050018310547,
        -2051.14404296875,
        618.412841796875
      ],
      [
        -78.54643249511719,
        -2051.68505859375,
        647.6465454101562
      ],
      [
        -79.41133117675781,
        -2049.59716796875,
        652.7044067382812
      ],
      [
        -78.51998138427734,
        -2051.748779296875,
        651.0970458984375
      ],
      [
        -79.91654968261719,
        -2049.2119140625,
        653.0237426757812
      ],
      [
        -80.4915542602539,
        -2049.109375,
        653.1491088867188
      ],
      [
        -79.41133880615234,
        -2049.59716796875,
        652.7044067382812
      ],
      [
        -79.91654968261719,
        -2049.2119140625,
        653.0237426757812
      ],
      [
        -78.50767517089844,
        -2051.778564453125,
        652.7044067382812
      ],
      [
        -78.50765991210938,
        -2051.778564453125,
        652.7044067382812
      ],
      [
        71.04067993164062,
        -2037.2186279296875,
        772.2144775390625
      ],
      [
        5.397914886474609,
        -2005.011474609375,
        676.5404052734375
      ],
      [
        71.04067993164062,
        -2037.2186279296875,
        772.2144775390625
      ],
      [
        124.90061950683594,
        -2053.60986328125,
        688.2540283203125
      ],
      [
        132.8318328857422,
        -2055.531494140625,
        678.410400390625
      ],
      [
        132.91094970703125,
        -2056.047607421875,
        675.76708984375
      ],
      [
        82.40290069580078,
        -2042.7933349609375,
        642.6964721679688
      ],
      [
        5.397911071777344,
        -2005.011474609375,
        676.5404052734375
      ],
      [
        129.67422485351562,
        -2065.98681640625,
        590.831787109375
      ],
      [
        94.50411987304688,
        -2048.730712890625,
        636.32275390625
      ],
      [
        94.5041275024414,
        -2048.730712890625,
        636.32275390625
      ],
      [
        82.40291595458984,
        -2042.7933349609375,
        642.6964721679688
      ],
      [
        153.40740966796875,
        -2073.255615234375,
        587.62353515625
      ],
      [
        134.99513244628906,
        -2066.762451171875,
        620.8826293945312
      ],
      [
        129.67422485351562,
        -2065.98681640625,
        590.831787109375
      ],
      [
        153.40740966796875,
        -2073.255615234375,
        587.62353515625
      ],
      [
        143.94595336914062,
        -2072.989013671875,
        588.9891357421875
      ],
      [
        134.52838134765625,
        -2066.597900390625,
        621.7257690429688
      ],
      [
        124.90062713623047,
        -2053.60986328125,
        688.2540283203125
      ],
      [
        134.52838134765625,
        -2066.597900390625,
        621.7257690429688
      ],
      [
        134.52838134765625,
        -2066.597900390625,
        621.7257690429688
      ],
      [
        -18.65771484375,
        -2064.812255859375,
        630.87255859375
      ],
      [
        45.367408752441406,
        -2070.211181640625,
        603.21728515625
      ],
      [
        -18.657730102539062,
        -2064.812255859375,
        630.87255859375
      ],
      [
        -75.278564453125,
        -2059.573974609375,
        640.2146606445312
      ],
      [
        -78.54642486572266,
        -2051.68505859375,
        647.6466064453125
      ],
      [
        -75.278564453125,
        -2059.573974609375,
        640.2146606445312
      ],
      [
        -65.69345092773438,
        -2067.24462890625,
        618.412841796875
      ],
      [
        -69.96453857421875,
        -2063.82666015625,
        635.9208984375
      ],
      [
        45.36741638183594,
        -2070.211181640625,
        603.21728515625
      ],
      [
        -57.76780700683594,
        -1982.3934326171875,
        708.9171142578125
      ],
      [
        1.1896400451660156,
        -2002.9466552734375,
        685.4716796875
      ],
      [
        -73.7710189819336,
        -2060.780517578125,
        651.5244750976562
      ],
      [
        -79.69985961914062,
        -2056.035888671875,
        655.4349975585938
      ],
      [
        -75.6828842163086,
        -2060.550048828125,
        652.7044067382812
      ],
      [
        -73.7710189819336,
        -2060.780517578125,
        651.5244750976562
      ],
      [
        -74.43592834472656,
        -2060.701416015625,
        651.92919921875
      ],
      [
        -75.6828842163086,
        -2060.550048828125,
        652.7044067382812
      ],
      [
        -74.43592834472656,
        -2060.701416015625,
        651.92919921875
      ],
      [
        136.03269958496094,
        -2069.1064453125,
        619.8883666992188
      ],
      [
        148.1786651611328,
        -2075.06591796875,
        699.8282470703125
      ],
      [
        136.03269958496094,
        -2069.1064453125,
        619.8883666992188
      ],
      [
        154.52288818359375,
        -2078.178466796875,
        587.62353515625
      ],
      [
        136.03269958496094,
        -2069.1064453125,
        619.8883666992188
      ],
      [
        143.94595336914062,
        -2072.989013671875,
        588.9891357421875
      ],
      [
        154.52288818359375,
        -2078.178466796875,
        587.62353515625
      ],
      [
        143.29933166503906,
        -2072.671875,
        723.3864135742188
      ],
      [
        148.1786651611328,
        -2075.06591796875,
        699.8282470703125
      ],
      [
        74.56230926513672,
        -2182.8388671875,
        993.514404296875
      ],
      [
        70.45851135253906,
        -2191.531005859375,
        952.922119140625
      ],
      [
        71.39912414550781,
        -2198.71875,
        936.33740234375
      ],
      [
        70.4585189819336,
        -2191.531005859375,
        952.922119140625
      ],
      [
        146.42982482910156,
        -2074.207763671875,
        688.318115234375
      ],
      [
        148.59835815429688,
        -2090.060791015625,
        604.54052734375
      ],
      [
        148.59835815429688,
        -2090.060791015625,
        604.54052734375
      ],
      [
        143.02252197265625,
        -2072.5361328125,
        665.892578125
      ],
      [
        153.90138244628906,
        -2077.87353515625,
        588.7080688476562
      ],
      [
        148.59832763671875,
        -2090.060791015625,
        604.5405883789062
      ],
      [
        154.0456085205078,
        -2077.9443359375,
        587.6851806640625
      ],
      [
        150.52145385742188,
        -2092.5107421875,
        588.6765747070312
      ],
      [
        144.96273803710938,
        -2115.666015625,
        589.97607421875
      ],
      [
        146.03309631347656,
        -2111.0625,
        589.9391479492188
      ],
      [
        145.30203247070312,
        -2114.197998046875,
        589.9774169921875
      ],
      [
        144.96273803710938,
        -2115.666015625,
        589.97607421875
      ],
      [
        145.30203247070312,
        -2114.197998046875,
        589.9774169921875
      ],
      [
        146.03309631347656,
        -2111.0625,
        589.9391479492188
      ],
      [
        71.39912414550781,
        -2198.71875,
        936.33740234375
      ],
      [
        67.68309020996094,
        -2197.409423828125,
        925.4697875976562
      ],
      [
        82.64772033691406,
        -2165.712890625,
        750.2713012695312
      ],
      [
        85.21322631835938,
        -2160.279052734375,
        709.093994140625
      ],
      [
        82.6477279663086,
        -2165.712890625,
        750.2713012695312
      ],
      [
        85.21322631835938,
        -2160.279052734375,
        709.093994140625
      ],
      [
        86.5254898071289,
        -2157.49951171875,
        704.8739013671875
      ],
      [
        139.16610717773438,
        -2072.854248046875,
        589.6790161132812
      ],
      [
        150.52145385742188,
        -2092.5107421875,
        588.6765747070312
      ],
      [
        103.46530151367188,
        -2121.619384765625,
        595.5591430664062
      ],
      [
        89.71923828125,
        -2150.73486328125,
        694.6030883789062
      ],
      [
        89.71923828125,
        -2150.73486328125,
        694.6030883789062
      ],
      [
        126.65480041503906,
        -2072.501708984375,
        591.4848022460938
      ],
      [
        110.58509063720703,
        -2106.538818359375,
        594.939453125
      ],
      [
        105.83856201171875,
        -2116.592529296875,
        595.3948364257812
      ],
      [
        103.46529388427734,
        -2121.619384765625,
        595.5591430664062
      ],
      [
        105.83856201171875,
        -2116.592529296875,
        595.3948364257812
      ],
      [
        110.58509826660156,
        -2106.538818359375,
        594.939453125
      ],
      [
        -93.47966766357422,
        -2080.496826171875,
        623.7249755859375
      ],
      [
        -86.0,
        -2091.3330078125,
        622.4713134765625
      ],
      [
        -61.554107666015625,
        -2126.74951171875,
        618.3739624023438
      ],
      [
        -93.47962951660156,
        -2080.496826171875,
        623.7249145507812
      ],
      [
        -95.73728942871094,
        -2077.281494140625,
        623.947021484375
      ],
      [
        -93.47962188720703,
        -2080.496826171875,
        623.7249145507812
      ],
      [
        -61.554107666015625,
        -2126.74951171875,
        618.3739624023438
      ],
      [
        -58.473697662353516,
        -2131.23388671875,
        617.796630859375
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        621.3797607421875
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        619.4662475585938
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        619.4662475585938
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        619.1134643554688
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        619.113525390625
      ],
      [
        -65.90440368652344,
        -2067.07568359375,
        619.277587890625
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        623.3673095703125
      ],
      [
        -92.5,
        -2071.60009765625,
        623.289794921875
      ],
      [
        -91.25299072265625,
        -2080.781494140625,
        623.4108276367188
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.0650024414062
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        621.3797607421875
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        623.3184814453125
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.0650024414062
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        618.412841796875
      ],
      [
        -88.0,
        -2071.60009765625,
        622.6361083984375
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        618.5244140625
      ],
      [
        -88.27063751220703,
        -2073.7421875,
        622.7459106445312
      ],
      [
        -89.30126953125,
        -2081.89990234375,
        623.1181030273438
      ],
      [
        -89.19329071044922,
        -2081.045166015625,
        623.1203002929688
      ],
      [
        -89.30126953125,
        -2081.89990234375,
        623.1181030273438
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        623.3673095703125
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        623.802001953125
      ],
      [
        -100.65653228759766,
        -2070.275390625,
        624.4310302734375
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        623.802001953125
      ],
      [
        -102.4698486328125,
        -2069.89013671875,
        618.412841796875
      ],
      [
        -58.47370147705078,
        -2131.23388671875,
        617.796630859375
      ],
      [
        26.906936645507812,
        -2132.77880859375,
        606.0013427734375
      ],
      [
        -58.39441680908203,
        -2131.3271484375,
        617.8444213867188
      ],
      [
        103.45639038085938,
        -2121.63818359375,
        595.6233520507812
      ],
      [
        27.273828506469727,
        -2132.59033203125,
        605.9542846679688
      ],
      [
        26.906936645507812,
        -2132.77880859375,
        606.0013427734375
      ],
      [
        27.27383041381836,
        -2132.59033203125,
        605.9542846679688
      ],
      [
        -95.7372817993164,
        -2077.281494140625,
        623.947021484375
      ],
      [
        -95.74957275390625,
        -2077.208251953125,
        624.10546875
      ],
      [
        40.27885055541992,
        -2069.781982421875,
        605.415283203125
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        622.0199584960938
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        620.111572265625
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        620.111572265625
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        619.9622802734375
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        619.9622802734375
      ],
      [
        -66.1320571899414,
        -2066.8935546875,
        620.2107543945312
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.4006958007812
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        622.0199584960938
      ],
      [
        -100.48622131347656,
        -2070.345947265625,
        624.8993530273438
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.4006958007812
      ],
      [
        -92.5,
        -2071.60009765625,
        623.7680053710938
      ],
      [
        -92.2044448852539,
        -2073.776123046875,
        623.683349609375
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        623.3184814453125
      ],
      [
        -88.0,
        -2071.60009765625,
        623.1448364257812
      ],
      [
        -88.27063751220703,
        -2073.7421875,
        622.7459106445312
      ],
      [
        -88.27063751220703,
        -2073.7421875,
        623.1392822265625
      ],
      [
        -91.99929809570312,
        -2075.28662109375,
        623.6245727539062
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        623.33837890625
      ],
      [
        -88.67304229736328,
        -2076.92724609375,
        622.9091796875
      ],
      [
        -88.65960693359375,
        -2076.821044921875,
        623.1312866210938
      ],
      [
        -91.76782989501953,
        -2076.990966796875,
        623.5582885742188
      ],
      [
        -91.75545501708984,
        -2077.08203125,
        623.362060546875
      ],
      [
        22.371559143066406,
        -2181.445068359375,
        792.9555053710938
      ],
      [
        -22.747966766357422,
        -2171.38818359375,
        644.5339965820312
      ],
      [
        22.371559143066406,
        -2181.445068359375,
        792.9555053710938
      ],
      [
        -3.875415802001953,
        -2156.9873046875,
        626.1060180664062
      ],
      [
        86.5254898071289,
        -2157.49951171875,
        704.8738403320312
      ],
      [
        -3.8754138946533203,
        -2156.9873046875,
        626.1060180664062
      ],
      [
        -27.96014404296875,
        -2167.105712890625,
        636.1889038085938
      ],
      [
        -32.082427978515625,
        -2162.259521484375,
        633.7041625976562
      ],
      [
        -25.55841064453125,
        -2169.852294921875,
        637.8534545898438
      ],
      [
        -25.34307098388672,
        -2169.969970703125,
        638.3653564453125
      ],
      [
        -25.34307098388672,
        -2169.969970703125,
        638.3653564453125
      ],
      [
        -24.728878021240234,
        -2170.3056640625,
        639.8253173828125
      ],
      [
        -24.728878021240234,
        -2170.3056640625,
        639.8252563476562
      ],
      [
        -22.747962951660156,
        -2171.38818359375,
        644.5339965820312
      ],
      [
        -25.55841064453125,
        -2169.852294921875,
        637.8534545898438
      ],
      [
        -27.960147857666016,
        -2167.105712890625,
        636.1889038085938
      ],
      [
        74.56230163574219,
        -2182.8388671875,
        993.514404296875
      ],
      [
        80.05440521240234,
        -2142.2177734375,
        1129.589111328125
      ],
      [
        -46.1274528503418,
        -2145.748291015625,
        625.2384033203125
      ],
      [
        26.063024520874023,
        -2132.764404296875,
        606.1185302734375
      ],
      [
        -95.98562622070312,
        -2075.80126953125,
        627.148193359375
      ],
      [
        -95.9856185913086,
        -2075.80126953125,
        627.148193359375
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        630.9339599609375
      ],
      [
        -67.10629272460938,
        -2071.697509765625,
        628.53857421875
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        628.041259765625
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        631.5253295898438
      ],
      [
        -69.96456909179688,
        -2063.82666015625,
        635.9210205078125
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        628.041259765625
      ],
      [
        -66.0084457397461,
        -2071.54150390625,
        628.5914916992188
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        631.5253295898438
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        627.80126953125
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        630.9339599609375
      ],
      [
        -98.12615966796875,
        -2071.323486328125,
        631.3895263671875
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        627.80126953125
      ],
      [
        -88.0,
        -2071.60009765625,
        630.3184814453125
      ],
      [
        -88.27063751220703,
        -2073.7421875,
        623.1392822265625
      ],
      [
        -88.27062225341797,
        -2073.7421875,
        628.3944091796875
      ],
      [
        -92.20442962646484,
        -2073.776123046875,
        623.683349609375
      ],
      [
        -92.5,
        -2071.60009765625,
        630.682861328125
      ],
      [
        -92.20440673828125,
        -2073.7763671875,
        628.6817016601562
      ],
      [
        -91.99927520751953,
        -2075.28662109375,
        623.6245727539062
      ],
      [
        -92.0062026977539,
        -2075.235595703125,
        627.3397827148438
      ],
      [
        -91.999267578125,
        -2075.28662109375,
        627.2297973632812
      ],
      [
        -88.65961456298828,
        -2076.821044921875,
        623.1312866210938
      ],
      [
        -88.39447021484375,
        -2074.722412109375,
        627.5138549804688
      ],
      [
        -91.76782989501953,
        -2076.99072265625,
        623.5582885742188
      ],
      [
        -98.35602569580078,
        -2061.6728515625,
        657.7044067382812
      ],
      [
        -80.77708435058594,
        -2059.573974609375,
        657.7044067382812
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        635.3427734375
      ],
      [
        -72.18742370605469,
        -2062.0478515625,
        650.2850341796875
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        634.935791015625
      ],
      [
        -76.02018737792969,
        -2061.3642578125,
        652.7044067382812
      ],
      [
        -80.62480163574219,
        -2059.5869140625,
        657.6386108398438
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        635.3427734375
      ],
      [
        -76.02018737792969,
        -2061.3642578125,
        652.7044067382812
      ],
      [
        -73.61572265625,
        -2061.798828125,
        651.1746215820312
      ],
      [
        -72.18742370605469,
        -2062.0478515625,
        650.2850341796875
      ],
      [
        -73.61572265625,
        -2061.798828125,
        651.1746215820312
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        628.3053588867188
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        634.935791015625
      ],
      [
        -96.6332015991211,
        -2071.94189453125,
        635.4951782226562
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        628.3053588867188
      ],
      [
        -92.5,
        -2071.60009765625,
        635.1734008789062
      ],
      [
        -92.20440673828125,
        -2073.7763671875,
        630.484130859375
      ],
      [
        -92.20440673828125,
        -2073.7763671875,
        628.6817016601562
      ],
      [
        -88.0,
        -2071.60009765625,
        634.0341186523438
      ],
      [
        -88.27062225341797,
        -2073.7421875,
        628.3944091796875
      ],
      [
        -88.27062225341797,
        -2073.7421875,
        629.5609130859375
      ],
      [
        -89.7894515991211,
        -2068.95947265625,
        657.7044067382812
      ],
      [
        -91.17008209228516,
        -2068.792724609375,
        657.7044067382812
      ],
      [
        -94.10689544677734,
        -2067.576416015625,
        657.7044067382812
      ],
      [
        -89.7894515991211,
        -2068.95947265625,
        657.7044067382812
      ],
      [
        -87.16259002685547,
        -2067.871337890625,
        657.7044067382812
      ],
      [
        -93.61260986328125,
        -2068.498046875,
        657.0421142578125
      ],
      [
        -94.10689544677734,
        -2067.576416015625,
        657.7044067382812
      ],
      [
        -91.17008209228516,
        -2068.792724609375,
        657.7044067382812
      ],
      [
        -90.37528991699219,
        -2074.533935546875,
        652.7044067382812
      ],
      [
        -90.37528991699219,
        -2074.533935546875,
        652.7044067382812
      ],
      [
        -88.2706069946289,
        -2073.7421875,
        641.2166748046875
      ],
      [
        -88.27061462402344,
        -2073.7421875,
        645.4983520507812
      ],
      [
        -88.27061462402344,
        -2073.7421875,
        645.4983520507812
      ],
      [
        -88.27063751220703,
        -2073.7421875,
        648.5706787109375
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        636.5319213867188
      ],
      [
        -88.2706069946289,
        -2073.7421875,
        641.2166748046875
      ],
      [
        -88.27063751220703,
        -2073.7421875,
        648.5706787109375
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        651.2399291992188
      ],
      [
        -88.27063751220703,
        -2073.7421875,
        629.5607299804688
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        636.5319213867188
      ],
      [
        -92.20442962646484,
        -2073.776123046875,
        641.2166748046875
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        645.4983520507812
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        645.4983520507812
      ],
      [
        -92.25763702392578,
        -2073.384521484375,
        648.5706787109375
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        647.6743774414062
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        636.5319213867188
      ],
      [
        -92.2044448852539,
        -2073.776123046875,
        641.2166748046875
      ],
      [
        -92.25763702392578,
        -2073.384521484375,
        648.5706787109375
      ],
      [
        -92.4161148071289,
        -2072.2177734375,
        651.2399291992188
      ],
      [
        -92.20442962646484,
        -2073.776123046875,
        630.4844970703125
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        636.5319213867188
      ],
      [
        -92.4161148071289,
        -2072.2177734375,
        651.2399291992188
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        651.2399291992188
      ],
      [
        -90.27857971191406,
        -2074.573974609375,
        651.2399291992188
      ],
      [
        -90.90779876708984,
        -2074.313232421875,
        651.2399291992188
      ],
      [
        -91.99927520751953,
        -2075.28662109375,
        641.2166748046875
      ],
      [
        -92.07524871826172,
        -2074.727294921875,
        645.4983520507812
      ],
      [
        -91.99928283691406,
        -2075.28662109375,
        644.2186279296875
      ],
      [
        -92.07524871826172,
        -2074.727294921875,
        645.4983520507812
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        636.5319213867188
      ],
      [
        -91.99929809570312,
        -2075.28662109375,
        641.2166748046875
      ],
      [
        -91.99927520751953,
        -2075.28662109375,
        627.2299194335938
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        636.5319213867188
      ],
      [
        -90.61878967285156,
        -2074.71484375,
        651.2399291992188
      ],
      [
        -89.0361328125,
        -2079.802001953125,
        643.094482421875
      ],
      [
        -88.94454193115234,
        -2079.076904296875,
        645.4983520507812
      ],
      [
        -88.94454193115234,
        -2079.076904296875,
        645.4983520507812
      ],
      [
        -88.82752990722656,
        -2078.150146484375,
        648.5706787109375
      ],
      [
        -89.28631591796875,
        -2081.781494140625,
        636.5319213867188
      ],
      [
        -89.25543975830078,
        -2081.537353515625,
        637.3416748046875
      ],
      [
        -88.82752990722656,
        -2078.150146484375,
        648.5706787109375
      ],
      [
        -88.72579193115234,
        -2077.344970703125,
        651.2399291992188
      ],
      [
        -89.30126953125,
        -2081.89990234375,
        636.1395263671875
      ],
      [
        -89.28631591796875,
        -2081.781494140625,
        636.5319213867188
      ],
      [
        -89.30126953125,
        -2081.89990234375,
        636.1395263671875
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        629.0877075195312
      ],
      [
        -91.82107543945312,
        -2076.5986328125,
        641.2166748046875
      ],
      [
        -91.5429916381836,
        -2078.646240234375,
        636.5319213867188
      ],
      [
        -91.82106018066406,
        -2076.598876953125,
        641.2166748046875
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        629.0877075195312
      ],
      [
        -91.5429916381836,
        -2078.646240234375,
        636.5319213867188
      ],
      [
        -88.72579193115234,
        -2077.344970703125,
        651.2399291992188
      ],
      [
        -89.25543975830078,
        -2081.537353515625,
        637.3416748046875
      ],
      [
        -89.515380859375,
        -2079.802001953125,
        641.2166748046875
      ],
      [
        -89.0361328125,
        -2079.802001953125,
        643.094482421875
      ],
      [
        -89.515380859375,
        -2079.802001953125,
        641.2166748046875
      ],
      [
        -82.2734375,
        -2206.352783203125,
        847.1928100585938
      ],
      [
        -65.38180541992188,
        -2204.3486328125,
        855.0975341796875
      ],
      [
        -65.38180541992188,
        -2204.3486328125,
        855.0975341796875
      ],
      [
        -178.07562255859375,
        -2239.39990234375,
        861.0
      ],
      [
        -125.63127899169922,
        -2221.324462890625,
        861.0
      ],
      [
        -174.51132202148438,
        -2233.716552734375,
        861.0
      ],
      [
        -121.76891326904297,
        -2209.897216796875,
        819.28125
      ],
      [
        -142.38246154785156,
        -2213.484130859375,
        819.0641479492188
      ],
      [
        -166.52584838867188,
        -2219.5,
        818.7000122070312
      ],
      [
        -127.32233428955078,
        -2211.562744140625,
        825.0
      ],
      [
        -126.84452056884766,
        -2211.640625,
        826.3348999023438
      ],
      [
        -122.97138977050781,
        -2213.58837890625,
        836.5
      ],
      [
        -114.96051025390625,
        -2211.697021484375,
        836.9834594726562
      ],
      [
        -117.47943115234375,
        -2210.52978515625,
        830.7184448242188
      ],
      [
        -121.76891326904297,
        -2209.897216796875,
        819.28125
      ],
      [
        -122.89964294433594,
        -2214.002685546875,
        838.0
      ],
      [
        -124.02631378173828,
        -2219.0439453125,
        854.5
      ],
      [
        -122.97138977050781,
        -2213.58837890625,
        836.5
      ],
      [
        -122.89964294433594,
        -2214.002685546875,
        838.0
      ],
      [
        -124.02632141113281,
        -2219.0439453125,
        854.5
      ],
      [
        -125.82259368896484,
        -2220.219970703125,
        857.0
      ],
      [
        -125.63127899169922,
        -2221.324462890625,
        861.0
      ],
      [
        -125.82259368896484,
        -2220.219970703125,
        857.0
      ],
      [
        -221.0,
        -2498.5,
        777.8729858398438
      ],
      [
        -217.0,
        -2498.5,
        777.8729858398438
      ],
      [
        -201.0,
        -2498.5,
        777.8729858398438
      ],
      [
        -197.0,
        -2498.5,
        777.8729858398438
      ],
      [
        -75.29743194580078,
        -2177.437255859375,
        618.4127807617188
      ],
      [
        -75.300048828125,
        -2181.199951171875,
        649.4935302734375
      ],
      [
        70.9651870727539,
        -2195.40283203125,
        943.988525390625
      ],
      [
        -133.9772491455078,
        -2165.45849609375,
        659.8342895507812
      ],
      [
        -131.2391357421875,
        -2167.624267578125,
        669.7568359375
      ],
      [
        -93.0119857788086,
        -2197.859130859375,
        808.2794189453125
      ],
      [
        -87.60076904296875,
        -2202.13916015625,
        827.887939453125
      ],
      [
        -131.2391357421875,
        -2167.624267578125,
        669.7568359375
      ],
      [
        -93.0119857788086,
        -2197.859130859375,
        808.2793579101562
      ],
      [
        -87.60076904296875,
        -2202.13916015625,
        827.887939453125
      ],
      [
        -82.2734375,
        -2206.352783203125,
        847.1928100585938
      ],
      [
        -105.28507232666016,
        -2159.63916015625,
        618.412841796875
      ],
      [
        -105.28974151611328,
        -2166.36376953125,
        652.7044067382812
      ],
      [
        -75.2867431640625,
        -2162.047607421875,
        618.412841796875
      ],
      [
        -75.29141235351562,
        -2168.772216796875,
        652.7044067382812
      ],
      [
        -99.88549041748047,
        -2167.778076171875,
        657.7044067382812
      ],
      [
        -99.88970184326172,
        -2171.7001953125,
        677.7044067382812
      ],
      [
        -80.6963882446289,
        -2169.31884765625,
        657.7044067382812
      ],
      [
        -80.69756317138672,
        -2173.240966796875,
        677.7044067382812
      ],
      [
        -80.69756317138672,
        -2173.240966796875,
        677.7044067382812
      ],
      [
        -99.88970184326172,
        -2171.7001953125,
        677.7044067382812
      ],
      [
        -86.70694732666016,
        -2181.0,
        664.7044067382812
      ],
      [
        -86.70694732666016,
        -2181.0,
        665.7044067382812
      ],
      [
        -86.70694732666016,
        -2181.0,
        659.7044067382812
      ],
      [
        -86.70694732666016,
        -2181.0,
        656.5999755859375
      ],
      [
        -86.70694732666016,
        -2181.0,
        659.7044067382812
      ],
      [
        -86.70694732666016,
        -2181.0,
        664.7044067382812
      ],
      [
        -86.70694732666016,
        -2181.0,
        665.7044067382812
      ],
      [
        -86.70694732666016,
        -2181.0,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        665.7044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        665.7044067382812
      ],
      [
        -86.70694732666016,
        -2181.0,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        675.2044067382812
      ],
      [
        -83.85347747802734,
        -2178.146484375,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        656.5999755859375
      ],
      [
        -86.70694732666016,
        -2181.0,
        656.5999755859375
      ],
      [
        -85.70693969726562,
        -2180.0,
        656.5999755859375
      ],
      [
        -85.70693969726562,
        -2180.0,
        654.5999755859375
      ],
      [
        -85.70693969726562,
        -2180.0,
        656.5999755859375
      ],
      [
        -93.29309844970703,
        -2181.0,
        664.7044067382812
      ],
      [
        -93.29309844970703,
        -2181.0,
        665.7044067382812
      ],
      [
        -93.29309844970703,
        -2181.0,
        659.7044067382812
      ],
      [
        -93.29309844970703,
        -2181.0,
        656.5999755859375
      ],
      [
        -93.29309844970703,
        -2181.0,
        659.7044067382812
      ],
      [
        -93.29309844970703,
        -2181.0,
        664.7044067382812
      ],
      [
        -93.29309844970703,
        -2181.0,
        665.7044067382812
      ],
      [
        -93.29309844970703,
        -2181.0,
        675.2044067382812
      ],
      [
        -98.89990234375,
        -2180.89990234375,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2180.89990234375,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2180.89990234375,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2180.89990234375,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2180.89990234375,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2180.89990234375,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2180.89990234375,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2180.89990234375,
        675.2044067382812
      ],
      [
        -93.29309844970703,
        -2181.0,
        675.2044067382812
      ],
      [
        -96.14655303955078,
        -2178.146484375,
        675.2044067382812
      ],
      [
        -98.89990234375,
        -2180.89990234375,
        675.2044067382812
      ],
      [
        -98.89990234375,
        -2180.89990234375,
        656.5999755859375
      ],
      [
        -93.29309844970703,
        -2181.0,
        656.5999755859375
      ],
      [
        -94.29289245605469,
        -2180.0,
        656.5999755859375
      ],
      [
        -94.29289245605469,
        -2180.0,
        654.5999755859375
      ],
      [
        -94.29289245605469,
        -2180.0,
        656.5999755859375
      ],
      [
        -89.995849609375,
        -2172.004150390625,
        675.2044067382812
      ],
      [
        -90.0035171508789,
        -2172.00341796875,
        675.2044067382812
      ],
      [
        -91.199951171875,
        -2173.199951171875,
        674.4000244140625
      ],
      [
        -89.199951171875,
        -2172.800048828125,
        674.4000244140625
      ],
      [
        -90.0000228881836,
        -2172.0,
        674.4000244140625
      ],
      [
        -88.39990234375,
        -2173.599853515625,
        675.2000122070312
      ],
      [
        -89.199951171875,
        -2172.800048828125,
        674.4000244140625
      ],
      [
        -91.199951171875,
        -2173.199951171875,
        674.4000244140625
      ],
      [
        -92.0,
        -2174.0,
        675.2000122070312
      ],
      [
        -89.99996948242188,
        -2172.0,
        656.5999755859375
      ],
      [
        -89.4998779296875,
        -2172.5,
        656.5999755859375
      ],
      [
        -90.49994659423828,
        -2172.5,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2169.22998046875,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2169.42626953125,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2168.60009765625,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2168.60009765625,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2168.60009765625,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2169.230224609375,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2168.60009765625,
        661.4922485351562
      ],
      [
        -98.89990234375,
        -2169.42626953125,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2171.288818359375,
        675.202392578125
      ],
      [
        -95.9760513305664,
        -2171.52392578125,
        675.2044067382812
      ],
      [
        -98.89990234375,
        -2171.289306640625,
        675.2044067382812
      ],
      [
        -92.75004577636719,
        -2174.75,
        675.2044067382812
      ],
      [
        -96.00017547607422,
        -2171.5,
        656.5999755859375
      ],
      [
        -96.00017547607422,
        -2171.5,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2168.60009765625,
        656.5999755859375
      ],
      [
        -90.50006103515625,
        -2171.5,
        656.5999755859375
      ],
      [
        -90.50006103515625,
        -2171.5,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2167.640869140625,
        656.5999755859375
      ],
      [
        -93.96281433105469,
        -2168.037109375,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2167.640869140625,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2168.24951171875,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2168.24951171875,
        659.7044067382812
      ],
      [
        -91.199951171875,
        -2171.749755859375,
        674.4000244140625
      ],
      [
        -92.0,
        -2171.84228515625,
        675.2000122070312
      ],
      [
        -91.199951171875,
        -2171.749755859375,
        674.4000244140625
      ],
      [
        -90.16738891601562,
        -2171.83251953125,
        674.4000244140625
      ],
      [
        -81.60009765625,
        -2170.815185546875,
        665.7044067382812
      ],
      [
        -81.60009765625,
        -2170.618896484375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2169.638427734375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2169.10009765625,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2169.10009765625,
        656.9591064453125
      ],
      [
        -81.60009765625,
        -2170.618896484375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2169.638427734375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2172.67822265625,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2170.815185546875,
        665.7044067382812
      ],
      [
        -81.60009765625,
        -2172.67822265625,
        675.2044067382812
      ],
      [
        -84.91234588623047,
        -2172.412353515625,
        675.2044067382812
      ],
      [
        -87.25003051757812,
        -2174.75,
        675.2044067382812
      ],
      [
        -84.00005340576172,
        -2171.5,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2169.10009765625,
        656.5999755859375
      ],
      [
        -84.00005340576172,
        -2171.5,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2169.029541015625,
        656.5999755859375
      ],
      [
        -88.39990234375,
        -2172.13134765625,
        675.2000122070312
      ],
      [
        -89.199951171875,
        -2171.91015625,
        674.4000244140625
      ],
      [
        -89.199951171875,
        -2171.91015625,
        674.4000244140625
      ],
      [
        -81.60009765625,
        -2169.029541015625,
        656.5999755859375
      ],
      [
        -80.6963882446289,
        -2169.31884765625,
        657.7044067382812
      ],
      [
        -77.42858123779297,
        -2168.98779296875,
        654.6787109375
      ],
      [
        -77.42858123779297,
        -2168.98779296875,
        654.6787109375
      ],
      [
        -75.29141235351562,
        -2168.772216796875,
        652.7044067382812
      ],
      [
        -102.34596252441406,
        -2167.134765625,
        655.4305419921875
      ],
      [
        -105.28974151611328,
        -2166.36376953125,
        652.7044067382812
      ],
      [
        -99.88549041748047,
        -2167.778076171875,
        657.7044067382812
      ],
      [
        -102.34596252441406,
        -2167.134765625,
        655.4305419921875
      ],
      [
        -105.29047393798828,
        -2167.41015625,
        658.0420532226562
      ],
      [
        -134.82742309570312,
        -2164.786376953125,
        656.7542724609375
      ],
      [
        -134.7414093017578,
        -2164.91015625,
        657.2598876953125
      ],
      [
        -122.04180908203125,
        -2208.415771484375,
        819.3709106445312
      ],
      [
        -122.04180908203125,
        -2208.415771484375,
        819.3709106445312
      ],
      [
        -127.35315704345703,
        -2211.384765625,
        825.0
      ],
      [
        -134.7414093017578,
        -2164.91015625,
        657.2598876953125
      ],
      [
        -133.9772491455078,
        -2165.45849609375,
        659.8342895507812
      ],
      [
        -134.82754516601562,
        -2164.786376953125,
        656.7543334960938
      ],
      [
        -84.61912536621094,
        -2144.383056640625,
        630.1279296875
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        632.3883056640625
      ],
      [
        -105.28030395507812,
        -2152.779052734375,
        641.0848388671875
      ],
      [
        -105.28959655761719,
        -2166.156005859375,
        651.6454467773438
      ],
      [
        -75.29055786132812,
        -2167.546875,
        646.456298828125
      ],
      [
        -75.278564453125,
        -2150.27197265625,
        632.818603515625
      ],
      [
        -79.01836395263672,
        -2139.58642578125,
        618.412841796875
      ],
      [
        -75.27082824707031,
        -2139.134033203125,
        618.412841796875
      ],
      [
        -75.27082824707031,
        -2139.134033203125,
        620.1395263671875
      ],
      [
        -64.5244140625,
        -2141.665771484375,
        623.77197265625
      ],
      [
        -75.278564453125,
        -2150.27197265625,
        632.818603515625
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        621.2391357421875
      ],
      [
        -70.19461059570312,
        -2138.521240234375,
        622.4784545898438
      ],
      [
        -64.5244140625,
        -2141.665771484375,
        623.77197265625
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        621.2391357421875
      ],
      [
        -108.00069427490234,
        -2146.93408203125,
        618.412841796875
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        632.3883056640625
      ],
      [
        -56.11074447631836,
        -2134.01171875,
        619.220947265625
      ],
      [
        -84.61912536621094,
        -2144.383056640625,
        630.1279296875
      ],
      [
        -64.5244140625,
        -2141.665771484375,
        625.3799438476562
      ],
      [
        -73.49462890625,
        -2148.84423828125,
        631.3179321289062
      ],
      [
        -64.5244140625,
        -2141.665771484375,
        625.3798217773438
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        623.293212890625
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        623.293212890625
      ],
      [
        -67.66808319091797,
        -2138.21630859375,
        623.642578125
      ],
      [
        -80.69099426269531,
        -2151.33544921875,
        657.7044067382812
      ],
      [
        -80.69271850585938,
        -2157.100341796875,
        677.7044067382812
      ],
      [
        -80.69271850585938,
        -2157.100341796875,
        677.7044067382812
      ],
      [
        -99.8792495727539,
        -2161.964599609375,
        677.7044067382812
      ],
      [
        -99.87306213378906,
        -2156.198486328125,
        657.7044067382812
      ],
      [
        -99.8792495727539,
        -2161.964599609375,
        677.7044067382812
      ],
      [
        -81.60009765625,
        -2151.24755859375,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2155.633544921875,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2156.610107421875,
        675.2044067382812
      ],
      [
        -98.89990234375,
        -2160.995849609375,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2153.871826171875,
        665.7044067382812
      ],
      [
        -81.60009765625,
        -2153.58349609375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2152.142333984375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2151.24755859375,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2153.58349609375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2152.142333984375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2156.60986328125,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2153.871826171875,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2157.969482421875,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2158.0,
        664.810546875
      ],
      [
        -98.89990234375,
        -2156.5283203125,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2157.969482421875,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2156.5283203125,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2155.633544921875,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2160.0,
        671.7496337890625
      ],
      [
        -98.89990234375,
        -2160.99462890625,
        675.2001953125
      ],
      [
        -98.89990234375,
        -2158.0,
        664.8107299804688
      ],
      [
        -98.50279998779297,
        -2158.0,
        665.1600341796875
      ],
      [
        -98.50279998779297,
        -2158.0,
        665.1600341796875
      ],
      [
        -94.27384948730469,
        -2158.0,
        668.8800048828125
      ],
      [
        -94.27384948730469,
        -2158.0,
        668.8800048828125
      ],
      [
        -94.0,
        -2158.0,
        669.1209106445312
      ],
      [
        -88.39990234375,
        -2158.33251953125,
        675.2000122070312
      ],
      [
        -89.199951171875,
        -2158.3046875,
        674.4000244140625
      ],
      [
        -91.199951171875,
        -2158.811767578125,
        674.4000244140625
      ],
      [
        -92.0,
        -2159.2451171875,
        675.2000122070312
      ],
      [
        -91.199951171875,
        -2158.811767578125,
        674.4000244140625
      ],
      [
        -89.199951171875,
        -2158.3046875,
        674.4000244140625
      ],
      [
        -94.0,
        -2160.0,
        669.6004028320312
      ],
      [
        -94.0,
        -2159.752197265625,
        675.2000122070312
      ],
      [
        -94.0,
        -2158.13818359375,
        669.6004028320312
      ],
      [
        -94.0,
        -2158.0,
        669.1209106445312
      ],
      [
        -105.28263092041016,
        -2156.128662109375,
        652.7044067382812
      ],
      [
        -104.25763702392578,
        -2156.142333984375,
        653.6534423828125
      ],
      [
        -105.28263092041016,
        -2156.128662109375,
        652.7044067382812
      ],
      [
        -99.87306213378906,
        -2156.198486328125,
        657.7044067382812
      ],
      [
        -104.25763702392578,
        -2156.142333984375,
        653.6534423828125
      ],
      [
        -80.520751953125,
        -2151.246826171875,
        657.5468139648438
      ],
      [
        -78.64490509033203,
        -2150.27197265625,
        655.8143920898438
      ],
      [
        -78.64490509033203,
        -2150.27197265625,
        655.8143920898438
      ],
      [
        -75.93452453613281,
        -2148.6884765625,
        652.7044067382812
      ],
      [
        -75.93452453613281,
        -2148.6884765625,
        652.7044067382812
      ],
      [
        -75.27725982666016,
        -2148.388427734375,
        652.2418212890625
      ],
      [
        -80.69099426269531,
        -2151.33544921875,
        657.7044067382812
      ],
      [
        -80.520751953125,
        -2151.246826171875,
        657.5468139648438
      ],
      [
        -69.83003997802734,
        -2145.91162109375,
        648.4400024414062
      ],
      [
        -64.5244140625,
        -2141.665771484375,
        638.37548828125
      ],
      [
        -64.5244140625,
        -2141.665771484375,
        638.37548828125
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        624.3515014648438
      ],
      [
        -69.83003997802734,
        -2145.91162109375,
        648.4400024414062
      ],
      [
        -73.14276123046875,
        -2147.414306640625,
        650.739501953125
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        624.3515014648438
      ],
      [
        -73.14276123046875,
        -2147.414306640625,
        650.739501953125
      ],
      [
        -123.37515258789062,
        -2201.177490234375,
        819.8090209960938
      ],
      [
        -186.154296875,
        -2217.491455078125,
        818.8215942382812
      ],
      [
        -187.47689819335938,
        -2219.5,
        818.7000122070312
      ],
      [
        -126.46916961669922,
        -2216.487548828125,
        861.0
      ],
      [
        -171.14173889160156,
        -2228.34375,
        861.0
      ],
      [
        -116.2279281616211,
        -2205.35986328125,
        837.0918579101562
      ],
      [
        -123.37515258789062,
        -2201.177490234375,
        819.8090209960938
      ],
      [
        -123.9848861694336,
        -2207.738037109375,
        838.0
      ],
      [
        -124.93572998046875,
        -2213.794189453125,
        854.5
      ],
      [
        -128.56640625,
        -2204.381103515625,
        825.0
      ],
      [
        -124.07225799560547,
        -2207.233642578125,
        836.5
      ],
      [
        -124.07225799560547,
        -2207.233642578125,
        836.5
      ],
      [
        -123.9848861694336,
        -2207.738037109375,
        838.0
      ],
      [
        -126.46916961669922,
        -2216.487548828125,
        861.0
      ],
      [
        -126.70217895507812,
        -2215.142578125,
        857.0
      ],
      [
        -124.93572998046875,
        -2213.794189453125,
        854.5
      ],
      [
        -126.70217895507812,
        -2215.142578125,
        857.0
      ],
      [
        -161.79112243652344,
        -2173.17431640625,
        711.2142333984375
      ],
      [
        -169.95626831054688,
        -2168.9296875,
        692.9869384765625
      ],
      [
        -137.57791137695312,
        -2185.760986328125,
        765.2659301757812
      ],
      [
        -161.79112243652344,
        -2173.17431640625,
        711.2142333984375
      ],
      [
        -169.95626831054688,
        -2168.9296875,
        692.9869384765625
      ],
      [
        -173.12741088867188,
        -2167.28125,
        685.9080810546875
      ],
      [
        -137.57791137695312,
        -2185.760986328125,
        765.2659301757812
      ],
      [
        -128.6708526611328,
        -2137.082275390625,
        633.5973510742188
      ],
      [
        -116.76280212402344,
        -2131.491943359375,
        626.689453125
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        636.0256958007812
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        639.105712890625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        632.0427856445312
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        636.0256958007812
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        624.122802734375
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.813232421875
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        625.3675537109375
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        624.122802734375
      ],
      [
        -92.5,
        -2138.245849609375,
        626.935546875
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        618.5244140625
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        625.1559448242188
      ],
      [
        -88.27063751220703,
        -2136.103759765625,
        618.5244140625
      ],
      [
        -88.0,
        -2138.245849609375,
        625.9924926757812
      ],
      [
        -88.27063751220703,
        -2136.103759765625,
        624.3584594726562
      ],
      [
        -70.19461059570312,
        -2138.521240234375,
        622.4784545898438
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        625.3675537109375
      ],
      [
        -88.47035217285156,
        -2134.52294921875,
        618.5244140625
      ],
      [
        -88.47035217285156,
        -2134.52294921875,
        623.152587890625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        632.042724609375
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.813232421875
      ],
      [
        -91.10298156738281,
        -2127.960205078125,
        618.5244140625
      ],
      [
        -89.23687744140625,
        -2128.455810546875,
        618.5244140625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        639.105712890625
      ],
      [
        -105.28030395507812,
        -2152.779052734375,
        641.0848388671875
      ],
      [
        -112.28321838378906,
        -2129.82763671875,
        625.337890625
      ],
      [
        -114.0335693359375,
        -2130.37158203125,
        625.563720703125
      ],
      [
        -86.0,
        -2121.6298828125,
        621.862548828125
      ],
      [
        -94.80000305175781,
        -2124.37451171875,
        623.026123046875
      ],
      [
        -112.28321838378906,
        -2129.82763671875,
        625.337890625
      ],
      [
        -68.79257202148438,
        -2116.2626953125,
        619.587158203125
      ],
      [
        -91.74382781982422,
        -2132.678466796875,
        622.3828125
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        622.4420776367188
      ],
      [
        -91.1823959350586,
        -2128.544677734375,
        622.4412841796875
      ],
      [
        -89.30126953125,
        -2127.946044921875,
        622.1928100585938
      ],
      [
        -88.6701889038086,
        -2132.941162109375,
        621.9459838867188
      ],
      [
        -89.24053955078125,
        -2128.4267578125,
        622.1747436523438
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        622.4420776367188
      ],
      [
        -89.30126953125,
        -2127.946044921875,
        622.1928100585938
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        622.44970703125
      ],
      [
        -89.30126953125,
        -2127.946044921875,
        622.1990966796875
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        622.4497680664062
      ],
      [
        -89.30126953125,
        -2127.946044921875,
        622.1990966796875
      ],
      [
        -128.6708526611328,
        -2137.082275390625,
        633.5973510742188
      ],
      [
        -168.78549194335938,
        -2157.221923828125,
        660.5862426757812
      ],
      [
        -175.46551513671875,
        -2159.86279296875,
        663.0540161132812
      ],
      [
        -175.2791748046875,
        -2160.482177734375,
        664.9551391601562
      ],
      [
        -175.46551513671875,
        -2159.86279296875,
        663.0540161132812
      ],
      [
        -168.78549194335938,
        -2157.221923828125,
        660.5862426757812
      ],
      [
        -114.0335693359375,
        -2130.37158203125,
        625.563720703125
      ],
      [
        -116.76280212402344,
        -2131.491943359375,
        626.689453125
      ],
      [
        -67.66808319091797,
        -2138.21630859375,
        623.642578125
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        626.367431640625
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        626.367431640625
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        625.1433715820312
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        625.1433715820312
      ],
      [
        -98.66927337646484,
        -2138.747314453125,
        628.6243896484375
      ],
      [
        -92.5,
        -2138.245849609375,
        627.3795776367188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        625.1559448242188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        625.9423828125
      ],
      [
        -88.2706298828125,
        -2136.103759765625,
        624.3584594726562
      ],
      [
        -88.0,
        -2138.245849609375,
        626.7058715820312
      ],
      [
        -88.2706298828125,
        -2136.103759765625,
        625.3753051757812
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        623.9208984375
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        624.9449462890625
      ],
      [
        -88.94564819335938,
        -2130.7607421875,
        622.0564575195312
      ],
      [
        -91.47805786132812,
        -2130.7216796875,
        622.4105224609375
      ],
      [
        70.81481170654297,
        -2194.253662109375,
        946.6399536132812
      ],
      [
        -173.12741088867188,
        -2167.28125,
        685.9080810546875
      ],
      [
        -173.39974975585938,
        -2166.727783203125,
        684.1293334960938
      ],
      [
        -173.39974975585938,
        -2166.727783203125,
        684.1293334960938
      ],
      [
        -97.39110565185547,
        -2144.29541015625,
        677.7044067382812
      ],
      [
        -87.74190521240234,
        -2141.734619140625,
        677.7044067382812
      ],
      [
        -80.68736267089844,
        -2139.244873046875,
        652.7044067382812
      ],
      [
        -80.68736267089844,
        -2139.244873046875,
        626.250244140625
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        652.7044067382812
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        629.2604370117188
      ],
      [
        -80.690673828125,
        -2150.27197265625,
        675.2044067382812
      ],
      [
        -83.4990234375,
        -2143.4921875,
        675.2044067382812
      ],
      [
        -97.058349609375,
        -2143.4921875,
        675.2044067382812
      ],
      [
        -97.058349609375,
        -2143.4921875,
        675.6716918945312
      ],
      [
        -97.39110565185547,
        -2144.29541015625,
        677.7044067382812
      ],
      [
        -99.86669921875,
        -2150.27197265625,
        675.2044067382812
      ],
      [
        -83.4990234375,
        -2143.4921875,
        675.2044067382812
      ],
      [
        -87.74190521240234,
        -2141.734619140625,
        677.7044067382812
      ],
      [
        -89.03577423095703,
        -2141.19873046875,
        675.2044067382812
      ],
      [
        -95.95394134521484,
        -2143.03466796875,
        675.2044067382812
      ],
      [
        -97.058349609375,
        -2143.4921875,
        675.6716918945312
      ],
      [
        -97.058349609375,
        -2143.4921875,
        675.2044067382812
      ],
      [
        -80.68779754638672,
        -2140.680908203125,
        654.0314331054688
      ],
      [
        -82.6537094116211,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -90.278564453125,
        -2139.488525390625,
        656.5999755859375
      ],
      [
        -80.68736267089844,
        -2139.244873046875,
        652.7044067382812
      ],
      [
        -88.27061462402344,
        -2136.103759765625,
        645.4983520507812
      ],
      [
        -88.2706069946289,
        -2136.103759765625,
        641.2166748046875
      ],
      [
        -88.27063751220703,
        -2136.103759765625,
        648.5706787109375
      ],
      [
        -88.27061462402344,
        -2136.103759765625,
        645.4983520507812
      ],
      [
        -88.2706069946289,
        -2136.103759765625,
        641.2166748046875
      ],
      [
        -88.2706298828125,
        -2136.103759765625,
        636.5319213867188
      ],
      [
        -88.27063751220703,
        -2136.103759765625,
        651.2399291992188
      ],
      [
        -88.27063751220703,
        -2136.103759765625,
        648.5706787109375
      ],
      [
        -88.2706298828125,
        -2136.103759765625,
        636.5319213867188
      ],
      [
        -88.2706298828125,
        -2136.103759765625,
        625.3753051757812
      ],
      [
        -90.278564453125,
        -2139.488525390625,
        656.5999755859375
      ],
      [
        -97.9036636352539,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -99.8564224243164,
        -2140.694091796875,
        654.0486450195312
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        652.7044067382812
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        645.4983520507812
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        641.2166748046875
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        648.5706787109375
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        645.4983520507812
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        641.2166748046875
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        636.5319213867188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        651.2399291992188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        648.5706787109375
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        636.5319213867188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        625.9423828125
      ],
      [
        -88.27063751220703,
        -2136.103759765625,
        651.2399291992188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        651.2399291992188
      ],
      [
        -90.27867126464844,
        -2135.27197265625,
        651.2399291992188
      ],
      [
        -99.8564224243164,
        -2140.694091796875,
        654.0486450195312
      ],
      [
        -97.9036636352539,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -99.86359405517578,
        -2147.37841796875,
        656.5999755859375
      ],
      [
        -82.6537094116211,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -80.68779754638672,
        -2140.680908203125,
        654.0314331054688
      ],
      [
        -80.68981170654297,
        -2147.387939453125,
        656.5999755859375
      ],
      [
        -90.278564453125,
        -2140.683837890625,
        672.8031005859375
      ],
      [
        -90.278564453125,
        -2140.683837890625,
        672.8031005859375
      ],
      [
        -81.60009765625,
        -2153.611328125,
        664.8008422851562
      ],
      [
        -81.60009765625,
        -2150.65478515625,
        664.8008422851562
      ],
      [
        -84.69074249267578,
        -2142.99853515625,
        659.7044067382812
      ],
      [
        -91.48558807373047,
        -2141.183837890625,
        659.7044067382812
      ],
      [
        -97.55834197998047,
        -2144.69921875,
        659.7044067382812
      ],
      [
        -88.83570098876953,
        -2140.086181640625,
        656.5999755859375
      ],
      [
        -84.09674835205078,
        -2142.04931640625,
        656.5999755859375
      ],
      [
        -96.46065521240234,
        -2142.04931640625,
        656.5999755859375
      ],
      [
        -91.99928283691406,
        -2134.559326171875,
        645.4983520507812
      ],
      [
        -91.99927520751953,
        -2134.559326171875,
        641.2166748046875
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        648.5706787109375
      ],
      [
        -91.99928283691406,
        -2134.559326171875,
        645.4983520507812
      ],
      [
        -91.99927520751953,
        -2134.559326171875,
        641.2166748046875
      ],
      [
        -91.99929809570312,
        -2134.559326171875,
        636.5319213867188
      ],
      [
        -91.99929809570312,
        -2134.559326171875,
        651.2399291992188
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        648.5706787109375
      ],
      [
        -91.99929809570312,
        -2134.559326171875,
        636.5319213867188
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        624.9449462890625
      ],
      [
        -91.99929809570312,
        -2134.559326171875,
        651.2399291992188
      ],
      [
        -88.94988250732422,
        -2130.726806640625,
        645.4983520507812
      ],
      [
        -89.0361328125,
        -2130.0439453125,
        643.4923095703125
      ],
      [
        -88.81785583496094,
        -2131.7724609375,
        648.5706787109375
      ],
      [
        -88.94988250732422,
        -2130.726806640625,
        645.4983520507812
      ],
      [
        -88.70307922363281,
        -2132.680908203125,
        651.2399291992188
      ],
      [
        -88.81785583496094,
        -2131.7724609375,
        648.5706787109375
      ],
      [
        -91.57328796386719,
        -2131.4228515625,
        645.4983520507812
      ],
      [
        -91.385986328125,
        -2130.0439453125,
        641.719482421875
      ],
      [
        -91.72557067871094,
        -2132.5439453125,
        648.5706787109375
      ],
      [
        -91.57328796386719,
        -2131.4228515625,
        645.4983520507812
      ],
      [
        -91.12891387939453,
        -2128.15087890625,
        636.5319213867188
      ],
      [
        -91.25139617919922,
        -2129.052978515625,
        639.003662109375
      ],
      [
        -91.85787200927734,
        -2133.51806640625,
        651.2399291992188
      ],
      [
        -91.72557067871094,
        -2132.5439453125,
        648.5706787109375
      ],
      [
        -91.12891387939453,
        -2128.15087890625,
        636.5319213867188
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        635.9702758789062
      ],
      [
        -90.35652160644531,
        -2127.946044921875,
        636.5319213867188
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        635.9702758789062
      ],
      [
        -88.70307922363281,
        -2132.680908203125,
        651.2399291992188
      ],
      [
        -91.85787200927734,
        -2133.51806640625,
        651.2399291992188
      ],
      [
        -91.25139617919922,
        -2129.052978515625,
        639.003662109375
      ],
      [
        -90.35652160644531,
        -2127.946044921875,
        636.5319213867188
      ],
      [
        -91.385986328125,
        -2130.0439453125,
        641.719482421875
      ],
      [
        -89.0361328125,
        -2130.0439453125,
        643.4923095703125
      ],
      [
        -64.5244140625,
        -2141.665771484375,
        644.228759765625
      ],
      [
        -69.80320739746094,
        -2145.89013671875,
        648.3890991210938
      ],
      [
        -80.68758392333984,
        -2139.978515625,
        653.3822631835938
      ],
      [
        -80.68753051757812,
        -2139.787841796875,
        653.2061157226562
      ],
      [
        -108.05611419677734,
        -2142.635498046875,
        644.2874145507812
      ],
      [
        -108.05611419677734,
        -2142.635498046875,
        644.2874145507812
      ],
      [
        -108.05611419677734,
        -2142.635498046875,
        633.6602783203125
      ],
      [
        -100.45149993896484,
        -2156.191162109375,
        657.1699829101562
      ],
      [
        -170.35757446289062,
        -2193.500732421875,
        820.2736206054688
      ],
      [
        -187.56570434570312,
        -2183.116943359375,
        774.4188842773438
      ],
      [
        -187.56570434570312,
        -2183.116943359375,
        774.4188842773438
      ],
      [
        -198.01239013671875,
        -2176.813232421875,
        746.581298828125
      ],
      [
        -154.5896759033203,
        -2206.3720703125,
        866.360107421875
      ],
      [
        -124.04479217529297,
        -2197.542236328125,
        820.029052734375
      ],
      [
        -170.35748291015625,
        -2193.50048828125,
        820.273681640625
      ],
      [
        -128.44638061523438,
        -2205.073974609375,
        861.0
      ],
      [
        -148.33340454101562,
        -2203.318115234375,
        861.0
      ],
      [
        -155.38943481445312,
        -2203.226318359375,
        861.0
      ],
      [
        -117.0048828125,
        -2201.47509765625,
        837.1583251953125
      ],
      [
        -124.04479217529297,
        -2197.542236328125,
        820.029052734375
      ],
      [
        -125.16646575927734,
        -2200.917236328125,
        838.0
      ],
      [
        -126.63636779785156,
        -2203.977294921875,
        854.5
      ],
      [
        -129.67071533203125,
        -2198.00634765625,
        825.0
      ],
      [
        -125.21746063232422,
        -2200.622802734375,
        836.5
      ],
      [
        -128.44638061523438,
        -2205.073974609375,
        861.0
      ],
      [
        -128.58242797851562,
        -2204.28857421875,
        857.0
      ],
      [
        -126.63636779785156,
        -2203.977294921875,
        854.5
      ],
      [
        -128.58242797851562,
        -2204.28857421875,
        857.0
      ],
      [
        -125.21746063232422,
        -2200.622802734375,
        836.5
      ],
      [
        -125.16646575927734,
        -2200.917236328125,
        838.0
      ],
      [
        -155.07394409179688,
        -2202.72314453125,
        861.0
      ],
      [
        -189.81390380859375,
        -2073.826904296875,
        637.5733642578125
      ],
      [
        -200.71852111816406,
        -2092.188232421875,
        638.75390625
      ],
      [
        -95.74341583251953,
        -2077.244873046875,
        624.0260620117188
      ],
      [
        -109.34033203125,
        -2064.5546875,
        626.2376098632812
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.8348999023438
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.909423828125
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.8348999023438
      ],
      [
        -109.34033203125,
        -2064.5546875,
        626.2376098632812
      ],
      [
        -106.7118911743164,
        -2061.33154296875,
        625.9280395507812
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.909423828125
      ],
      [
        -100.50362396240234,
        -2070.338623046875,
        624.8515014648438
      ],
      [
        -94.69828033447266,
        -2078.76123046875,
        623.8447875976562
      ],
      [
        -200.71853637695312,
        -2092.188232421875,
        638.75390625
      ],
      [
        -207.16590881347656,
        -2114.41748046875,
        653.239990234375
      ],
      [
        -219.81341552734375,
        -2146.833740234375,
        668.0908813476562
      ],
      [
        -207.16590881347656,
        -2114.41748046875,
        653.239990234375
      ],
      [
        -219.81341552734375,
        -2146.833740234375,
        668.0908813476562
      ],
      [
        -175.2791748046875,
        -2160.482177734375,
        664.9551391601562
      ],
      [
        -217.5003204345703,
        -2150.048095703125,
        676.4593505859375
      ],
      [
        -199.50973510742188,
        -2175.04833984375,
        741.5471801757812
      ],
      [
        -172.86422729492188,
        -2046.8643798828125,
        637.6512451171875
      ],
      [
        -189.81390380859375,
        -2073.826904296875,
        637.5733642578125
      ],
      [
        -94.57088470458984,
        -2078.942626953125,
        623.832275390625
      ],
      [
        -95.7535171508789,
        -2077.1845703125,
        624.1563110351562
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        625.5057373046875
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        626.487548828125
      ],
      [
        -109.34033203125,
        -2064.5546875,
        627.1937866210938
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        626.487548828125
      ],
      [
        -109.34033203125,
        -2064.5546875,
        627.1937866210938
      ],
      [
        -106.551025390625,
        -2061.13427734375,
        627.1146240234375
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        625.5057373046875
      ],
      [
        -100.30313873291016,
        -2070.421630859375,
        625.40283203125
      ],
      [
        -172.86422729492188,
        -2046.8643798828125,
        637.6512451171875
      ],
      [
        -150.82333374023438,
        -2029.1021728515625,
        658.7252807617188
      ],
      [
        -94.29871368408203,
        -2079.330322265625,
        623.8054809570312
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        642.6431884765625
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.447021484375
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.447021484375
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        634.208984375
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        632.651123046875
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        634.208984375
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        632.651123046875
      ],
      [
        -98.12611389160156,
        -2071.3232421875,
        631.3896484375
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        642.6431884765625
      ],
      [
        -104.56550598144531,
        -2057.8525390625,
        644.1493530273438
      ],
      [
        -86.9010009765625,
        -2090.027587890625,
        622.622314453125
      ],
      [
        -94.80000305175781,
        -2086.306884765625,
        623.7910766601562
      ],
      [
        -86.9012451171875,
        -2090.02734375,
        622.622314453125
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        644.1884765625
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.8286743164062
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        636.1566772460938
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        635.5226440429688
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.8286743164062
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        635.5226440429688
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        636.1566772460938
      ],
      [
        -96.54846954345703,
        -2071.976806640625,
        635.7281494140625
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        644.1884765625
      ],
      [
        -104.36114501953125,
        -2057.359130859375,
        646.3414306640625
      ],
      [
        -198.01239013671875,
        -2176.813232421875,
        746.581298828125
      ],
      [
        -199.50973510742188,
        -2175.04833984375,
        741.5471801757812
      ],
      [
        -114.05365753173828,
        -2130.3798828125,
        625.572021484375
      ],
      [
        -162.45565795898438,
        -2181.5,
        821.0
      ],
      [
        -166.02816772460938,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -166.02816772460938,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -160.38650512695312,
        -2181.5,
        825.0
      ],
      [
        -162.45565795898438,
        -2181.5,
        821.0
      ],
      [
        -139.69480895996094,
        -2181.5,
        865.0
      ],
      [
        -143.8331298828125,
        -2181.5,
        857.0
      ],
      [
        -145.49356079101562,
        -2187.44677734375,
        861.0
      ],
      [
        -130.71417236328125,
        -2181.5,
        856.0177001953125
      ],
      [
        -127.5,
        -2186.3974609375,
        836.5
      ],
      [
        -128.129150390625,
        -2181.5,
        834.691162109375
      ],
      [
        -127.5,
        -2186.3974609375,
        836.5
      ],
      [
        -132.53016662597656,
        -2181.5,
        857.0
      ],
      [
        -127.5,
        -2186.668701171875,
        836.8875732421875
      ],
      [
        -147.5626983642578,
        -2187.44677734375,
        857.0
      ],
      [
        -143.8331298828125,
        -2181.5,
        857.0
      ],
      [
        -140.26210021972656,
        -2179.60009765625,
        861.5999755859375
      ],
      [
        -142.79855346679688,
        -2181.5,
        859.0
      ],
      [
        -139.53794860839844,
        -2179.60009765625,
        863.0
      ],
      [
        -140.26210021972656,
        -2179.60009765625,
        861.5999755859375
      ],
      [
        -135.78326416015625,
        -2019.826904296875,
        676.5550537109375
      ],
      [
        -150.82333374023438,
        -2029.1021728515625,
        658.7252807617188
      ],
      [
        -135.78326416015625,
        -2019.826904296875,
        676.5550537109375
      ],
      [
        -127.98283386230469,
        -2011.8914794921875,
        682.013671875
      ],
      [
        -91.81829071044922,
        -2071.843505859375,
        654.6378784179688
      ],
      [
        -102.93746948242188,
        -2056.703369140625,
        653.768798828125
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        647.6743774414062
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        648.5706787109375
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        648.5706787109375
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        651.2399291992188
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        651.2399291992188
      ],
      [
        -90.90784454345703,
        -2074.313232421875,
        651.2399291992188
      ],
      [
        -194.8511962890625,
        -1920.0,
        765.0
      ],
      [
        -170.0,
        -1929.899169921875,
        765.0
      ],
      [
        -170.0,
        -1929.899169921875,
        770.0
      ],
      [
        -170.0,
        -1929.899169921875,
        765.0
      ],
      [
        -184.0,
        -1924.322509765625,
        765.0
      ],
      [
        -184.0,
        -1924.322509765625,
        754.0
      ],
      [
        -194.8513946533203,
        -1920.0,
        754.0
      ],
      [
        -184.0,
        -1924.322509765625,
        754.0
      ],
      [
        -291.9776916503906,
        -2125.632568359375,
        676.287109375
      ],
      [
        -253.38365173339844,
        -2170.007080078125,
        784.3949584960938
      ],
      [
        -166.49237060546875,
        -2220.929931640625,
        861.0
      ],
      [
        -219.77322387695312,
        -2203.49951171875,
        861.0
      ],
      [
        -261.32635498046875,
        -2213.743408203125,
        861.0
      ],
      [
        -268.4875793457031,
        -2216.238037109375,
        861.0
      ],
      [
        -272.43353271484375,
        -2219.5,
        864.529296875
      ],
      [
        -277.624755859375,
        -2219.5,
        861.1482543945312
      ],
      [
        -277.6429138183594,
        -2219.5,
        861.0
      ],
      [
        -277.6274108886719,
        -2219.421630859375,
        861.0
      ],
      [
        -368.4404602050781,
        -2147.481689453125,
        665.0
      ],
      [
        -369.74945068359375,
        -2147.07373046875,
        663.162353515625
      ],
      [
        -253.42080688476562,
        -2189.343017578125,
        820.5253295898438
      ],
      [
        -270.5449523925781,
        -2195.120849609375,
        820.1755981445312
      ],
      [
        -237.07595825195312,
        -2219.5,
        818.7000122070312
      ],
      [
        -270.3288269042969,
        -2203.7763671875,
        836.5
      ],
      [
        -264.9380798339844,
        -2195.748291015625,
        825.0
      ],
      [
        -270.5449523925781,
        -2195.120849609375,
        820.1755981445312
      ],
      [
        -278.0543212890625,
        -2206.77099609375,
        837.0676879882812
      ],
      [
        -278.6665954589844,
        -2219.5,
        852.6400146484375
      ],
      [
        -278.0543212890625,
        -2206.77099609375,
        837.0676879882812
      ],
      [
        -277.7808532714844,
        -2214.874267578125,
        852.3973999023438
      ],
      [
        -269.97509765625,
        -2213.27978515625,
        854.5
      ],
      [
        -270.47674560546875,
        -2204.630126953125,
        838.0
      ],
      [
        -270.47674560546875,
        -2204.630126953125,
        838.0
      ],
      [
        -270.328857421875,
        -2203.7763671875,
        836.5
      ],
      [
        -268.0931396484375,
        -2213.961181640625,
        857.0
      ],
      [
        -269.97509765625,
        -2213.27978515625,
        854.5
      ],
      [
        -268.4875793457031,
        -2216.238037109375,
        861.0
      ],
      [
        -268.0931396484375,
        -2213.961181640625,
        857.0
      ],
      [
        -390.7622375488281,
        -2160.501220703125,
        667.9999389648438
      ],
      [
        -398.7380676269531,
        -2148.240966796875,
        639.9999389648438
      ],
      [
        -360.2727966308594,
        -2158.593017578125,
        667.9999389648438
      ],
      [
        -390.7622985839844,
        -2160.5009765625,
        667.9999389648438
      ],
      [
        -366.303466796875,
        -2148.1474609375,
        667.9999389648438
      ],
      [
        -324.62567138671875,
        -2118.133056640625,
        641.0
      ],
      [
        -324.95721435546875,
        -2117.713623046875,
        639.9999389648438
      ],
      [
        -314.135009765625,
        -2131.402587890625,
        641.0
      ],
      [
        -378.9644775390625,
        -2138.253662109375,
        640.0
      ],
      [
        -377.17633056640625,
        -2137.3505859375,
        640.0
      ],
      [
        -366.3355712890625,
        -2132.12744140625,
        640.0
      ],
      [
        -368.2364196777344,
        -2132.835205078125,
        640.0
      ],
      [
        -367.9453430175781,
        -2132.688232421875,
        640.0
      ],
      [
        -377.17633056640625,
        -2137.3505859375,
        640.0
      ],
      [
        -368.2364196777344,
        -2132.835205078125,
        640.0
      ],
      [
        -312.0,
        -2234.0,
        640.0
      ],
      [
        -312.0,
        -2237.0,
        640.0
      ],
      [
        -310.0,
        -2234.0,
        640.0
      ],
      [
        -312.0,
        -2234.0,
        640.0
      ],
      [
        -378.7044372558594,
        -2138.7041015625,
        641.0
      ],
      [
        -378.9644775390625,
        -2138.253662109375,
        640.0
      ],
      [
        -374.341552734375,
        -2146.2607421875,
        641.0
      ],
      [
        -362.217041015625,
        -2139.2607421875,
        641.0
      ],
      [
        -366.3355712890625,
        -2132.12744140625,
        640.0
      ],
      [
        -366.0784912109375,
        -2132.57275390625,
        641.0
      ],
      [
        -371.609375,
        -2146.992919921875,
        641.0
      ],
      [
        -369.87750244140625,
        -2145.992919921875,
        641.0
      ],
      [
        -362.94921875,
        -2141.992919921875,
        641.0
      ],
      [
        -364.8468017578125,
        -2143.08837890625,
        641.0
      ],
      [
        -312.0,
        -2234.0,
        641.0
      ],
      [
        -312.0,
        -2237.0,
        641.0
      ],
      [
        -310.0,
        -2234.0,
        641.0
      ],
      [
        -312.0,
        -2234.0,
        641.0
      ],
      [
        -371.609375,
        -2146.992919921875,
        641.0
      ],
      [
        -374.341552734375,
        -2146.2607421875,
        641.0
      ],
      [
        -362.217041015625,
        -2139.2607421875,
        641.0
      ],
      [
        -362.94921875,
        -2141.992919921875,
        641.0
      ],
      [
        -240.39039611816406,
        -2184.946533203125,
        820.7913818359375
      ],
      [
        -246.2559814453125,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -234.23330688476562,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -234.2333221435547,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -246.25599670410156,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -177.9420166015625,
        -2205.019287109375,
        819.5764770507812
      ],
      [
        -253.38365173339844,
        -2170.007080078125,
        784.3949584960938
      ],
      [
        -240.8127899169922,
        -2185.0888671875,
        820.7827758789062
      ],
      [
        -364.05999755859375,
        -2145.26904296875,
        665.0
      ],
      [
        -363.5448913574219,
        -2143.491455078125,
        662.3916015625
      ],
      [
        -315.6745910644531,
        -2129.455078125,
        667.9999389648438
      ],
      [
        -314.34857177734375,
        -2131.132568359375,
        671.9999389648438
      ],
      [
        -315.6745910644531,
        -2129.455078125,
        667.9999389648438
      ],
      [
        -337.492919921875,
        -2137.055419921875,
        667.9999389648438
      ],
      [
        -337.9971923828125,
        -2137.23095703125,
        667.9999389648438
      ],
      [
        -358.62103271484375,
        -2157.760009765625,
        667.9999389648438
      ],
      [
        -364.6523742675781,
        -2147.3134765625,
        667.9999389648438
      ],
      [
        -359.56414794921875,
        -2144.74365234375,
        667.9999389648438
      ],
      [
        -337.9971923828125,
        -2137.23095703125,
        667.9999389648438
      ],
      [
        -323.86419677734375,
        -2125.89013671875,
        656.0
      ],
      [
        -326.04931640625,
        -2122.10546875,
        647.5
      ],
      [
        -330.28045654296875,
        -2122.777099609375,
        646.0
      ],
      [
        -328.35760498046875,
        -2122.107177734375,
        646.0
      ],
      [
        -320.6269226074219,
        -2139.497314453125,
        646.0
      ],
      [
        -319.760986328125,
        -2138.997314453125,
        646.0
      ],
      [
        -318.760986328125,
        -2140.7294921875,
        646.0
      ],
      [
        -318.760986328125,
        -2140.7294921875,
        646.0
      ],
      [
        -319.626953125,
        -2141.2294921875,
        646.0
      ],
      [
        -328.35760498046875,
        -2122.107177734375,
        646.0
      ],
      [
        -326.04931640625,
        -2122.10546875,
        647.5
      ],
      [
        -325.27276611328125,
        -2127.450439453125,
        658.0
      ],
      [
        -323.86419677734375,
        -2125.89013671875,
        656.0
      ],
      [
        -315.1533203125,
        -2170.978271484375,
        648.0004272460938
      ],
      [
        -305.626953125,
        -2165.478271484375,
        647.999755859375
      ],
      [
        -330.602294921875,
        -2179.897705078125,
        642.21435546875
      ],
      [
        -335.6023254394531,
        -2171.2373046875,
        642.21435546875
      ],
      [
        -330.95050048828125,
        -2180.0986328125,
        643.0
      ],
      [
        -330.602294921875,
        -2179.897705078125,
        642.21435546875
      ],
      [
        -331.3936767578125,
        -2180.3544921875,
        643.9999389648438
      ],
      [
        -327.710693359375,
        -2178.228271484375,
        643.9999389648438
      ],
      [
        -315.1533203125,
        -2170.978271484375,
        643.9999389648438
      ],
      [
        -305.626953125,
        -2165.478271484375,
        643.9999389648438
      ],
      [
        -342.778076171875,
        -2127.13037109375,
        646.0
      ],
      [
        -332.28009033203125,
        -2180.866455078125,
        646.0
      ],
      [
        -327.710693359375,
        -2178.228271484375,
        646.0
      ],
      [
        -315.1533203125,
        -2170.978271484375,
        646.0
      ],
      [
        -305.626953125,
        -2165.478271484375,
        646.0
      ],
      [
        -314.19110107421875,
        -2158.64013671875,
        646.0
      ],
      [
        -314.591064453125,
        -2157.96142578125,
        646.0
      ],
      [
        -314.591064453125,
        -2157.96142578125,
        646.0
      ],
      [
        -311.8197937011719,
        -2156.361572265625,
        646.0
      ],
      [
        -314.0910949707031,
        -2158.800048828125,
        646.0
      ],
      [
        -314.19110107421875,
        -2158.64013671875,
        646.0
      ],
      [
        -311.126953125,
        -2155.951904296875,
        646.0
      ],
      [
        -311.8197937011719,
        -2156.361572265625,
        646.0
      ],
      [
        -320.6533203125,
        -2161.451904296875,
        646.0
      ],
      [
        -319.4408874511719,
        -2160.800048828125,
        646.0
      ],
      [
        -319.4408874511719,
        -2160.800048828125,
        646.0
      ],
      [
        -319.34088134765625,
        -2160.9599609375,
        646.0
      ],
      [
        -319.34088134765625,
        -2160.9599609375,
        646.0
      ],
      [
        -318.94091796875,
        -2161.6142578125,
        646.0
      ],
      [
        -314.57427978515625,
        -2157.989990234375,
        646.0
      ],
      [
        -336.4956359863281,
        -2138.84716796875,
        671.9999389648438
      ],
      [
        -314.34857177734375,
        -2131.132568359375,
        671.9999389648438
      ],
      [
        -336.4956359863281,
        -2138.84716796875,
        671.9999389648438
      ],
      [
        -337.492919921875,
        -2137.055419921875,
        667.9999389648438
      ],
      [
        -327.48822021484375,
        -2219.71875,
        651.0
      ],
      [
        -327.4789733886719,
        -2219.733642578125,
        641.0
      ],
      [
        -327.49127197265625,
        -2219.7138671875,
        641.0
      ],
      [
        -375.82666015625,
        -2143.6884765625,
        652.0665893554688
      ],
      [
        -363.2335205078125,
        -2137.500244140625,
        652.0665893554688
      ],
      [
        -364.595947265625,
        -2139.140625,
        653.9999389648438
      ],
      [
        -373.5358581542969,
        -2143.656005859375,
        653.9999389648438
      ],
      [
        -373.5358581542969,
        -2143.656005859375,
        653.9999389648438
      ],
      [
        -375.82666015625,
        -2143.6884765625,
        652.0665893554688
      ],
      [
        -291.9776916503906,
        -2125.632568359375,
        676.287109375
      ],
      [
        -229.68516540527344,
        -2089.302490234375,
        648.9296264648438
      ],
      [
        -221.1641845703125,
        -2082.565673828125,
        641.8828735351562
      ],
      [
        -229.68516540527344,
        -2089.302490234375,
        648.9296264648438
      ],
      [
        -194.23110961914062,
        -2081.2646484375,
        638.0515747070312
      ],
      [
        -221.16416931152344,
        -2082.565673828125,
        641.8828735351562
      ],
      [
        -210.3173370361328,
        -2078.007080078125,
        640.4237670898438
      ],
      [
        -235.50057983398438,
        -2186.518310546875,
        820.6962890625
      ],
      [
        -233.986572265625,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -233.986572265625,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -176.25527954101562,
        -2202.45751953125,
        819.7315063476562
      ],
      [
        -163.9807586669922,
        -2216.925048828125,
        861.0
      ],
      [
        -216.2542266845703,
        -2202.632080078125,
        861.0
      ],
      [
        -147.6560516357422,
        -2236.791748046875,
        918.2081298828125
      ],
      [
        -146.74072265625,
        -2237.2451171875,
        918.9628295898438
      ],
      [
        -155.3894500732422,
        -2203.22607421875,
        861.0
      ],
      [
        -215.482177734375,
        -2202.441650390625,
        861.0
      ],
      [
        -228.36341857910156,
        -2188.4384765625,
        820.580078125
      ],
      [
        -170.35757446289062,
        -2193.500732421875,
        820.2736206054688
      ],
      [
        -155.07421875,
        -2202.723388671875,
        861.0
      ],
      [
        -200.39308166503906,
        -2198.721923828125,
        861.0
      ],
      [
        -230.1759490966797,
        -2181.5,
        821.0
      ],
      [
        -224.03480529785156,
        -2181.5,
        825.0
      ],
      [
        -230.1759490966797,
        -2181.5,
        821.0
      ],
      [
        -143.97581481933594,
        -2181.5,
        857.0
      ],
      [
        -143.8071746826172,
        -2181.5,
        857.0501708984375
      ],
      [
        -154.65687561035156,
        -2187.44677734375,
        861.0
      ],
      [
        -168.0985107421875,
        -2187.44677734375,
        857.0
      ],
      [
        -143.97645568847656,
        -2181.5,
        857.0
      ],
      [
        -199.1468963623047,
        -2073.312255859375,
        638.9210815429688
      ],
      [
        -186.2097625732422,
        -2068.09375,
        637.5899047851562
      ],
      [
        -199.1471405029297,
        -2073.312255859375,
        638.921142578125
      ],
      [
        -185.83477783203125,
        -2187.44677734375,
        861.0
      ],
      [
        -162.62155151367188,
        -2181.5,
        865.0
      ],
      [
        -168.76278686523438,
        -2181.5,
        861.0
      ],
      [
        -141.7639617919922,
        -2181.5,
        861.0
      ],
      [
        -146.0,
        -2180.03857421875,
        861.0
      ],
      [
        -140.847412109375,
        -2180.03857421875,
        861.0
      ],
      [
        -146.0,
        -2180.03857421875,
        861.0
      ],
      [
        -146.0,
        -2181.5,
        861.0
      ],
      [
        -191.97613525390625,
        -2187.44677734375,
        857.0
      ],
      [
        -174.90402221679688,
        -2181.5,
        857.0
      ],
      [
        -174.9040069580078,
        -2181.5,
        857.0
      ],
      [
        -292.8619384765625,
        -2125.372802734375,
        676.3875122070312
      ],
      [
        -255.99998474121094,
        -2167.59130859375,
        779.0836791992188
      ],
      [
        -255.99998474121094,
        -2167.59130859375,
        779.0836791992188
      ],
      [
        -241.49468994140625,
        -2184.905517578125,
        820.7938842773438
      ],
      [
        -227.51223754882812,
        -2201.59521484375,
        861.0
      ],
      [
        -266.14605712890625,
        -2215.42236328125,
        861.0
      ],
      [
        -226.91893005371094,
        -2201.7578125,
        861.0
      ],
      [
        -315.9477233886719,
        -2129.109619140625,
        667.9999389648438
      ],
      [
        -314.61785888671875,
        -2130.7919921875,
        671.9999389648438
      ],
      [
        -315.9477233886719,
        -2129.109619140625,
        667.9999389648438
      ],
      [
        -325.2576904296875,
        -2117.33349609375,
        639.9999389648438
      ],
      [
        -336.6001281738281,
        -2138.659423828125,
        671.9999389648438
      ],
      [
        -314.61785888671875,
        -2130.7919921875,
        671.9999389648438
      ],
      [
        -337.6019287109375,
        -2136.859619140625,
        667.9999389648438
      ],
      [
        -338.11614990234375,
        -2137.043701171875,
        667.9999389648438
      ],
      [
        -359.403076171875,
        -2144.662353515625,
        667.9999389648438
      ],
      [
        -338.11614990234375,
        -2137.043701171875,
        667.9999389648438
      ],
      [
        -363.2641906738281,
        -2137.447021484375,
        652.0665893554688
      ],
      [
        -366.3796081542969,
        -2132.05126953125,
        640.0
      ],
      [
        -342.916259765625,
        -2126.89111328125,
        646.0
      ],
      [
        -328.561767578125,
        -2121.753662109375,
        646.0
      ],
      [
        -324.0661926269531,
        -2125.540283203125,
        656.0
      ],
      [
        -326.2606201171875,
        -2121.739501953125,
        647.5
      ],
      [
        -325.4637145996094,
        -2127.11962890625,
        658.0
      ],
      [
        -324.0661926269531,
        -2125.540283203125,
        656.0
      ],
      [
        -328.561767578125,
        -2121.753662109375,
        646.0
      ],
      [
        -326.2606201171875,
        -2121.739501953125,
        647.5
      ],
      [
        -366.3796081542969,
        -2132.05126953125,
        640.0
      ],
      [
        -367.4245910644531,
        -2132.42529296875,
        640.0
      ],
      [
        -336.6001281738281,
        -2138.659423828125,
        671.9999389648438
      ],
      [
        -337.6019287109375,
        -2136.859619140625,
        667.9999389648438
      ],
      [
        -270.5155944824219,
        -2194.963623046875,
        820.1851196289062
      ],
      [
        -270.46417236328125,
        -2204.5576171875,
        838.0
      ],
      [
        -270.314697265625,
        -2203.69482421875,
        836.5
      ],
      [
        -264.904296875,
        -2195.55322265625,
        825.0
      ],
      [
        -265.3108215332031,
        -2193.15966796875,
        820.2943115234375
      ],
      [
        -270.5155944824219,
        -2194.963623046875,
        820.1851196289062
      ],
      [
        -265.1891174316406,
        -2193.313720703125,
        820.2849731445312
      ],
      [
        -270.46417236328125,
        -2204.5576171875,
        838.0
      ],
      [
        -270.3147277832031,
        -2203.69482421875,
        836.5
      ],
      [
        -241.49510192871094,
        -2184.905517578125,
        820.7938842773438
      ],
      [
        -247.3237762451172,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -240.81251525878906,
        -2185.0888671875,
        820.7827758789062
      ],
      [
        -247.32301330566406,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -226.59634399414062,
        -2201.267333984375,
        861.0
      ],
      [
        -226.0362091064453,
        -2201.450439453125,
        861.0
      ],
      [
        -241.0248260498047,
        -2184.742431640625,
        820.8037719726562
      ],
      [
        -240.39039611816406,
        -2184.946533203125,
        820.7913818359375
      ],
      [
        -292.8619384765625,
        -2125.372802734375,
        676.3875122070312
      ],
      [
        -230.67520141601562,
        -2088.1982421875,
        648.7401123046875
      ],
      [
        -222.7790985107422,
        -2081.8056640625,
        642.1300048828125
      ],
      [
        -230.67520141601562,
        -2088.1982421875,
        648.7401123046875
      ],
      [
        -210.3173370361328,
        -2078.007080078125,
        640.4237670898438
      ],
      [
        -222.77908325195312,
        -2081.8056640625,
        642.1300048828125
      ],
      [
        -212.7891845703125,
        -2077.50634765625,
        640.7882690429688
      ],
      [
        -187.98097229003906,
        -2187.44677734375,
        861.0
      ],
      [
        -165.3345947265625,
        -2181.5,
        865.0
      ],
      [
        -171.36509704589844,
        -2181.5,
        861.0
      ],
      [
        -168.76278686523438,
        -2181.5,
        861.0
      ],
      [
        -194.0113983154297,
        -2187.44677734375,
        857.0
      ],
      [
        -177.39561462402344,
        -2181.5,
        857.0
      ],
      [
        -177.39559936523438,
        -2181.5,
        857.0
      ],
      [
        -184.73155212402344,
        -2065.7421875,
        637.5966796875
      ],
      [
        -202.60140991210938,
        -2073.121826171875,
        639.419921875
      ],
      [
        -202.60118103027344,
        -2073.121826171875,
        639.419921875
      ],
      [
        -231.66876220703125,
        -2181.5,
        821.0
      ],
      [
        -225.63856506347656,
        -2181.5,
        825.0
      ],
      [
        -231.6687774658203,
        -2181.5,
        821.0
      ],
      [
        -300.4163513183594,
        -2123.153564453125,
        677.2455444335938
      ],
      [
        -278.7550354003906,
        -2146.5810546875,
        732.8895874023438
      ],
      [
        -278.7550354003906,
        -2146.5810546875,
        732.8895874023438
      ],
      [
        -245.17384338378906,
        -2183.91552734375,
        820.8538208007812
      ],
      [
        -318.5452575683594,
        -2125.823974609375,
        667.9999389648438
      ],
      [
        -317.154541015625,
        -2127.583251953125,
        671.9999389648438
      ],
      [
        -318.5452575683594,
        -2125.823974609375,
        667.9999389648438
      ],
      [
        -328.2811279296875,
        -2113.50927734375,
        639.9999389648438
      ],
      [
        -337.6195983886719,
        -2136.82763671875,
        671.9999389648438
      ],
      [
        -317.154541015625,
        -2127.583251953125,
        671.9999389648438
      ],
      [
        -338.6816101074219,
        -2134.919677734375,
        667.9999389648438
      ],
      [
        -339.290283203125,
        -2135.19482421875,
        667.9999389648438
      ],
      [
        -352.2353210449219,
        -2141.0419921875,
        667.9999389648438
      ],
      [
        -339.290283203125,
        -2135.19482421875,
        667.9999389648438
      ],
      [
        -344.37689208984375,
        -2124.361083984375,
        646.0
      ],
      [
        -330.63897705078125,
        -2118.15576171875,
        646.0
      ],
      [
        -364.83050537109375,
        -2134.734375,
        646.0
      ],
      [
        -366.4483337402344,
        -2131.93212890625,
        640.0
      ],
      [
        -364.88812255859375,
        -2134.634521484375,
        646.0
      ],
      [
        -366.4483337402344,
        -2131.93212890625,
        640.0
      ],
      [
        -326.07415771484375,
        -2122.0625,
        656.0
      ],
      [
        -328.3973083496094,
        -2118.03857421875,
        647.5
      ],
      [
        -363.3105773925781,
        -2137.36669921875,
        652.0665893554688
      ],
      [
        -330.63897705078125,
        -2118.15576171875,
        646.0
      ],
      [
        -328.3973083496094,
        -2118.03857421875,
        647.5
      ],
      [
        -327.359130859375,
        -2123.836669921875,
        658.0
      ],
      [
        -326.07415771484375,
        -2122.0625,
        656.0
      ],
      [
        -337.6195983886719,
        -2136.82763671875,
        671.9999389648438
      ],
      [
        -338.6816101074219,
        -2134.919677734375,
        667.9999389648438
      ],
      [
        -265.5843200683594,
        -2192.813720703125,
        820.3152465820312
      ],
      [
        -265.3108215332031,
        -2193.15966796875,
        820.2943115234375
      ],
      [
        -264.85723876953125,
        -2195.281494140625,
        825.0
      ],
      [
        -266.0658874511719,
        -2197.30126953125,
        827.468994140625
      ],
      [
        -229.84800720214844,
        -2200.954833984375,
        861.0
      ],
      [
        -245.58639526367188,
        -2208.06396484375,
        861.0
      ],
      [
        -227.51258850097656,
        -2201.59521484375,
        861.0
      ],
      [
        -245.17408752441406,
        -2183.91552734375,
        820.8538208007812
      ],
      [
        -252.07797241210938,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -241.49510192871094,
        -2184.905517578125,
        820.7938842773438
      ],
      [
        -252.07791137695312,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -244.50466918945312,
        -2183.623779296875,
        820.8714599609375
      ],
      [
        -241.0248260498047,
        -2184.742431640625,
        820.8037719726562
      ],
      [
        -228.8833465576172,
        -2200.51904296875,
        861.0
      ],
      [
        -226.59629821777344,
        -2201.267333984375,
        861.0
      ],
      [
        -300.4163513183594,
        -2123.153564453125,
        677.2455444335938
      ],
      [
        -240.01048278808594,
        -2077.787109375,
        646.9533081054688
      ],
      [
        -212.7891845703125,
        -2077.50634765625,
        640.7882690429688
      ],
      [
        -237.26171875,
        -2074.9892578125,
        644.346435546875
      ],
      [
        -233.93527221679688,
        -2073.22412109375,
        643.9066162109375
      ],
      [
        -237.26171875,
        -2074.9892578125,
        644.346435546875
      ],
      [
        -240.01048278808594,
        -2077.787109375,
        646.9533081054688
      ],
      [
        -177.4660186767578,
        -2044.494140625,
        638.5073852539062
      ],
      [
        -230.8101806640625,
        -2071.56591796875,
        643.493408203125
      ],
      [
        -199.9435577392578,
        -2187.44677734375,
        861.0
      ],
      [
        -181.4931640625,
        -2181.5,
        865.0
      ],
      [
        -186.77857971191406,
        -2181.5,
        861.0
      ],
      [
        -171.36509704589844,
        -2181.5,
        861.0
      ],
      [
        -230.81011962890625,
        -2071.56591796875,
        643.493408203125
      ],
      [
        -205.22923278808594,
        -2187.44677734375,
        857.0
      ],
      [
        -192.0640106201172,
        -2181.5,
        857.0
      ],
      [
        -192.06399536132812,
        -2181.5,
        857.0
      ],
      [
        -234.34767150878906,
        -2181.5,
        825.0
      ],
      [
        -239.6328887939453,
        -2181.5,
        821.0
      ],
      [
        -239.63287353515625,
        -2181.5,
        821.0
      ],
      [
        -177.4660186767578,
        -2044.494140625,
        638.5073852539062
      ],
      [
        -167.5012969970703,
        -2042.54248046875,
        642.7789306640625
      ],
      [
        -295.6273193359375,
        -2134.037109375,
        705.107421875
      ],
      [
        -298.57330322265625,
        -2128.282470703125,
        692.6574096679688
      ],
      [
        -245.89476013183594,
        -2183.7216796875,
        820.8655395507812
      ],
      [
        -294.19219970703125,
        -2133.650634765625,
        705.6890869140625
      ],
      [
        -303.77581787109375,
        -2122.16650390625,
        677.6270751953125
      ],
      [
        -298.57330322265625,
        -2128.282470703125,
        692.6574096679688
      ],
      [
        -319.5613708496094,
        -2124.538818359375,
        667.9999389648438
      ],
      [
        -318.2466735839844,
        -2126.201904296875,
        671.9999389648438
      ],
      [
        -319.5613708496094,
        -2124.538818359375,
        667.9999389648438
      ],
      [
        -328.7640686035156,
        -2112.8984375,
        639.9999389648438
      ],
      [
        -337.9849548339844,
        -2136.171142578125,
        671.9999389648438
      ],
      [
        -318.2466735839844,
        -2126.201904296875,
        671.9999389648438
      ],
      [
        -344.41558837890625,
        -2124.294189453125,
        646.0
      ],
      [
        -331.0054931640625,
        -2117.52099609375,
        646.0
      ],
      [
        -338.995849609375,
        -2134.35498046875,
        667.9999389648438
      ],
      [
        -339.62249755859375,
        -2134.671630859375,
        667.9999389648438
      ],
      [
        -339.62249755859375,
        -2134.671630859375,
        667.9999389648438
      ],
      [
        -326.6171875,
        -2121.121826171875,
        656.0
      ],
      [
        -328.8274841308594,
        -2117.29345703125,
        647.5
      ],
      [
        -327.88507080078125,
        -2122.92578125,
        658.0
      ],
      [
        -326.6171875,
        -2121.121826171875,
        656.0
      ],
      [
        -331.0054931640625,
        -2117.52099609375,
        646.0
      ],
      [
        -328.8274841308594,
        -2117.29345703125,
        647.5
      ],
      [
        -337.9849548339844,
        -2136.171142578125,
        671.9999389648438
      ],
      [
        -338.995849609375,
        -2134.35498046875,
        667.9999389648438
      ],
      [
        -245.89480590820312,
        -2183.7216796875,
        820.8655395507812
      ],
      [
        -252.1000518798828,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -245.17381286621094,
        -2183.91552734375,
        820.8538208007812
      ],
      [
        -252.10000610351562,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -252.21978759765625,
        -2186.9873046875,
        820.6679077148438
      ],
      [
        -303.77581787109375,
        -2122.16650390625,
        677.6270751953125
      ],
      [
        -303.6487731933594,
        -2122.063720703125,
        677.5606079101562
      ],
      [
        -300.0645751953125,
        -2122.889404296875,
        677.0691528320312
      ],
      [
        -243.7688446044922,
        -2073.595458984375,
        646.2339477539062
      ],
      [
        -233.93527221679688,
        -2073.22412109375,
        643.9066162109375
      ],
      [
        -242.68882751464844,
        -2072.43505859375,
        645.177001953125
      ],
      [
        -241.4340362548828,
        -2071.70556640625,
        645.012451171875
      ],
      [
        -242.68882751464844,
        -2072.43505859375,
        645.177001953125
      ],
      [
        -243.7688446044922,
        -2073.595458984375,
        646.2339477539062
      ],
      [
        -185.3372344970703,
        -2040.4398193359375,
        639.9717407226562
      ],
      [
        -240.29417419433594,
        -2071.04296875,
        644.8629150390625
      ],
      [
        -185.3372344970703,
        -2040.4398193359375,
        639.9717407226562
      ],
      [
        -156.4415740966797,
        -2033.6297607421875,
        653.353515625
      ],
      [
        -203.50860595703125,
        -2187.44677734375,
        861.0
      ],
      [
        -222.39744567871094,
        -2197.58935546875,
        861.0
      ],
      [
        -187.5176239013672,
        -2181.5,
        865.0
      ],
      [
        -192.43356323242188,
        -2181.5,
        861.0
      ],
      [
        -186.77857971191406,
        -2181.5,
        861.0
      ],
      [
        -208.4244842529297,
        -2187.44677734375,
        857.0
      ],
      [
        -197.3494873046875,
        -2181.5,
        857.0
      ],
      [
        -197.3494873046875,
        -2181.5,
        857.0
      ],
      [
        -240.29417419433594,
        -2071.04296875,
        644.8629150390625
      ],
      [
        -236.6760711669922,
        -2181.5,
        825.0
      ],
      [
        -241.59207153320312,
        -2181.5,
        821.0
      ],
      [
        -241.59207153320312,
        -2181.5,
        821.0
      ],
      [
        -294.1370849609375,
        -2133.71826171875,
        705.85302734375
      ],
      [
        -294.1370849609375,
        -2133.71826171875,
        705.85302734375
      ],
      [
        -295.6273193359375,
        -2134.037109375,
        705.1073608398438
      ],
      [
        -245.89486694335938,
        -2183.7216796875,
        820.8655395507812
      ],
      [
        -245.96267700195312,
        -2183.703369140625,
        820.8666381835938
      ],
      [
        -268.22979736328125,
        -2214.75,
        861.0
      ],
      [
        -229.84786987304688,
        -2200.954833984375,
        861.0
      ],
      [
        -232.66213989257812,
        -2200.18310546875,
        861.0
      ],
      [
        -277.400146484375,
        -2219.5,
        862.9825439453125
      ],
      [
        -277.6274108886719,
        -2219.421630859375,
        861.0
      ],
      [
        -277.4501953125,
        -2218.526123046875,
        861.0
      ],
      [
        -269.774658203125,
        -2212.122802734375,
        854.5
      ],
      [
        -270.38446044921875,
        -2204.097412109375,
        838.0
      ],
      [
        -270.2441711425781,
        -2203.28759765625,
        836.5
      ],
      [
        -264.9940490722656,
        -2195.510009765625,
        825.2794799804688
      ],
      [
        -268.22979736328125,
        -2214.75,
        861.0
      ],
      [
        -267.855712890625,
        -2212.590576171875,
        857.0
      ],
      [
        -267.855712890625,
        -2212.590576171875,
        857.0
      ],
      [
        -269.774658203125,
        -2212.122802734375,
        854.5
      ],
      [
        -270.38446044921875,
        -2204.097412109375,
        838.0
      ],
      [
        -270.24420166015625,
        -2203.28759765625,
        836.5
      ],
      [
        -241.9779510498047,
        -2197.628173828125,
        861.0
      ],
      [
        -267.49652099609375,
        -2210.51708984375,
        861.0
      ],
      [
        -276.7727966308594,
        -2216.75537109375,
        863.6699829101562
      ],
      [
        -274.7591247558594,
        -2217.675048828125,
        866.9991455078125
      ],
      [
        -277.4501953125,
        -2218.526123046875,
        861.0
      ],
      [
        -276.7945251464844,
        -2215.213134765625,
        861.0
      ],
      [
        -276.7727966308594,
        -2216.75537109375,
        863.6699829101562
      ],
      [
        -276.9884948730469,
        -2201.44189453125,
        837.1588745117188
      ],
      [
        -269.1918640136719,
        -2187.879150390625,
        820.6138916015625
      ],
      [
        -276.9884948730469,
        -2201.44189453125,
        837.1588745117188
      ],
      [
        -268.9704284667969,
        -2207.480224609375,
        854.5
      ],
      [
        -269.3399963378906,
        -2198.068115234375,
        838.0
      ],
      [
        -254.15232849121094,
        -2181.5,
        821.0
      ],
      [
        -256.1170654296875,
        -2181.5,
        821.0
      ],
      [
        -267.23712158203125,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -267.23712158203125,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -269.1918640136719,
        -2187.879150390625,
        820.6138916015625
      ],
      [
        -269.17437744140625,
        -2197.112060546875,
        836.5
      ],
      [
        -263.5207214355469,
        -2187.56640625,
        825.0
      ],
      [
        -267.49652099609375,
        -2210.51708984375,
        861.0
      ],
      [
        -267.05474853515625,
        -2207.967041015625,
        857.0
      ],
      [
        -269.3399963378906,
        -2198.068115234375,
        838.0
      ],
      [
        -269.17437744140625,
        -2197.112060546875,
        836.5
      ],
      [
        -267.05474853515625,
        -2207.967041015625,
        857.0
      ],
      [
        -268.9704284667969,
        -2207.480224609375,
        854.5
      ],
      [
        -255.14068603515625,
        -2181.5,
        821.8477172851562
      ],
      [
        -256.1170654296875,
        -2181.5,
        821.0
      ],
      [
        -254.15232849121094,
        -2181.5,
        821.0
      ],
      [
        -255.25772094726562,
        -2181.356689453125,
        821.5
      ],
      [
        -255.54124450683594,
        -2181.5,
        821.5
      ],
      [
        -254.735595703125,
        -2181.5,
        821.5
      ],
      [
        -221.82037353515625,
        -2187.44677734375,
        861.0
      ],
      [
        -205.43936157226562,
        -2181.5,
        865.0
      ],
      [
        -210.04632568359375,
        -2181.5,
        861.0
      ],
      [
        -192.43356323242188,
        -2181.5,
        861.0
      ],
      [
        -226.42739868164062,
        -2187.44677734375,
        857.0
      ],
      [
        -214.6532745361328,
        -2181.5,
        857.0
      ],
      [
        -214.6532745361328,
        -2181.5,
        857.0
      ],
      [
        -251.50999450683594,
        -2181.5,
        825.0
      ],
      [
        -251.77947998046875,
        -2179.60009765625,
        821.5
      ],
      [
        -251.97039794921875,
        -2181.5,
        824.5999755859375
      ],
      [
        -251.20370483398438,
        -2179.60009765625,
        822.0
      ],
      [
        -251.20370483398438,
        -2179.60009765625,
        822.0
      ],
      [
        -251.7794189453125,
        -2179.60009765625,
        821.5
      ],
      [
        -279.2771301269531,
        -2067.12646484375,
        645.7384643554688
      ],
      [
        -301.4779357910156,
        -2092.2255859375,
        661.1591796875
      ],
      [
        -363.35614013671875,
        -2137.91748046875,
        668.1741943359375
      ],
      [
        -342.22515869140625,
        -2128.552734375,
        667.9999389648438
      ],
      [
        -343.2315368652344,
        -2128.98828125,
        667.9999389648438
      ],
      [
        -392.83599853515625,
        -2157.3134765625,
        667.9999389648438
      ],
      [
        -362.91778564453125,
        -2137.509521484375,
        667.9999389648438
      ],
      [
        -343.23150634765625,
        -2128.98828125,
        667.9999389648438
      ],
      [
        -394.6380920410156,
        -2139.6162109375,
        639.9999389648438
      ],
      [
        -354.8740539550781,
        -2113.295166015625,
        639.9999389648438
      ],
      [
        -392.83599853515625,
        -2157.3134765625,
        667.9999389648438
      ],
      [
        -401.4259033203125,
        -2144.109375,
        639.9999389648438
      ],
      [
        -322.97540283203125,
        -2120.220458984375,
        667.9999389648438
      ],
      [
        -332.02117919921875,
        -2108.77880859375,
        655.7276611328125
      ],
      [
        -337.5279846191406,
        -2101.813232421875,
        639.9999389648438
      ],
      [
        -333.1905517578125,
        -2109.736572265625,
        656.0
      ],
      [
        -334.162841796875,
        -2108.052490234375,
        652.5496826171875
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        641.2273559570312
      ],
      [
        -378.614013671875,
        -2131.060546875,
        643.0404052734375
      ],
      [
        -373.41796875,
        -2128.060546875,
        643.6917114257812
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        645.5701293945312
      ],
      [
        -367.6324157714844,
        -2129.881103515625,
        652.0665893554688
      ],
      [
        -367.717041015625,
        -2129.734619140625,
        651.766357421875
      ],
      [
        -348.8375244140625,
        -2113.869140625,
        645.9999389648438
      ],
      [
        -337.85394287109375,
        -2107.52783203125,
        645.9999389648438
      ],
      [
        -337.85394287109375,
        -2107.52783203125,
        645.9999389648438
      ],
      [
        -337.65106201171875,
        -2107.41064453125,
        645.9999389648438
      ],
      [
        -333.9332580566406,
        -2112.449951171875,
        658.0
      ],
      [
        -333.1905517578125,
        -2109.736572265625,
        656.0
      ],
      [
        -333.3268737792969,
        -2109.992919921875,
        656.2462158203125
      ],
      [
        -339.35888671875,
        -2111.052490234375,
        651.8984375
      ],
      [
        -340.408935546875,
        -2109.234130859375,
        648.1729125976562
      ],
      [
        -337.551025390625,
        -2107.583984375,
        648.5309448242188
      ],
      [
        -340.408935546875,
        -2109.234130859375,
        648.1729125976562
      ],
      [
        -337.551025390625,
        -2107.583984375,
        648.5309448242188
      ],
      [
        -337.65106201171875,
        -2107.41064453125,
        645.9999389648438
      ],
      [
        -337.65106201171875,
        -2107.41064453125,
        648.1759033203125
      ],
      [
        -344.554931640625,
        -2114.052490234375,
        651.2471923828125
      ],
      [
        -345.604736328125,
        -2112.23388671875,
        647.5216064453125
      ],
      [
        -348.809326171875,
        -2114.083984375,
        647.1198120117188
      ],
      [
        -345.604736328125,
        -2112.23388671875,
        647.5216064453125
      ],
      [
        -349.0048828125,
        -2114.132568359375,
        646.9999389648438
      ],
      [
        -348.809326171875,
        -2114.083984375,
        647.1196899414062
      ],
      [
        -349.0048828125,
        -2114.132568359375,
        646.9999389648438
      ],
      [
        -348.819091796875,
        -2114.009765625,
        646.9999389648438
      ],
      [
        -379.32867431640625,
        -2137.623046875,
        652.0665893554688
      ],
      [
        -379.841552734375,
        -2136.734619140625,
        650.2466430664062
      ],
      [
        -368.758544921875,
        -2131.930908203125,
        653.9999389648438
      ],
      [
        -377.1127624511719,
        -2137.460693359375,
        653.9999389648438
      ],
      [
        -377.1127624511719,
        -2137.460693359375,
        653.9999389648438
      ],
      [
        -379.32867431640625,
        -2137.623046875,
        652.0665893554688
      ],
      [
        -373.41796875,
        -2128.060546875,
        643.691650390625
      ],
      [
        -372.26806640625,
        -2130.052490234375,
        647.7724609375
      ],
      [
        -378.614013671875,
        -2131.060546875,
        643.0403442382812
      ],
      [
        -377.464111328125,
        -2133.052490234375,
        647.1211547851562
      ],
      [
        -348.90057373046875,
        -2113.388916015625,
        645.9999389648438
      ],
      [
        -339.5661315917969,
        -2107.21044921875,
        645.9999389648438
      ],
      [
        -339.566162109375,
        -2107.21044921875,
        645.9999389648438
      ],
      [
        -338.2642822265625,
        -2106.3486328125,
        645.9999389648438
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        645.5701293945312
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        642.0267944335938
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        642.0267944335938
      ],
      [
        -354.8740539550781,
        -2113.295166015625,
        639.9999389648438
      ],
      [
        -394.6380920410156,
        -2139.6162109375,
        639.9999389648438
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        641.2273559570312
      ],
      [
        -338.2642822265625,
        -2106.3486328125,
        645.9999389648438
      ],
      [
        -241.4340362548828,
        -2071.70556640625,
        645.012451171875
      ],
      [
        -339.98004150390625,
        -2132.58642578125,
        671.9999389648438
      ],
      [
        -320.0271911621094,
        -2123.94970703125,
        671.9999389648438
      ],
      [
        -339.98004150390625,
        -2132.58642578125,
        671.9999389648438
      ],
      [
        -342.22515869140625,
        -2128.552734375,
        667.9999389648438
      ],
      [
        -322.97540283203125,
        -2120.220458984375,
        667.9999389648438
      ],
      [
        -320.0271911621094,
        -2123.94970703125,
        671.9999389648438
      ],
      [
        -329.72320556640625,
        -2143.168701171875,
        691.2015380859375
      ],
      [
        -329.02239990234375,
        -2112.57177734375,
        664.2922973632812
      ],
      [
        -320.1700134277344,
        -2105.479736328125,
        662.4656372070312
      ],
      [
        -363.35614013671875,
        -2137.91748046875,
        668.1741943359375
      ],
      [
        -362.8336181640625,
        -2137.530517578125,
        668.1135864257812
      ],
      [
        -341.31842041015625,
        -2130.181640625,
        671.9999389648438
      ],
      [
        -322.43695068359375,
        -2120.901611328125,
        671.9999389648438
      ],
      [
        -343.5758361816406,
        -2126.1259765625,
        667.9999389648438
      ],
      [
        -344.65045166015625,
        -2126.75390625,
        667.9999389648438
      ],
      [
        -361.8580322265625,
        -2136.80810546875,
        667.9999389648438
      ],
      [
        -344.65045166015625,
        -2126.75390625,
        667.9999389648438
      ],
      [
        -325.8544921875,
        -2116.578857421875,
        667.9999389648438
      ],
      [
        -328.7745666503906,
        -2112.88525390625,
        664.5823364257812
      ],
      [
        -329.0569152832031,
        -2112.528076171875,
        664.1937255859375
      ],
      [
        -334.2977600097656,
        -2111.818603515625,
        658.0
      ],
      [
        -362.8336181640625,
        -2137.530517578125,
        668.1135864257812
      ],
      [
        -362.7071533203125,
        -2137.370361328125,
        668.0
      ],
      [
        -324.4424743652344,
        -2118.36474609375,
        667.9999389648438
      ],
      [
        -322.43695068359375,
        -2120.901611328125,
        671.9999389648438
      ],
      [
        -322.56671142578125,
        -2120.737548828125,
        671.8480224609375
      ],
      [
        -341.31842041015625,
        -2130.181640625,
        671.9999389648438
      ],
      [
        -342.81622314453125,
        -2127.49072265625,
        667.9999389648438
      ],
      [
        -325.8544921875,
        -2116.578857421875,
        667.9999389648438
      ],
      [
        -343.5758361816406,
        -2126.1259765625,
        667.9999389648438
      ],
      [
        -343.94171142578125,
        -2125.468505859375,
        667.9999389648438
      ],
      [
        -345.10400390625,
        -2126.03955078125,
        667.9999389648438
      ],
      [
        -346.9906921386719,
        -2126.966796875,
        667.9999389648438
      ],
      [
        -345.10400390625,
        -2126.03955078125,
        667.9999389648438
      ],
      [
        -329.0224609375,
        -2112.57177734375,
        664.2921752929688
      ],
      [
        -343.94171142578125,
        -2125.468505859375,
        667.9999389648438
      ],
      [
        -320.1700134277344,
        -2105.479736328125,
        662.4656372070312
      ],
      [
        -301.4779357910156,
        -2092.2255859375,
        661.1591796875
      ],
      [
        -343.0555725097656,
        -2127.060546875,
        671.9999389648438
      ],
      [
        -326.32373046875,
        -2115.9853515625,
        671.9999389648438
      ],
      [
        -327.7242431640625,
        -2114.2138671875,
        667.9999389648438
      ],
      [
        -326.32373046875,
        -2115.9853515625,
        671.9999389648438
      ],
      [
        -327.7242431640625,
        -2114.2138671875,
        667.9999389648438
      ],
      [
        -343.0555725097656,
        -2127.060546875,
        671.9999389648438
      ],
      [
        -344.1531066894531,
        -2125.088623046875,
        667.9999389648438
      ],
      [
        -344.1531066894531,
        -2125.088623046875,
        667.9999389648438
      ],
      [
        -345.2477722167969,
        -2125.813232421875,
        667.9999389648438
      ],
      [
        -345.2477722167969,
        -2125.813232421875,
        667.9999389648438
      ],
      [
        -279.2771301269531,
        -2067.12646484375,
        645.7384643554688
      ],
      [
        -266.4683837890625,
        -2058.64794921875,
        645.7384643554688
      ],
      [
        -156.26707458496094,
        -2010.894287109375,
        683.0797119140625
      ],
      [
        -213.13516235351562,
        -2024.114501953125,
        646.8789672851562
      ],
      [
        -156.26707458496094,
        -2010.894287109375,
        683.0797119140625
      ],
      [
        -133.99038696289062,
        -2000.7490234375,
        689.8985595703125
      ],
      [
        -220.6219024658203,
        -2028.46044921875,
        645.9752807617188
      ],
      [
        -215.57534790039062,
        -2024.864990234375,
        645.5972290039062
      ],
      [
        -220.62191772460938,
        -2028.4605712890625,
        645.9752807617188
      ],
      [
        -262.76373291015625,
        -2056.19580078125,
        645.7384643554688
      ],
      [
        -262.7638244628906,
        -2056.19580078125,
        645.7384643554688
      ],
      [
        -215.57534790039062,
        -2024.864990234375,
        645.5972290039062
      ],
      [
        -213.13516235351562,
        -2024.114501953125,
        646.8789672851562
      ],
      [
        -241.65335083007812,
        -2187.44677734375,
        861.0
      ],
      [
        -266.32958984375,
        -2203.78076171875,
        861.0
      ],
      [
        -228.59268188476562,
        -2181.5,
        865.0
      ],
      [
        -232.6695098876953,
        -2181.5,
        861.0
      ],
      [
        -210.04632568359375,
        -2181.5,
        861.0
      ],
      [
        -275.79937744140625,
        -2211.6884765625,
        863.4299926757812
      ],
      [
        -273.808837890625,
        -2212.589111328125,
        866.7180786132812
      ],
      [
        -275.7684326171875,
        -2210.028564453125,
        861.0
      ],
      [
        -275.79937744140625,
        -2211.6884765625,
        863.4299926757812
      ],
      [
        -276.7945251464844,
        -2215.213134765625,
        861.0
      ],
      [
        -294.19219970703125,
        -2133.650634765625,
        705.6890869140625
      ],
      [
        -275.4665832519531,
        -2193.83251953125,
        837.2890014648438
      ],
      [
        -245.7301025390625,
        -2187.44677734375,
        857.0
      ],
      [
        -236.746337890625,
        -2181.5,
        857.0
      ],
      [
        -236.746337890625,
        -2181.5,
        857.0
      ],
      [
        -266.32958984375,
        -2203.78076171875,
        861.0
      ],
      [
        -265.8015441894531,
        -2200.732666015625,
        857.0
      ],
      [
        -271.9827575683594,
        -2186.925537109375,
        830.4692993164062
      ],
      [
        -269.24615478515625,
        -2181.5,
        825.1123046875
      ],
      [
        -271.9827575683594,
        -2186.925537109375,
        830.4692993164062
      ],
      [
        -275.4665832519531,
        -2193.83251953125,
        837.2890014648438
      ],
      [
        -267.7305603027344,
        -2200.322998046875,
        854.5
      ],
      [
        -267.8114929199219,
        -2189.244873046875,
        838.0
      ],
      [
        -267.8680114746094,
        -2181.5,
        826.4645385742188
      ],
      [
        -269.24615478515625,
        -2181.5,
        825.1123046875
      ],
      [
        -268.3788757324219,
        -2181.5,
        822.250244140625
      ],
      [
        -264.9912414550781,
        -2181.5,
        829.2872924804688
      ],
      [
        -267.6134948730469,
        -2188.101806640625,
        836.5
      ],
      [
        -267.2770690917969,
        -2187.44677734375,
        835.8590698242188
      ],
      [
        -267.2770690917969,
        -2187.44677734375,
        835.8590698242188
      ],
      [
        -264.9912414550781,
        -2181.5,
        829.2872924804688
      ],
      [
        -262.10870361328125,
        -2181.5,
        821.0
      ],
      [
        -262.04779052734375,
        -2184.3935546875,
        820.8248901367188
      ],
      [
        -261.0785217285156,
        -2181.5,
        821.0
      ],
      [
        -261.4764099121094,
        -2184.11474609375,
        820.8417358398438
      ],
      [
        -267.8114929199219,
        -2189.244873046875,
        838.0
      ],
      [
        -267.6134948730469,
        -2188.101806640625,
        836.5
      ],
      [
        -265.8015441894531,
        -2200.732666015625,
        857.0
      ],
      [
        -267.7305603027344,
        -2200.322998046875,
        854.5
      ],
      [
        -235.15554809570312,
        -1920.0,
        765.0
      ],
      [
        -294.5815734863281,
        -2027.41845703125,
        765.0
      ],
      [
        -224.3616485595703,
        -1948.4486083984375,
        765.0
      ],
      [
        -225.79273986816406,
        -1937.7965087890625,
        783.8977661132812
      ],
      [
        -195.1357421875,
        -1922.8343505859375,
        805.9156494140625
      ],
      [
        -170.0,
        -1934.9676513671875,
        781.1329956054688
      ],
      [
        -170.0,
        -1944.15771484375,
        765.0
      ],
      [
        -245.4122314453125,
        -1948.96728515625,
        765.0
      ],
      [
        -246.79368591308594,
        -1947.1268310546875,
        768.314453125
      ],
      [
        -225.79273986816406,
        -1937.7965087890625,
        783.8977661132812
      ],
      [
        -224.3616485595703,
        -1948.4486083984375,
        765.0
      ],
      [
        -246.79368591308594,
        -1947.1268310546875,
        768.314453125
      ],
      [
        -245.4122314453125,
        -1948.96728515625,
        765.0
      ],
      [
        -250.96910095214844,
        -1948.584716796875,
        765.0
      ],
      [
        -170.0,
        -1934.9676513671875,
        781.1329956054688
      ],
      [
        -195.1357421875,
        -1922.8343505859375,
        805.9156494140625
      ],
      [
        -176.00677490234375,
        -1927.5064697265625,
        827.2785034179688
      ],
      [
        -170.0,
        -1929.899169921875,
        825.8252563476562
      ],
      [
        -291.3095703125,
        -2030.6904296875,
        770.0
      ],
      [
        -294.5815734863281,
        -2027.41845703125,
        765.0
      ],
      [
        -156.3317413330078,
        -1943.078857421875,
        765.0
      ],
      [
        -264.28582763671875,
        -2181.5,
        856.0177001953125
      ],
      [
        -267.5,
        -2186.3974609375,
        836.5
      ],
      [
        -267.5,
        -2186.3974609375,
        836.5
      ],
      [
        -266.870849609375,
        -2181.5,
        834.691162109375
      ],
      [
        -267.6828918457031,
        -2188.50244140625,
        837.0258178710938
      ],
      [
        -331.3708190917969,
        -1977.4061279296875,
        701.5845947265625
      ],
      [
        -364.708251953125,
        -2005.7095947265625,
        684.19091796875
      ],
      [
        -283.0,
        -1979.0,
        675.0123901367188
      ],
      [
        -283.0,
        -1987.0,
        665.296875
      ],
      [
        -275.0,
        -1987.0,
        661.2224731445312
      ],
      [
        -275.0,
        -1979.0,
        670.9380493164062
      ],
      [
        -283.0,
        -1987.0,
        665.296875
      ],
      [
        -275.0,
        -1987.0,
        661.2224731445312
      ],
      [
        -195.0,
        -1946.1309814453125,
        765.0
      ],
      [
        -187.0,
        -1945.49951171875,
        765.0
      ],
      [
        -187.0,
        -1979.346435546875,
        705.5827026367188
      ],
      [
        -195.0,
        -1980.298828125,
        705.0193481445312
      ],
      [
        -195.0,
        -1920.0,
        754.0
      ],
      [
        -195.0,
        -1952.397216796875,
        754.0
      ],
      [
        -187.0,
        -1951.765869140625,
        754.0
      ],
      [
        -187.0,
        -1923.12744140625,
        754.0
      ],
      [
        -195.0,
        -1987.0,
        754.0
      ],
      [
        -187.0,
        -1987.0,
        754.0
      ],
      [
        -195.0,
        -1987.0,
        700.32421875
      ],
      [
        -195.0,
        -1980.298828125,
        705.0193481445312
      ],
      [
        -187.0,
        -1979.346435546875,
        705.5827026367188
      ],
      [
        -187.0,
        -1987.0,
        700.2202758789062
      ],
      [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      [
        -187.0,
        -1951.765869140625,
        754.0
      ],
      [
        -184.0,
        -1945.2628173828125,
        765.0
      ],
      [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      [
        -141.40330505371094,
        -1987.0,
        699.6279907226562
      ],
      [
        -184.0,
        -1987.0,
        765.0
      ],
      [
        -184.0,
        -1987.0,
        754.0
      ],
      [
        -184.0,
        -1987.0,
        754.0
      ],
      [
        -195.0,
        -1994.003662109375,
        695.4171142578125
      ],
      [
        -195.0,
        -2019.8985595703125,
        658.42333984375
      ],
      [
        -195.0,
        -1994.003662109375,
        695.4171142578125
      ],
      [
        -195.0,
        -1990.0,
        754.0
      ],
      [
        -195.0,
        -2014.0,
        765.0
      ],
      [
        -195.0,
        -1990.0,
        754.0
      ],
      [
        -331.3708190917969,
        -1977.4061279296875,
        701.5845947265625
      ],
      [
        -320.8838195800781,
        -1972.99560546875,
        709.5015869140625
      ],
      [
        -195.0,
        -1952.777587890625,
        753.3320922851562
      ],
      [
        -275.0,
        -1987.0,
        692.0352783203125
      ],
      [
        -275.0,
        -1979.0,
        704.552490234375
      ],
      [
        -283.0,
        -1979.0,
        703.77734375
      ],
      [
        -283.0,
        -1987.0,
        691.2601318359375
      ],
      [
        -283.0,
        -1987.0,
        691.2601318359375
      ],
      [
        -275.0,
        -1987.0,
        692.0352783203125
      ],
      [
        -198.0,
        -1952.164794921875,
        754.0
      ],
      [
        -195.0,
        -1952.3507080078125,
        754.0
      ],
      [
        -198.0,
        -1952.164794921875,
        754.0
      ],
      [
        -198.0,
        -1945.134521484375,
        765.0
      ],
      [
        -195.0,
        -1986.3773193359375,
        700.760498046875
      ],
      [
        -195.0,
        -1988.702392578125,
        699.1314086914062
      ],
      [
        -320.8838195800781,
        -1972.99560546875,
        709.5015869140625
      ],
      [
        -198.0,
        -1952.634033203125,
        754.0
      ],
      [
        -198.0,
        -1946.367919921875,
        765.0
      ],
      [
        -198.0,
        -1952.634033203125,
        754.0
      ],
      [
        -195.0,
        -1952.397216796875,
        754.0
      ],
      [
        -198.0,
        -1954.02001953125,
        754.0
      ],
      [
        -198.0,
        -1947.799072265625,
        765.0
      ],
      [
        -198.0,
        -1954.02001953125,
        754.0
      ],
      [
        -195.0,
        -1953.946044921875,
        754.0
      ],
      [
        -198.0,
        -1958.0234375,
        754.0
      ],
      [
        -198.0,
        -1952.2310791015625,
        765.0
      ],
      [
        -198.0,
        -1958.0234375,
        754.0
      ],
      [
        -195.0,
        -1958.2298583984375,
        754.0
      ],
      [
        -366.8480529785156,
        -2108.9384765625,
        640.0
      ],
      [
        -359.504638671875,
        -2105.41552734375,
        639.9999389648438
      ],
      [
        -360.5283508300781,
        -2117.037841796875,
        639.9999389648438
      ],
      [
        -366.84912109375,
        -2108.938232421875,
        639.9999389648438
      ],
      [
        -341.5058898925781,
        -2096.781494140625,
        639.9999389648438
      ],
      [
        -337.2313537597656,
        -2102.1884765625,
        640.84716796875
      ],
      [
        -355.507568359375,
        -2108.482421875,
        640.5662841796875
      ],
      [
        -359.504638671875,
        -2105.41552734375,
        639.9999389648438
      ],
      [
        -354.8399353027344,
        -2113.554443359375,
        640.4176025390625
      ],
      [
        -355.507568359375,
        -2108.482421875,
        640.5662841796875
      ],
      [
        -355.4948425292969,
        -2108.5791015625,
        640.5779418945312
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7276000976562
      ],
      [
        -336.9211120605469,
        -2102.580810546875,
        641.7332763671875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        640.169189453125
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        640.5848999023438
      ],
      [
        -368.5413818359375,
        -2106.769775390625,
        639.9999389648438
      ],
      [
        -360.365234375,
        -2104.755126953125,
        640.4842529296875
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        640.1516723632812
      ],
      [
        -369.7836608886719,
        -2105.177978515625,
        639.9999389648438
      ],
      [
        -367.435791015625,
        -2103.822265625,
        640.169189453125
      ],
      [
        -355.507568359375,
        -2108.482421875,
        640.5810546875
      ],
      [
        -360.365234375,
        -2104.755126953125,
        640.4842529296875
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        640.1516723632812
      ],
      [
        -368.5411071777344,
        -2106.769775390625,
        639.9999389648438
      ],
      [
        -355.507568359375,
        -2108.482421875,
        640.5810546875
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.6522827148438
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7276000976562
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.79150390625
      ],
      [
        -360.30859375,
        -2091.77294921875,
        640.9903564453125
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.346923828125
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.6522827148438
      ],
      [
        -360.30859375,
        -2091.77294921875,
        640.9903564453125
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.346923828125
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        640.5848999023438
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.79150390625
      ],
      [
        -214.79324340820312,
        -2024.6243896484375,
        646.008056640625
      ],
      [
        -386.3768615722656,
        -2112.560791015625,
        639.28125
      ],
      [
        -376.5368957519531,
        -2107.5634765625,
        639.890625
      ],
      [
        -373.08868408203125,
        -2109.395263671875,
        639.9999389648438
      ],
      [
        -366.09820556640625,
        -2120.724853515625,
        639.9999389648438
      ],
      [
        -371.88018798828125,
        -2111.352294921875,
        640.0
      ],
      [
        -383.708251953125,
        -2111.960693359375,
        639.424560546875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.8128662109375
      ],
      [
        -336.86126708984375,
        -2102.656494140625,
        641.9041748046875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        640.4286499023438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        640.8154907226562
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        640.4254150390625
      ],
      [
        -373.088623046875,
        -2109.395263671875,
        640.0
      ],
      [
        -374.1383361816406,
        -2107.692138671875,
        640.0
      ],
      [
        -367.435791015625,
        -2103.822265625,
        640.4285888671875
      ],
      [
        -360.365234375,
        -2104.755126953125,
        640.7348022460938
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        640.4254150390625
      ],
      [
        -355.507568359375,
        -2108.482421875,
        640.8554077148438
      ],
      [
        -360.365234375,
        -2104.755126953125,
        640.73486328125
      ],
      [
        -354.81402587890625,
        -2113.751220703125,
        640.73486328125
      ],
      [
        -355.507568359375,
        -2108.482421875,
        640.85546875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        640.8154907226562
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.9821166992188
      ],
      [
        -347.66058349609375,
        -2089.669677734375,
        641.7002563476562
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.8128662109375
      ],
      [
        -347.5388488769531,
        -2089.7822265625,
        641.7752685546875
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.9821166992188
      ],
      [
        -359.2350769042969,
        -2096.520751953125,
        640.859619140625
      ],
      [
        -359.1490173339844,
        -2096.9013671875,
        641.0206909179688
      ],
      [
        -380.7559814453125,
        -2109.727783203125,
        639.6287231445312
      ],
      [
        -377.9178466796875,
        -2108.01611328125,
        639.8123168945312
      ],
      [
        -359.1897277832031,
        -2096.721435546875,
        641.0240478515625
      ],
      [
        -360.0279235839844,
        -2097.226806640625,
        640.9697875976562
      ],
      [
        -347.6043395996094,
        -2089.734375,
        641.7735595703125
      ],
      [
        -360.0279235839844,
        -2097.226806640625,
        640.9697875976562
      ],
      [
        -369.4089050292969,
        -2102.884521484375,
        640.3628540039062
      ],
      [
        -369.4089050292969,
        -2102.884521484375,
        640.3628540039062
      ],
      [
        -377.9178466796875,
        -2108.01611328125,
        639.8123168945312
      ],
      [
        -376.5368957519531,
        -2107.5634765625,
        639.890625
      ],
      [
        -381.0160217285156,
        -2109.884521484375,
        639.6118774414062
      ],
      [
        -384.4620666503906,
        -2111.99951171875,
        639.3878784179688
      ],
      [
        -359.1897277832031,
        -2096.72119140625,
        641.0239868164062
      ],
      [
        -347.59619140625,
        -2089.729248046875,
        641.7741088867188
      ],
      [
        -360.30859375,
        -2091.77294921875,
        641.115234375
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.4136962890625
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.4136352539062
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.70263671875
      ],
      [
        -360.30859375,
        -2091.77294921875,
        641.115234375
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.70263671875
      ],
      [
        -383.73828125,
        -2111.20166015625,
        639.4451904296875
      ],
      [
        -386.3768615722656,
        -2112.560791015625,
        639.28125
      ],
      [
        -383.83221435546875,
        -2111.343994140625,
        639.4366455078125
      ],
      [
        -380.7559814453125,
        -2109.727783203125,
        639.6287231445312
      ],
      [
        -383.73828125,
        -2111.20166015625,
        639.4451904296875
      ],
      [
        -277.9921569824219,
        -2066.27587890625,
        645.7384643554688
      ],
      [
        -217.88108825683594,
        -2020.9951171875,
        649.8903198242188
      ],
      [
        -207.73861694335938,
        -2022.8599853515625,
        650.3142700195312
      ],
      [
        -519.0640869140625,
        -2202.2109375,
        639.28125
      ],
      [
        -345.8387145996094,
        -2122.06005859375,
        667.9999389648438
      ],
      [
        -347.13427734375,
        -2122.842529296875,
        667.9999389648438
      ],
      [
        -396.04443359375,
        -2152.381591796875,
        667.9999389648438
      ],
      [
        -347.13427734375,
        -2122.842529296875,
        667.9999389648438
      ],
      [
        -392.07244873046875,
        -2119.150390625,
        640.0
      ],
      [
        -375.8052673339844,
        -2109.32568359375,
        640.0
      ],
      [
        -401.447021484375,
        -2124.708740234375,
        639.9061889648438
      ],
      [
        -380.6932678222656,
        -2111.8056640625,
        639.5712280273438
      ],
      [
        -329.3799133300781,
        -2112.11962890625,
        667.9999389648438
      ],
      [
        -344.80450439453125,
        -2092.609130859375,
        641.8219604492188
      ],
      [
        -396.04443359375,
        -2152.381591796875,
        667.9999389648438
      ],
      [
        -405.737060546875,
        -2137.482421875,
        649.1535034179688
      ],
      [
        -373.41796875,
        -2128.060546875,
        658.3231201171875
      ],
      [
        -378.614013671875,
        -2131.060546875,
        658.197509765625
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        657.8483276367188
      ],
      [
        -378.614013671875,
        -2131.060546875,
        658.197509765625
      ],
      [
        -373.41796875,
        -2128.060546875,
        658.3231201171875
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        658.6851196289062
      ],
      [
        -337.551025390625,
        -2107.583984375,
        659.3994140625
      ],
      [
        -337.65118408203125,
        -2107.410400390625,
        648.1754760742188
      ],
      [
        -337.65118408203125,
        -2107.410400390625,
        659.1869506835938
      ],
      [
        -349.51324462890625,
        -2114.259033203125,
        646.9999389648438
      ],
      [
        -348.809326171875,
        -2114.083984375,
        659.12744140625
      ],
      [
        -349.5132751464844,
        -2114.259033203125,
        658.900390625
      ],
      [
        -341.4305725097656,
        -2112.24853515625,
        655.9999389648438
      ],
      [
        -345.07318115234375,
        -2113.15478515625,
        655.9999389648438
      ],
      [
        -344.554931640625,
        -2114.052490234375,
        653.9999389648438
      ],
      [
        -345.07318115234375,
        -2113.15478515625,
        655.9999389648438
      ],
      [
        -345.07318115234375,
        -2113.15478515625,
        653.9999389648438
      ],
      [
        -345.07318115234375,
        -2113.15478515625,
        649.4080810546875
      ],
      [
        -339.20880126953125,
        -2108.541259765625,
        659.3594360351562
      ],
      [
        -346.87628173828125,
        -2112.968017578125,
        659.1742553710938
      ],
      [
        -337.551025390625,
        -2107.583984375,
        659.3994750976562
      ],
      [
        -339.20880126953125,
        -2108.541259765625,
        659.3594360351562
      ],
      [
        -346.87628173828125,
        -2112.968017578125,
        659.1742553710938
      ],
      [
        -348.809326171875,
        -2114.083984375,
        659.1275024414062
      ],
      [
        -349.51324462890625,
        -2114.259033203125,
        646.9999389648438
      ],
      [
        -348.83758544921875,
        -2113.868896484375,
        646.9999389648438
      ],
      [
        -343.86737060546875,
        -2096.643798828125,
        645.9999389648438
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        655.2444458007812
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        657.8483276367188
      ],
      [
        -404.0048828125,
        -2136.482421875,
        649.1953735351562
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        655.2444458007812
      ],
      [
        -405.737060546875,
        -2137.482421875,
        649.1535034179688
      ],
      [
        -406.0782470703125,
        -2134.891357421875,
        639.9999389648438
      ],
      [
        -406.0782470703125,
        -2134.891357421875,
        646.6134643554688
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.7142944335938
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        643.2442626953125
      ],
      [
        -404.0048828125,
        -2136.482421875,
        649.1953735351562
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.7142333984375
      ],
      [
        -405.1450500488281,
        -2127.820556640625,
        639.9999389648438
      ],
      [
        -405.1450500488281,
        -2127.820556640625,
        640.7039794921875
      ],
      [
        -353.33819580078125,
        -2102.363525390625,
        645.9999389648438
      ],
      [
        -343.86737060546875,
        -2096.643798828125,
        645.9999389648438
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        645.9999389648438
      ],
      [
        -355.507568359375,
        -2108.482421875,
        645.9999389648438
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        645.9999389648438
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        645.9999389648438
      ],
      [
        -360.365234375,
        -2104.755126953125,
        644.3177490234375
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        641.7137451171875
      ],
      [
        -365.22308349609375,
        -2103.53076171875,
        640.5414428710938
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        642.8467407226562
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        642.8466186523438
      ],
      [
        -359.0538635253906,
        -2100.23095703125,
        640.9283447265625
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        641.7137451171875
      ],
      [
        -375.3231506347656,
        -2110.685302734375,
        641.4991455078125
      ],
      [
        -391.3579406738281,
        -2119.943115234375,
        641.11181640625
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        640.8773193359375
      ],
      [
        -375.3231506347656,
        -2110.685302734375,
        641.4991455078125
      ],
      [
        -375.8052673339844,
        -2109.32568359375,
        640.0
      ],
      [
        -404.0361328125,
        -2126.37548828125,
        639.9999389648438
      ],
      [
        -392.07244873046875,
        -2119.150390625,
        640.0
      ],
      [
        -391.3579406738281,
        -2119.943115234375,
        641.11181640625
      ],
      [
        -355.507568359375,
        -2108.482421875,
        645.9999389648438
      ],
      [
        -360.365234375,
        -2104.755126953125,
        644.3177490234375
      ],
      [
        -359.01434326171875,
        -2105.791748046875,
        645.9999389648438
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        640.8773193359375
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        643.2442626953125
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        657.8479614257812
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        658.6851196289062
      ],
      [
        -355.6556091308594,
        -2115.787353515625,
        645.9999389648438
      ],
      [
        -355.6556091308594,
        -2115.787353515625,
        656.9193115234375
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        656.3178100585938
      ],
      [
        -353.59454345703125,
        -2114.8515625,
        657.1998901367188
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        656.3177490234375
      ],
      [
        -354.4248046875,
        -2106.984130859375,
        649.5999145507812
      ],
      [
        -356.1233215332031,
        -2108.010009765625,
        649.5999145507812
      ],
      [
        -352.5886535644531,
        -2103.011962890625,
        646.9999389648438
      ],
      [
        -353.3381652832031,
        -2102.363525390625,
        645.9999389648438
      ],
      [
        -356.51251220703125,
        -2105.3818359375,
        646.9999389648438
      ],
      [
        -352.588623046875,
        -2103.011962890625,
        646.9999389648438
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        646.9999389648438
      ],
      [
        -355.507568359375,
        -2108.482421875,
        646.9999389648438
      ],
      [
        -355.507568359375,
        -2108.482421875,
        646.9999389648438
      ],
      [
        -358.2112731933594,
        -2106.407958984375,
        646.9999389648438
      ],
      [
        -356.1233215332031,
        -2108.010009765625,
        649.5999145507812
      ],
      [
        -354.4248046875,
        -2106.984130859375,
        649.5999145507812
      ],
      [
        -356.51251220703125,
        -2105.3818359375,
        646.9999389648438
      ],
      [
        -353.59454345703125,
        -2114.8515625,
        657.1998901367188
      ],
      [
        -352.8631591796875,
        -2114.40966796875,
        657.1998901367188
      ],
      [
        -329.42010498046875,
        -2095.0888671875,
        652.51171875
      ],
      [
        -299.1033935546875,
        -2076.335205078125,
        652.1085205078125
      ],
      [
        -292.99835205078125,
        -2065.633544921875,
        645.7384643554688
      ],
      [
        -299.1033935546875,
        -2076.335205078125,
        652.1085205078125
      ],
      [
        -292.99835205078125,
        -2065.633544921875,
        645.7384643554688
      ],
      [
        -282.35491943359375,
        -2059.205322265625,
        645.7384643554688
      ],
      [
        -201.66094970703125,
        -2021.447021484375,
        654.1831665039062
      ],
      [
        -212.70021057128906,
        -2021.94775390625,
        650.1068725585938
      ],
      [
        -210.8738555908203,
        -2021.757080078125,
        650.9353637695312
      ],
      [
        -337.2130126953125,
        -2102.21142578125,
        654.705810546875
      ],
      [
        -329.42010498046875,
        -2095.0888671875,
        652.51171875
      ],
      [
        -196.56898498535156,
        -2020.2633056640625,
        657.424560546875
      ],
      [
        -392.92803955078125,
        -2150.49951171875,
        667.9998779296875
      ],
      [
        -344.00396728515625,
        -2125.3564453125,
        671.9999389648438
      ],
      [
        -327.02294921875,
        -2115.100830078125,
        671.9999389648438
      ],
      [
        -344.00396728515625,
        -2125.3564453125,
        671.9999389648438
      ],
      [
        -345.8387145996094,
        -2122.06005859375,
        667.9999389648438
      ],
      [
        -329.3799133300781,
        -2112.11962890625,
        667.9999389648438
      ],
      [
        -327.02294921875,
        -2115.100830078125,
        671.9999389648438
      ],
      [
        -519.0640869140625,
        -2202.2109375,
        639.28125
      ],
      [
        -513.1190795898438,
        -2191.46484375,
        639.28125
      ],
      [
        -425.5252685546875,
        -2058.641845703125,
        653.1666870117188
      ],
      [
        -364.708251953125,
        -2005.7095947265625,
        684.19091796875
      ],
      [
        -482.16583251953125,
        -2135.513671875,
        639.28125
      ],
      [
        -493.8836975097656,
        -2156.69482421875,
        639.28125
      ],
      [
        -460.3519287109375,
        -2096.0830078125,
        639.28125
      ],
      [
        -482.16583251953125,
        -2135.513671875,
        639.28125
      ],
      [
        -493.8836975097656,
        -2156.69482421875,
        639.28125
      ],
      [
        -348.1908264160156,
        -2117.833984375,
        667.9999389648438
      ],
      [
        -349.6827087402344,
        -2118.829345703125,
        667.9999389648438
      ],
      [
        -397.2311706542969,
        -2150.557373046875,
        667.9999389648438
      ],
      [
        -349.6827087402344,
        -2118.829345703125,
        667.9999389648438
      ],
      [
        -299.1072692871094,
        -2058.383056640625,
        645.7384643554688
      ],
      [
        -336.96319580078125,
        -2079.83544921875,
        642.5633544921875
      ],
      [
        -299.1072692871094,
        -2058.383056640625,
        645.7384643554688
      ],
      [
        -287.60015869140625,
        -2050.704833984375,
        645.7384643554688
      ],
      [
        -217.96669006347656,
        -2019.2060546875,
        652.420166015625
      ],
      [
        -205.6908721923828,
        -2021.2158203125,
        653.2865600585938
      ],
      [
        -293.27459716796875,
        -2066.11767578125,
        646.0267333984375
      ],
      [
        -332.9189147949219,
        -2107.64306640625,
        667.9999389648438
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        647.4328002929688
      ],
      [
        -398.08636474609375,
        -2152.732177734375,
        667.9999389648438
      ],
      [
        -418.117919921875,
        -2164.494384765625,
        667.9999389648438
      ],
      [
        -396.4431457519531,
        -2151.768798828125,
        667.9999389648438
      ],
      [
        -405.737060546875,
        -2137.482421875,
        650.9712524414062
      ],
      [
        -337.551025390625,
        -2107.583984375,
        659.7159423828125
      ],
      [
        -344.4078369140625,
        -2095.707763671875,
        645.9999389648438
      ],
      [
        -379.283447265625,
        -2109.22900390625,
        639.9999389648438
      ],
      [
        -376.7274475097656,
        -2107.728271484375,
        639.9999389648438
      ],
      [
        -394.216796875,
        -2118.446533203125,
        640.0
      ],
      [
        -375.74163818359375,
        -2107.236572265625,
        640.0
      ],
      [
        -379.283447265625,
        -2109.22900390625,
        639.9999389648438
      ],
      [
        -380.0483703613281,
        -2109.301025390625,
        639.6744995117188
      ],
      [
        -375.74163818359375,
        -2107.236572265625,
        640.0
      ],
      [
        -375.8092041015625,
        -2107.1171875,
        639.9379272460938
      ],
      [
        -375.3216247558594,
        -2106.90283203125,
        640.0
      ],
      [
        -373.41796875,
        -2128.060546875,
        659.2125244140625
      ],
      [
        -378.614013671875,
        -2131.060546875,
        659.16845703125
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        659.0458984375
      ],
      [
        -378.614013671875,
        -2131.060546875,
        659.16845703125
      ],
      [
        -373.41796875,
        -2128.060546875,
        659.2125244140625
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        659.33935546875
      ],
      [
        -339.0860900878906,
        -2108.470458984375,
        659.7029418945312
      ],
      [
        -347.06097412109375,
        -2113.07470703125,
        659.6353149414062
      ],
      [
        -337.551025390625,
        -2107.583984375,
        659.7159423828125
      ],
      [
        -339.0860900878906,
        -2108.470458984375,
        659.7029418945312
      ],
      [
        -347.06097412109375,
        -2113.07470703125,
        659.6353149414062
      ],
      [
        -348.809326171875,
        -2114.083984375,
        659.6204833984375
      ],
      [
        -348.809326171875,
        -2114.083984375,
        659.6204223632812
      ],
      [
        -349.5128479003906,
        -2114.259033203125,
        659.4151000976562
      ],
      [
        -349.5128479003906,
        -2114.259033203125,
        658.9005126953125
      ],
      [
        -376.2414855957031,
        -2108.90625,
        640.96044921875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.1424560546875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        640.4264526367188
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.6255493164062
      ],
      [
        -406.736328125,
        -2129.89404296875,
        642.7066650390625
      ],
      [
        -402.07666015625,
        -2123.822265625,
        640.4264526367188
      ],
      [
        -360.365234375,
        -2104.755126953125,
        644.8130493164062
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        642.7860107421875
      ],
      [
        -353.4625549316406,
        -2102.255859375,
        645.9999389648438
      ],
      [
        -343.95709228515625,
        -2096.488525390625,
        645.9999389648438
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.1423950195312
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        643.67578125
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        643.67578125
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.4857788085938
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.4857788085938
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        640.9859008789062
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.322265625
      ],
      [
        -353.46258544921875,
        -2102.255859375,
        645.9999389648438
      ],
      [
        -352.90869140625,
        -2102.735107421875,
        646.5729370117188
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        642.7860107421875
      ],
      [
        -375.48980712890625,
        -2110.781494140625,
        642.5989379882812
      ],
      [
        -391.15643310546875,
        -2119.826904296875,
        642.2750854492188
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        642.070068359375
      ],
      [
        -375.48980712890625,
        -2110.781494140625,
        642.5989379882812
      ],
      [
        -376.2414855957031,
        -2108.90625,
        640.96044921875
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.6255493164062
      ],
      [
        -391.15643310546875,
        -2119.826904296875,
        642.2750854492188
      ],
      [
        -406.14617919921875,
        -2134.375732421875,
        646.1077880859375
      ],
      [
        -406.736328125,
        -2129.89404296875,
        642.7066650390625
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        642.070068359375
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        643.8945922851562
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        643.8945922851562
      ],
      [
        -404.4173278808594,
        -2133.34912109375,
        646.1235961914062
      ],
      [
        -358.593505859375,
        -2106.114501953125,
        646.5239868164062
      ],
      [
        -360.365234375,
        -2104.755126953125,
        644.81298828125
      ],
      [
        -376.68206787109375,
        -2107.806884765625,
        639.9999389648438
      ],
      [
        -376.241455078125,
        -2108.90625,
        640.9603271484375
      ],
      [
        -358.8147888183594,
        -2098.379638671875,
        640.9934692382812
      ],
      [
        -392.9296875,
        -2117.66552734375,
        640.0
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.6255493164062
      ],
      [
        -405.737060546875,
        -2137.482421875,
        650.97119140625
      ],
      [
        -406.736328125,
        -2129.89404296875,
        643.920166015625
      ],
      [
        -376.2871398925781,
        -2108.9326171875,
        641.2616577148438
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.3364868164062
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.0430297851562
      ],
      [
        -392.3555908203125,
        -2118.209716796875,
        641.12548828125
      ],
      [
        -404.0048828125,
        -2136.482421875,
        650.9859008789062
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        656.660888671875
      ],
      [
        -406.736328125,
        -2129.89404296875,
        643.920166015625
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.0430297851562
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        645.3453979492188
      ],
      [
        -404.0048828125,
        -2136.482421875,
        650.9859008789062
      ],
      [
        -354.31060791015625,
        -2101.522216796875,
        645.9999389648438
      ],
      [
        -344.4078369140625,
        -2095.707763671875,
        645.9999389648438
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.3365478515625
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        644.3174438476562
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        643.3367309570312
      ],
      [
        -375.5898742675781,
        -2110.83935546875,
        643.2591552734375
      ],
      [
        -391.0085754394531,
        -2119.741455078125,
        643.128662109375
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        643.0432739257812
      ],
      [
        -392.3555908203125,
        -2118.209716796875,
        641.12548828125
      ],
      [
        -391.0085754394531,
        -2119.741455078125,
        643.128662109375
      ],
      [
        -375.5898742675781,
        -2110.83935546875,
        643.2591552734375
      ],
      [
        -376.2871398925781,
        -2108.9326171875,
        641.2616577148438
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        643.0433349609375
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        645.3453979492188
      ],
      [
        -360.365234375,
        -2104.755126953125,
        645.72216796875
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        643.3367309570312
      ],
      [
        -359.13616943359375,
        -2105.6982421875,
        645.9999389648438
      ],
      [
        -360.365234375,
        -2104.755126953125,
        645.72216796875
      ],
      [
        -360.12744140625,
        -2104.9375,
        645.9999389648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        644.3175048828125
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.6099853515625
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.6099853515625
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.322265625
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.41015625
      ],
      [
        -358.435791015625,
        -2119.41064453125,
        659.33935546875
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        657.0374145507812
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        658.4627075195312
      ],
      [
        -354.48822021484375,
        -2114.612060546875,
        657.1998901367188
      ],
      [
        -352.9550476074219,
        -2113.711669921875,
        657.1998901367188
      ],
      [
        -354.70849609375,
        -2114.552978515625,
        657.0374145507812
      ],
      [
        -354.48822021484375,
        -2114.612060546875,
        657.1998901367188
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        656.6608276367188
      ],
      [
        -393.07666015625,
        -2139.41064453125,
        659.0458984375
      ],
      [
        -357.0457763671875,
        -2107.30224609375,
        649.5999145507812
      ],
      [
        -357.55133056640625,
        -2104.584716796875,
        646.9999389648438
      ],
      [
        -353.51214599609375,
        -2102.212890625,
        646.9999389648438
      ],
      [
        -353.5121765136719,
        -2102.212890625,
        646.9999389648438
      ],
      [
        -354.3105773925781,
        -2101.522216796875,
        645.9999389648438
      ],
      [
        -355.326171875,
        -2106.29248046875,
        649.5999145507812
      ],
      [
        -357.55133056640625,
        -2104.584716796875,
        646.9999389648438
      ],
      [
        -355.326171875,
        -2106.29248046875,
        649.5999145507812
      ],
      [
        -357.0457763671875,
        -2107.30224609375,
        649.5999145507812
      ],
      [
        -365.81597900390625,
        -2102.724609375,
        641.2101440429688
      ],
      [
        -358.8181457519531,
        -2098.36474609375,
        640.9937133789062
      ],
      [
        -376.7274475097656,
        -2107.728271484375,
        639.9999389648438
      ],
      [
        -398.08636474609375,
        -2152.732177734375,
        667.9999389648438
      ],
      [
        -347.20257568359375,
        -2089.575927734375,
        641.797119140625
      ],
      [
        -346.9264831542969,
        -2089.92529296875,
        642.001220703125
      ],
      [
        -347.5387878417969,
        -2089.7822265625,
        641.7753295898438
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        642.9185180664062
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.9072265625
      ],
      [
        -359.1490173339844,
        -2096.9013671875,
        641.0206909179688
      ],
      [
        -358.88433837890625,
        -2099.67724609375,
        642.0924072265625
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.9071655273438
      ],
      [
        -397.2311706542969,
        -2150.557373046875,
        667.9999389648438
      ],
      [
        -405.737060546875,
        -2137.482421875,
        652.3652954101562
      ],
      [
        -338.2374267578125,
        -2106.39501953125,
        663.9999389648438
      ],
      [
        -346.551025390625,
        -2091.995361328125,
        647.3677978515625
      ],
      [
        -347.24755859375,
        -2089.519287109375,
        641.796630859375
      ],
      [
        -347.5960388183594,
        -2089.729248046875,
        641.774169921875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        643.966552734375
      ],
      [
        -348.1603698730469,
        -2089.207763671875,
        641.7626953125
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        647.4327392578125
      ],
      [
        -348.1603088378906,
        -2089.207763671875,
        644.1481323242188
      ],
      [
        -339.4824523925781,
        -2107.225830078125,
        663.9999389648438
      ],
      [
        -348.8858947753906,
        -2113.50048828125,
        663.9999389648438
      ],
      [
        -338.2374267578125,
        -2106.39501953125,
        663.9999389648438
      ],
      [
        -339.4824523925781,
        -2107.225830078125,
        663.9999389648438
      ],
      [
        -350.3255920410156,
        -2114.461181640625,
        663.9999389648438
      ],
      [
        -348.809326171875,
        -2114.083984375,
        664.5289916992188
      ],
      [
        -348.809326171875,
        -2114.083984375,
        664.5289916992188
      ],
      [
        -348.8858947753906,
        -2113.50048828125,
        663.9999389648438
      ],
      [
        -349.51275634765625,
        -2114.259033203125,
        663.9999389648438
      ],
      [
        -349.5128479003906,
        -2114.259033203125,
        659.4151000976562
      ],
      [
        -373.5609436035156,
        -2126.518310546875,
        661.1256713867188
      ],
      [
        -379.53021240234375,
        -2130.2578125,
        660.9225463867188
      ],
      [
        -379.53021240234375,
        -2130.2578125,
        660.9225463867188
      ],
      [
        -393.2631530761719,
        -2138.861328125,
        660.4552001953125
      ],
      [
        -359.77593994140625,
        -2117.882568359375,
        661.5947875976562
      ],
      [
        -373.5609436035156,
        -2126.518310546875,
        661.1256713867188
      ],
      [
        -350.3255920410156,
        -2114.461181640625,
        663.9999389648438
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        663.1448974609375
      ],
      [
        -352.776123046875,
        -2115.07080078125,
        660.7428588867188
      ],
      [
        -349.5128479003906,
        -2114.259033203125,
        659.9999389648438
      ],
      [
        -405.737060546875,
        -2137.482421875,
        652.365234375
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.4820556640625
      ],
      [
        -404.0048828125,
        -2136.482421875,
        652.4953002929688
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        658.305908203125
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.482177734375
      ],
      [
        -402.07666015625,
        -2123.822265625,
        643.0118408203125
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        646.9889526367188
      ],
      [
        -404.0048828125,
        -2136.482421875,
        652.4953002929688
      ],
      [
        -376.83917236328125,
        -2109.25146484375,
        644.9042358398438
      ],
      [
        -367.435791015625,
        -2103.822265625,
        645.6093139648438
      ],
      [
        -402.07666015625,
        -2123.822265625,
        643.0118408203125
      ],
      [
        -391.8966064453125,
        -2117.94482421875,
        643.775146484375
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        645.0125122070312
      ],
      [
        -404.803955078125,
        -2130.411865234375,
        646.9889526367188
      ],
      [
        -395.35418701171875,
        -2139.71044921875,
        659.9999389648438
      ],
      [
        -399.147216796875,
        -2140.209716796875,
        658.305908203125
      ],
      [
        -357.43658447265625,
        -2098.81787109375,
        646.9999389648438
      ],
      [
        -357.809326171875,
        -2098.495361328125,
        646.523681640625
      ],
      [
        -367.435791015625,
        -2103.822265625,
        645.609375
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9978637695312
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        647.6097412109375
      ],
      [
        -376.1389465332031,
        -2111.15625,
        646.882080078125
      ],
      [
        -390.5455017089844,
        -2119.47412109375,
        645.8020629882812
      ],
      [
        -401.07666015625,
        -2125.55419921875,
        645.0125732421875
      ],
      [
        -376.1389465332031,
        -2111.15625,
        646.882080078125
      ],
      [
        -376.83917236328125,
        -2109.25146484375,
        644.9042358398438
      ],
      [
        -391.8966064453125,
        -2117.94482421875,
        643.775146484375
      ],
      [
        -390.5455017089844,
        -2119.47412109375,
        645.802001953125
      ],
      [
        -359.34417724609375,
        -2103.208984375,
        649.5999145507812
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9979248046875
      ],
      [
        -360.365234375,
        -2104.755126953125,
        650.321044921875
      ],
      [
        -366.435791015625,
        -2105.55419921875,
        647.6098022460938
      ],
      [
        -359.34417724609375,
        -2103.208984375,
        649.5999145507812
      ],
      [
        -357.7739562988281,
        -2104.4140625,
        649.5999145507812
      ],
      [
        -360.0830078125,
        -2103.701904296875,
        649.5999145507812
      ],
      [
        -354.94622802734375,
        -2112.7470703125,
        659.9998168945312
      ],
      [
        -355.3525390625,
        -2109.66015625,
        657.1998901367188
      ],
      [
        -353.63916015625,
        -2108.516845703125,
        657.1998901367188
      ],
      [
        -355.3525390625,
        -2109.66015625,
        657.1998901367188
      ],
      [
        -358.9751281738281,
        -2117.160400390625,
        661.4381713867188
      ],
      [
        -359.77593994140625,
        -2117.882568359375,
        661.5947875976562
      ],
      [
        -355.76873779296875,
        -2114.268798828125,
        660.8111572265625
      ],
      [
        -358.9751281738281,
        -2117.160400390625,
        661.438232421875
      ],
      [
        -393.2631530761719,
        -2138.861328125,
        660.4552001953125
      ],
      [
        -393.53826904296875,
        -2138.972900390625,
        660.3953247070312
      ],
      [
        -395.35418701171875,
        -2139.71044921875,
        659.9999389648438
      ],
      [
        -393.53826904296875,
        -2138.972900390625,
        660.3953247070312
      ],
      [
        -355.7687072753906,
        -2114.268798828125,
        660.8111572265625
      ],
      [
        -354.94622802734375,
        -2112.7470703125,
        659.9998168945312
      ],
      [
        -353.7373352050781,
        -2102.01806640625,
        646.9999389648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9978637695312
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        646.45849609375
      ],
      [
        -358.2016906738281,
        -2099.328369140625,
        646.9999389648438
      ],
      [
        -357.4365234375,
        -2098.81787109375,
        646.9999389648438
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        642.7212524414062
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        642.8890380859375
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.8206787109375
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        642.72119140625
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        646.4585571289062
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        646.2623291015625
      ],
      [
        -359.1897277832031,
        -2096.72119140625,
        641.0239868164062
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        642.72119140625
      ],
      [
        -359.94158935546875,
        -2093.39599609375,
        641.0853271484375
      ],
      [
        -349.9858703613281,
        -2087.520751953125,
        641.7257080078125
      ],
      [
        -344.69561767578125,
        -2092.7470703125,
        645.3406982421875
      ],
      [
        -218.08865356445312,
        -2016.6572265625,
        656.0243530273438
      ],
      [
        -195.0,
        -2014.0863037109375,
        666.7268676757812
      ],
      [
        -346.243896484375,
        -2121.331787109375,
        671.9999389648438
      ],
      [
        -330.4360656738281,
        -2110.78369140625,
        671.9999389648438
      ],
      [
        -332.9189147949219,
        -2107.64306640625,
        667.9999389648438
      ],
      [
        -330.4360656738281,
        -2110.78369140625,
        671.9999389648438
      ],
      [
        -346.243896484375,
        -2121.331787109375,
        671.9999389648438
      ],
      [
        -348.1908264160156,
        -2117.833984375,
        667.9999389648438
      ],
      [
        -283.0,
        -1979.0,
        750.0411987304688
      ],
      [
        -283.0,
        -1986.2734375,
        754.0
      ],
      [
        -275.0,
        -1971.8126220703125,
        754.0
      ],
      [
        -283.0,
        -1986.2734375,
        754.0
      ],
      [
        -283.0,
        -1987.0,
        754.0
      ],
      [
        -275.0,
        -1987.0,
        754.0
      ],
      [
        -283.4019775390625,
        -1987.0,
        754.0
      ],
      [
        -198.0,
        -1987.0,
        754.0
      ],
      [
        -198.0,
        -1987.0,
        765.0
      ],
      [
        -198.0,
        -1987.0,
        754.0
      ],
      [
        -195.0,
        -1987.0,
        754.0
      ],
      [
        -272.0,
        -1987.0,
        765.0
      ],
      [
        -272.0,
        -1986.60009765625,
        765.0
      ],
      [
        -272.0,
        -1966.3897705078125,
        754.0
      ],
      [
        -272.0,
        -1987.0,
        754.0
      ],
      [
        -272.0,
        -1987.0,
        754.0
      ],
      [
        -272.0,
        -1966.3897705078125,
        754.0
      ],
      [
        -211.06044006347656,
        -1987.0,
        700.5327758789062
      ],
      [
        -202.6909942626953,
        -1987.0,
        700.424072265625
      ],
      [
        -219.50772094726562,
        -1987.0,
        697.9608764648438
      ],
      [
        -211.06044006347656,
        -1987.0,
        700.5327758789062
      ],
      [
        -425.5252685546875,
        -2058.641845703125,
        653.1666870117188
      ],
      [
        -460.3519287109375,
        -2096.0830078125,
        639.28125
      ],
      [
        -376.9042053222656,
        -2109.288818359375,
        664.0
      ],
      [
        -391.626708984375,
        -2117.788818359375,
        664.0
      ],
      [
        -376.9042053222656,
        -2109.288818359375,
        664.0
      ],
      [
        -367.435791015625,
        -2103.822265625,
        664.0
      ],
      [
        -402.07666015625,
        -2123.822265625,
        664.0
      ],
      [
        -391.626708984375,
        -2117.788818359375,
        664.0
      ],
      [
        -399.40728759765625,
        -2147.21240234375,
        664.0
      ],
      [
        -405.737060546875,
        -2137.482421875,
        664.0
      ],
      [
        -345.8387451171875,
        -2091.353271484375,
        667.9999389648438
      ],
      [
        -345.8387451171875,
        -2091.353271484375,
        664.0
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        664.0
      ],
      [
        -405.737060546875,
        -2137.482421875,
        664.0
      ],
      [
        -406.736328125,
        -2129.89404296875,
        664.0
      ],
      [
        -406.736328125,
        -2129.89404296875,
        664.0
      ],
      [
        -402.07666015625,
        -2123.822265625,
        664.0
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        664.0
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        664.0
      ],
      [
        -367.435791015625,
        -2103.822265625,
        664.0
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        664.0
      ],
      [
        -358.7216491699219,
        -2098.79150390625,
        667.9999389648438
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        664.0
      ],
      [
        -358.7216491699219,
        -2098.79150390625,
        664.0
      ],
      [
        -360.30859375,
        -2091.77294921875,
        664.0
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        664.0
      ],
      [
        -360.30859375,
        -2091.77294921875,
        664.0
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        664.0
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        664.0
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        664.0
      ],
      [
        -348.1603088378906,
        -2089.207763671875,
        644.1481323242188
      ],
      [
        -348.1603088378906,
        -2089.2080078125,
        664.0
      ],
      [
        -356.3513488769531,
        -2105.505615234375,
        663.9999389648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        660.74267578125
      ],
      [
        -357.77392578125,
        -2104.4140625,
        657.1998901367188
      ],
      [
        -357.70416259765625,
        -2087.4541015625,
        659.9999389648438
      ],
      [
        -357.70416259765625,
        -2087.4541015625,
        654.9999389648438
      ],
      [
        -285.0616455078125,
        -1990.0,
        754.0
      ],
      [
        -286.0,
        -2000.741455078125,
        758.9231567382812
      ],
      [
        -286.0,
        -2011.9063720703125,
        765.0
      ],
      [
        -286.0,
        -2000.741455078125,
        758.9231567382812
      ],
      [
        -285.0616455078125,
        -1990.0,
        754.0
      ],
      [
        -527.6102294921875,
        -2209.016357421875,
        639.28125
      ],
      [
        -563.0726928710938,
        -2243.481689453125,
        630.2252807617188
      ],
      [
        -560.1396484375,
        -2241.306640625,
        631.3899536132812
      ],
      [
        -507.0682067871094,
        -2180.527099609375,
        639.28125
      ],
      [
        -527.610107421875,
        -2209.01611328125,
        639.28125
      ],
      [
        -550.4645385742188,
        -1968.5693359375,
        964.237060546875
      ],
      [
        -437.40081787109375,
        -1932.2159423828125,
        892.0023193359375
      ],
      [
        -442.0,
        -1928.0,
        904.8359375
      ],
      [
        -437.40081787109375,
        -1932.2159423828125,
        892.0023193359375
      ],
      [
        -430.0,
        -1939.0,
        871.3511352539062
      ],
      [
        -430.0,
        -1939.0,
        871.3511352539062
      ],
      [
        -422.5,
        -1939.0,
        862.8703002929688
      ],
      [
        -360.0,
        -1939.0,
        789.0540771484375
      ],
      [
        -369.0,
        -1939.0,
        800.2040405273438
      ],
      [
        -348.0,
        -1928.0,
        796.7987060546875
      ],
      [
        -348.0,
        -1920.88037109375,
        811.4334106445312
      ],
      [
        -348.0,
        -1894.5,
        859.1947021484375
      ],
      [
        -360.0,
        -1939.0,
        789.0540771484375
      ],
      [
        -348.0,
        -1928.0,
        796.7986450195312
      ],
      [
        -422.5,
        -1945.875,
        766.0
      ],
      [
        -422.5,
        -1939.0,
        862.8703002929688
      ],
      [
        -422.5,
        -1945.875,
        850.4231567382812
      ],
      [
        -417.9999694824219,
        -1950.0,
        766.0
      ],
      [
        -417.9999694824219,
        -1950.0,
        837.8662109375
      ],
      [
        -414.0,
        -1950.0,
        833.343017578125
      ],
      [
        -369.0,
        -1950.0,
        777.59326171875
      ],
      [
        -369.0,
        -1939.0,
        800.2040405273438
      ],
      [
        -414.0,
        -1953.6666259765625,
        778.7999267578125
      ],
      [
        -414.0,
        -1950.0,
        833.3432006835938
      ],
      [
        -414.0,
        -1953.6666259765625,
        825.8063354492188
      ],
      [
        -398.9490661621094,
        -1967.46337890625,
        778.7999267578125
      ],
      [
        -369.9740295410156,
        -1950.0,
        778.7999267578125
      ],
      [
        -414.0,
        -1953.6666259765625,
        778.7999267578125
      ],
      [
        -422.5,
        -1950.0,
        842.9548950195312
      ],
      [
        -422.5,
        -1950.0,
        842.9548950195312
      ],
      [
        -414.0,
        -1972.0,
        788.1215209960938
      ],
      [
        -406.8780822753906,
        -1972.0,
        778.7999267578125
      ],
      [
        -401.2017822265625,
        -1968.8211669921875,
        778.7999267578125
      ],
      [
        -406.8780822753906,
        -1972.0,
        778.7999267578125
      ],
      [
        -414.0,
        -1972.0,
        788.1215209960938
      ],
      [
        -437.50244140625,
        -1938.574951171875,
        885.9445190429688
      ],
      [
        -435.19549560546875,
        -1934.2374267578125,
        892.0023193359375
      ],
      [
        -441.5985107421875,
        -1928.3680419921875,
        912.0
      ],
      [
        -435.19549560546875,
        -1934.2374267578125,
        892.0023193359375
      ],
      [
        -433.4656677246094,
        -1935.8231201171875,
        886.5997924804688
      ],
      [
        -433.4741516113281,
        -1935.8154296875,
        881.0453491210938
      ],
      [
        -441.5985107421875,
        -1928.3680419921875,
        912.0
      ],
      [
        -441.5421447753906,
        -1928.0,
        912.686767578125
      ],
      [
        -435.970703125,
        -1937.517578125,
        886.2202758789062
      ],
      [
        -437.50244140625,
        -1938.574951171875,
        885.9445190429688
      ],
      [
        -435.970703125,
        -1937.517578125,
        886.2202758789062
      ],
      [
        -435.84088134765625,
        -1937.4423828125,
        886.214111328125
      ],
      [
        -348.0,
        -1894.5,
        865.658935546875
      ],
      [
        -396.4644775390625,
        -1935.34716796875,
        841.7379760742188
      ],
      [
        -414.0011291503906,
        -1944.9122314453125,
        843.802490234375
      ],
      [
        -379.3593444824219,
        -1926.0172119140625,
        839.7249755859375
      ],
      [
        -382.8941650390625,
        -1927.9453125,
        840.140869140625
      ],
      [
        -414.0011291503906,
        -1944.9122314453125,
        843.802490234375
      ],
      [
        -430.0,
        -1939.0,
        871.6712646484375
      ],
      [
        -422.5,
        -1939.0,
        863.5264282226562
      ],
      [
        -430.0,
        -1939.0,
        871.6710205078125
      ],
      [
        -433.47406005859375,
        -1935.8155517578125,
        881.0967407226562
      ],
      [
        -422.5,
        -1939.0,
        863.5264282226562
      ],
      [
        -422.5,
        -1942.0523681640625,
        858.1080932617188
      ],
      [
        -422.5,
        -1945.1715087890625,
        851.6968383789062
      ],
      [
        -422.5,
        -1949.5477294921875,
        844.8030395507812
      ],
      [
        -422.5,
        -1950.0,
        843.8734130859375
      ],
      [
        -422.5,
        -1950.0,
        843.8734130859375
      ],
      [
        -379.3593444824219,
        -1926.0172119140625,
        839.7249145507812
      ],
      [
        -384.9010009765625,
        -1911.1502685546875,
        877.1497802734375
      ],
      [
        -422.5,
        -1939.0,
        866.4844360351562
      ],
      [
        -430.0,
        -1939.0,
        875.776123046875
      ],
      [
        -430.0,
        -1939.0,
        875.776123046875
      ],
      [
        -422.5,
        -1939.0,
        866.4844360351562
      ],
      [
        -433.3038330078125,
        -1935.9715576171875,
        886.0941162109375
      ],
      [
        -440.5136413574219,
        -1940.653564453125,
        896.0842895507812
      ],
      [
        -547.708251953125,
        -1969.0567626953125,
        970.00341796875
      ],
      [
        -433.4573669433594,
        -1935.8306884765625,
        892.0023193359375
      ],
      [
        -437.4790954589844,
        -1932.1441650390625,
        912.0
      ],
      [
        -433.4481201171875,
        -1935.8392333984375,
        898.0882568359375
      ],
      [
        -433.4573669433594,
        -1935.8306884765625,
        892.0023193359375
      ],
      [
        -433.4656677246094,
        -1935.8231201171875,
        886.5997924804688
      ],
      [
        -437.4790954589844,
        -1932.1441650390625,
        912.0
      ],
      [
        -436.4453125,
        -1928.0,
        920.3319702148438
      ],
      [
        -435.970703125,
        -1937.517578125,
        897.4674682617188
      ],
      [
        -440.5136413574219,
        -1940.653564453125,
        896.0842895507812
      ],
      [
        -435.84088134765625,
        -1937.4423828125,
        886.214111328125
      ],
      [
        -435.970703125,
        -1937.517578125,
        897.4674072265625
      ],
      [
        -435.5732116699219,
        -1937.287109375,
        897.4857177734375
      ],
      [
        -348.0,
        -1928.0,
        804.5711059570312
      ],
      [
        -348.0,
        -1894.5,
        882.864990234375
      ],
      [
        -366.15032958984375,
        -1939.5062255859375,
        801.43603515625
      ],
      [
        -365.4545593261719,
        -1907.9791259765625,
        874.2081909179688
      ],
      [
        -369.0,
        -1950.0,
        778.6002197265625
      ],
      [
        -369.0,
        -1939.0,
        804.1193237304688
      ],
      [
        -369.37664794921875,
        -1950.0,
        778.7999267578125
      ],
      [
        -370.33819580078125,
        -1950.219482421875,
        778.7999267578125
      ],
      [
        -360.0,
        -1939.0,
        794.5689697265625
      ],
      [
        -348.0,
        -1928.0,
        804.571044921875
      ],
      [
        -360.0,
        -1939.0,
        794.5689697265625
      ],
      [
        -369.0,
        -1939.0,
        804.1195068359375
      ],
      [
        -366.1397705078125,
        -1939.0,
        802.6047973632812
      ],
      [
        -414.0,
        -1950.0,
        839.5379028320312
      ],
      [
        -366.15032958984375,
        -1939.5062255859375,
        801.4360961914062
      ],
      [
        -373.719970703125,
        -1942.5078125,
        804.3279418945312
      ],
      [
        -369.0,
        -1950.787353515625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        780.6400146484375
      ],
      [
        -369.0,
        -1950.7550048828125,
        778.8754272460938
      ],
      [
        -369.0,
        -1950.7550048828125,
        778.8754272460938
      ],
      [
        -369.0,
        -1950.787353515625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        780.639892578125
      ],
      [
        -369.0,
        -1940.6357421875,
        802.5252685546875
      ],
      [
        -369.0,
        -1939.0,
        805.428955078125
      ],
      [
        -369.0,
        -1949.9139404296875,
        778.7999267578125
      ],
      [
        -369.0,
        -1939.0,
        805.42919921875
      ],
      [
        -366.6462707519531,
        -1939.0,
        802.873046875
      ],
      [
        -369.0,
        -1939.0,
        806.3482666015625
      ],
      [
        -369.0,
        -1939.0,
        806.3482666015625
      ],
      [
        -422.5,
        -1939.0,
        876.3712768554688
      ],
      [
        -422.5,
        -1950.0,
        850.6632080078125
      ],
      [
        -422.5,
        -1950.0,
        850.6632080078125
      ],
      [
        -414.0,
        -1950.0,
        839.5380249023438
      ],
      [
        -430.0,
        -1939.0,
        886.1876220703125
      ],
      [
        -422.5,
        -1939.0,
        876.3712768554688
      ],
      [
        -431.6846923828125,
        -1937.4556884765625,
        892.0023193359375
      ],
      [
        -431.6846923828125,
        -1937.4556884765625,
        892.0023193359375
      ],
      [
        -430.0,
        -1939.0,
        886.1876220703125
      ],
      [
        -433.3038330078125,
        -1935.9715576171875,
        897.5902099609375
      ],
      [
        -441.18359375,
        -1941.115966796875,
        898.3402709960938
      ],
      [
        -547.5830078125,
        -1969.078857421875,
        970.2655029296875
      ],
      [
        -433.4481201171875,
        -1935.8392333984375,
        898.0882568359375
      ],
      [
        -436.69482421875,
        -1932.863037109375,
        912.0
      ],
      [
        -433.4440612792969,
        -1935.8428955078125,
        900.7529907226562
      ],
      [
        -436.69482421875,
        -1932.863037109375,
        912.0
      ],
      [
        -435.43597412109375,
        -1928.0,
        921.8460083007812
      ],
      [
        -435.970703125,
        -1937.517578125,
        900.0757446289062
      ],
      [
        -441.18359375,
        -1941.115966796875,
        898.3402709960938
      ],
      [
        -435.5732116699219,
        -1937.287109375,
        897.4857177734375
      ],
      [
        -435.970703125,
        -1937.517578125,
        900.07568359375
      ],
      [
        -435.51080322265625,
        -1937.2509765625,
        900.1087646484375
      ],
      [
        -407.14849853515625,
        -1972.0,
        781.3280029296875
      ],
      [
        -348.0,
        -1928.0,
        808.5042724609375
      ],
      [
        -348.0,
        -1912.8416748046875,
        844.2811889648438
      ],
      [
        -348.0,
        -1897.6322021484375,
        875.5444946289062
      ],
      [
        -361.89312744140625,
        -1943.8536376953125,
        789.0957641601562
      ],
      [
        -365.66552734375,
        -1917.5384521484375,
        852.142822265625
      ],
      [
        -360.9438781738281,
        -1925.7882080078125,
        830.5034790039062
      ],
      [
        -360.0,
        -1939.0,
        798.0972900390625
      ],
      [
        -348.0,
        -1928.0,
        808.5042724609375
      ],
      [
        -360.0,
        -1939.0,
        798.0972900390625
      ],
      [
        -366.1394958496094,
        -1939.0,
        802.6044311523438
      ],
      [
        -361.63775634765625,
        -1939.0,
        800.2202758789062
      ],
      [
        -405.1983337402344,
        -1972.0,
        778.7999267578125
      ],
      [
        -369.0,
        -1952.119140625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        783.801513671875
      ],
      [
        -369.0,
        -1952.032958984375,
        779.0032348632812
      ],
      [
        -369.0,
        -1952.032958984375,
        779.0032348632812
      ],
      [
        -369.0,
        -1952.119140625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        783.8016967773438
      ],
      [
        -369.0,
        -1939.0,
        809.7638549804688
      ],
      [
        -369.0,
        -1946.408447265625,
        792.2781982421875
      ],
      [
        -370.8448181152344,
        -1947.0716552734375,
        793.1043090820312
      ],
      [
        -369.0,
        -1940.63623046875,
        802.5247802734375
      ],
      [
        -405.1983337402344,
        -1972.0,
        778.7999267578125
      ],
      [
        -407.1487121582031,
        -1972.0,
        781.3281860351562
      ],
      [
        -361.89312744140625,
        -1943.8536376953125,
        789.0957641601562
      ],
      [
        -369.0,
        -1939.0,
        809.7638549804688
      ],
      [
        -300.0,
        -1920.0697021484375,
        765.0
      ],
      [
        -300.0,
        -1920.0,
        765.1644287109375
      ],
      [
        -299.8731384277344,
        -1920.0,
        765.0
      ],
      [
        -300.0,
        -1920.0697021484375,
        765.0
      ],
      [
        -414.0,
        -1972.0,
        790.2094116210938
      ],
      [
        -414.0,
        -1950.0,
        842.1343383789062
      ],
      [
        -348.0,
        -1894.5,
        887.5716552734375
      ],
      [
        -359.96099853515625,
        -1907.083251953125,
        873.377197265625
      ],
      [
        -414.0,
        -1972.0,
        790.2094116210938
      ],
      [
        -422.5,
        -1939.0,
        879.114990234375
      ],
      [
        -422.5,
        -1950.0,
        853.15283203125
      ],
      [
        -422.5,
        -1950.0,
        853.15283203125
      ],
      [
        -414.0,
        -1950.0,
        842.1344604492188
      ],
      [
        -430.0,
        -1939.0,
        888.8370971679688
      ],
      [
        -422.5,
        -1939.0,
        879.114990234375
      ],
      [
        -430.91485595703125,
        -1938.161376953125,
        892.0023193359375
      ],
      [
        -430.91485595703125,
        -1938.161376953125,
        892.0023193359375
      ],
      [
        -430.0,
        -1939.0,
        888.8370971679688
      ],
      [
        -433.3038330078125,
        -1935.9715576171875,
        900.267578125
      ],
      [
        -404.1032409667969,
        -2039.9971923828125,
        664.0946044921875
      ],
      [
        -463.44085693359375,
        -2101.66650390625,
        639.28125
      ],
      [
        -433.4873046875,
        -1935.8033447265625,
        912.0
      ],
      [
        -430.0,
        -1933.3961181640625,
        921.1699829101562
      ],
      [
        -430.0,
        -1933.3961181640625,
        921.1699829101562
      ],
      [
        -422.1824951171875,
        -1928.0,
        930.0
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        900.9024658203125
      ],
      [
        -433.4873046875,
        -1935.8033447265625,
        912.0
      ],
      [
        -431.2306213378906,
        -1934.76953125,
        1080.0
      ],
      [
        -434.07354736328125,
        -1936.417724609375,
        960.4888305664062
      ],
      [
        -434.07354736328125,
        -1936.417724609375,
        960.4888305664062
      ],
      [
        -435.51080322265625,
        -1937.2509765625,
        900.1087646484375
      ],
      [
        -430.0,
        -1933.5428466796875,
        920.929931640625
      ],
      [
        -421.84124755859375,
        -1928.0,
        930.0
      ],
      [
        -433.4440612792969,
        -1935.8428955078125,
        900.7529907226562
      ],
      [
        -433.42694091796875,
        -1935.858642578125,
        912.0
      ],
      [
        -433.42694091796875,
        -1935.858642578125,
        912.0
      ],
      [
        -430.0,
        -1933.5428466796875,
        920.929931640625
      ],
      [
        -348.0,
        -1905.1326904296875,
        892.0023193359375
      ],
      [
        -348.0,
        -1905.1326904296875,
        912.0
      ],
      [
        -348.0,
        -1905.1326904296875,
        892.0023193359375
      ],
      [
        -348.0,
        -1905.1326904296875,
        862.4762573242188
      ],
      [
        -348.0,
        -1905.1326904296875,
        912.0
      ],
      [
        -360.0,
        -1907.0894775390625,
        930.0
      ],
      [
        -599.257568359375,
        -2193.659912109375,
        641.6248779296875
      ],
      [
        -690.06005859375,
        -2259.00048828125,
        641.6248779296875
      ],
      [
        -610.9901733398438,
        -2204.50390625,
        639.2813110351562
      ],
      [
        -689.3097534179688,
        -2260.86181640625,
        639.28125
      ],
      [
        -610.9901733398438,
        -2204.50390625,
        639.2813110351562
      ],
      [
        -689.3846435546875,
        -2260.676025390625,
        639.51513671875
      ],
      [
        -598.208740234375,
        -2195.306396484375,
        639.2813110351562
      ],
      [
        -599.257568359375,
        -2193.659912109375,
        641.6248779296875
      ],
      [
        -300.0,
        -1945.20947265625,
        765.0
      ],
      [
        -250.96913146972656,
        -1948.5845947265625,
        765.0
      ],
      [
        -300.0,
        -1945.20947265625,
        765.0
      ],
      [
        -300.0,
        -1942.576416015625,
        770.0
      ],
      [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      [
        -272.0,
        -1952.92919921875,
        754.0
      ],
      [
        -272.0,
        -1947.136962890625,
        765.0
      ],
      [
        -272.0,
        -1952.92919921875,
        754.0
      ],
      [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      [
        -286.0,
        -1946.173095703125,
        765.0
      ],
      [
        -193.1866455078125,
        -1923.3104248046875,
        808.0923461914062
      ],
      [
        -208.4437255859375,
        -1914.585693359375,
        835.1259765625
      ],
      [
        -184.5933074951172,
        -1925.4093017578125,
        817.689208984375
      ],
      [
        -348.0,
        -1928.0,
        818.51708984375
      ],
      [
        -348.0,
        -1905.1326904296875,
        871.5677490234375
      ],
      [
        -360.0,
        -1939.0,
        799.3529052734375
      ],
      [
        -348.0,
        -1928.0,
        818.51708984375
      ],
      [
        -360.0,
        -1939.0,
        799.3529052734375
      ],
      [
        -361.63775634765625,
        -1939.0,
        800.2202758789062
      ],
      [
        -430.0,
        -1934.0562744140625,
        920.0897216796875
      ],
      [
        -419.55340576171875,
        -1928.0,
        930.0
      ],
      [
        -433.3037414550781,
        -1935.9715576171875,
        900.267578125
      ],
      [
        -433.3038024902344,
        -1935.9715576171875,
        912.0
      ],
      [
        -433.3038024902344,
        -1935.9715576171875,
        912.0
      ],
      [
        -430.0,
        -1934.0562744140625,
        920.0897216796875
      ],
      [
        -404.59893798828125,
        -1972.0,
        778.7999267578125
      ],
      [
        -375.3886413574219,
        -1957.9095458984375,
        778.7999267578125
      ],
      [
        -369.0,
        -1954.001220703125,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        785.9027709960938
      ],
      [
        -369.0,
        -1953.7879638671875,
        779.1787109375
      ],
      [
        -369.0,
        -1953.7879638671875,
        779.1787109375
      ],
      [
        -369.0,
        -1954.0013427734375,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        785.9027099609375
      ],
      [
        -369.0,
        -1946.408935546875,
        792.2772827148438
      ],
      [
        -404.59893798828125,
        -1972.0,
        778.7999267578125
      ],
      [
        -407.1487121582031,
        -1972.0,
        781.3281860351562
      ],
      [
        -369.0,
        -1950.0,
        788.7234497070312
      ],
      [
        -369.0,
        -1954.603759765625,
        779.2603149414062
      ],
      [
        -369.0,
        -1954.603759765625,
        779.2603149414062
      ],
      [
        -369.0,
        -1954.8277587890625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        788.7235717773438
      ],
      [
        -369.0,
        -1939.0,
        811.334228515625
      ],
      [
        -369.0,
        -1954.8277587890625,
        778.7999267578125
      ],
      [
        -360.0,
        -1939.0,
        802.4103393554688
      ],
      [
        -369.0,
        -1939.0,
        811.334228515625
      ],
      [
        -360.0,
        -1939.0,
        802.4103393554688
      ],
      [
        -355.6589660644531,
        -1935.020751953125,
        806.2855834960938
      ],
      [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      [
        -525.8126831054688,
        -2209.88818359375,
        641.351806640625
      ],
      [
        -525.5756225585938,
        -2210.003173828125,
        641.6248779296875
      ],
      [
        -561.891357421875,
        -2238.921875,
        641.6248779296875
      ],
      [
        -561.7347412109375,
        -2240.273681640625,
        641.6248779296875
      ],
      [
        -561.334716796875,
        -2239.679443359375,
        641.6248779296875
      ],
      [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      [
        -369.0,
        -1939.0,
        912.0
      ],
      [
        -414.0,
        -1939.0,
        912.0
      ],
      [
        -414.0,
        -1928.0,
        930.0
      ],
      [
        -369.0,
        -1928.0,
        930.0
      ],
      [
        -414.0,
        -1939.0,
        904.0
      ],
      [
        -414.0,
        -1939.0,
        894.0
      ],
      [
        -369.0,
        -1939.0,
        909.7214965820312
      ],
      [
        -414.0,
        -1939.0,
        904.0
      ],
      [
        -414.0,
        -1939.0,
        912.0
      ],
      [
        -369.0,
        -1939.0,
        912.0
      ],
      [
        -369.0,
        -1939.0,
        909.7214965820312
      ],
      [
        -422.5,
        -1939.0,
        912.0
      ],
      [
        -422.5,
        -1929.708251953125,
        927.2046508789062
      ],
      [
        -422.5,
        -1939.0,
        908.25
      ],
      [
        -422.5,
        -1939.0,
        908.25
      ],
      [
        -422.5,
        -1939.0,
        912.0
      ],
      [
        -300.0,
        -1972.0,
        765.0
      ],
      [
        -263.9230041503906,
        -1972.0,
        765.0
      ],
      [
        -300.0,
        -1972.0,
        765.0
      ],
      [
        -300.0,
        -1972.0,
        770.0
      ],
      [
        -349.0,
        -1972.0,
        778.7999267578125
      ],
      [
        -349.0,
        -1972.0,
        780.0
      ],
      [
        -349.0,
        -1972.0,
        778.7999267578125
      ],
      [
        -286.0,
        -1972.0,
        754.0
      ],
      [
        -286.0,
        -1972.0,
        765.0
      ],
      [
        -272.0,
        -1972.0,
        765.0
      ],
      [
        -272.0,
        -1972.0,
        757.0535278320312
      ],
      [
        -286.0,
        -1972.0,
        754.0
      ],
      [
        -275.10369873046875,
        -1972.0,
        754.0
      ],
      [
        -334.4937744140625,
        -1972.0,
        709.7407836914062
      ],
      [
        -330.72119140625,
        -1972.0,
        710.1063232421875
      ],
      [
        -334.4937744140625,
        -1972.0,
        709.7407836914062
      ],
      [
        -335.0843811035156,
        -1972.0,
        710.0416259765625
      ],
      [
        -300.0,
        -1987.0,
        768.5
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -4275.525390625,
        -300.0
      ],
      "bbox_max": [
        862.638671875,
        2921.382080078125,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600968956947327,
        0.260924369096756,
        0.10065929591655731
      ],
      "plane_d": 4053.40478515625,
      "bbox_min": [
        -4912.15185546875,
        -2440.358154296875,
        -300.0
      ],
      "bbox_max": [
        -485.10174560546875,
        2200.0,
        1179.126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -4100.0,
        -2269.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3509.2900390625,
        2200.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -704.1276245117188,
        -2440.358154296875,
        0.0
      ],
      "bbox_max": [
        -485.10174560546875,
        -2329.093994140625,
        74.91236877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085832595825195,
        0.02404039539396763
      ],
      "plane_d": 1733.21240234375,
      "bbox_min": [
        -699.1730346679688,
        -2341.75634765625,
        0.0
      ],
      "bbox_max": [
        -694.7417602539062,
        -2332.319091796875,
        73.73088836669922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6797831654548645,
        0.7331898212432861,
        0.018096331506967545
      ],
      "plane_d": 2118.830810546875,
      "bbox_min": [
        -511.46240234375,
        -2440.358154296875,
        0.0
      ],
      "bbox_max": [
        -485.10174560546875,
        -2415.673583984375,
        15.572943687438965
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5381221771240234,
        0.8373711705207825,
        0.0960942804813385
      ],
      "plane_d": 2298.044677734375,
      "bbox_min": [
        -511.46240234375,
        -2420.46630859375,
        0.0
      ],
      "bbox_max": [
        -506.6939697265625,
        -2415.673583984375,
        15.572943687438965
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600968956947327,
        0.260924369096756,
        0.10065929591655731
      ],
      "plane_d": 4053.40478515625,
      "bbox_min": [
        -4912.15185546875,
        -4275.525390625,
        0.0
      ],
      "bbox_max": [
        862.638671875,
        2154.178466796875,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -1049.821533203125,
        -2820.1337890625,
        73.21707153320312
      ],
      "bbox_max": [
        -482.3701171875,
        -2022.358642578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -1049.821533203125,
        -2819.0322265625,
        73.21707153320312
      ],
      "bbox_max": [
        -495.6847229003906,
        -2022.358642578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -1049.821533203125,
        -2819.0322265625,
        219.68569946289062
      ],
      "bbox_max": [
        -495.6847229003906,
        -2022.358642578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -1049.821533203125,
        -2819.0322265625,
        219.68569946289062
      ],
      "bbox_max": [
        -495.6847229003906,
        -2022.358642578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -1049.821533203125,
        -2819.0322265625,
        219.68569946289062
      ],
      "bbox_max": [
        -495.6847229003906,
        -2022.358642578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9314306974411011,
        0.3556700348854065,
        0.0770426094532013
      ],
      "plane_d": 1355.5810546875,
      "bbox_min": [
        -988.625,
        -2819.0322265625,
        639.3530883789062
      ],
      "bbox_max": [
        -495.6847229003906,
        -2310.43701171875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321791529655457,
        0.32900404930114746,
        0.1509908139705658
      ],
      "plane_d": 1178.5645751953125,
      "bbox_min": [
        -988.625,
        -2816.75732421875,
        639.3530883789062
      ],
      "bbox_max": [
        -498.223876953125,
        -2310.43701171875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8198854923248291,
        0.5702467560768127,
        0.05105101317167282
      ],
      "plane_d": 1870.3758544921875,
      "bbox_min": [
        -988.625,
        -2645.0,
        639.3530883789062
      ],
      "bbox_max": [
        -594.252197265625,
        -2310.43701171875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8297061324119568,
        0.5531379580497742,
        0.07500854879617691
      ],
      "plane_d": 1800.5321044921875,
      "bbox_min": [
        -988.625,
        -2645.0,
        639.3530883789062
      ],
      "bbox_max": [
        -594.252197265625,
        -2310.43701171875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -988.625,
        -2645.0,
        639.3530883789062
      ],
      "bbox_max": [
        -711.36962890625,
        -2310.43701171875,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -789.134033203125,
        -2435.9833984375,
        639.3530883789062
      ],
      "bbox_max": [
        -714.5018920898438,
        -2317.40283203125,
        640.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333296895027161,
        -0.5605107545852661,
        -0.5335925817489624
      ],
      "plane_d": -479.0086364746094,
      "bbox_min": [
        -988.625,
        -2645.0,
        687.1875
      ],
      "bbox_max": [
        -802.5723876953125,
        -2410.9833984375,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -930.0518798828125,
        -2566.875,
        687.1875
      ],
      "bbox_max": [
        -812.6871337890625,
        -2410.9833984375,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -930.0518798828125,
        -2566.875,
        687.846923828125
      ],
      "bbox_max": [
        -902.8463745117188,
        -2520.06982421875,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016451746225357056,
        -0.023649385198950768,
        -0.999584972858429
      ],
      "plane_d": 616.3050537109375,
      "bbox_min": [
        -877.5479736328125,
        -2499.0419921875,
        687.1875
      ],
      "bbox_max": [
        -812.6871337890625,
        -2410.9833984375,
        690.078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015236764214932919,
        -0.025140661746263504,
        -0.9995678067207336
      ],
      "plane_d": 613.6358642578125,
      "bbox_min": [
        -877.5479736328125,
        -2499.0419921875,
        689.4432983398438
      ],
      "bbox_max": [
        -859.77783203125,
        -2482.402587890625,
        690.078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015236764214932919,
        -0.025140661746263504,
        -0.9995678067207336
      ],
      "plane_d": 613.6358642578125,
      "bbox_min": [
        -988.625,
        -2645.0,
        687.3624877929688
      ],
      "bbox_max": [
        -802.5723876953125,
        -2427.213134765625,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016451746225357056,
        -0.023649385198950768,
        -0.999584972858429
      ],
      "plane_d": 616.3050537109375,
      "bbox_min": [
        -988.625,
        -2645.0,
        687.3624877929688
      ],
      "bbox_max": [
        -804.638427734375,
        -2427.213134765625,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -988.625,
        -2645.0,
        693.8779907226562
      ],
      "bbox_max": [
        -958.9133911132812,
        -2598.63916015625,
        707.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -980.0184326171875,
        -2645.0,
        688.1981811523438
      ],
      "bbox_max": [
        -946.35205078125,
        -2579.038818359375,
        695.36572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -975.183349609375,
        -2645.0,
        639.3778686523438
      ],
      "bbox_max": [
        -711.36962890625,
        -2310.43701171875,
        688.6541137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -975.183349609375,
        -2645.0,
        639.3778686523438
      ],
      "bbox_max": [
        -711.36962890625,
        -2310.43701171875,
        688.6541137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -754.98779296875,
        -2310.43701171875,
        685.8677978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -764.5123291015625,
        -2310.43701171875,
        674.5700073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -975.183349609375,
        -2645.0,
        639.3778686523438
      ],
      "bbox_max": [
        -711.36962890625,
        -2310.63232421875,
        688.6541137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -975.183349609375,
        -2645.0,
        687.1875
      ],
      "bbox_max": [
        -796.634033203125,
        -2410.9833984375,
        688.6541137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -975.183349609375,
        -2645.0,
        687.4075927734375
      ],
      "bbox_max": [
        -879.5546264648438,
        -2495.801513671875,
        688.6541137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333296895027161,
        -0.5605107545852661,
        -0.5335925817489624
      ],
      "plane_d": -479.0086364746094,
      "bbox_min": [
        -946.35205078125,
        -2579.038818359375,
        687.586669921875
      ],
      "bbox_max": [
        -930.0518798828125,
        -2560.419189453125,
        688.1981811523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -902.8463745117188,
        -2520.06982421875,
        687.4075927734375
      ],
      "bbox_max": [
        -879.5546264648438,
        -2495.801513671875,
        687.8468627929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016451746225357056,
        -0.023649385198950768,
        -0.999584972858429
      ],
      "plane_d": 616.3050537109375,
      "bbox_min": [
        -974.9632568359375,
        -2645.0,
        687.1875
      ],
      "bbox_max": [
        -796.634033203125,
        -2410.9833984375,
        688.3485717773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015236764214932919,
        -0.025140661746263504,
        -0.9995678067207336
      ],
      "plane_d": 613.6358642578125,
      "bbox_min": [
        -804.64013671875,
        -2439.763427734375,
        687.1875
      ],
      "bbox_max": [
        -796.634033203125,
        -2430.9833984375,
        687.4988403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -974.9632568359375,
        -2645.0,
        687.7821044921875
      ],
      "bbox_max": [
        -972.4475708007812,
        -2640.122802734375,
        688.3485717773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -974.5633544921875,
        -2645.0,
        639.3778686523438
      ],
      "bbox_max": [
        -711.36962890625,
        -2310.63232421875,
        687.7935180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -974.5633544921875,
        -2645.0,
        639.3778686523438
      ],
      "bbox_max": [
        -711.36962890625,
        -2311.39697265625,
        687.7935180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00834949966520071,
        0.011480561457574368,
        0.9998992085456848
      ],
      "plane_d": -605.692626953125,
      "bbox_min": [
        -974.5633544921875,
        -2645.0,
        640.3125
      ],
      "bbox_max": [
        -711.36962890625,
        -2343.50244140625,
        687.7935180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -974.5633544921875,
        -2645.0,
        640.3125
      ],
      "bbox_max": [
        -711.36962890625,
        -2343.50244140625,
        687.7935180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -920.5996704101562,
        -2645.0,
        641.796875
      ],
      "bbox_max": [
        -841.7667236328125,
        -2509.036865234375,
        667.578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -915.73583984375,
        -2576.875,
        641.796875
      ],
      "bbox_max": [
        -841.7667236328125,
        -2509.036865234375,
        652.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03805441036820412,
        0.1391364485025406,
        0.98954176902771
      ],
      "plane_d": -254.50424194335938,
      "bbox_min": [
        -915.73583984375,
        -2576.875,
        646.7396850585938
      ],
      "bbox_max": [
        -869.765625,
        -2529.48095703125,
        652.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34332793951034546,
        0.3998381495475769,
        -0.8498560190200806
      ],
      "plane_d": 1271.518798828125,
      "bbox_min": [
        -974.5633544921875,
        -2645.0,
        656.4391479492188
      ],
      "bbox_max": [
        -712.98974609375,
        -2353.859130859375,
        687.7935180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -974.5633544921875,
        -2645.0,
        657.1979370117188
      ],
      "bbox_max": [
        -934.0123901367188,
        -2582.408447265625,
        687.7935180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -974.5633544921875,
        -2645.0,
        667.578125
      ],
      "bbox_max": [
        -942.985595703125,
        -2589.50048828125,
        687.7935180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -934.8543701171875,
        -2585.9384765625,
        656.4391479492188
      ],
      "bbox_max": [
        -933.0162963867188,
        -2581.62109375,
        658.5185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -955.5763549804688,
        -2601.230712890625,
        640.3125
      ],
      "bbox_max": [
        -712.98974609375,
        -2343.50244140625,
        687.6912841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.675027072429657,
        -0.49037832021713257,
        -0.5512418150901794
      ],
      "plane_d": -246.33090209960938,
      "bbox_min": [
        -955.5763549804688,
        -2601.230712890625,
        640.3125
      ],
      "bbox_max": [
        -712.98974609375,
        -2343.50244140625,
        687.6912841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7694186568260193,
        -0.5282776355743408,
        0.35905107855796814
      ],
      "plane_d": -862.0191650390625,
      "bbox_min": [
        -955.5763549804688,
        -2601.230712890625,
        640.3125
      ],
      "bbox_max": [
        -712.98974609375,
        -2343.50244140625,
        687.6912841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -955.5763549804688,
        -2601.230712890625,
        641.796875
      ],
      "bbox_max": [
        -712.98974609375,
        -2343.50244140625,
        687.6912841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333296895027161,
        -0.5605107545852661,
        -0.5335925817489624
      ],
      "plane_d": -479.0086364746094,
      "bbox_min": [
        -945.1063232421875,
        -2577.094970703125,
        682.5
      ],
      "bbox_max": [
        -933.75,
        -2559.375,
        687.6348876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -943.8311767578125,
        -2584.6416015625,
        665.9375
      ],
      "bbox_max": [
        -879.8209228515625,
        -2487.185546875,
        687.6210327148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333296895027161,
        -0.5605107545852661,
        -0.5335925817489624
      ],
      "plane_d": -479.0086364746094,
      "bbox_min": [
        -940.8788452148438,
        -2572.30517578125,
        682.5
      ],
      "bbox_max": [
        -930.3886108398438,
        -2559.375,
        687.6210327148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -943.8311767578125,
        -2584.6416015625,
        665.9375
      ],
      "bbox_max": [
        -879.8209228515625,
        -2487.185546875,
        687.478759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -943.8311767578125,
        -2584.6416015625,
        677.4135131835938
      ],
      "bbox_max": [
        -932.1755981445312,
        -2559.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -938.0740966796875,
        -2573.47998046875,
        677.4135131835938
      ],
      "bbox_max": [
        -932.1755981445312,
        -2559.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -949.4379272460938,
        -2595.51171875,
        680.9249877929688
      ],
      "bbox_max": [
        -943.8311767578125,
        -2584.6416015625,
        682.6007690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -890.0479736328125,
        -2529.48095703125,
        641.796875
      ],
      "bbox_max": [
        -860.5833740234375,
        -2491.873046875,
        646.7396850585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34332793951034546,
        0.3998381495475769,
        -0.8498560190200806
      ],
      "plane_d": 1271.518798828125,
      "bbox_min": [
        -947.4171752929688,
        -2593.629150390625,
        652.96875
      ],
      "bbox_max": [
        -712.98974609375,
        -2343.50244140625,
        686.9425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -947.4171752929688,
        -2593.629150390625,
        658.5185546875
      ],
      "bbox_max": [
        -928.8388671875,
        -2559.8056640625,
        681.3382568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -947.4171752929688,
        -2593.629150390625,
        677.25
      ],
      "bbox_max": [
        -938.0741577148438,
        -2573.47998046875,
        681.3382568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -934.0123901367188,
        -2582.408447265625,
        652.96875
      ],
      "bbox_max": [
        -915.73583984375,
        -2560.71826171875,
        666.63330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -924.609375,
        -2569.14306640625,
        652.96875
      ],
      "bbox_max": [
        -915.73583984375,
        -2561.875,
        654.24609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -698.2745361328125,
        -2409.47900390625,
        1258.9176025390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -511.1015625,
        -2816.75732421875,
        1386.6339111328125
      ],
      "bbox_max": [
        -498.223876953125,
        -2806.955322265625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -502.130126953125,
        -2819.0322265625,
        1386.6339111328125
      ],
      "bbox_max": [
        -495.6847229003906,
        -2806.955322265625,
        1479.110595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -1049.821533203125,
        -2408.3671875,
        219.68569946289062
      ],
      "bbox_max": [
        -685.0712890625,
        -2022.358642578125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -860.804443359375,
        -2408.3671875,
        531.78662109375
      ],
      "bbox_max": [
        -685.0712890625,
        -2167.271728515625,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -770.8287353515625,
        -2408.3671875,
        639.3507080078125
      ],
      "bbox_max": [
        -685.0712890625,
        -2306.33251953125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -765.279052734375,
        -2323.63623046875,
        639.3507080078125
      ],
      "bbox_max": [
        -749.987060546875,
        -2306.33251953125,
        686.7015380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -754.6053466796875,
        -2320.1953125,
        686.6405639648438
      ],
      "bbox_max": [
        -752.467041015625,
        -2317.2001953125,
        686.6597900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -763.1380615234375,
        -2323.63623046875,
        639.3507080078125
      ],
      "bbox_max": [
        -749.987060546875,
        -2307.621826171875,
        686.7015380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -763.1380615234375,
        -2323.63623046875,
        639.3507080078125
      ],
      "bbox_max": [
        -749.987060546875,
        -2307.621826171875,
        686.7015380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -758.4019775390625,
        -2317.40283203125,
        639.3507080078125
      ],
      "bbox_max": [
        -753.7208251953125,
        -2311.61328125,
        639.38037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -763.1380615234375,
        -2311.39697265625,
        649.1970825195312
      ],
      "bbox_max": [
        -760.0313720703125,
        -2307.621826171875,
        651.2776489257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -767.986572265625,
        -2408.3671875,
        639.3568725585938
      ],
      "bbox_max": [
        -685.0712890625,
        -2312.703125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -767.986572265625,
        -2343.50244140625,
        639.3568725585938
      ],
      "bbox_max": [
        -726.142822265625,
        -2315.81494140625,
        1420.7086181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -752.9869384765625,
        -2343.50244140625,
        639.3568725585938
      ],
      "bbox_max": [
        -726.142822265625,
        -2315.81494140625,
        686.9425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -752.9869384765625,
        -2333.996337890625,
        639.3568725585938
      ],
      "bbox_max": [
        -734.5928344726562,
        -2315.81494140625,
        686.6405639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -752.5239868164062,
        -2317.2001953125,
        686.5301513671875
      ],
      "bbox_max": [
        -752.123779296875,
        -2316.721435546875,
        686.6405639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -860.804443359375,
        -2356.54345703125,
        531.78662109375
      ],
      "bbox_max": [
        -724.2152099609375,
        -2167.271728515625,
        1427.1370849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -860.804443359375,
        -2356.54345703125,
        634.0618286132812
      ],
      "bbox_max": [
        -724.2152099609375,
        -2173.491455078125,
        1427.1370849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -774.5052490234375,
        -2356.54345703125,
        1051.602294921875
      ],
      "bbox_max": [
        -724.2152099609375,
        -2299.1416015625,
        1427.1370849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -761.962646484375,
        -2356.54345703125,
        1051.602294921875
      ],
      "bbox_max": [
        -724.2152099609375,
        -2312.703125,
        1427.1370849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -738.92578125,
        -2356.54345703125,
        1345.9888916015625
      ],
      "bbox_max": [
        -724.2152099609375,
        -2338.6396484375,
        1427.1370849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -738.92578125,
        -2352.36181640625,
        1390.9632568359375
      ],
      "bbox_max": [
        -729.0043334960938,
        -2339.8720703125,
        1427.1370849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -860.804443359375,
        -2338.1650390625,
        634.0618286132812
      ],
      "bbox_max": [
        -729.5592041015625,
        -2173.491455078125,
        1403.452880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -860.804443359375,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2173.491455078125,
        1402.3492431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -770.0617065429688,
        -2316.208740234375,
        639.3263549804688
      ],
      "bbox_max": [
        -751.8521118164062,
        -2280.2109375,
        836.8139038085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -762.0160522460938,
        -2308.695556640625,
        647.4500732421875
      ],
      "bbox_max": [
        -756.6925659179688,
        -2303.34375,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -762.0160522460938,
        -2307.94970703125,
        649.5208740234375
      ],
      "bbox_max": [
        -756.8021850585938,
        -2303.34375,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -762.0160522460938,
        -2306.4140625,
        675.0604858398438
      ],
      "bbox_max": [
        -761.55126953125,
        -2305.747802734375,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -761.9382934570312,
        -2315.81494140625,
        675.13037109375
      ],
      "bbox_max": [
        -752.9869384765625,
        -2305.747802734375,
        685.6275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -759.2738037109375,
        -2316.208740234375,
        639.3263549804688
      ],
      "bbox_max": [
        -751.8521118164062,
        -2303.717529296875,
        649.45166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -756.3106689453125,
        -2316.208740234375,
        639.3263549804688
      ],
      "bbox_max": [
        -751.8521118164062,
        -2309.225830078125,
        639.35693359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.7415771484375,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2280.03857421875,
        1270.78173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -768.7000732421875,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2282.04248046875,
        835.7608032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -753.0465087890625,
        -2316.721435546875,
        685.511474609375
      ],
      "bbox_max": [
        -752.123779296875,
        -2315.6474609375,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -768.256591796875,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2282.130859375,
        816.5458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -757.1021728515625,
        -2303.7177734375,
        649.4514770507812
      ],
      "bbox_max": [
        -755.9295654296875,
        -2302.220703125,
        655.3711547851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -756.84716796875,
        -2303.7177734375,
        649.4514770507812
      ],
      "bbox_max": [
        -755.9295654296875,
        -2302.23095703125,
        650.2191162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -756.84716796875,
        -2303.449951171875,
        649.943603515625
      ],
      "bbox_max": [
        -755.9295654296875,
        -2302.23095703125,
        650.2191162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -756.6925659179688,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2302.23388671875,
        650.0578002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -754.4367065429688,
        -2317.242431640625,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2308.314453125,
        639.3574829101562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -774.9254760742188,
        -2338.1650390625,
        634.0618286132812
      ],
      "bbox_max": [
        -729.5592041015625,
        -2287.4091796875,
        1403.452880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -763.294189453125,
        -2338.1650390625,
        634.0618286132812
      ],
      "bbox_max": [
        -729.5592041015625,
        -2287.4091796875,
        760.8279418945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -763.2392578125,
        -2302.23388671875,
        634.0618286132812
      ],
      "bbox_max": [
        -753.3262329101562,
        -2287.467529296875,
        760.21142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -755.9369506835938,
        -2302.23388671875,
        650.0578002929688
      ],
      "bbox_max": [
        -755.906494140625,
        -2302.20166015625,
        650.1961669921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -757.6132202148438,
        -2302.20166015625,
        634.0618286132812
      ],
      "bbox_max": [
        -753.3262329101562,
        -2294.22802734375,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.871337890625,
        -2300.75,
        641.6248779296875
      ],
      "bbox_max": [
        -753.8310546875,
        -2300.702880859375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -755.9295654296875,
        -2338.1650390625,
        637.1535034179688
      ],
      "bbox_max": [
        -729.5592041015625,
        -2300.52978515625,
        650.060791015625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -753.7503051757812,
        -2304.79736328125,
        637.1535034179688
      ],
      "bbox_max": [
        -750.960693359375,
        -2300.94140625,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -755.9295654296875,
        -2308.314453125,
        639.27490234375
      ],
      "bbox_max": [
        -750.8941040039062,
        -2300.52978515625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -755.9295654296875,
        -2308.314453125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2302.20166015625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.8582153320312,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.8941040039062,
        -2300.52978515625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -750.960693359375,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.8941040039062,
        -2304.749755859375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -852.66796875,
        -2190.765625,
        531.78662109375
      ],
      "bbox_max": [
        -834.5742797851562,
        -2167.271728515625,
        787.6206665039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -852.66796875,
        -2190.765625,
        704.5286254882812
      ],
      "bbox_max": [
        -834.5742797851562,
        -2168.956298828125,
        787.6206665039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762436032295227,
        0.7347268462181091,
        0.053582221269607544
      ],
      "plane_d": 2184.045166015625,
      "bbox_min": [
        -1049.821533203125,
        -2168.956298828125,
        219.68569946289062
      ],
      "bbox_max": [
        -846.7315063476562,
        -2022.358642578125,
        733.704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6963309645652771,
        0.7165287137031555,
        0.04134921357035637
      ],
      "plane_d": 2171.017333984375,
      "bbox_min": [
        -1049.821533203125,
        -2121.847900390625,
        219.68569946289062
      ],
      "bbox_max": [
        -953.9031982421875,
        -2022.358642578125,
        507.709716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36377382278442383,
        0.930548906326294,
        0.04180183261632919
      ],
      "plane_d": 2304.13818359375,
      "bbox_min": [
        -964.5498046875,
        -2121.847900390625,
        301.9143371582031
      ],
      "bbox_max": [
        -953.9031982421875,
        -2114.3740234375,
        507.709716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -969.41943359375,
        -2168.956298828125,
        306.42681884765625
      ],
      "bbox_max": [
        -846.7315063476562,
        -2116.968017578125,
        733.704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005043566226959,
        0.9524807333946228,
        0.04977479577064514
      ],
      "plane_d": 2285.599609375,
      "bbox_min": [
        -969.41943359375,
        -2168.956298828125,
        507.709716796875
      ],
      "bbox_max": [
        -846.7315063476562,
        -2121.847900390625,
        733.704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -852.66796875,
        -2168.956298828125,
        509.7704772949219
      ],
      "bbox_max": [
        -846.7315063476562,
        -2165.156982421875,
        733.704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36377382278442383,
        0.930548906326294,
        0.04180183261632919
      ],
      "plane_d": 2304.13818359375,
      "bbox_min": [
        -964.5498046875,
        -2162.234619140625,
        306.42681884765625
      ],
      "bbox_max": [
        -847.6062622070312,
        -2116.968017578125,
        507.709716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -761.0557861328125,
        -2350.402099609375,
        551.3601684570312
      ],
      "bbox_max": [
        -714.7833862304688,
        -2288.81787109375,
        699.5836791992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -750.7191162109375,
        -2350.402099609375,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2305.024169921875,
        639.3632202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -761.0557861328125,
        -2313.18505859375,
        626.47314453125
      ],
      "bbox_max": [
        -742.0281372070312,
        -2288.81787109375,
        699.5836791992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -753.5884399414062,
        -2313.18505859375,
        639.28125
      ],
      "bbox_max": [
        -742.0281372070312,
        -2299.47509765625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.5884399414062,
        -2304.749755859375,
        639.28125
      ],
      "bbox_max": [
        -749.1293334960938,
        -2299.47509765625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -750.8943481445312,
        -2304.749755859375,
        639.28125
      ],
      "bbox_max": [
        -749.1293334960938,
        -2303.485107421875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -847.845703125,
        -2407.66796875,
        380.368408203125
      ],
      "bbox_max": [
        -673.747314453125,
        -2162.010986328125,
        1385.3800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -847.845703125,
        -2292.517822265625,
        384.78607177734375
      ],
      "bbox_max": [
        -756.9111938476562,
        -2162.010986328125,
        1371.9813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -847.845703125,
        -2292.517822265625,
        384.78607177734375
      ],
      "bbox_max": [
        -756.9111938476562,
        -2162.010986328125,
        1063.432373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -775.706787109375,
        -2292.517822265625,
        598.3528442382812
      ],
      "bbox_max": [
        -756.9111938476562,
        -2263.27197265625,
        1003.4503173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.706787109375,
        -2285.833740234375,
        833.5809326171875
      ],
      "bbox_max": [
        -765.8814697265625,
        -2263.27197265625,
        944.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -775.6287231445312,
        -2292.517822265625,
        598.3528442382812
      ],
      "bbox_max": [
        -756.9111938476562,
        -2264.03369140625,
        1003.4503173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.0944213867188,
        -2286.757080078125,
        833.050048828125
      ],
      "bbox_max": [
        -765.195068359375,
        -2264.15380859375,
        942.9473876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -761.4224853515625,
        -2292.517822265625,
        598.3528442382812
      ],
      "bbox_max": [
        -756.9111938476562,
        -2276.431640625,
        626.7407836914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -847.845703125,
        -2254.945068359375,
        384.78607177734375
      ],
      "bbox_max": [
        -781.3290405273438,
        -2162.010986328125,
        946.2814331054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -847.845703125,
        -2165.156982421875,
        384.78607177734375
      ],
      "bbox_max": [
        -845.2881469726562,
        -2162.010986328125,
        509.7704772949219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36377382278442383,
        0.930548906326294,
        0.04180183261632919
      ],
      "plane_d": 2304.13818359375,
      "bbox_min": [
        -847.6853637695312,
        -2163.03515625,
        384.78607177734375
      ],
      "bbox_max": [
        -845.2881469726562,
        -2162.010986328125,
        389.07147216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -837.989501953125,
        -2254.945068359375,
        619.2900390625
      ],
      "bbox_max": [
        -781.3290405273438,
        -2183.863525390625,
        946.2814331054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -845.5904541015625,
        -2246.891845703125,
        386.55322265625
      ],
      "bbox_max": [
        -784.2568969726562,
        -2163.02685546875,
        819.130615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -845.5904541015625,
        -2163.380126953125,
        386.55322265625
      ],
      "bbox_max": [
        -845.19384765625,
        -2163.02685546875,
        405.04217529296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -786.48876953125,
        -2407.66796875,
        380.368408203125
      ],
      "bbox_max": [
        -673.747314453125,
        -2264.956787109375,
        1385.3800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -786.48876953125,
        -2407.66796875,
        930.5113525390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2264.956787109375,
        1385.3800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -742.3389282226562,
        -2407.66796875,
        1126.5194091796875
      ],
      "bbox_max": [
        -685.0712890625,
        -2326.51611328125,
        1376.4813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -742.3389282226562,
        -2338.6396484375,
        1126.5194091796875
      ],
      "bbox_max": [
        -733.4500122070312,
        -2326.51611328125,
        1376.4813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -742.3389282226562,
        -2332.292724609375,
        1126.5194091796875
      ],
      "bbox_max": [
        -733.7013549804688,
        -2326.51611328125,
        1229.1395263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025199890137,
        0.34713053703308105,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -786.48876953125,
        -2280.03857421875,
        1270.78173828125
      ],
      "bbox_max": [
        -778.7415771484375,
        -2264.956787109375,
        1385.3800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -769.1553344726562,
        -2404.270751953125,
        380.368408203125
      ],
      "bbox_max": [
        -673.747314453125,
        -2268.39013671875,
        783.2012939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9562264084815979,
        0.139556884765625,
        0.257205992937088
      ],
      "plane_d": 836.2110595703125,
      "bbox_min": [
        -742.0281372070312,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2313.18505859375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -712.98974609375,
        -2355.322998046875,
        648.9346923828125
      ],
      "bbox_max": [
        -709.5630493164062,
        -2352.47119140625,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -769.1553344726562,
        -2327.564453125,
        592.373046875
      ],
      "bbox_max": [
        -726.714599609375,
        -2268.39013671875,
        783.2012939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -752.1113891601562,
        -2303.5068359375,
        639.28125
      ],
      "bbox_max": [
        -744.8853759765625,
        -2296.32080078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -749.15966796875,
        -2303.5068359375,
        639.28125
      ],
      "bbox_max": [
        -744.8853759765625,
        -2300.444091796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -792.2164916992188,
        -2407.66796875,
        377.5164794921875
      ],
      "bbox_max": [
        -673.747314453125,
        -2225.827880859375,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -792.2164916992188,
        -2264.4326171875,
        502.0954895019531
      ],
      "bbox_max": [
        -774.7032470703125,
        -2225.827880859375,
        1053.9071044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -775.980712890625,
        -2264.4326171875,
        932.4193115234375
      ],
      "bbox_max": [
        -774.7032470703125,
        -2262.449951171875,
        949.2652587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.980712890625,
        -2264.15380859375,
        942.9473876953125
      ],
      "bbox_max": [
        -775.0944213867188,
        -2262.449951171875,
        949.2652587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -792.2164916992188,
        -2261.210693359375,
        502.0954895019531
      ],
      "bbox_max": [
        -778.3212280273438,
        -2225.827880859375,
        1053.9071044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -781.3290405273438,
        -2261.210693359375,
        946.2814331054688
      ],
      "bbox_max": [
        -778.3212280273438,
        -2254.945068359375,
        1053.9071044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -781.3290405273438,
        -2257.5849609375,
        946.2814331054688
      ],
      "bbox_max": [
        -779.5615234375,
        -2254.945068359375,
        969.53857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -779.2199096679688,
        -2407.66796875,
        377.5164794921875
      ],
      "bbox_max": [
        -673.747314453125,
        -2261.03125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9562264084815979,
        0.139556884765625,
        0.257205992937088
      ],
      "plane_d": 836.2110595703125,
      "bbox_min": [
        -726.714599609375,
        -2407.66796875,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2327.564453125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -726.714599609375,
        -2353.44921875,
        639.28125
      ],
      "bbox_max": [
        -709.4921875,
        -2327.564453125,
        666.9879760742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -710.5648193359375,
        -2353.44921875,
        649.135009765625
      ],
      "bbox_max": [
        -709.4921875,
        -2352.415283203125,
        666.9879760742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -721.0750122070312,
        -2407.66796875,
        1168.208984375
      ],
      "bbox_max": [
        -685.0712890625,
        -2351.303955078125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -779.2199096679688,
        -2352.88818359375,
        591.1971435546875
      ],
      "bbox_max": [
        -720.0845336914062,
        -2261.03125,
        1199.8267822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -779.2199096679688,
        -2264.304931640625,
        942.7564697265625
      ],
      "bbox_max": [
        -774.9893798828125,
        -2261.03125,
        1062.6337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -775.9306640625,
        -2264.304931640625,
        942.7564697265625
      ],
      "bbox_max": [
        -774.9893798828125,
        -2262.95849609375,
        966.3355712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.5611572265625,
        -2264.304931640625,
        942.7564697265625
      ],
      "bbox_max": [
        -774.9893798828125,
        -2263.055419921875,
        948.4865112304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -762.185791015625,
        -2352.88818359375,
        591.1971435546875
      ],
      "bbox_max": [
        -720.0845336914062,
        -2272.865478515625,
        1199.8267822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -733.7513427734375,
        -2352.88818359375,
        1138.8836669921875
      ],
      "bbox_max": [
        -720.0845336914062,
        -2332.134033203125,
        1199.8267822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -733.7513427734375,
        -2333.14013671875,
        1138.8836669921875
      ],
      "bbox_max": [
        -732.7146606445312,
        -2332.134033203125,
        1178.7674560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.7513427734375,
        -2333.14013671875,
        1156.9886474609375
      ],
      "bbox_max": [
        -733.1165161132812,
        -2332.134033203125,
        1178.7674560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.7513427734375,
        -2332.5322265625,
        1156.9886474609375
      ],
      "bbox_max": [
        -733.1771850585938,
        -2332.134033203125,
        1165.042236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -762.185791015625,
        -2327.97412109375,
        591.1971435546875
      ],
      "bbox_max": [
        -726.2783203125,
        -2272.865478515625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -762.185791015625,
        -2277.610107421875,
        591.1971435546875
      ],
      "bbox_max": [
        -759.3041381835938,
        -2272.865478515625,
        593.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -747.6936645507812,
        -2300.46630859375,
        639.28125
      ],
      "bbox_max": [
        -744.742919921875,
        -2296.215087890625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -744.9161987304688,
        -2300.46630859375,
        639.28125
      ],
      "bbox_max": [
        -744.742919921875,
        -2300.342041015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085832595825195,
        0.02404039539396763
      ],
      "plane_d": 1733.21240234375,
      "bbox_min": [
        -791.0175170898438,
        -2404.270751953125,
        73.21707153320312
      ],
      "bbox_max": [
        -666.5949096679688,
        -2227.248291015625,
        1190.5146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -791.0175170898438,
        -2404.270751953125,
        73.73089599609375
      ],
      "bbox_max": [
        -673.747314453125,
        -2227.248291015625,
        1190.5146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9562264084815979,
        0.139556884765625,
        0.257205992937088
      ],
      "plane_d": 836.2110595703125,
      "bbox_min": [
        -726.2783203125,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2327.97412109375,
        1190.5146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -726.2783203125,
        -2353.375732421875,
        639.28125
      ],
      "bbox_max": [
        -706.224853515625,
        -2327.97412109375,
        666.59521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -710.4673461914062,
        -2353.375732421875,
        649.1428833007812
      ],
      "bbox_max": [
        -706.224853515625,
        -2349.98681640625,
        666.59521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -720.0993041992188,
        -2355.997802734375,
        1185.6202392578125
      ],
      "bbox_max": [
        -718.0741577148438,
        -2352.827392578125,
        1190.5146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -791.0175170898438,
        -2352.896240234375,
        504.7087707519531
      ],
      "bbox_max": [
        -708.852294921875,
        -2227.248291015625,
        1186.9747314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -791.0175170898438,
        -2263.2548828125,
        504.7087707519531
      ],
      "bbox_max": [
        -765.472412109375,
        -2227.248291015625,
        1022.2198486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -776.570068359375,
        -2263.2548828125,
        941.223876953125
      ],
      "bbox_max": [
        -775.2893676757812,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2263.055419921875,
        948.4865112304688
      ],
      "bbox_max": [
        -775.5611572265625,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -791.0175170898438,
        -2261.03125,
        504.7087707519531
      ],
      "bbox_max": [
        -765.472412109375,
        -2227.248291015625,
        1022.2198486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -779.7763061523438,
        -2261.03125,
        950.908203125
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        1022.2198486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -779.7763061523438,
        -2260.681396484375,
        950.908203125
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        966.5499267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.3212280273438,
        -2352.896240234375,
        560.3877563476562
      ],
      "bbox_max": [
        -708.852294921875,
        -2257.5107421875,
        1186.9747314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -778.3212280273438,
        -2263.15966796875,
        948.3524780273438
      ],
      "bbox_max": [
        -775.4889526367188,
        -2260.681396484375,
        1027.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -776.570068359375,
        -2263.15966796875,
        948.3524780273438
      ],
      "bbox_max": [
        -775.4889526367188,
        -2260.681396484375,
        964.4517822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2263.15966796875,
        948.3524780273438
      ],
      "bbox_max": [
        -775.4889526367188,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -765.472412109375,
        -2352.896240234375,
        560.3877563476562
      ],
      "bbox_max": [
        -708.852294921875,
        -2257.5107421875,
        1186.9747314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -765.472412109375,
        -2276.89111328125,
        560.3877563476562
      ],
      "bbox_max": [
        -759.5247802734375,
        -2257.5107421875,
        592.7221069335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -747.5454711914062,
        -2352.896240234375,
        639.28125
      ],
      "bbox_max": [
        -720.05517578125,
        -2289.942138671875,
        1186.9747314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.18798828125,
        -2332.730224609375,
        1158.943359375
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494384765625,
        1164.02734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.18798828125,
        -2332.605712890625,
        1158.943359375
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494384765625,
        1160.837646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -747.5454711914062,
        -2300.36376953125,
        639.28125
      ],
      "bbox_max": [
        -736.3060302734375,
        -2289.942138671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -744.7731323242188,
        -2300.36376953125,
        639.28125
      ],
      "bbox_max": [
        -736.3060302734375,
        -2294.296630859375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -738.759521484375,
        -2349.337158203125,
        630.2252807617188
      ],
      "bbox_max": [
        -666.5949096679688,
        -2255.988037109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -736.3522338867188,
        -2349.337158203125,
        639.2811889648438
      ],
      "bbox_max": [
        -666.7262573242188,
        -2260.673583984375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5919927358627319,
        0.8059433102607727,
        0.0
      ],
      "plane_d": 1469.767333984375,
      "bbox_min": [
        -708.852294921875,
        -2349.337158203125,
        639.2811889648438
      ],
      "bbox_max": [
        -666.7262573242188,
        -2314.91064453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -705.815185546875,
        -2349.337158203125,
        639.2811889648438
      ],
      "bbox_max": [
        -666.7262573242188,
        -2320.349609375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -498.223876953125,
        -2820.1337890625,
        529.9791259765625
      ],
      "bbox_max": [
        -482.3701171875,
        -2800.61376953125,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -498.223876953125,
        -2808.2001953125,
        1385.04638671875
      ],
      "bbox_max": [
        -495.4368591308594,
        -2806.955322265625,
        1388.3187255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5381221771240234,
        0.8373711705207825,
        0.0960942804813385
      ],
      "plane_d": 2298.044677734375,
      "bbox_min": [
        -691.2036743164062,
        -4275.525390625,
        0.0
      ],
      "bbox_max": [
        862.638671875,
        -1865.0,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -506.6939697265625,
        -4275.525390625,
        0.0
      ],
      "bbox_max": [
        862.638671875,
        -2420.46630859375,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661833047866821,
        0.25639787316322327,
        0.027386151254177094
      ],
      "plane_d": 1823.6815185546875,
      "bbox_min": [
        -301.69952392578125,
        -4275.525390625,
        0.0
      ],
      "bbox_max": [
        862.638671875,
        -2988.336181640625,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9662607908248901,
        0.2561880648136139,
        0.02660275809466839
      ],
      "plane_d": 1823.3367919921875,
      "bbox_min": [
        -301.69952392578125,
        -4257.208984375,
        544.813232421875
      ],
      "bbox_max": [
        862.638671875,
        -2988.336181640625,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8440337181091309,
        0.5237486362457275,
        0.11530200392007828
      ],
      "plane_d": 1527.4400634765625,
      "bbox_min": [
        -301.69952392578125,
        -3536.330078125,
        1363.6724853515625
      ],
      "bbox_max": [
        176.252197265625,
        -2988.336181640625,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5382782816886902,
        0.8385637402534485,
        0.08406741917133331
      ],
      "plane_d": 2561.375,
      "bbox_min": [
        -301.69952392578125,
        -3178.84619140625,
        1363.6724853515625
      ],
      "bbox_max": [
        -42.06678009033203,
        -2988.336181640625,
        1577.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5380130410194397,
        0.8274743556976318,
        0.16071178019046783
      ],
      "plane_d": 2416.71533203125,
      "bbox_min": [
        -301.69952392578125,
        -3161.155517578125,
        1363.6724853515625
      ],
      "bbox_max": [
        -57.122589111328125,
        -2988.336181640625,
        1447.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -301.69952392578125,
        -3031.18994140625,
        1363.6724853515625
      ],
      "bbox_max": [
        -246.2596893310547,
        -2988.336181640625,
        1447.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5808821320533752,
        0.8135150671005249,
        0.027732910588383675
      ],
      "plane_d": 2567.5458984375,
      "bbox_min": [
        -495.48614501953125,
        -3172.2548828125,
        0.0
      ],
      "bbox_max": [
        2.78466796875,
        -2807.683837890625,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -495.48614501953125,
        -3172.2548828125,
        651.6136474609375
      ],
      "bbox_max": [
        -22.141357421875,
        -2807.683837890625,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5784721970558167,
        0.8153333067893982,
        0.024523697793483734
      ],
      "plane_d": 2574.3935546875,
      "bbox_min": [
        -495.48614501953125,
        -3172.2548828125,
        651.6136474609375
      ],
      "bbox_max": [
        -22.141357421875,
        -2807.910400390625,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5775443315505981,
        0.816006064414978,
        0.024013593792915344
      ],
      "plane_d": 2576.892578125,
      "bbox_min": [
        -306.5943603515625,
        -3172.2548828125,
        699.0181884765625
      ],
      "bbox_max": [
        -22.141357421875,
        -2982.996337890625,
        1444.156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5380130410194397,
        0.8274743556976318,
        0.16071178019046783
      ],
      "plane_d": 2416.71533203125,
      "bbox_min": [
        -306.4407653808594,
        -3172.2548828125,
        1354.7957763671875
      ],
      "bbox_max": [
        -40.82177734375,
        -2983.163818359375,
        1444.156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -306.4407653808594,
        -3172.2548828125,
        1354.7957763671875
      ],
      "bbox_max": [
        -40.82177734375,
        -2983.163818359375,
        1444.156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5382782816886902,
        0.8385637402534485,
        0.08406741917133331
      ],
      "plane_d": 2561.375,
      "bbox_min": [
        -57.122589111328125,
        -3172.2548828125,
        1428.406005859375
      ],
      "bbox_max": [
        -40.82177734375,
        -3161.155517578125,
        1444.156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -306.5943603515625,
        -3024.712158203125,
        699.0181884765625
      ],
      "bbox_max": [
        -229.613525390625,
        -2982.996337890625,
        1431.28369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -306.5943603515625,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2982.996337890625,
        1431.28369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -230.98553466796875,
        -3015.99462890625,
        699.0181884765625
      ],
      "bbox_max": [
        -229.613525390625,
        -3014.8623046875,
        707.403076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -495.48614501953125,
        -3024.712158203125,
        651.6136474609375
      ],
      "bbox_max": [
        -230.6397247314453,
        -2807.910400390625,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -495.48614501953125,
        -2981.80517578125,
        688.5384521484375
      ],
      "bbox_max": [
        -307.68621826171875,
        -2807.910400390625,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -495.48614501953125,
        -2965.373291015625,
        1307.5714111328125
      ],
      "bbox_max": [
        -322.748779296875,
        -2807.910400390625,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -495.4368591308594,
        -2965.373291015625,
        1307.5714111328125
      ],
      "bbox_max": [
        -322.748779296875,
        -2808.2001953125,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -495.4368591308594,
        -2860.219482421875,
        1388.3187255859375
      ],
      "bbox_max": [
        -378.988037109375,
        -2808.2001953125,
        1477.5262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -361.8818359375,
        -2965.373291015625,
        1307.5714111328125
      ],
      "bbox_max": [
        -322.748779296875,
        -2854.516357421875,
        1425.114990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857489347457886,
        0.7124961614608765,
        0.1486533135175705
      ],
      "plane_d": 2121.406005859375,
      "bbox_min": [
        -347.90234375,
        -2965.373291015625,
        1313.6531982421875
      ],
      "bbox_max": [
        -322.748779296875,
        -2932.19970703125,
        1425.114990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -347.90234375,
        -2965.373291015625,
        1402.2528076171875
      ],
      "bbox_max": [
        -322.748779296875,
        -2937.93310546875,
        1425.114990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -331.759765625,
        -2981.80517578125,
        688.5384521484375
      ],
      "bbox_max": [
        -307.68621826171875,
        -2924.27294921875,
        1430.8126220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857489347457886,
        0.7124961614608765,
        0.1486533135175705
      ],
      "plane_d": 2121.406005859375,
      "bbox_min": [
        -331.759765625,
        -2981.80517578125,
        1313.6531982421875
      ],
      "bbox_max": [
        -307.68621826171875,
        -2932.19970703125,
        1430.8126220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -325.2165222167969,
        -2981.80517578125,
        1395.3326416015625
      ],
      "bbox_max": [
        -307.68621826171875,
        -2956.982421875,
        1430.8126220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -331.759765625,
        -2943.16455078125,
        1249.1214599609375
      ],
      "bbox_max": [
        -321.032958984375,
        -2932.19970703125,
        1321.677978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857489347457886,
        0.7124961614608765,
        0.1486533135175705
      ],
      "plane_d": 2121.406005859375,
      "bbox_min": [
        -331.759765625,
        -2943.16455078125,
        1313.6531982421875
      ],
      "bbox_max": [
        -322.1067199707031,
        -2932.19970703125,
        1321.677978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -322.5382995605469,
        -3024.712158203125,
        688.5384521484375
      ],
      "bbox_max": [
        -230.6397247314453,
        -2924.27294921875,
        1431.2255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -313.454833984375,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2966.85888671875,
        1431.2255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -321.0329284667969,
        -3014.869140625,
        688.5384521484375
      ],
      "bbox_max": [
        -230.6397247314453,
        -2924.27294921875,
        1249.1214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6797831654548645,
        0.7331898212432861,
        0.018096331506967545
      ],
      "plane_d": 2118.830810546875,
      "bbox_min": [
        -506.6939697265625,
        -2675.23974609375,
        9.885124206542969
      ],
      "bbox_max": [
        -208.74124145507812,
        -2420.46630859375,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5633555054664612,
        0.8184596300125122,
        0.11293553560972214
      ],
      "plane_d": 2242.135498046875,
      "bbox_min": [
        -343.02734375,
        -2675.23974609375,
        749.8496704101562
      ],
      "bbox_max": [
        -266.6285705566406,
        -2625.52685546875,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14437326788902283,
        0.977375328540802,
        0.1545761078596115
      ],
      "plane_d": 2438.747314453125,
      "bbox_min": [
        -274.07421875,
        -2675.23974609375,
        749.8496704101562
      ],
      "bbox_max": [
        -266.6285705566406,
        -2654.277587890625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29478561878204346,
        0.9554215669631958,
        0.016467038542032242
      ],
      "plane_d": 2442.81298828125,
      "bbox_min": [
        -274.07421875,
        -2654.277587890625,
        90.5094223022461
      ],
      "bbox_max": [
        -208.74124145507812,
        -2623.136962890625,
        749.8496704101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29478561878204346,
        0.9554215669631958,
        0.016467038542032242
      ],
      "plane_d": 2442.81298828125,
      "bbox_min": [
        -691.2036743164062,
        -2674.623046875,
        112.62752532958984
      ],
      "bbox_max": [
        162.44873046875,
        -1865.0,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26160192489624023,
        0.9247593879699707,
        0.27637779712677
      ],
      "plane_d": 2175.628173828125,
      "bbox_min": [
        -274.07421875,
        -2674.623046875,
        749.8496704101562
      ],
      "bbox_max": [
        -126.417724609375,
        -2615.420654296875,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14437326788902283,
        0.977375328540802,
        0.1545761078596115
      ],
      "plane_d": 2438.747314453125,
      "bbox_min": [
        -274.07421875,
        -2674.623046875,
        749.8496704101562
      ],
      "bbox_max": [
        -132.919921875,
        -2654.277587890625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -691.2036743164062,
        -2508.5,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1865.0,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9814715385437012,
        0.1916080117225647
      ],
      "plane_d": -2147.4345703125,
      "bbox_min": [
        -172.9431915283203,
        -2198.71875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1865.0,
        1129.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9607705473899841,
        -0.2770630121231079,
        -0.012491104193031788
      ],
      "plane_d": -484.89111328125,
      "bbox_min": [
        -172.9431915283203,
        -2073.255615234375,
        587.62353515625
      ],
      "bbox_max": [
        153.40740966796875,
        -1865.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9888145923614502,
        -0.07494720071554184,
        -0.1289515197277069
      ],
      "plane_d": 10.24078369140625,
      "bbox_min": [
        -172.9431915283203,
        -2063.59326171875,
        618.412841796875
      ],
      "bbox_max": [
        -20.0,
        -1865.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -172.9431915283203,
        -2063.563720703125,
        618.412841796875
      ],
      "bbox_max": [
        -51.42585754394531,
        -1865.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -129.07843017578125,
        -2063.563720703125,
        618.412841796875
      ],
      "bbox_max": [
        -51.42585754394531,
        -1946.1995849609375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -118.56555938720703,
        -2063.563720703125,
        618.412841796875
      ],
      "bbox_max": [
        -55.977264404296875,
        -1950.38720703125,
        813.3817138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -98.83558654785156,
        -1981.531005859375,
        700.0296020507812
      ],
      "bbox_max": [
        -57.60731506347656,
        -1969.0758056640625,
        786.18359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -98.47842407226562,
        -1981.531005859375,
        700.0296020507812
      ],
      "bbox_max": [
        -68.91596221923828,
        -1969.3336181640625,
        711.3555297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -99.86669921875,
        -2063.563720703125,
        618.412841796875
      ],
      "bbox_max": [
        -69.2557601928711,
        -1969.4150390625,
        711.2977905273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05980534851551056,
        -0.671236515045166,
        0.7388266921043396
      ],
      "plane_d": -1850.9669189453125,
      "bbox_min": [
        -97.80717468261719,
        -2063.563720703125,
        618.412841796875
      ],
      "bbox_max": [
        -78.00985717773438,
        -2033.1204833984375,
        666.0718383789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 1923.475830078125,
      "bbox_min": [
        -96.99676513671875,
        -2048.5146484375,
        618.412841796875
      ],
      "bbox_max": [
        -80.76506042480469,
        -2044.573974609375,
        653.890380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -96.99676513671875,
        -2047.5574951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -85.13462829589844,
        -2044.573974609375,
        653.890380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -90.278564453125,
        -2046.7047119140625,
        652.7044067382812
      ],
      "bbox_max": [
        -85.13462829589844,
        -2044.573974609375,
        653.890380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -97.63473510742188,
        -2049.501953125,
        650.7062377929688
      ],
      "bbox_max": [
        -80.4915542602539,
        -2045.8577880859375,
        655.2828369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 1923.475830078125,
      "bbox_min": [
        -85.13462829589844,
        -2048.619384765625,
        650.7062377929688
      ],
      "bbox_max": [
        -80.51241302490234,
        -2046.7047119140625,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -99.86669921875,
        -2059.573974609375,
        653.1491088867188
      ],
      "bbox_max": [
        -80.46389770507812,
        -2047.364990234375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532700657844543,
        0.2706069350242615,
        0.7071138620376587
      ],
      "plane_d": 144.97592163085938,
      "bbox_min": [
        -99.86669921875,
        -2059.573974609375,
        653.7388916015625
      ],
      "bbox_max": [
        -80.46389770507812,
        -2047.364990234375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -99.86669921875,
        -2059.573974609375,
        654.4420776367188
      ],
      "bbox_max": [
        -90.278564453125,
        -2047.364990234375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.653276264667511,
        0.27059444785118103,
        0.7071129083633423
      ],
      "plane_d": 26.99755859375,
      "bbox_min": [
        -99.86669921875,
        -2059.573974609375,
        656.0746459960938
      ],
      "bbox_max": [
        -97.058349609375,
        -2051.547119140625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -172.9431915283203,
        -2063.324462890625,
        618.412841796875
      ],
      "bbox_max": [
        -88.89671325683594,
        -1920.0,
        862.9803466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -172.9431915283203,
        -1969.4150390625,
        711.2977905273438
      ],
      "bbox_max": [
        -98.47756958007812,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -172.9431915283203,
        -1924.089111328125,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -99.61474609375,
        -1969.4150390625,
        711.2977905273438
      ],
      "bbox_max": [
        -98.47756958007812,
        -1968.943359375,
        713.1172485351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -99.61474609375,
        -1969.4150390625,
        711.2977905273438
      ],
      "bbox_max": [
        -98.47756958007812,
        -1968.943359375,
        711.7363891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -156.78652954101562,
        -2063.324462890625,
        618.412841796875
      ],
      "bbox_max": [
        -88.89671325683594,
        -1940.0272216796875,
        862.9803466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -148.03103637695312,
        -2063.324462890625,
        618.412841796875
      ],
      "bbox_max": [
        -88.89671325683594,
        -1940.0272216796875,
        862.9803466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -119.99136352539062,
        -2063.324462890625,
        618.412841796875
      ],
      "bbox_max": [
        -88.89671325683594,
        -1968.943359375,
        711.7363891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05980534851551056,
        -0.671236515045166,
        0.7388266921043396
      ],
      "plane_d": -1850.9669189453125,
      "bbox_min": [
        -119.99136352539062,
        -2063.324462890625,
        618.412841796875
      ],
      "bbox_max": [
        -88.89671325683594,
        -2026.7135009765625,
        671.52490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826923370361328,
        0.9238758087158203,
        0.0
      ],
      "plane_d": 1854.383544921875,
      "bbox_min": [
        -119.99136352539062,
        -2062.580810546875,
        618.412841796875
      ],
      "bbox_max": [
        -88.89671325683594,
        -2026.7135009765625,
        671.52490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -107.73072052001953,
        -2062.580810546875,
        618.412841796875
      ],
      "bbox_max": [
        -88.89671325683594,
        -2044.573974609375,
        652.889892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -98.24210357666016,
        -2047.8726806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -96.92052459716797,
        -2047.3251953125,
        652.889892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -107.73072052001953,
        -2062.580810546875,
        618.412841796875
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        636.500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -119.99136352539062,
        -2049.560791015625,
        652.0034790039062
      ],
      "bbox_max": [
        -106.350830078125,
        -2026.7135009765625,
        671.52490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -119.99136352539062,
        -2032.661865234375,
        664.9536743164062
      ],
      "bbox_max": [
        -106.350830078125,
        -2026.7135009765625,
        671.52490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -104.56549835205078,
        -2057.8525390625,
        644.1494750976562
      ],
      "bbox_max": [
        -96.99676513671875,
        -2047.5576171875,
        654.4420166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.653276264667511,
        0.27059444785118103,
        0.7071129083633423
      ],
      "plane_d": 26.99755859375,
      "bbox_min": [
        -102.37576293945312,
        -2052.56591796875,
        651.923583984375
      ],
      "bbox_max": [
        -96.99676513671875,
        -2047.5576171875,
        654.4420166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -100.88525390625,
        -2050.113525390625,
        651.923583984375
      ],
      "bbox_max": [
        -96.99676513671875,
        -2047.5576171875,
        654.4420166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826923370361328,
        0.9238758087158203,
        0.0
      ],
      "plane_d": 1854.383544921875,
      "bbox_min": [
        -100.88525390625,
        -2048.967529296875,
        651.923583984375
      ],
      "bbox_max": [
        -98.24210357666016,
        -2047.8726806640625,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -104.0156021118164,
        -2056.52490234375,
        650.0479736328125
      ],
      "bbox_max": [
        -97.63469696044922,
        -2049.501953125,
        654.8831176757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.653276264667511,
        0.27059444785118103,
        0.7071129083633423
      ],
      "plane_d": 26.99755859375,
      "bbox_min": [
        -102.6607894897461,
        -2053.254150390625,
        652.7044067382812
      ],
      "bbox_max": [
        -97.63469696044922,
        -2049.501953125,
        654.8831176757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -99.73948669433594,
        -2050.44287109375,
        654.201416015625
      ],
      "bbox_max": [
        -97.63469696044922,
        -2049.501953125,
        654.8831176757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -144.57403564453125,
        -2059.573974609375,
        650.5011596679688
      ],
      "bbox_max": [
        -97.81600952148438,
        -1940.0272216796875,
        862.9803466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -103.97335052490234,
        -2056.4228515625,
        650.5011596679688
      ],
      "bbox_max": [
        -97.81600952148438,
        -2050.054443359375,
        656.0746459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -99.41008758544922,
        -2051.547119140625,
        654.6317749023438
      ],
      "bbox_max": [
        -97.81600952148438,
        -2050.054443359375,
        656.0746459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -84.84825134277344,
        -2063.59326171875,
        618.412841796875
      ],
      "bbox_max": [
        -54.583152770996094,
        -1975.3182373046875,
        809.252685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -57.60731506347656,
        -1976.522216796875,
        786.18359375
      ],
      "bbox_max": [
        -54.68634796142578,
        -1975.3182373046875,
        801.305419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -55.977264404296875,
        -1975.83251953125,
        797.9343872070312
      ],
      "bbox_max": [
        -54.68634796142578,
        -1975.318359375,
        801.305419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -84.84825134277344,
        -2063.59326171875,
        618.412841796875
      ],
      "bbox_max": [
        -54.583152770996094,
        -1975.472900390625,
        809.252685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05980534851551056,
        -0.671236515045166,
        0.7388266921043396
      ],
      "plane_d": -1850.9669189453125,
      "bbox_min": [
        -84.84825134277344,
        -2063.59326171875,
        618.412841796875
      ],
      "bbox_max": [
        -73.37274169921875,
        -2034.18310546875,
        663.50390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 1923.475830078125,
      "bbox_min": [
        -84.84825134277344,
        -2051.68505859375,
        618.412841796875
      ],
      "bbox_max": [
        -78.54643249511719,
        -2046.8233642578125,
        650.7062377929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": 857.7465209960938,
      "bbox_min": [
        -79.672119140625,
        -2051.68505859375,
        618.412841796875
      ],
      "bbox_max": [
        -78.54643249511719,
        -2048.967529296875,
        650.2064208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": 857.7465209960938,
      "bbox_min": [
        -80.76506042480469,
        -2051.748779296875,
        647.6465454101562
      ],
      "bbox_max": [
        -78.51998138427734,
        -2048.5146484375,
        653.1491088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 1923.475830078125,
      "bbox_min": [
        -80.76506042480469,
        -2049.59716796875,
        650.2064208984375
      ],
      "bbox_max": [
        -79.41133880615234,
        -2048.5146484375,
        653.1491088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -80.51241302490234,
        -2049.59716796875,
        652.7044067382812
      ],
      "bbox_max": [
        -79.41133880615234,
        -2048.619384765625,
        653.1491088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532700657844543,
        0.2706069350242615,
        0.7071138620376587
      ],
      "plane_d": 144.97592163085938,
      "bbox_min": [
        -79.91654968261719,
        -2049.59716796875,
        652.7044067382812
      ],
      "bbox_max": [
        -79.41133880615234,
        -2048.967529296875,
        653.0237426757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532700657844543,
        0.2706069350242615,
        0.7071138620376587
      ],
      "plane_d": 144.97592163085938,
      "bbox_min": [
        -80.690673828125,
        -2059.573974609375,
        651.0970458984375
      ],
      "bbox_max": [
        -54.583152770996094,
        -1975.472900390625,
        809.252685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": 857.7465209960938,
      "bbox_min": [
        -80.4915542602539,
        -2051.778564453125,
        651.0970458984375
      ],
      "bbox_max": [
        -78.50765991210938,
        -2049.109375,
        653.7388916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -80.4915542602539,
        -2049.75927734375,
        653.0237426757812
      ],
      "bbox_max": [
        -79.91654968261719,
        -2049.109375,
        653.7388916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -55.58918380737305,
        -1975.8736572265625,
        800.4033203125
      ],
      "bbox_max": [
        -54.583152770996094,
        -1975.472900390625,
        809.252685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.440481036901474,
        -0.8977619409561157,
        0.0
      ],
      "plane_d": -1797.645263671875,
      "bbox_min": [
        -82.11737060546875,
        -2073.255615234375,
        587.62353515625
      ],
      "bbox_max": [
        153.40740966796875,
        -1975.821044921875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.826246440410614,
        -0.5570085048675537,
        0.08401353657245636
      ],
      "plane_d": -1092.1922607421875,
      "bbox_min": [
        121.512451171875,
        -2056.047607421875,
        637.62353515625
      ],
      "bbox_max": [
        132.91094970703125,
        -2044.892578125,
        678.410400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        5.397911071777344,
        -2073.255615234375,
        587.62353515625
      ],
      "bbox_max": [
        153.40740966796875,
        -2005.011474609375,
        688.2540283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        82.40291595458984,
        -2073.255615234375,
        587.62353515625
      ],
      "bbox_max": [
        153.40740966796875,
        -2042.7933349609375,
        642.6964721679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05980534851551056,
        -0.671236515045166,
        0.7388266921043396
      ],
      "plane_d": -1850.9669189453125,
      "bbox_min": [
        82.40291595458984,
        -2048.730712890625,
        636.32275390625
      ],
      "bbox_max": [
        121.512451171875,
        -2042.7933349609375,
        642.6964721679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8734391927719116,
        -0.19791147112846375,
        -0.44489893317222595
      ],
      "plane_d": -14.895965576171875,
      "bbox_min": [
        121.512451171875,
        -2073.255615234375,
        587.62353515625
      ],
      "bbox_max": [
        153.40740966796875,
        -2044.892578125,
        637.62353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        129.67422485351562,
        -2073.255615234375,
        587.62353515625
      ],
      "bbox_max": [
        153.40740966796875,
        -2064.892578125,
        590.831787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        121.512451171875,
        -2066.762451171875,
        620.8826293945312
      ],
      "bbox_max": [
        134.99513244628906,
        -2044.892578125,
        688.2540283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.826246440410614,
        -0.5570085048675537,
        0.08401353657245636
      ],
      "plane_d": -1092.1922607421875,
      "bbox_min": [
        121.512451171875,
        -2066.762451171875,
        620.8826293945312
      ],
      "bbox_max": [
        134.99513244628906,
        -2044.892578125,
        675.76708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8734391927719116,
        -0.19791147112846375,
        -0.44489893317222595
      ],
      "plane_d": -14.895965576171875,
      "bbox_min": [
        121.512451171875,
        -2066.762451171875,
        620.8826293945312
      ],
      "bbox_max": [
        134.99513244628906,
        -2044.892578125,
        637.62353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -82.11737060546875,
        -2072.989013671875,
        588.9891357421875
      ],
      "bbox_max": [
        143.94595336914062,
        -1975.821044921875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -78.77050018310547,
        -2072.989013671875,
        588.9891357421875
      ],
      "bbox_max": [
        143.94595336914062,
        -2048.730712890625,
        647.6466064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": 857.7465209960938,
      "bbox_min": [
        -78.77050018310547,
        -2067.24462890625,
        618.412841796875
      ],
      "bbox_max": [
        -65.69345092773438,
        -2051.14404296875,
        647.6466064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        0.7807667851448059,
        -0.0
      ],
      "plane_d": 1655.082763671875,
      "bbox_min": [
        -75.278564453125,
        -2067.24462890625,
        618.412841796875
      ],
      "bbox_max": [
        -65.69345092773438,
        -2059.573974609375,
        640.2146606445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        45.36741638183594,
        -2072.989013671875,
        588.9891357421875
      ],
      "bbox_max": [
        143.94595336914062,
        -2065.98681640625,
        603.21728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -58.14104080200195,
        -2005.011474609375,
        676.5404052734375
      ],
      "bbox_max": [
        5.397914886474609,
        -1982.3934326171875,
        708.9171142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -80.690673828125,
        -2063.82666015625,
        635.9208984375
      ],
      "bbox_max": [
        1.1896400451660156,
        -1975.821044921875,
        797.9343872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -55.010284423828125,
        -1977.1312255859375,
        790.7861328125
      ],
      "bbox_max": [
        -51.42585754394531,
        -1975.821044921875,
        797.9343872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        0.7807667851448059,
        -0.0
      ],
      "plane_d": 1655.082763671875,
      "bbox_min": [
        -80.690673828125,
        -2063.82666015625,
        635.9208984375
      ],
      "bbox_max": [
        -69.96453857421875,
        -2051.68505859375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        -0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -937.260986328125,
      "bbox_min": [
        -75.6828842163086,
        -2060.701416015625,
        651.92919921875
      ],
      "bbox_max": [
        -74.43592834472656,
        -2059.573974609375,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": 857.7465209960938,
      "bbox_min": [
        -79.69985961914062,
        -2059.573974609375,
        640.2146606445312
      ],
      "bbox_max": [
        -75.278564453125,
        -2051.68505859375,
        655.4349975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532700657844543,
        0.2706069350242615,
        0.7071138620376587
      ],
      "plane_d": 144.97592163085938,
      "bbox_min": [
        -79.69985961914062,
        -2059.573974609375,
        652.7044067382812
      ],
      "bbox_max": [
        -75.278564453125,
        -2051.778564453125,
        655.4349975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.440481036901474,
        -0.8977619409561157,
        0.0
      ],
      "plane_d": -1797.645263671875,
      "bbox_min": [
        -102.4698486328125,
        -2198.71875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1977.1312255859375,
        1129.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8734391927719116,
        -0.19791147112846375,
        -0.44489893317222595
      ],
      "plane_d": -14.895965576171875,
      "bbox_min": [
        134.52838134765625,
        -2078.178466796875,
        587.62353515625
      ],
      "bbox_max": [
        154.52288818359375,
        -2066.597900390625,
        621.7257690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        143.94595336914062,
        -2078.178466796875,
        587.62353515625
      ],
      "bbox_max": [
        154.52288818359375,
        -2072.989013671875,
        588.9891357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9240420460700989,
        0.31055086851119995,
        -0.22294506430625916
      ],
      "plane_d": 937.360107421875,
      "bbox_min": [
        143.29933166503906,
        -2075.06591796875,
        699.8282470703125
      ],
      "bbox_max": [
        148.1786651611328,
        -2067.178466796875,
        723.3864135742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45699819922447205,
        -0.8811807036399841,
        -0.1211327537894249
      ],
      "plane_d": -1669.15185546875,
      "bbox_min": [
        71.04067993164062,
        -2066.00927734375,
        688.2540283203125
      ],
      "bbox_max": [
        129.7200469970703,
        -2037.2186279296875,
        772.2144775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9042837023735046,
        0.4269319474697113,
        0.0
      ],
      "plane_d": 999.3490600585938,
      "bbox_min": [
        -102.4698486328125,
        -2198.71875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2059.573974609375,
        1129.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        67.68309020996094,
        -2198.71875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2066.00927734375,
        952.922119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9362152218818665,
        0.2509586215019226,
        -0.2460101991891861
      ],
      "plane_d": 826.9634399414062,
      "bbox_min": [
        113.528564453125,
        -2157.653076171875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2066.00927734375,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9240420460700989,
        0.31055086851119995,
        -0.22294506430625916
      ],
      "plane_d": 937.360107421875,
      "bbox_min": [
        113.528564453125,
        -2157.653076171875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2072.671875,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.826246440410614,
        -0.5570085048675537,
        0.08401353657245636
      ],
      "plane_d": -1092.1922607421875,
      "bbox_min": [
        146.42982482910156,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2074.207763671875,
        699.8282470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.826246440410614,
        -0.5570085048675537,
        0.08401353657245636
      ],
      "plane_d": -1092.1922607421875,
      "bbox_min": [
        143.02252197265625,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2072.5361328125,
        688.318115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        113.528564453125,
        -2157.653076171875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2092.5107421875,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13787776231765747,
        -0.03273407742381096,
        0.9899080991744995
      ],
      "plane_d": -673.2636108398438,
      "bbox_min": [
        144.96273803710938,
        -2115.666015625,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2111.0625,
        589.9774169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        145.30203247070312,
        -2114.197998046875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2111.0625,
        589.9774169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        67.68309020996094,
        -2198.71875,
        587.6851806640625
      ],
      "bbox_max": [
        154.0456085205078,
        -2066.00927734375,
        936.33740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        85.21322631835938,
        -2160.279052734375,
        704.8739013671875
      ],
      "bbox_max": [
        113.528564453125,
        -2157.49951171875,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        86.5254898071289,
        -2157.653076171875,
        587.6851806640625
      ],
      "bbox_max": [
        154.0456085205078,
        -2066.00927734375,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.826246440410614,
        -0.5570085048675537,
        0.08401353657245636
      ],
      "plane_d": -1092.1922607421875,
      "bbox_min": [
        136.03269958496094,
        -2092.5107421875,
        587.6851806640625
      ],
      "bbox_max": [
        154.0456085205078,
        -2069.1064453125,
        665.892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8734391927719116,
        -0.19791147112846375,
        -0.44489893317222595
      ],
      "plane_d": -14.895965576171875,
      "bbox_min": [
        136.03269958496094,
        -2092.5107421875,
        587.6851806640625
      ],
      "bbox_max": [
        154.0456085205078,
        -2069.1064453125,
        619.8883666992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        139.16610717773438,
        -2092.5107421875,
        587.6851806640625
      ],
      "bbox_max": [
        154.0456085205078,
        -2072.854248046875,
        589.6790161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        86.5254898071289,
        -2157.653076171875,
        588.6765747070312
      ],
      "bbox_max": [
        150.52145385742188,
        -2072.501708984375,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        86.5254898071289,
        -2157.653076171875,
        694.6030883789062
      ],
      "bbox_max": [
        113.528564453125,
        -2150.73486328125,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        103.46529388427734,
        -2121.619384765625,
        588.6765747070312
      ],
      "bbox_max": [
        150.52145385742188,
        -2072.501708984375,
        595.5591430664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        105.83856201171875,
        -2116.592529296875,
        589.9391479492188
      ],
      "bbox_max": [
        146.03309631347656,
        -2106.538818359375,
        595.3948364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        -102.4698486328125,
        -2197.409423828125,
        591.4848022460938
      ],
      "bbox_max": [
        129.7200469970703,
        -2059.573974609375,
        1129.589111328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        -102.4698486328125,
        -2132.77880859375,
        591.4848022460938
      ],
      "bbox_max": [
        126.65480041503906,
        -2066.8935546875,
        624.8993530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -102.4698486328125,
        -2081.89990234375,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2067.07568359375,
        624.4310302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9148070812225342,
        -0.40389132499694824,
        0.0
      ],
      "plane_d": -776.2926025390625,
      "bbox_min": [
        -66.12939453125,
        -2071.8154296875,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2067.07568359375,
        619.4662475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        0.7807667851448059,
        -0.0
      ],
      "plane_d": 1655.082763671875,
      "bbox_min": [
        -65.90440368652344,
        -2068.18017578125,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2067.07568359375,
        619.277587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -102.4698486328125,
        -2081.89990234375,
        618.412841796875
      ],
      "bbox_max": [
        -79.672119140625,
        -2069.89013671875,
        624.4310302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -92.20443725585938,
        -2074.573974609375,
        618.412841796875
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        623.3184814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -88.27063751220703,
        -2073.7421875,
        618.5244140625
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        622.7459106445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.10107421875,
        -2081.89990234375,
        618.5244140625
      ],
      "bbox_max": [
        -88.2706298828125,
        -2073.7421875,
        623.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2081.89990234375,
      "bbox_min": [
        -91.10107421875,
        -2081.89990234375,
        618.5244140625
      ],
      "bbox_max": [
        -89.30126953125,
        -2081.89990234375,
        623.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -102.4698486328125,
        -2073.7763671875,
        618.412841796875
      ],
      "bbox_max": [
        -92.20443725585938,
        -2069.89013671875,
        624.4310302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -102.4698486328125,
        -2070.1806640625,
        618.412841796875
      ],
      "bbox_max": [
        -100.88525390625,
        -2069.89013671875,
        623.802001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -58.47370147705078,
        -2132.77880859375,
        595.5591430664062
      ],
      "bbox_max": [
        103.46530151367188,
        -2121.619384765625,
        617.8444213867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        26.906936645507812,
        -2132.77880859375,
        595.5591430664062
      ],
      "bbox_max": [
        103.46530151367188,
        -2121.619384765625,
        606.0013427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        26.906936645507812,
        -2132.77880859375,
        605.8223876953125
      ],
      "bbox_max": [
        27.27383041381836,
        -2132.563232421875,
        606.0013427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -100.65653228759766,
        -2081.045166015625,
        603.21728515625
      ],
      "bbox_max": [
        45.367408752441406,
        -2066.8935546875,
        624.8993530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -100.65653228759766,
        -2077.08203125,
        619.1134643554688
      ],
      "bbox_max": [
        -64.5244140625,
        -2066.8935546875,
        624.8993530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9148070812225342,
        -0.40389132499694824,
        0.0
      ],
      "plane_d": -776.2926025390625,
      "bbox_min": [
        -66.1320571899414,
        -2071.8154296875,
        619.1134643554688
      ],
      "bbox_max": [
        -64.5244140625,
        -2066.8935546875,
        620.2107543945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        0.7807667851448059,
        -0.0
      ],
      "plane_d": 1655.082763671875,
      "bbox_min": [
        -66.1320571899414,
        -2068.18017578125,
        619.113525390625
      ],
      "bbox_max": [
        -64.5244140625,
        -2066.8935546875,
        620.2107543945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -100.65653228759766,
        -2077.08203125,
        621.3797607421875
      ],
      "bbox_max": [
        -79.672119140625,
        -2070.1806640625,
        624.8993530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.65653228759766,
        -2075.28662109375,
        622.6361083984375
      ],
      "bbox_max": [
        -88.0,
        -2070.275390625,
        624.8993530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.776123046875,
        622.6361083984375
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        623.7680053710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -88.27063751220703,
        -2073.7421875,
        622.6361083984375
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        623.1448364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.2044448852539,
        -2075.28662109375,
        623.3184814453125
      ],
      "bbox_max": [
        -91.9992904663086,
        -2073.776123046875,
        623.683349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.99929809570312,
        -2077.08203125,
        622.7459106445312
      ],
      "bbox_max": [
        -88.27063751220703,
        -2073.7421875,
        623.6245727539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.99929809570312,
        -2077.08203125,
        623.33837890625
      ],
      "bbox_max": [
        -91.75545501708984,
        -2075.28662109375,
        623.6245727539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.76782989501953,
        -2081.045166015625,
        622.9091796875
      ],
      "bbox_max": [
        -88.65960693359375,
        -2076.821044921875,
        623.5582885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.76782989501953,
        -2080.781494140625,
        623.362060546875
      ],
      "bbox_max": [
        -91.25299072265625,
        -2076.990966796875,
        623.5582885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        -102.00392150878906,
        -2197.409423828125,
        595.6233520507812
      ],
      "bbox_max": [
        129.7200469970703,
        -2059.573974609375,
        1129.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        -32.082427978515625,
        -2171.38818359375,
        626.1060180664062
      ],
      "bbox_max": [
        86.5254898071289,
        -2156.9873046875,
        709.093994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -32.082427978515625,
        -2171.38818359375,
        626.1060180664062
      ],
      "bbox_max": [
        -3.8754138946533203,
        -2156.9873046875,
        644.5339965820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -27.960147857666016,
        -2171.38818359375,
        636.1889038085938
      ],
      "bbox_max": [
        -20.5302734375,
        -2167.105712890625,
        644.5339965820312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.16232021152973175,
        0.6113415360450745,
        0.7745409607887268
      ],
      "plane_d": 836.6258544921875,
      "bbox_min": [
        -27.960147857666016,
        -2170.08544921875,
        636.1889038085938
      ],
      "bbox_max": [
        -20.5302734375,
        -2167.105712890625,
        637.8534545898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642076253890991,
        0.49060776829719543,
        -0.11157596111297607
      ],
      "plane_d": 1246.207275390625,
      "bbox_min": [
        -102.00392150878906,
        -2182.8388671875,
        595.6233520507812
      ],
      "bbox_max": [
        129.7200469970703,
        -2059.573974609375,
        1129.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        -102.00392150878906,
        -2162.259521484375,
        595.6233520507812
      ],
      "bbox_max": [
        103.45639038085938,
        -2059.573974609375,
        704.8738403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        -46.1274528503418,
        -2162.259521484375,
        605.9542846679688
      ],
      "bbox_max": [
        89.71923828125,
        -2132.59033203125,
        704.8738403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -46.1274528503418,
        -2162.259521484375,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        633.7041625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -102.00392150878906,
        -2145.748291015625,
        605.415283203125
      ],
      "bbox_max": [
        40.27885055541992,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05980534851551056,
        -0.671236515045166,
        0.7388266921043396
      ],
      "plane_d": -1850.9669189453125,
      "bbox_min": [
        -102.00392150878906,
        -2076.99072265625,
        619.9622802734375
      ],
      "bbox_max": [
        -18.65771484375,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9148070812225342,
        -0.40389132499694824,
        0.0
      ],
      "plane_d": -776.2926025390625,
      "bbox_min": [
        -66.12939453125,
        -2071.8154296875,
        619.9622802734375
      ],
      "bbox_max": [
        -64.5244140625,
        -2068.18017578125,
        631.5253295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -100.48622131347656,
        -2076.99072265625,
        622.0199584960938
      ],
      "bbox_max": [
        -79.672119140625,
        -2070.1806640625,
        631.3895263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.48622131347656,
        -2075.28662109375,
        623.1392822265625
      ],
      "bbox_max": [
        -88.0,
        -2070.345947265625,
        631.3895263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        623.1392822265625
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        630.682861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        623.683349609375
      ],
      "bbox_max": [
        -92.20440673828125,
        -2071.60009765625,
        630.682861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20442962646484,
        -2075.28662109375,
        623.6245727539062
      ],
      "bbox_max": [
        -91.999267578125,
        -2073.776123046875,
        628.6817016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.99927520751953,
        -2076.99072265625,
        623.1312866210938
      ],
      "bbox_max": [
        -88.27062225341797,
        -2073.7421875,
        628.3944091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.99927520751953,
        -2076.99072265625,
        623.5582885742188
      ],
      "bbox_max": [
        -91.76782989501953,
        -2075.28662109375,
        627.2297973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -99.86669921875,
        -2075.235595703125,
        627.3397827148438
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532716155052185,
        -0.270601361989975,
        0.7071146368980408
      ],
      "plane_d": -969.6830444335938,
      "bbox_min": [
        -80.62480163574219,
        -2071.54150390625,
        628.5914916992188
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.5869140625,
        657.6386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9148070812225342,
        -0.40389132499694824,
        0.0
      ],
      "plane_d": -776.2926025390625,
      "bbox_min": [
        -66.0084457397461,
        -2071.54150390625,
        628.5914916992188
      ],
      "bbox_max": [
        -64.5244140625,
        -2068.18017578125,
        635.3427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        -0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -937.260986328125,
      "bbox_min": [
        -76.02018737792969,
        -2062.0478515625,
        650.2850341796875
      ],
      "bbox_max": [
        -72.18742370605469,
        -2060.550048828125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        -0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -959.4097900390625,
      "bbox_min": [
        -74.43592834472656,
        -2062.0478515625,
        650.2850341796875
      ],
      "bbox_max": [
        -72.18742370605469,
        -2060.701416015625,
        651.92919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -98.12615966796875,
        -2075.235595703125,
        627.3397827148438
      ],
      "bbox_max": [
        -79.672119140625,
        -2070.1806640625,
        635.4951782226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -98.12615966796875,
        -2075.235595703125,
        627.3397827148438
      ],
      "bbox_max": [
        -88.0,
        -2071.323486328125,
        635.4951782226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        628.3944091796875
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        635.1734008789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -88.27062225341797,
        -2073.7421875,
        628.3944091796875
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        634.0341186523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20440673828125,
        -2075.235595703125,
        627.3397827148438
      ],
      "bbox_max": [
        -92.0062026977539,
        -2073.7763671875,
        630.484130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -88.39447021484375,
        -2074.722412109375,
        627.5138549804688
      ],
      "bbox_max": [
        -88.27062225341797,
        -2073.7421875,
        629.5609130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -98.35602569580078,
        -2145.748291015625,
        606.1185302734375
      ],
      "bbox_max": [
        26.063024520874023,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        0.7807667851448059,
        -0.0
      ],
      "plane_d": 1655.082763671875,
      "bbox_min": [
        -98.35602569580078,
        -2071.8154296875,
        628.041259765625
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -98.35602569580078,
        -2071.8154296875,
        628.041259765625
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        -0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -937.260986328125,
      "bbox_min": [
        -94.10689544677734,
        -2071.8154296875,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -94.10689544677734,
        -2070.1806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2067.576416015625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2705896496772766,
        -0.6532796025276184,
        0.7071117758750916
      ],
      "plane_d": -1841.240234375,
      "bbox_min": [
        -94.10689544677734,
        -2068.792724609375,
        657.0421142578125
      ],
      "bbox_max": [
        -91.17008209228516,
        -2067.576416015625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        -0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -959.4097900390625,
      "bbox_min": [
        -87.16259002685547,
        -2071.8154296875,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532716155052185,
        -0.270601361989975,
        0.7071146368980408
      ],
      "plane_d": -969.6830444335938,
      "bbox_min": [
        -87.16259002685547,
        -2070.1806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -76.02018737792969,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -87.16259002685547,
        -2070.1806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2066.353759765625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -96.6332015991211,
        -2081.89990234375,
        623.1181030273438
      ],
      "bbox_max": [
        -79.672119140625,
        -2068.498046875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -93.61260986328125,
        -2074.573974609375,
        629.5607299804688
      ],
      "bbox_max": [
        -79.672119140625,
        -2068.498046875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2705896496772766,
        -0.6532796025276184,
        0.7071117758750916
      ],
      "plane_d": -1841.240234375,
      "bbox_min": [
        -93.61260986328125,
        -2074.573974609375,
        629.5607299804688
      ],
      "bbox_max": [
        -88.0,
        -2068.498046875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -92.5,
        -2074.573974609375,
        629.5607299804688
      ],
      "bbox_max": [
        -88.0,
        -2068.792724609375,
        657.7044067382812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2074.573974609375,
        630.4844970703125
      ],
      "bbox_max": [
        -88.0,
        -2068.792724609375,
        657.7044067382812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.5,
        -2074.573974609375,
        651.2399291992188
      ],
      "bbox_max": [
        -88.0,
        -2068.792724609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -91.17008209228516,
        -2069.162109375,
        657.7044067382812
      ],
      "bbox_max": [
        -89.7894515991211,
        -2068.792724609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.2044448852539,
        -2075.28662109375,
        627.2299194335938
      ],
      "bbox_max": [
        -90.27857971191406,
        -2073.776123046875,
        651.2399291992188
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -90.90779876708984,
        -2074.71484375,
        651.2399291992188
      ],
      "bbox_max": [
        -90.27857971191406,
        -2074.313232421875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.99929809570312,
        -2081.89990234375,
        623.1181030273438
      ],
      "bbox_max": [
        -88.2706069946289,
        -2073.7421875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2081.89990234375,
      "bbox_min": [
        -91.99929809570312,
        -2081.89990234375,
        623.1181030273438
      ],
      "bbox_max": [
        -88.2706298828125,
        -2073.7421875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.99929809570312,
        -2081.89990234375,
        623.3673095703125
      ],
      "bbox_max": [
        -88.2706298828125,
        -2073.7421875,
        651.2399291992188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2079.802001953125,
      "bbox_min": [
        -89.515380859375,
        -2079.802001953125,
        641.2166748046875
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        643.094482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7759400010108948,
        0.4866269528865814,
        0.4013866186141968
      ],
      "plane_d": 605.982421875,
      "bbox_min": [
        -691.2036743164062,
        -2508.5,
        617.796630859375
      ],
      "bbox_max": [
        80.05440521240234,
        -1894.5,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7798405289649963,
        0.46382713317871094,
        0.42037254571914673
      ],
      "plane_d": 529.9271850585938,
      "bbox_min": [
        -312.205322265625,
        -2508.5,
        617.796630859375
      ],
      "bbox_max": [
        80.05440521240234,
        -2011.8914794921875,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2366829514503479,
        0.9335814118385315,
        0.2690852880477905
      ],
      "plane_d": 1812.3699951171875,
      "bbox_min": [
        -312.205322265625,
        -2508.5,
        617.796630859375
      ],
      "bbox_max": [
        80.05440521240234,
        -2011.8914794921875,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -312.205322265625,
        -2508.5,
        618.4127807617188
      ],
      "bbox_max": [
        71.39912414550781,
        -2134.01171875,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        -312.205322265625,
        -2508.5,
        618.4127807617188
      ],
      "bbox_max": [
        71.39912414550781,
        -2177.437255859375,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 644.0186767578125,
      "bbox_min": [
        -312.205322265625,
        -2508.5,
        618.4127807617188
      ],
      "bbox_max": [
        -75.29743194580078,
        -2177.437255859375,
        861.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -267.07666015625,
        -2508.5,
        618.4127807617188
      ],
      "bbox_max": [
        -75.29743194580078,
        -2177.437255859375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -267.07666015625,
        -2508.5,
        618.4127807617188
      ],
      "bbox_max": [
        -75.29743194580078,
        -2177.437255859375,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -121.76891326904297,
        -2219.5,
        818.7000122070312
      ],
      "bbox_max": [
        -113.39990234375,
        -2209.897216796875,
        836.9834594726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -125.82259368896484,
        -2239.39990234375,
        854.5
      ],
      "bbox_max": [
        -120.5,
        -2219.0439453125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -125.82259368896484,
        -2239.39990234375,
        857.0
      ],
      "bbox_max": [
        -122.5,
        -2220.219970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.15676754713058472,
        -0.9876355528831482
      ],
      "plane_d": 376.5713195800781,
      "bbox_min": [
        -267.07666015625,
        -2502.5,
        618.4127807617188
      ],
      "bbox_max": [
        -75.29743194580078,
        -2177.437255859375,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2498.5,
      "bbox_min": [
        -221.0,
        -2498.5,
        777.8729858398438
      ],
      "bbox_max": [
        -197.0,
        -2498.5,
        778.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999997615814209,
        -0.0006946580833755434,
        0.0
      ],
      "plane_d": 73.78484344482422,
      "bbox_min": [
        -267.07666015625,
        -2502.5,
        618.4127807617188
      ],
      "bbox_max": [
        -75.29743194580078,
        -2177.437255859375,
        777.8729858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -267.07666015625,
        -2502.5,
        638.0
      ],
      "bbox_max": [
        -197.0,
        -2311.052490234375,
        777.8729858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5731114149093628,
        0.8194774389266968,
        -0.0
      ],
      "plane_d": 2056.7548828125,
      "bbox_min": [
        -267.07666015625,
        -2502.5,
        638.0
      ],
      "bbox_max": [
        -197.0,
        -2325.29345703125,
        777.8729858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238552451133728,
        0.38274234533309937,
        0.0
      ],
      "plane_d": 645.162353515625,
      "bbox_min": [
        -267.07666015625,
        -2502.5,
        638.0
      ],
      "bbox_max": [
        -197.0,
        -2325.29345703125,
        777.8729858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267287611961365,
        0.9238839745521545,
        -0.0
      ],
      "plane_d": 2249.71142578125,
      "bbox_min": [
        -265.004638671875,
        -2502.5,
        638.0
      ],
      "bbox_max": [
        -197.0,
        -2325.29345703125,
        777.8729858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2498.5,
      "bbox_min": [
        -221.0,
        -2502.5,
        775.0
      ],
      "bbox_max": [
        -197.0,
        -2498.5,
        777.8729858398438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 775.9999389648438,
      "bbox_min": [
        -221.0,
        -2502.5,
        775.0
      ],
      "bbox_max": [
        -197.0,
        -2498.5,
        776.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2499.0,
      "bbox_min": [
        -220.5,
        -2499.0,
        775.0
      ],
      "bbox_max": [
        -197.5,
        -2499.0,
        776.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38260340690612793,
        0.923912763595581,
        0.0
      ],
      "plane_d": 2252.760009765625,
      "bbox_min": [
        -267.07666015625,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -266.15283203125,
        -2327.682373046875,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -312.205322265625,
        -2346.7353515625,
        626.0
      ],
      "bbox_max": [
        -260.188232421875,
        -2292.359130859375,
        709.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -312.205322265625,
        -2327.682373046875,
        626.0
      ],
      "bbox_max": [
        -260.188232421875,
        -2292.359130859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826896548271179,
        0.9238770604133606,
        -0.0
      ],
      "plane_d": 2234.69970703125,
      "bbox_min": [
        -305.317138671875,
        -2311.052490234375,
        626.0
      ],
      "bbox_max": [
        -260.188232421875,
        -2292.359130859375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        63.3701171875,
        -2206.544921875,
        936.33740234375
      ],
      "bbox_max": [
        71.39912414550781,
        -2195.40283203125,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -142.38246154785156,
        -2213.484130859375,
        618.4127807617188
      ],
      "bbox_max": [
        -22.747962951660156,
        -2134.01171875,
        847.1928100585938
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -142.38246154785156,
        -2213.484130859375,
        618.4127807617188
      ],
      "bbox_max": [
        -75.2867431640625,
        -2159.63916015625,
        830.7184448242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999997615814209,
        -0.0006946580833755434,
        0.0
      ],
      "plane_d": 73.78484344482422,
      "bbox_min": [
        -105.300048828125,
        -2181.199951171875,
        618.4127807617188
      ],
      "bbox_max": [
        -75.2867431640625,
        -2162.047607421875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.999999463558197,
        0.0010735620744526386,
        0.0
      ],
      "plane_d": -97.55819702148438,
      "bbox_min": [
        -105.300048828125,
        -2181.199951171875,
        626.0
      ],
      "bbox_max": [
        -75.29141235351562,
        -2166.36376953125,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0002999660500790924,
        0.0
      ],
      "plane_d": 80.04566192626953,
      "bbox_min": [
        -99.89990234375,
        -2181.199951171875,
        626.0
      ],
      "bbox_max": [
        -75.29141235351562,
        -2167.640869140625,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -99.89990234375,
        -2181.199951171875,
        626.0
      ],
      "bbox_max": [
        -80.69756317138672,
        -2167.640869140625,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 1599.4754638671875,
      "bbox_min": [
        -98.89990234375,
        -2181.0,
        626.0
      ],
      "bbox_max": [
        -81.60009765625,
        -2167.640869140625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1480.8887939453125,
      "bbox_min": [
        -98.89990234375,
        -2181.0,
        626.0
      ],
      "bbox_max": [
        -81.60009765625,
        -2167.640869140625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2181.0,
      "bbox_min": [
        -86.70694732666016,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2178.146484375,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -86.70694732666016,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2178.146484375,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 675.2044067382812,
      "bbox_min": [
        -86.70694732666016,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2178.146484375,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -86.70694732666016,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2178.146484375,
        656.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2180.0,
      "bbox_min": [
        -85.70693969726562,
        -2180.0,
        654.5999755859375
      ],
      "bbox_max": [
        -85.0,
        -2180.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1472.1962890625,
      "bbox_min": [
        -98.89990234375,
        -2181.0,
        626.0
      ],
      "bbox_max": [
        -83.85347747802734,
        -2167.640869140625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 1608.16796875,
      "bbox_min": [
        -98.89990234375,
        -2181.0,
        626.0
      ],
      "bbox_max": [
        -83.85347747802734,
        -2172.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2181.0,
      "bbox_min": [
        -98.89990234375,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -93.29309844970703,
        -2178.146484375,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -93.29309844970703,
        -2178.146484375,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 675.2044067382812,
      "bbox_min": [
        -98.89990234375,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -93.29309844970703,
        -2178.146484375,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -93.29309844970703,
        -2178.146484375,
        656.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2180.0,
      "bbox_min": [
        -95.0,
        -2180.0,
        654.5999755859375
      ],
      "bbox_max": [
        -94.29289245605469,
        -2180.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2181.0,
      "bbox_min": [
        -96.14655303955078,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -83.85347747802734,
        -2172.0,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 675.2044067382812,
      "bbox_min": [
        -96.14655303955078,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -83.85347747802734,
        -2172.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2180.0,
      "bbox_min": [
        -94.29289245605469,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -85.70693969726562,
        -2172.0,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -94.29289245605469,
        -2181.0,
        656.5999755859375
      ],
      "bbox_max": [
        -85.70693969726562,
        -2180.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 674.4000244140625,
      "bbox_min": [
        -92.0,
        -2180.0,
        656.5999755859375
      ],
      "bbox_max": [
        -88.39990234375,
        -2172.0,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070798277854919,
        -0.0,
        -0.7071337699890137
      ],
      "plane_d": 412.4053649902344,
      "bbox_min": [
        -92.0,
        -2180.0,
        674.4000244140625
      ],
      "bbox_max": [
        -91.199951171875,
        -2173.199951171875,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -90.49994659423828,
        -2172.5,
        656.5999755859375
      ],
      "bbox_max": [
        -89.4998779296875,
        -2172.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1603.3646240234375,
      "bbox_min": [
        -98.89990234375,
        -2180.89990234375,
        626.0
      ],
      "bbox_max": [
        -89.99996948242188,
        -2167.640869140625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2180.89990234375,
        654.5999755859375
      ],
      "bbox_max": [
        -92.75004577636719,
        -2168.60009765625,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2180.89990234375,
        654.5999755859375
      ],
      "bbox_max": [
        -94.646484375,
        -2168.60009765625,
        656.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 96.5,
      "bbox_min": [
        -96.5,
        -2178.5,
        654.5999755859375
      ],
      "bbox_max": [
        -96.5,
        -2174.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2174.75,
        656.5999755859375
      ],
      "bbox_max": [
        -89.99996948242188,
        -2167.640869140625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 675.2044067382812,
      "bbox_min": [
        -98.89990234375,
        -2174.75,
        656.5999755859375
      ],
      "bbox_max": [
        -90.0000228881836,
        -2167.640869140625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2174.0,
        656.5999755859375
      ],
      "bbox_max": [
        -90.0000228881836,
        -2167.640869140625,
        675.2000122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 674.4000244140625,
      "bbox_min": [
        -91.199951171875,
        -2173.199951171875,
        674.4000244140625
      ],
      "bbox_max": [
        -90.0000228881836,
        -2171.749755859375,
        674.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1476.0853271484375,
      "bbox_min": [
        -93.96281433105469,
        -2180.39990234375,
        626.0
      ],
      "bbox_max": [
        -81.60009765625,
        -2168.037109375,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -87.25003051757812,
        -2180.39990234375,
        654.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2169.10009765625,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -85.353515625,
        -2180.39990234375,
        654.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2169.10009765625,
        656.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -83.5,
      "bbox_min": [
        -83.5,
        -2178.5,
        654.5999755859375
      ],
      "bbox_max": [
        -83.5,
        -2174.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -93.96281433105469,
        -2174.75,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2168.037109375,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 675.2044067382812,
      "bbox_min": [
        -90.16738891601562,
        -2174.75,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2169.029541015625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 674.4000244140625,
      "bbox_min": [
        -90.16738891601562,
        -2172.800048828125,
        674.4000244140625
      ],
      "bbox_max": [
        -89.199951171875,
        -2171.83251953125,
        674.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -81.60009765625,
        -2169.10009765625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2169.029541015625,
        656.9591064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6794146299362183,
        -0.0002038013335550204,
        0.733754575252533
      ],
      "plane_d": -428.20941162109375,
      "bbox_min": [
        -80.699951171875,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -75.29141235351562,
        -2168.772216796875,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6793980598449707,
        0.0004719383723568171,
        0.7337697148323059
      ],
      "plane_d": -549.4459838867188,
      "bbox_min": [
        -105.300048828125,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.88549041748047,
        -2166.36376953125,
        658.0420532226562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.07822323590517044,
        0.9795448184013367,
        0.1854003369808197
      ],
      "plane_d": 2009.3104248046875,
      "bbox_min": [
        -105.29047393798828,
        -2167.77783203125,
        652.7044067382812
      ],
      "bbox_max": [
        -99.885498046875,
        -2166.39990234375,
        658.0420532226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08373019099235535,
        0.9710349440574646,
        0.22378645837306976
      ],
      "plane_d": 1966.399658203125,
      "bbox_min": [
        -142.38246154785156,
        -2213.484130859375,
        651.6449584960938
      ],
      "bbox_max": [
        -105.28955078125,
        -2164.786376953125,
        830.7184448242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -142.38246154785156,
        -2213.484130859375,
        819.0641479492188
      ],
      "bbox_max": [
        -117.47943115234375,
        -2208.415771484375,
        830.7184448242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07822323590517044,
        0.9795448184013367,
        0.1854003369808197
      ],
      "plane_d": 2009.3104248046875,
      "bbox_min": [
        -134.7414093017578,
        -2167.41015625,
        652.7044067382812
      ],
      "bbox_max": [
        -105.28980255126953,
        -2164.91015625,
        659.8342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232021152973175,
        0.6113415360450745,
        0.7745409607887268
      ],
      "plane_d": 836.6258544921875,
      "bbox_min": [
        -134.82754516601562,
        -2173.240966796875,
        618.412841796875
      ],
      "bbox_max": [
        -25.55841064453125,
        -2134.01171875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -108.00069427490234,
        -2167.546875,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        651.6454467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -79.01836395263672,
        -2139.58642578125,
        618.412841796875
      ],
      "bbox_max": [
        -75.27082824707031,
        -2139.134033203125,
        620.1395263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9148070812225342,
        0.40389132499694824,
        -0.0
      ],
      "plane_d": 924.0276489257812,
      "bbox_min": [
        -66.12939453125,
        -2141.665771484375,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        623.77197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -108.00069427490234,
        -2150.27197265625,
        618.412841796875
      ],
      "bbox_max": [
        -105.278564453125,
        -2146.93408203125,
        632.3883056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -105.28974151611328,
        -2173.240966796875,
        619.220947265625
      ],
      "bbox_max": [
        -27.96014404296875,
        -2134.01171875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -70.19461059570312,
        -2138.521240234375,
        621.2391357421875
      ],
      "bbox_max": [
        -66.12939453125,
        -2138.030517578125,
        623.642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0002999660500790924,
        0.0
      ],
      "plane_d": 80.04566192626953,
      "bbox_min": [
        -105.28974151611328,
        -2173.240966796875,
        623.293212890625
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -105.28974151611328,
        -2173.240966796875,
        641.0848388671875
      ],
      "bbox_max": [
        -80.69271850585938,
        -2151.24755859375,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.999999463558197,
        0.0010735620744526386,
        0.0
      ],
      "plane_d": -97.55819702148438,
      "bbox_min": [
        -105.28974151611328,
        -2172.67822265625,
        641.0848388671875
      ],
      "bbox_max": [
        -81.60009765625,
        -2151.24755859375,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2172.67822265625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2151.24755859375,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 675.2044067382812,
      "bbox_min": [
        -98.89990234375,
        -2172.67822265625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2151.24755859375,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -98.89990234375,
        -2172.67822265625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2151.24755859375,
        675.2044067382812
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2172.13134765625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2155.633544921875,
        675.2044067382812
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2158.0,
      "bbox_min": [
        -98.89990234375,
        -2172.13134765625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2158.0,
        675.2044067382812
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.7070798277854919,
        0.0,
        -0.7071337699890137
      ],
      "plane_d": 539.9625244140625,
      "bbox_min": [
        -97.0,
        -2172.13134765625,
        656.5999755859375
      ],
      "bbox_max": [
        -83.60009765625,
        -2158.0,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070798277854919,
        -0.0,
        -0.7071337699890137
      ],
      "plane_d": 412.4053649902344,
      "bbox_min": [
        -94.0,
        -2171.91015625,
        669.6004028320312
      ],
      "bbox_max": [
        -89.199951171875,
        -2158.13818359375,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 674.4000244140625,
      "bbox_min": [
        -91.199951171875,
        -2171.91015625,
        674.4000244140625
      ],
      "bbox_max": [
        -89.199951171875,
        -2158.3046875,
        674.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 94.0,
      "bbox_min": [
        -94.0,
        -2160.0,
        669.6004028320312
      ],
      "bbox_max": [
        -94.0,
        -2158.13818359375,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -86.60009765625,
      "bbox_min": [
        -97.0,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -83.60009765625,
        -2158.0,
        675.2000122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7784107327461243,
        0.0,
        -0.6277554631233215
      ],
      "plane_d": 352.48260498046875,
      "bbox_min": [
        -86.60009765625,
        -2160.0,
        658.3200073242188
      ],
      "bbox_max": [
        -83.60009765625,
        -2158.0,
        668.8800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7208325266838074,
        0.0,
        0.6931092739105225
      ],
      "plane_d": -518.7118530273438,
      "bbox_min": [
        -86.60009765625,
        -2160.0,
        658.3200073242188
      ],
      "bbox_max": [
        -83.60009765625,
        -2158.0,
        665.1600341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -83.60009765625,
      "bbox_min": [
        -83.60009765625,
        -2160.0,
        661.4400024414062
      ],
      "bbox_max": [
        -83.60009765625,
        -2158.0,
        665.1600341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7784107327461243,
        0.0,
        -0.6277554631233215
      ],
      "plane_d": 493.06365966796875,
      "bbox_min": [
        -97.0,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -94.0,
        -2158.0,
        669.6004028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 94.0,
      "bbox_min": [
        -94.0,
        -2160.0,
        668.8800048828125
      ],
      "bbox_max": [
        -94.0,
        -2158.0,
        669.6004028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7208325266838074,
        0.0,
        0.6931092739105225
      ],
      "plane_d": -388.5294494628906,
      "bbox_min": [
        -97.0,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -94.0,
        -2158.0,
        665.1600341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 94.0,
      "bbox_min": [
        -94.0,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -94.0,
        -2158.0,
        658.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 97.0,
      "bbox_min": [
        -97.0,
        -2160.0,
        661.4400024414062
      ],
      "bbox_max": [
        -97.0,
        -2158.0,
        665.1600341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28974151611328,
        -2167.778076171875,
        641.0848388671875
      ],
      "bbox_max": [
        -99.87306213378906,
        -2152.779052734375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786047220230103,
        0.0007285246392711997,
        0.7345033884048462
      ],
      "plane_d": -549.2896118164062,
      "bbox_min": [
        -105.28974151611328,
        -2167.778076171875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.87306213378906,
        -2156.128662109375,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999997615814209,
        -0.0006946580833755434,
        0.0
      ],
      "plane_d": 73.78484344482422,
      "bbox_min": [
        -80.6963882446289,
        -2169.31884765625,
        623.293212890625
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -78.64490509033203,
        -2150.27197265625,
        652.2418212890625
      ],
      "bbox_max": [
        -75.27725982666016,
        -2148.388427734375,
        655.8143920898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -68.14163208007812,
      "bbox_min": [
        -75.93452453613281,
        -2150.27197265625,
        652.2418212890625
      ],
      "bbox_max": [
        -75.27725982666016,
        -2148.388427734375,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6794146299362183,
        -0.0002038013335550204,
        0.733754575252533
      ],
      "plane_d": -428.20941162109375,
      "bbox_min": [
        -80.6963882446289,
        -2169.31884765625,
        654.6787109375
      ],
      "bbox_max": [
        -77.42858123779297,
        -2151.246826171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        -0.7807668447494507,
        0.0
      ],
      "plane_d": -1631.8253173828125,
      "bbox_min": [
        -75.278564453125,
        -2150.27197265625,
        623.293212890625
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -50.819091796875,
      "bbox_min": [
        -75.278564453125,
        -2150.27197265625,
        623.293212890625
      ],
      "bbox_max": [
        -66.12939453125,
        -2138.030517578125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -67.66808319091797,
        -2138.21630859375,
        623.293212890625
      ],
      "bbox_max": [
        -66.12939453125,
        -2138.030517578125,
        624.3515014648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -68.14163208007812,
      "bbox_min": [
        -75.278564453125,
        -2150.27197265625,
        650.739501953125
      ],
      "bbox_max": [
        -73.14276123046875,
        -2147.414306640625,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642076253890991,
        0.49060776829719543,
        -0.11157596111297607
      ],
      "plane_d": 1246.207275390625,
      "bbox_min": [
        -219.81341552734375,
        -2303.484619140625,
        617.796630859375
      ],
      "bbox_max": [
        80.05440521240234,
        -2011.8914794921875,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24286268651485443,
        0.915098249912262,
        0.3218894898891449
      ],
      "plane_d": 1720.4425048828125,
      "bbox_min": [
        -219.81341552734375,
        -2247.94970703125,
        617.796630859375
      ],
      "bbox_max": [
        74.56230926513672,
        -2011.8914794921875,
        993.514404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07853952795267105,
        0.978276252746582,
        0.19185161590576172
      ],
      "plane_d": 2002.348876953125,
      "bbox_min": [
        -187.47689819335938,
        -2233.716552734375,
        617.796630859375
      ],
      "bbox_max": [
        70.9651870727539,
        -2116.2626953125,
        975.9653930664062
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -187.47689819335938,
        -2233.716552734375,
        656.7542724609375
      ],
      "bbox_max": [
        -114.96051025390625,
        -2163.4716796875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -128.56640625,
        -2221.324462890625,
        819.3709106445312
      ],
      "bbox_max": [
        -114.96051025390625,
        -2201.177490234375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -128.56640625,
        -2221.324462890625,
        825.0
      ],
      "bbox_max": [
        -122.89964294433594,
        -2204.381103515625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -128.56640625,
        -2221.324462890625,
        825.0
      ],
      "bbox_max": [
        -122.89964294433594,
        -2204.381103515625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -126.70217895507812,
        -2221.324462890625,
        836.5
      ],
      "bbox_max": [
        -122.89964294433594,
        -2207.233642578125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -126.70217895507812,
        -2221.324462890625,
        854.5
      ],
      "bbox_max": [
        -124.02632141113281,
        -2213.794189453125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -126.70217895507812,
        -2220.219970703125,
        854.5
      ],
      "bbox_max": [
        -124.02632141113281,
        -2213.794189453125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07822323590517044,
        0.9795448184013367,
        0.1854003369808197
      ],
      "plane_d": 2009.3104248046875,
      "bbox_min": [
        -163.181640625,
        -2165.45849609375,
        656.7542724609375
      ],
      "bbox_max": [
        -133.9772491455078,
        -2163.4716796875,
        661.6588745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08373019099235535,
        0.9710349440574646,
        0.22378645837306976
      ],
      "plane_d": 1966.399658203125,
      "bbox_min": [
        -163.181640625,
        -2164.91015625,
        656.7542724609375
      ],
      "bbox_max": [
        -134.7414093017578,
        -2163.4716796875,
        661.6588745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.086369089782238,
        0.9781539440155029,
        0.18909035623073578
      ],
      "plane_d": 2005.18896484375,
      "bbox_min": [
        -175.46551513671875,
        -2210.680419921875,
        617.796630859375
      ],
      "bbox_max": [
        70.9651870727539,
        -2116.2626953125,
        975.9653930664062
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        -175.46551513671875,
        -2210.680419921875,
        617.796630859375
      ],
      "bbox_max": [
        70.9651870727539,
        -2116.2626953125,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -89.64111328125,
        -2210.680419921875,
        847.1928100585938
      ],
      "bbox_max": [
        -65.38180541992188,
        -2204.3486328125,
        872.276611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232021152973175,
        0.6113415360450745,
        0.7745409607887268
      ],
      "plane_d": 836.6258544921875,
      "bbox_min": [
        -175.46551513671875,
        -2206.544921875,
        617.796630859375
      ],
      "bbox_max": [
        70.9651870727539,
        -2116.2626953125,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2152.779052734375,
        618.412841796875
      ],
      "bbox_max": [
        -70.19461059570312,
        -2127.960205078125,
        641.0848388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        618.412841796875
      ],
      "bbox_max": [
        -70.19461059570312,
        -2127.960205078125,
        636.0256958007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -107.177978515625,
        -2140.8193359375,
        618.412841796875
      ],
      "bbox_max": [
        -70.19461059570312,
        -2127.960205078125,
        632.042724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2007.28369140625,
      "bbox_min": [
        -92.5,
        -2139.665283203125,
        618.412841796875
      ],
      "bbox_max": [
        -70.19461059570312,
        -2134.52294921875,
        626.935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        618.5244140625
      ],
      "bbox_max": [
        -88.0,
        -2136.069580078125,
        626.935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        0.12534287571907043,
        0.0
      ],
      "plane_d": 355.31988525390625,
      "bbox_min": [
        -88.27063751220703,
        -2138.245849609375,
        618.5244140625
      ],
      "bbox_max": [
        -88.0,
        -2136.103759765625,
        625.9924926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -88.47035217285156,
        -2139.665283203125,
        618.412841796875
      ],
      "bbox_max": [
        -70.19461059570312,
        -2134.52294921875,
        625.3675537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        0.12534287571907043,
        0.0
      ],
      "plane_d": 355.31988525390625,
      "bbox_min": [
        -88.47035217285156,
        -2136.103759765625,
        618.5244140625
      ],
      "bbox_max": [
        -88.27063751220703,
        -2134.52294921875,
        624.3584594726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -107.177978515625,
        -2140.8193359375,
        618.412841796875
      ],
      "bbox_max": [
        -88.47035217285156,
        -2127.960205078125,
        632.042724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.20442199707031,
        -2136.069580078125,
        618.5244140625
      ],
      "bbox_max": [
        -88.47035217285156,
        -2127.960205078125,
        625.1559448242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        0.12534287571907043,
        0.0
      ],
      "plane_d": 355.31988525390625,
      "bbox_min": [
        -89.23687744140625,
        -2134.52294921875,
        618.5244140625
      ],
      "bbox_max": [
        -88.47035217285156,
        -2128.455810546875,
        623.152587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28030395507812,
        -2152.779052734375,
        632.3883056640625
      ],
      "bbox_max": [
        -105.278564453125,
        -2150.27197265625,
        641.0848388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13787776231765747,
        -0.03273407742381096,
        0.9899080991744995
      ],
      "plane_d": -673.2636108398438,
      "bbox_min": [
        -175.46551513671875,
        -2206.544921875,
        617.796630859375
      ],
      "bbox_max": [
        70.9651870727539,
        -2116.2626953125,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        -112.28321838378906,
        -2132.941162109375,
        618.3739624023438
      ],
      "bbox_max": [
        -61.554107666015625,
        -2116.2626953125,
        625.337890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9921135902404785,
        0.12534287571907043,
        0.0
      ],
      "plane_d": 355.31988525390625,
      "bbox_min": [
        -91.10107421875,
        -2132.941162109375,
        618.5244140625
      ],
      "bbox_max": [
        -88.6701889038086,
        -2127.946044921875,
        622.4420776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2127.946044921875,
      "bbox_min": [
        -91.10107421875,
        -2127.946044921875,
        618.5244140625
      ],
      "bbox_max": [
        -89.30126953125,
        -2127.946044921875,
        622.4420776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2127.946044921875,
      "bbox_min": [
        -91.1823959350586,
        -2128.544677734375,
        622.1747436523438
      ],
      "bbox_max": [
        -89.24053955078125,
        -2127.946044921875,
        622.4497680664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -91.1823959350586,
        -2128.544677734375,
        622.1747436523438
      ],
      "bbox_max": [
        -89.24053955078125,
        -2127.946044921875,
        622.4497680664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        0.12534287571907043,
        0.0
      ],
      "plane_d": 355.31988525390625,
      "bbox_min": [
        -89.30126953125,
        -2128.4267578125,
        622.1747436523438
      ],
      "bbox_max": [
        -89.24053955078125,
        -2127.946044921875,
        622.1990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -175.46551513671875,
        -2206.544921875,
        617.796630859375
      ],
      "bbox_max": [
        70.9651870727539,
        -2127.946044921875,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -175.46551513671875,
        -2163.4716796875,
        660.5862426757812
      ],
      "bbox_max": [
        -163.181640625,
        -2157.221923828125,
        664.9551391601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -175.46551513671875,
        -2163.4716796875,
        660.5862426757812
      ],
      "bbox_max": [
        -163.181640625,
        -2157.221923828125,
        663.0540161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -175.2791748046875,
        -2206.544921875,
        617.796630859375
      ],
      "bbox_max": [
        70.9651870727539,
        -2127.946044921875,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2007.28369140625,
      "bbox_min": [
        -98.66927337646484,
        -2139.665283203125,
        621.9459838867188
      ],
      "bbox_max": [
        -79.672119140625,
        -2130.7216796875,
        628.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -98.66927337646484,
        -2138.747314453125,
        623.9208984375
      ],
      "bbox_max": [
        -88.0,
        -2134.559326171875,
        628.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        0.12534287571907043,
        0.0
      ],
      "plane_d": 355.31988525390625,
      "bbox_min": [
        -88.2706298828125,
        -2138.245849609375,
        624.3584594726562
      ],
      "bbox_max": [
        -88.0,
        -2136.103759765625,
        626.7058715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.20442962646484,
        -2136.069580078125,
        623.9208984375
      ],
      "bbox_max": [
        -91.9992904663086,
        -2134.559326171875,
        625.9423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        0.12534287571907043,
        0.0
      ],
      "plane_d": 355.31988525390625,
      "bbox_min": [
        -91.9992904663086,
        -2136.103759765625,
        621.9459838867188
      ],
      "bbox_max": [
        -88.2706298828125,
        -2130.7216796875,
        625.3753051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -91.9992904663086,
        -2134.559326171875,
        622.3828125
      ],
      "bbox_max": [
        -91.47805786132812,
        -2130.7216796875,
        624.9449462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        -175.2791748046875,
        -2206.544921875,
        622.0564575195312
      ],
      "bbox_max": [
        70.9651870727539,
        -2127.946044921875,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25527524948120117,
        0.9336197376251221,
        0.25137388706207275
      ],
      "plane_d": 1895.1923828125,
      "bbox_min": [
        -175.2791748046875,
        -2167.28125,
        622.0564575195312
      ],
      "bbox_max": [
        -64.5244140625,
        -2127.946044921875,
        685.9080810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -175.2791748046875,
        -2166.727783203125,
        622.0564575195312
      ],
      "bbox_max": [
        -64.5244140625,
        -2127.946044921875,
        684.1293334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -109.34033203125,
        -2161.964599609375,
        622.0564575195312
      ],
      "bbox_max": [
        -64.5244140625,
        -2127.946044921875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.999999463558197,
        0.0010735620744526386,
        0.0
      ],
      "plane_d": -97.55819702148438,
      "bbox_min": [
        -109.34033203125,
        -2161.964599609375,
        622.0564575195312
      ],
      "bbox_max": [
        -64.5244140625,
        -2127.946044921875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9148070812225342,
        0.40389132499694824,
        -0.0
      ],
      "plane_d": 924.0276489257812,
      "bbox_min": [
        -99.86669921875,
        -2160.995849609375,
        622.0564575195312
      ],
      "bbox_max": [
        -64.5244140625,
        -2127.946044921875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0002999660500790924,
        0.0
      ],
      "plane_d": 80.04566192626953,
      "bbox_min": [
        -99.86669921875,
        -2160.995849609375,
        622.0564575195312
      ],
      "bbox_max": [
        -64.5244140625,
        -2127.946044921875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2007.28369140625,
      "bbox_min": [
        -99.86669921875,
        -2160.995849609375,
        622.0564575195312
      ],
      "bbox_max": [
        -80.68736267089844,
        -2127.946044921875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 675.2044067382812,
      "bbox_min": [
        -99.86669921875,
        -2160.995849609375,
        625.3753051757812
      ],
      "bbox_max": [
        -80.68736267089844,
        -2135.27197265625,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238762259483337,
        0.3826916813850403,
        -0.0
      ],
      "plane_d": 897.4393920898438,
      "bbox_min": [
        -99.86669921875,
        -2150.27197265625,
        675.2044067382812
      ],
      "bbox_max": [
        -80.690673828125,
        -2141.19873046875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238762259483337,
        0.3826916813850403,
        0.0
      ],
      "plane_d": 730.626708984375,
      "bbox_min": [
        -99.86669921875,
        -2150.27197265625,
        675.2044067382812
      ],
      "bbox_max": [
        -83.4990234375,
        -2141.19873046875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3827034533023834,
        0.9238713383674622,
        -0.0
      ],
      "plane_d": 2012.266357421875,
      "bbox_min": [
        -97.058349609375,
        -2143.4921875,
        675.2044067382812
      ],
      "bbox_max": [
        -83.4990234375,
        -2141.19873046875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826916813850403,
        0.9238762259483337,
        0.0
      ],
      "plane_d": 1943.1781005859375,
      "bbox_min": [
        -97.058349609375,
        -2143.4921875,
        675.2044067382812
      ],
      "bbox_max": [
        -95.95394134521484,
        -2143.03466796875,
        675.6716918945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -99.86669921875,
        -2160.99462890625,
        625.3753051757812
      ],
      "bbox_max": [
        -80.68736267089844,
        -2135.27197265625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -99.86359405517578,
        -2147.387939453125,
        625.3753051757812
      ],
      "bbox_max": [
        -80.68736267089844,
        -2135.27197265625,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        0.12534287571907043,
        0.0
      ],
      "plane_d": 355.31988525390625,
      "bbox_min": [
        -99.86359405517578,
        -2147.387939453125,
        625.3753051757812
      ],
      "bbox_max": [
        -80.68779754638672,
        -2135.27197265625,
        656.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -99.86359405517578,
        -2147.37841796875,
        625.9423828125
      ],
      "bbox_max": [
        -88.0,
        -2135.27197265625,
        656.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        651.2399291992188
      ],
      "bbox_max": [
        -88.0,
        -2135.27197265625,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -99.86359405517578,
        -2147.37841796875,
        654.0486450195312
      ],
      "bbox_max": [
        -97.9036636352539,
        -2140.694091796875,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -82.6537094116211,
        -2147.387939453125,
        654.0314331054688
      ],
      "bbox_max": [
        -80.68779754638672,
        -2140.680908203125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238762259483337,
        0.3826916813850403,
        0.0
      ],
      "plane_d": 730.626708984375,
      "bbox_min": [
        -99.86669921875,
        -2160.99462890625,
        656.5999755859375
      ],
      "bbox_max": [
        -80.68981170654297,
        -2139.488525390625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238762259483337,
        0.3826916813850403,
        -0.0
      ],
      "plane_d": 897.4393920898438,
      "bbox_min": [
        -99.86669921875,
        -2160.99462890625,
        656.5999755859375
      ],
      "bbox_max": [
        -80.68981170654297,
        -2139.488525390625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826916813850403,
        0.9238762259483337,
        0.0
      ],
      "plane_d": 1943.1781005859375,
      "bbox_min": [
        -99.86669921875,
        -2160.99462890625,
        656.5999755859375
      ],
      "bbox_max": [
        -80.690673828125,
        -2139.488525390625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3827034533023834,
        0.9238713383674622,
        -0.0
      ],
      "plane_d": 2012.266357421875,
      "bbox_min": [
        -99.86669921875,
        -2160.99462890625,
        656.5999755859375
      ],
      "bbox_max": [
        -80.690673828125,
        -2140.086181640625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 664.7044067382812,
      "bbox_min": [
        -99.86669921875,
        -2160.99462890625,
        656.5999755859375
      ],
      "bbox_max": [
        -80.690673828125,
        -2140.683837890625,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2160.99462890625,
        664.7044067382812
      ],
      "bbox_max": [
        -81.60009765625,
        -2141.683837890625,
        675.2044067382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9272966980934143,
        -0.3743273913860321,
        -0.0
      ],
      "plane_d": -880.7164916992188,
      "bbox_min": [
        -98.89990234375,
        -2159.752197265625,
        664.7044067382812
      ],
      "bbox_max": [
        -81.60009765625,
        -2141.683837890625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9301388263702393,
        -0.36720818281173706,
        0.0
      ],
      "plane_d": -697.7473754882812,
      "bbox_min": [
        -98.89990234375,
        -2159.752197265625,
        664.7044067382812
      ],
      "bbox_max": [
        -81.60009765625,
        -2141.683837890625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.382678747177124,
        -0.923881471157074,
        0.0
      ],
      "plane_d": -1944.1142578125,
      "bbox_min": [
        -98.89990234375,
        -2159.752197265625,
        664.7044067382812
      ],
      "bbox_max": [
        -81.60009765625,
        -2141.683837890625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070798277854919,
        -0.0,
        -0.7071337699890137
      ],
      "plane_d": 412.4053649902344,
      "bbox_min": [
        -98.89990234375,
        -2159.752197265625,
        664.7044067382812
      ],
      "bbox_max": [
        -81.60009765625,
        -2141.683837890625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070798277854919,
        0.0,
        -0.7071337699890137
      ],
      "plane_d": 539.9625244140625,
      "bbox_min": [
        -91.199951171875,
        -2158.811767578125,
        664.8008422851562
      ],
      "bbox_max": [
        -81.60009765625,
        -2144.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 674.4000244140625,
      "bbox_min": [
        -91.199951171875,
        -2158.811767578125,
        674.4000244140625
      ],
      "bbox_max": [
        -89.199951171875,
        -2144.0,
        674.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -81.60009765625,
        -2156.60986328125,
        664.8008422851562
      ],
      "bbox_max": [
        -81.60009765625,
        -2150.65478515625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2158.0,
      "bbox_min": [
        -98.89990234375,
        -2159.752197265625,
        664.7044067382812
      ],
      "bbox_max": [
        -81.60009765625,
        -2141.683837890625,
        675.2000122070312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 94.0,
      "bbox_min": [
        -94.0,
        -2159.752197265625,
        669.1209106445312
      ],
      "bbox_max": [
        -94.0,
        -2158.0,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826918601989746,
        -0.9238760471343994,
        -0.0
      ],
      "plane_d": -2013.19921875,
      "bbox_min": [
        -90.278564453125,
        -2153.611328125,
        664.7044067382812
      ],
      "bbox_max": [
        -81.60009765625,
        -2141.683837890625,
        665.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -81.60009765625,
        -2153.611328125,
        664.7044067382812
      ],
      "bbox_max": [
        -81.60009765625,
        -2150.65478515625,
        664.8008422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3681499660015106,
        0.9297664761543274,
        0.0
      ],
      "plane_d": 2036.0167236328125,
      "bbox_min": [
        -99.86669921875,
        -2157.969482421875,
        656.5999755859375
      ],
      "bbox_max": [
        -80.690673828125,
        -2140.683837890625,
        664.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2157.969482421875,
        656.5999755859375
      ],
      "bbox_max": [
        -98.89990234375,
        -2150.65478515625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.387968510389328,
        0.9216726422309875,
        0.0
      ],
      "plane_d": 1950.5413818359375,
      "bbox_min": [
        -99.86669921875,
        -2153.58349609375,
        656.5999755859375
      ],
      "bbox_max": [
        -80.690673828125,
        -2140.683837890625,
        664.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -81.60009765625,
        -2153.58349609375,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2150.65478515625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9272966980934143,
        -0.3743273913860321,
        0.0
      ],
      "plane_d": -880.7164916992188,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -80.690673828125,
        -2140.683837890625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -84.69074249267578,
        -2150.65478515625,
        659.7044067382812
      ],
      "bbox_max": [
        -80.690673828125,
        -2142.99853515625,
        659.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -91.48558807373047,
        -2144.19921875,
        659.7044067382812
      ],
      "bbox_max": [
        -84.2060546875,
        -2140.683837890625,
        659.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2010255753993988,
        -0.4735967814922333,
        0.8574934005737305
      ],
      "plane_d": -1600.109375,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -84.85640716552734,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3907240033149719,
        -0.9205079078674316,
        -0.0
      ],
      "plane_d": -2010.5838623046875,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -84.85640716552734,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33503803610801697,
        0.7893171906471252,
        0.5145173072814941
      ],
      "plane_d": 1382.001708984375,
      "bbox_min": [
        -87.25821685791016,
        -2145.713623046875,
        660.5999755859375
      ],
      "bbox_max": [
        -84.85640716552734,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33503907918930054,
        -0.789319634437561,
        -0.5145128965377808
      ],
      "plane_d": -1384.9254150390625,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        659.0999755859375
      ],
      "bbox_max": [
        -85.83323669433594,
        -2146.80126953125,
        659.5287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3907240033149719,
        -0.9205079078674316,
        -0.0
      ],
      "plane_d": -2010.841064453125,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        659.5287475585938
      ],
      "bbox_max": [
        -85.93377685546875,
        -2147.0380859375,
        660.5287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.382678747177124,
        -0.923881471157074,
        0.0
      ],
      "plane_d": -1944.1143798828125,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -90.278564453125,
        -2141.183837890625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -97.55834197998047,
        -2144.69921875,
        659.7044067382812
      ],
      "bbox_max": [
        -90.278564453125,
        -2141.183837890625,
        659.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9205051064491272,
        0.3907306492328644,
        -0.0
      ],
      "plane_d": 923.93603515625,
      "bbox_min": [
        -95.74359130859375,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2010255753993988,
        -0.4735967814922333,
        0.8574934005737305
      ],
      "plane_d": -1563.80419921875,
      "bbox_min": [
        -95.74359130859375,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3907240033149719,
        -0.9205079078674316,
        0.0
      ],
      "plane_d": -1940.01904296875,
      "bbox_min": [
        -95.74359130859375,
        -2147.778076171875,
        656.5999755859375
      ],
      "bbox_max": [
        -92.46549987792969,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33503803610801697,
        0.7893171906471252,
        0.5145173072814941
      ],
      "plane_d": 1321.4937744140625,
      "bbox_min": [
        -95.74359130859375,
        -2145.713623046875,
        660.5999755859375
      ],
      "bbox_max": [
        -93.34178161621094,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3907240033149719,
        -0.9205079078674316,
        0.0
      ],
      "plane_d": -1940.2762451171875,
      "bbox_min": [
        -94.66622161865234,
        -2148.014892578125,
        659.5287475585938
      ],
      "bbox_max": [
        -92.36495971679688,
        -2147.0380859375,
        660.5287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        659.7044067382812
      ],
      "bbox_max": [
        -96.351318359375,
        -2144.19921875,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -90.278564453125,
        -2143.4921875,
        656.5999755859375
      ],
      "bbox_max": [
        -83.4990234375,
        -2140.086181640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -97.058349609375,
        -2143.4921875,
        656.5999755859375
      ],
      "bbox_max": [
        -88.83570098876953,
        -2139.488525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -90.278564453125,
        -2140.683837890625,
        656.5999755859375
      ],
      "bbox_max": [
        -88.83570098876953,
        -2139.488525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -84.09674835205078,
        -2150.27197265625,
        656.5999755859375
      ],
      "bbox_max": [
        -80.68981170654297,
        -2142.04931640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -84.09674835205078,
        -2143.4921875,
        656.5999755859375
      ],
      "bbox_max": [
        -82.6537094116211,
        -2142.04931640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -99.86669921875,
        -2150.27197265625,
        656.5999755859375
      ],
      "bbox_max": [
        -96.46065521240234,
        -2142.04931640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -97.9036636352539,
        -2143.4921875,
        656.5999755859375
      ],
      "bbox_max": [
        -96.46065521240234,
        -2142.04931640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.20442962646484,
        -2136.069580078125,
        624.9449462890625
      ],
      "bbox_max": [
        -90.27867126464844,
        -2134.559326171875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.20442962646484,
        -2136.069580078125,
        651.2399291992188
      ],
      "bbox_max": [
        -90.27867126464844,
        -2134.559326171875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        0.12534287571907043,
        0.0
      ],
      "plane_d": 355.31988525390625,
      "bbox_min": [
        -91.99929809570312,
        -2136.103759765625,
        622.0564575195312
      ],
      "bbox_max": [
        -88.2706069946289,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -91.99929809570312,
        -2136.103759765625,
        622.1990966796875
      ],
      "bbox_max": [
        -88.27063751220703,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2127.946044921875,
      "bbox_min": [
        -91.99929809570312,
        -2136.103759765625,
        622.1990966796875
      ],
      "bbox_max": [
        -88.27063751220703,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -91.99929809570312,
        -2136.103759765625,
        636.5319213867188
      ],
      "bbox_max": [
        -88.27063751220703,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.912666380405426,
        0.4087052345275879
      ],
      "plane_d": 1681.950927734375,
      "bbox_min": [
        -91.385986328125,
        -2130.0439453125,
        636.5319213867188
      ],
      "bbox_max": [
        -89.0361328125,
        -2127.946044921875,
        643.4923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2130.0439453125,
      "bbox_min": [
        -91.385986328125,
        -2130.0439453125,
        641.2166748046875
      ],
      "bbox_max": [
        -89.0361328125,
        -2130.0439453125,
        643.4923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -80.69099426269531,
        -2151.33544921875,
        623.642578125
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        -0.7807668447494507,
        0.0
      ],
      "plane_d": -1631.8253173828125,
      "bbox_min": [
        -80.68758392333984,
        -2145.89013671875,
        638.37548828125
      ],
      "bbox_max": [
        -64.5244140625,
        -2139.665283203125,
        653.3822631835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -80.68758392333984,
        -2139.978515625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2139.665283203125,
        653.3822631835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -50.819091796875,
      "bbox_min": [
        -80.69099426269531,
        -2151.33544921875,
        644.228759765625
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6248225569725037,
        -0.7807668447494507,
        0.0
      ],
      "plane_d": -1631.8253173828125,
      "bbox_min": [
        -69.83003997802734,
        -2145.91162109375,
        644.228759765625
      ],
      "bbox_max": [
        -64.5244140625,
        -2141.665771484375,
        648.4400024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785882115364075,
        -0.00047138650552369654,
        0.7345187664031982
      ],
      "plane_d": -429.3540954589844,
      "bbox_min": [
        -80.69099426269531,
        -2151.33544921875,
        652.7044067382812
      ],
      "bbox_max": [
        -78.64490509033203,
        -2139.665283203125,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -80.68779754638672,
        -2140.680908203125,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2139.665283203125,
        654.0314331054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2007.28369140625,
      "bbox_min": [
        -80.68753051757812,
        -2139.787841796875,
        626.250244140625
      ],
      "bbox_max": [
        -79.672119140625,
        -2139.244873046875,
        653.2061157226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -80.68753051757812,
        -2139.787841796875,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2139.244873046875,
        653.2061157226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -109.34033203125,
        -2156.198486328125,
        629.2604370117188
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2156.198486328125,
        633.6602783203125
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -109.34033203125,
        -2156.198486328125,
        633.6602783203125
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -100.88525390625,
        -2140.694091796875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        654.0486450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28263092041016,
        -2156.191162109375,
        639.105712890625
      ],
      "bbox_max": [
        -100.45149993896484,
        -2150.27197265625,
        657.1699829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786047220230103,
        0.0007285246392711997,
        0.7345033884048462
      ],
      "plane_d": -549.2896118164062,
      "bbox_min": [
        -105.28263092041016,
        -2156.191162109375,
        652.7044067382812
      ],
      "bbox_max": [
        -100.45149993896484,
        -2150.27197265625,
        657.1699829101562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -108.05611419677734,
        -2142.635498046875,
        629.813232421875
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -108.05611419677734,
        -2142.635498046875,
        632.0427856445312
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": 375.2848815917969,
      "bbox_min": [
        -108.05611419677734,
        -2142.635498046875,
        644.2874145507812
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08636119961738586,
        0.9781544804573059,
        0.18909142911434174
      ],
      "plane_d": 2005.18798828125,
      "bbox_min": [
        -219.81341552734375,
        -2247.94970703125,
        618.412841796875
      ],
      "bbox_max": [
        74.56230926513672,
        -2011.8914794921875,
        993.514404296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -186.154296875,
        -2228.34375,
        818.8215942382812
      ],
      "bbox_max": [
        -116.2279281616211,
        -2193.50048828125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -171.14173889160156,
        -2228.34375,
        819.8090209960938
      ],
      "bbox_max": [
        -116.2279281616211,
        -2197.542236328125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -129.67071533203125,
        -2216.487548828125,
        825.0
      ],
      "bbox_max": [
        -123.9848861694336,
        -2198.00634765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -129.67071533203125,
        -2216.487548828125,
        825.0
      ],
      "bbox_max": [
        -123.9848861694336,
        -2198.00634765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -128.58242797851562,
        -2216.487548828125,
        836.5
      ],
      "bbox_max": [
        -123.9848861694336,
        -2200.622802734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -128.58242797851562,
        -2215.142578125,
        836.5
      ],
      "bbox_max": [
        -123.9848861694336,
        -2200.622802734375,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -125.21746063232422,
        -2207.738037109375,
        836.5
      ],
      "bbox_max": [
        -123.9848861694336,
        -2200.622802734375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -155.38943481445312,
        -2203.318115234375,
        861.0
      ],
      "bbox_max": [
        -148.33340454101562,
        -2202.72314453125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -219.81341552734375,
        -2206.7255859375,
        618.412841796875
      ],
      "bbox_max": [
        74.56230926513672,
        -2011.8914794921875,
        993.514404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -112.20849609375,
        -2078.76123046875,
        618.412841796875
      ],
      "bbox_max": [
        -94.69828033447266,
        -2061.33154296875,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2070.338623046875,
        618.412841796875
      ],
      "bbox_max": [
        -100.50362396240234,
        -2061.33154296875,
        626.2376098632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -109.34033203125,
        -2070.338623046875,
        618.412841796875
      ],
      "bbox_max": [
        -100.50362396240234,
        -2061.33154296875,
        626.2376098632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2064.5546875,
        618.412841796875
      ],
      "bbox_max": [
        -106.7118911743164,
        -2061.33154296875,
        626.2376098632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.88525390625,
        -2070.338623046875,
        623.802001953125
      ],
      "bbox_max": [
        -100.50362396240234,
        -2070.1806640625,
        624.909423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        -112.20849609375,
        -2078.76123046875,
        623.8447875976562
      ],
      "bbox_max": [
        -94.69828033447266,
        -2077.281494140625,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -219.81341552734375,
        -2206.7255859375,
        619.587158203125
      ],
      "bbox_max": [
        74.56230926513672,
        -2011.8914794921875,
        993.514404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -219.81341552734375,
        -2160.482177734375,
        653.239990234375
      ],
      "bbox_max": [
        -168.78549194335938,
        -2114.41748046875,
        676.4593505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -219.81341552734375,
        -2160.482177734375,
        663.0540161132812
      ],
      "bbox_max": [
        -175.2791748046875,
        -2146.833740234375,
        676.4593505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -217.5003204345703,
        -2206.7255859375,
        619.587158203125
      ],
      "bbox_max": [
        74.56230926513672,
        -2011.8914794921875,
        993.514404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -199.50973510742188,
        -2206.7255859375,
        619.587158203125
      ],
      "bbox_max": [
        74.56230926513672,
        -2011.8914794921875,
        993.514404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        -112.20849609375,
        -2078.942626953125,
        623.832275390625
      ],
      "bbox_max": [
        -94.57088470458984,
        -2061.13427734375,
        627.1937866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -112.20849609375,
        -2078.106689453125,
        624.0260620117188
      ],
      "bbox_max": [
        -95.74341583251953,
        -2061.13427734375,
        627.1937866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -109.34033203125,
        -2070.421630859375,
        624.8515014648438
      ],
      "bbox_max": [
        -100.30313873291016,
        -2061.13427734375,
        627.1937866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2069.026611328125,
        625.8348999023438
      ],
      "bbox_max": [
        -106.551025390625,
        -2061.13427734375,
        627.1937866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2064.5546875,
        625.9280395507812
      ],
      "bbox_max": [
        -106.551025390625,
        -2061.13427734375,
        627.1937866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.88525390625,
        -2070.421630859375,
        624.8515014648438
      ],
      "bbox_max": [
        -100.30313873291016,
        -2070.1806640625,
        625.5057373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -199.50973510742188,
        -2206.7255859375,
        619.587158203125
      ],
      "bbox_max": [
        74.56230926513672,
        -2011.8914794921875,
        993.514404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05980534851551056,
        -0.671236515045166,
        0.7388266921043396
      ],
      "plane_d": -1850.9669189453125,
      "bbox_min": [
        -112.20849609375,
        -2090.027587890625,
        622.622314453125
      ],
      "bbox_max": [
        -86.9010009765625,
        -2049.560791015625,
        652.0034790039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        -112.20849609375,
        -2079.330322265625,
        623.8054809570312
      ],
      "bbox_max": [
        -94.29871368408203,
        -2057.8525390625,
        644.1493530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -112.20849609375,
        -2078.106689453125,
        624.1563110351562
      ],
      "bbox_max": [
        -95.7535171508789,
        -2057.8525390625,
        644.1493530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2071.3232421875,
        625.40283203125
      ],
      "bbox_max": [
        -98.12611389160156,
        -2057.8525390625,
        644.1493530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.177978515625,
        -2071.3232421875,
        625.40283203125
      ],
      "bbox_max": [
        -98.12611389160156,
        -2069.026611328125,
        634.208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.88525390625,
        -2071.3232421875,
        625.40283203125
      ],
      "bbox_max": [
        -98.12611389160156,
        -2070.1806640625,
        632.651123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -105.278564453125,
        -2059.573974609375,
        636.500732421875
      ],
      "bbox_max": [
        -104.56550598144531,
        -2057.8525390625,
        644.1493530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        -112.20849609375,
        -2090.027587890625,
        622.622314453125
      ],
      "bbox_max": [
        -86.9010009765625,
        -2057.359130859375,
        646.3414306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        -112.20849609375,
        -2080.496826171875,
        623.7249145507812
      ],
      "bbox_max": [
        -93.47962188720703,
        -2078.106689453125,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2071.976806640625,
        631.3896484375
      ],
      "bbox_max": [
        -96.54846954345703,
        -2057.359130859375,
        646.3414306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -109.34033203125,
        -2071.976806640625,
        631.3896484375
      ],
      "bbox_max": [
        -96.54846954345703,
        -2064.5546875,
        638.8286743164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2069.026611328125,
        634.208984375
      ],
      "bbox_max": [
        -107.177978515625,
        -2064.5546875,
        638.8286743164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.88525390625,
        -2071.976806640625,
        631.3896484375
      ],
      "bbox_max": [
        -96.54846954345703,
        -2070.1806640625,
        636.1566772460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -105.278564453125,
        -2059.573974609375,
        642.6431884765625
      ],
      "bbox_max": [
        -104.36114501953125,
        -2057.359130859375,
        646.3414306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25527524948120117,
        0.9336197376251221,
        0.25137388706207275
      ],
      "plane_d": 1895.1923828125,
      "bbox_min": [
        -199.50973510742188,
        -2206.7255859375,
        619.587158203125
      ],
      "bbox_max": [
        74.56230926513672,
        -2011.8914794921875,
        993.514404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        -170.35748291015625,
        -2206.7255859375,
        619.587158203125
      ],
      "bbox_max": [
        74.56230926513672,
        -2011.8914794921875,
        993.514404296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.13787776231765747,
        -0.03273407742381096,
        0.9899080991744995
      ],
      "plane_d": -673.2636108398438,
      "bbox_min": [
        -119.778564453125,
        -2130.3798828125,
        625.337890625
      ],
      "bbox_max": [
        -112.28321838378906,
        -2129.82763671875,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -119.778564453125,
        -2130.3798828125,
        625.563720703125
      ],
      "bbox_max": [
        -114.0335693359375,
        -2130.282470703125,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -170.35748291015625,
        -2206.7255859375,
        625.572021484375
      ],
      "bbox_max": [
        74.56230926513672,
        -2011.8914794921875,
        993.514404296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        63.3701171875,
        -2206.544921875,
        946.6399536132812
      ],
      "bbox_max": [
        70.81481170654297,
        -2191.531005859375,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -162.45565795898438,
        -2206.7255859375,
        820.029052734375
      ],
      "bbox_max": [
        -117.0048828125,
        -2179.60009765625,
        866.218994140625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.9739704728126526,
        0.1927611380815506,
        0.11926676332950592
      ],
      "plane_d": 438.472900390625,
      "bbox_min": [
        -155.07394409179688,
        -2206.7255859375,
        820.029052734375
      ],
      "bbox_max": [
        -117.0048828125,
        -2181.5,
        866.218994140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -155.07394409179688,
        -2206.7255859375,
        820.029052734375
      ],
      "bbox_max": [
        -117.0048828125,
        -2181.5,
        866.218994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8180037140846252,
        0.18297229707241058,
        0.5453358292579651
      ],
      "plane_d": 30.507049560546875,
      "bbox_min": [
        -126.0,
        -2206.7255859375,
        862.0
      ],
      "bbox_max": [
        -119.234130859375,
        -2181.5,
        866.218994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -147.5626983642578,
        -2205.073974609375,
        820.029052734375
      ],
      "bbox_max": [
        -117.0048828125,
        -2181.5,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -147.5626983642578,
        -2205.073974609375,
        825.0
      ],
      "bbox_max": [
        -125.16646575927734,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9927337765693665,
        -0.0,
        -0.12033136934041977
      ],
      "plane_d": -25.735870361328125,
      "bbox_min": [
        -130.71417236328125,
        -2187.44677734375,
        834.691162109375
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        856.0177001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 432.67938232421875,
      "bbox_min": [
        -130.71417236328125,
        -2187.44677734375,
        834.691162109375
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        856.0177001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -127.5,
      "bbox_min": [
        -128.129150390625,
        -2187.44677734375,
        834.691162109375
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444968104362488,
        0.0,
        0.32852062582969666
      ],
      "plane_d": -395.2308349609375,
      "bbox_min": [
        -128.129150390625,
        -2186.3974609375,
        834.691162109375
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -147.5626983642578,
        -2205.073974609375,
        825.0
      ],
      "bbox_max": [
        -125.16646575927734,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -132.53016662597656,
        -2204.28857421875,
        825.0
      ],
      "bbox_max": [
        -125.16646575927734,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 432.67938232421875,
      "bbox_min": [
        -132.53016662597656,
        -2187.44677734375,
        854.5
      ],
      "bbox_max": [
        -129.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -132.53016662597656,
        -2187.44677734375,
        857.0
      ],
      "bbox_max": [
        -131.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -131.5,
        -2200.917236328125,
        825.0
      ],
      "bbox_max": [
        -125.16646575927734,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444968104362488,
        0.0,
        0.32852062582969666
      ],
      "plane_d": -395.2308349609375,
      "bbox_min": [
        -131.5,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        836.8875732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -127.5,
      "bbox_min": [
        -127.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -127.5,
        -2186.3974609375,
        836.8875732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -127.5,
        -2200.917236328125,
        836.5
      ],
      "bbox_max": [
        -125.16646575927734,
        -2186.668701171875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -127.5,
      "bbox_min": [
        -127.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -127.5,
        -2186.668701171875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -147.5626983642578,
        -2187.44677734375,
        857.0
      ],
      "bbox_max": [
        -131.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -146.0,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 134.0,
      "bbox_min": [
        -134.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -142.79855346679688,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -140.26210021972656,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 134.0,
      "bbox_min": [
        -134.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -150.82333374023438,
        -2144.29541015625,
        625.572021484375
      ],
      "bbox_max": [
        -87.74190521240234,
        -2011.8914794921875,
        682.013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -135.78326416015625,
        -2026.7135009765625,
        671.52490234375
      ],
      "bbox_max": [
        -119.99136352539062,
        -2011.8914794921875,
        682.013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -109.34033203125,
        -2071.843505859375,
        635.5226440429688
      ],
      "bbox_max": [
        -91.81829071044922,
        -2055.927001953125,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -109.34033203125,
        -2071.843505859375,
        635.5226440429688
      ],
      "bbox_max": [
        -91.81829071044922,
        -2055.927001953125,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2071.843505859375,
        635.5226440429688
      ],
      "bbox_max": [
        -91.81829071044922,
        -2055.927001953125,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2705896496772766,
        -0.6532796025276184,
        0.7071117758750916
      ],
      "plane_d": -1841.240234375,
      "bbox_min": [
        -109.34033203125,
        -2071.843505859375,
        635.5226440429688
      ],
      "bbox_max": [
        -91.81829071044922,
        -2056.703369140625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2069.026611328125,
        635.5226440429688
      ],
      "bbox_max": [
        -94.10689544677734,
        -2056.703369140625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -105.278564453125,
        -2067.576416015625,
        652.7044067382812
      ],
      "bbox_max": [
        -94.10689544677734,
        -2056.703369140625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.653276264667511,
        0.27059444785118103,
        0.7071129083633423
      ],
      "plane_d": 26.99755859375,
      "bbox_min": [
        -105.278564453125,
        -2059.573974609375,
        652.7044067382812
      ],
      "bbox_max": [
        -99.86669921875,
        -2056.703369140625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -105.278564453125,
        -2059.573974609375,
        644.1884765625
      ],
      "bbox_max": [
        -102.93746948242188,
        -2055.927001953125,
        653.768798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.653276264667511,
        0.27059444785118103,
        0.7071129083633423
      ],
      "plane_d": 26.99755859375,
      "bbox_min": [
        -105.278564453125,
        -2059.573974609375,
        652.7044067382812
      ],
      "bbox_max": [
        -102.93746948242188,
        -2055.927001953125,
        653.768798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.88525390625,
        -2081.89990234375,
        629.0877075195312
      ],
      "bbox_max": [
        -88.72579193115234,
        -2070.1806640625,
        654.6378784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.4161148071289,
        -2074.313232421875,
        647.6743774414062
      ],
      "bbox_max": [
        -90.90784454345703,
        -2072.2177734375,
        651.2399291992188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20443725585938,
        -2081.89990234375,
        629.0877075195312
      ],
      "bbox_max": [
        -88.72579193115234,
        -2073.7763671875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2081.89990234375,
      "bbox_min": [
        -92.20443725585938,
        -2081.89990234375,
        629.0877075195312
      ],
      "bbox_max": [
        -88.72579193115234,
        -2073.7763671875,
        651.2399291992188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.20443725585938,
        -2081.89990234375,
        636.1395263671875
      ],
      "bbox_max": [
        -88.72579193115234,
        -2073.7763671875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.385986328125,
        -2081.89990234375,
        636.1395263671875
      ],
      "bbox_max": [
        -88.72579193115234,
        -2077.344970703125,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.9126664400100708,
        0.4087052345275879
      ],
      "plane_d": -2160.234130859375,
      "bbox_min": [
        -91.385986328125,
        -2081.89990234375,
        636.5319213867188
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        648.5706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2079.802001953125,
      "bbox_min": [
        -91.385986328125,
        -2081.89990234375,
        641.2166748046875
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        648.5706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8258352279663086,
        -0.5639114379882812
      ],
      "plane_d": -1353.56982421875,
      "bbox_min": [
        -91.385986328125,
        -2081.89990234375,
        645.4983520507812
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        648.5706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232021152973175,
        0.6113415360450745,
        0.7745409607887268
      ],
      "plane_d": 836.6258544921875,
      "bbox_min": [
        -128.6708526611328,
        -2144.29541015625,
        625.572021484375
      ],
      "bbox_max": [
        -87.74190521240234,
        -2127.946044921875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -119.778564453125,
        -2144.29541015625,
        625.572021484375
      ],
      "bbox_max": [
        -87.74190521240234,
        -2127.946044921875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826916813850403,
        0.9238762259483337,
        0.0
      ],
      "plane_d": 1943.1781005859375,
      "bbox_min": [
        -119.778564453125,
        -2144.29541015625,
        625.572021484375
      ],
      "bbox_max": [
        -87.74190521240234,
        -2127.946044921875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3827034533023834,
        0.9238713383674622,
        -0.0
      ],
      "plane_d": 2012.266357421875,
      "bbox_min": [
        -97.39110565185547,
        -2144.29541015625,
        672.8031005859375
      ],
      "bbox_max": [
        -87.74190521240234,
        -2140.683837890625,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238762259483337,
        0.3826916813850403,
        0.0
      ],
      "plane_d": 730.626708984375,
      "bbox_min": [
        -97.39110565185547,
        -2144.29541015625,
        675.6716918945312
      ],
      "bbox_max": [
        -97.058349609375,
        -2143.4921875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -119.778564453125,
        -2133.51806640625,
        625.572021484375
      ],
      "bbox_max": [
        -88.70307922363281,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -91.85787200927734,
        -2133.51806640625,
        635.9702758789062
      ],
      "bbox_max": [
        -88.70307922363281,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        0.12534287571907043,
        0.0
      ],
      "plane_d": 355.31988525390625,
      "bbox_min": [
        -91.385986328125,
        -2132.680908203125,
        635.9702758789062
      ],
      "bbox_max": [
        -88.70307922363281,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8258352875709534,
        -0.563911497592926
      ],
      "plane_d": 2123.0693359375,
      "bbox_min": [
        -91.385986328125,
        -2130.0439453125,
        635.9702758789062
      ],
      "bbox_max": [
        -89.0361328125,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2127.946044921875,
      "bbox_min": [
        -91.10107421875,
        -2127.946044921875,
        648.5706787109375
      ],
      "bbox_max": [
        -89.30126953125,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2130.0439453125,
      "bbox_min": [
        -91.385986328125,
        -2130.0439453125,
        635.9702758789062
      ],
      "bbox_max": [
        -89.0361328125,
        -2127.946044921875,
        645.4983520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.912666380405426,
        0.4087052345275879
      ],
      "plane_d": 1681.950927734375,
      "bbox_min": [
        -91.25139617919922,
        -2129.052978515625,
        635.9702758789062
      ],
      "bbox_max": [
        -90.35652160644531,
        -2127.946044921875,
        639.003662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2127.946044921875,
      "bbox_min": [
        -91.10107421875,
        -2127.946044921875,
        635.9702758789062
      ],
      "bbox_max": [
        -90.35652160644531,
        -2127.946044921875,
        636.5319213867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -119.778564453125,
        -2131.491943359375,
        625.572021484375
      ],
      "bbox_max": [
        -114.05365753173828,
        -2130.282470703125,
        626.689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -691.2036743164062,
        -2399.99365234375,
        630.2252807617188
      ],
      "bbox_max": [
        -51.42585754394531,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -170.0,
        -1929.899169921875,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1922.3160400390625,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 184.0,
      "bbox_min": [
        -194.8513946533203,
        -1924.322509765625,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -194.8513946533203,
        -1924.322509765625,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538359522819519,
        0.3617154061794281,
        0.6645753979682922
      ],
      "plane_d": 32.34027099609375,
      "bbox_min": [
        -691.2036743164062,
        -2399.99365234375,
        630.2252807617188
      ],
      "bbox_max": [
        -127.98283386230469,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -519.0640869140625,
        -2247.94970703125,
        635.0
      ],
      "bbox_max": [
        -127.98283386230469,
        -1920.0,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -408.99609375,
        -2247.94970703125,
        637.4000244140625
      ],
      "bbox_max": [
        -127.98283386230469,
        -2000.7490234375,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -398.7380676269531,
        -2247.94970703125,
        637.4000244140625
      ],
      "bbox_max": [
        -139.53794860839844,
        -2033.6297607421875,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1865149885416031,
        0.7565726637840271,
        0.6267455220222473
      ],
      "plane_d": 1086.4886474609375,
      "bbox_min": [
        -398.7380676269531,
        -2247.94970703125,
        637.4000244140625
      ],
      "bbox_max": [
        -139.53794860839844,
        -2068.09375,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -398.7380676269531,
        -2247.94970703125,
        637.4000244140625
      ],
      "bbox_max": [
        -143.8071746826172,
        -2068.09375,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -398.7380676269531,
        -2239.39990234375,
        637.4000244140625
      ],
      "bbox_max": [
        -166.49237060546875,
        -2117.713623046875,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1917705088853836,
        0.7642001509666443,
        0.615810215473175
      ],
      "plane_d": 1111.511474609375,
      "bbox_min": [
        -297.98779296875,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -264.1787109375,
        -2219.421630859375,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.6429138183594,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -277.624755859375,
        -2219.421630859375,
        861.1482543945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7727664709091187,
        0.44615718722343445,
        -0.45141535997390747
      ],
      "plane_d": 1543.02392578125,
      "bbox_min": [
        -398.7380676269531,
        -2239.39990234375,
        637.4000244140625
      ],
      "bbox_max": [
        -177.9420166015625,
        -2117.713623046875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -398.7380676269531,
        -2239.39990234375,
        639.9999389648438
      ],
      "bbox_max": [
        -237.07595825195312,
        -2148.1474609375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -280.60009765625,
        -2219.5,
        818.7000122070312
      ],
      "bbox_max": [
        -270.5449523925781,
        -2195.120849609375,
        852.6400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -280.60009765625,
        -2219.5,
        836.8499755859375
      ],
      "bbox_max": [
        -277.7808532714844,
        -2206.77099609375,
        852.6400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -9.649078369140625,
      "bbox_min": [
        -278.6665954589844,
        -2239.39990234375,
        836.5
      ],
      "bbox_max": [
        -268.0931396484375,
        -2203.7763671875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -278.6665954589844,
        -2219.5,
        852.3973999023438
      ],
      "bbox_max": [
        -277.6274108886719,
        -2214.874267578125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -276.5,
        -2239.39990234375,
        836.5
      ],
      "bbox_max": [
        -268.0931396484375,
        -2203.7763671875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 441.2032470703125,
      "bbox_min": [
        -274.5,
        -2239.39990234375,
        854.5
      ],
      "bbox_max": [
        -268.0931396484375,
        -2213.27978515625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -113.74404907226562,
      "bbox_min": [
        -272.5,
        -2239.39990234375,
        857.0
      ],
      "bbox_max": [
        -268.0931396484375,
        -2213.961181640625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -398.7380676269531,
        -2170.64208984375,
        639.9999389648438
      ],
      "bbox_max": [
        -360.2727966308594,
        -2148.1474609375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -390.7622985839844,
        -2170.64208984375,
        667.9999389648438
      ],
      "bbox_max": [
        -360.2727966308594,
        -2148.1474609375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8327006101608276,
        0.48076021671295166,
        0.27473509311676025
      ],
      "plane_d": 1169.46533203125,
      "bbox_min": [
        -378.9644775390625,
        -2237.0,
        637.4000244140625
      ],
      "bbox_max": [
        -177.9420166015625,
        -2117.713623046875,
        820.7913818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -378.9644775390625,
        -2237.0,
        637.4000244140625
      ],
      "bbox_max": [
        -177.9420166015625,
        -2117.713623046875,
        820.7913818359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -378.9644775390625,
        -2237.0,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2117.713623046875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        -378.9644775390625,
        -2237.0,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2132.12744140625,
        641.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -312.0,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2234.0,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        0.5000061392784119,
        0.0
      ],
      "plane_d": 1397.33154296875,
      "bbox_min": [
        -378.9644775390625,
        -2237.0,
        640.0
      ],
      "bbox_max": [
        -310.0,
        -2132.12744140625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660219311714172,
        -0.5000061392784119,
        -0.0
      ],
      "plane_d": -1383.3314208984375,
      "bbox_min": [
        -374.341552734375,
        -2237.0,
        640.0
      ],
      "bbox_max": [
        -310.0,
        -2132.12744140625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        0.866020917892456,
        0.0
      ],
      "plane_d": 1673.533203125,
      "bbox_min": [
        -374.341552734375,
        -2237.0,
        640.0
      ],
      "bbox_max": [
        -310.0,
        -2139.2607421875,
        641.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -312.0,
      "bbox_min": [
        -312.0,
        -2237.0,
        640.0
      ],
      "bbox_max": [
        -310.0,
        -2234.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -312.0,
        -2234.0,
        640.0
      ],
      "bbox_max": [
        -310.0,
        -2234.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25884971022605896,
        0.9659175872802734,
        0.0
      ],
      "plane_d": 2170.009033203125,
      "bbox_min": [
        -374.341552734375,
        -2146.992919921875,
        640.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2139.2607421875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659176468849182,
        0.2588496804237366,
        0.0
      ],
      "plane_d": 203.8751220703125,
      "bbox_min": [
        -362.94921875,
        -2141.992919921875,
        640.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2139.2607421875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -378.7044372558594,
        -2237.0,
        641.0
      ],
      "bbox_max": [
        -177.9420166015625,
        -2118.133056640625,
        820.7913818359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7709356546401978,
        -0.44509947299957275,
        -0.4555707275867462
      ],
      "plane_d": -932.5703735351562,
      "bbox_min": [
        -378.7044372558594,
        -2237.0,
        641.0
      ],
      "bbox_max": [
        -305.626953125,
        -2118.133056640625,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -364.6523742675781,
        -2183.130126953125,
        641.0
      ],
      "bbox_max": [
        -305.626953125,
        -2118.133056640625,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -364.6523742675781,
        -2183.130126953125,
        642.21435546875
      ],
      "bbox_max": [
        -305.626953125,
        -2122.10546875,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660251498222351,
        -0.500000536441803,
        0.0
      ],
      "plane_d": -1347.4207763671875,
      "bbox_min": [
        -342.778076171875,
        -2183.130126953125,
        642.21435546875
      ],
      "bbox_max": [
        -305.626953125,
        -2122.10546875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660251498222351,
        -0.500000536441803,
        -0.0
      ],
      "plane_d": -1343.4207763671875,
      "bbox_min": [
        -330.28045654296875,
        -2141.2294921875,
        644.9999389648438
      ],
      "bbox_max": [
        -317.162841796875,
        -2122.10546875,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.0,
      "bbox_min": [
        -330.28045654296875,
        -2141.2294921875,
        644.9999389648438
      ],
      "bbox_max": [
        -317.162841796875,
        -2122.10546875,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000253915786743,
        0.8660107851028442,
        0.0
      ],
      "plane_d": 1694.5062255859375,
      "bbox_min": [
        -319.626953125,
        -2141.2294921875,
        644.9999389648438
      ],
      "bbox_max": [
        -318.760986328125,
        -2140.7294921875,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5196319818496704,
        -0.300010085105896,
        0.799985408782959
      ],
      "plane_d": -1324.0693359375,
      "bbox_min": [
        -328.35760498046875,
        -2141.2294921875,
        646.0
      ],
      "bbox_max": [
        -317.162841796875,
        -2122.10546875,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123877763748169,
        -0.35356274247169495,
        -0.707088828086853
      ],
      "plane_d": -486.1158142089844,
      "bbox_min": [
        -325.27276611328125,
        -2141.2294921875,
        646.0
      ],
      "bbox_max": [
        -317.162841796875,
        -2125.89013671875,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866041362285614,
        -0.4999725818634033,
        0.0
      ],
      "plane_d": -1346.3662109375,
      "bbox_min": [
        -323.02880859375,
        -2141.2294921875,
        646.0
      ],
      "bbox_max": [
        -317.162841796875,
        -2128.837158203125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49991971254348755,
        0.866071879863739,
        0.0
      ],
      "plane_d": 1692.670654296875,
      "bbox_min": [
        -323.02880859375,
        -2138.997314453125,
        646.0
      ],
      "bbox_max": [
        -317.162841796875,
        -2128.837158203125,
        658.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8492258787155151,
        -0.49029940366744995,
        0.19601531326770782
      ],
      "plane_d": -1445.5511474609375,
      "bbox_min": [
        -323.02880859375,
        -2137.997314453125,
        649.0
      ],
      "bbox_max": [
        -317.162841796875,
        -2128.837158203125,
        651.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -322.6826171875,
        -2137.79736328125,
        649.0
      ],
      "bbox_max": [
        -317.162841796875,
        -2128.837158203125,
        651.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000253319740295,
        0.8660107254981995,
        -2.769461389107164e-05
      ],
      "plane_d": 1688.524169921875,
      "bbox_min": [
        -320.02880859375,
        -2134.533203125,
        649.0
      ],
      "bbox_max": [
        -319.162841796875,
        -2134.033203125,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000253915786743,
        0.8660107851028442,
        0.0
      ],
      "plane_d": 1694.5062255859375,
      "bbox_min": [
        -319.626953125,
        -2141.2294921875,
        646.0
      ],
      "bbox_max": [
        -318.760986328125,
        -2140.7294921875,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49239566922187805,
        0.8528446555137634,
        -0.1737886667251587
      ],
      "plane_d": 1808.942138671875,
      "bbox_min": [
        -342.778076171875,
        -2183.130126953125,
        642.21435546875
      ],
      "bbox_max": [
        -305.626953125,
        -2122.777099609375,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999966025352478,
        0.8660274744033813,
        0.0
      ],
      "plane_d": 1722.55126953125,
      "bbox_min": [
        -315.1533203125,
        -2170.978271484375,
        647.999755859375
      ],
      "bbox_max": [
        -305.626953125,
        -2165.478271484375,
        659.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -643.9999389648438,
      "bbox_min": [
        -342.778076171875,
        -2181.378173828125,
        642.21435546875
      ],
      "bbox_max": [
        -305.626953125,
        -2122.777099609375,
        657.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -643.0,
      "bbox_min": [
        -335.6023254394531,
        -2180.3544921875,
        642.21435546875
      ],
      "bbox_max": [
        -305.626953125,
        -2156.81787109375,
        643.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1983572542667389,
        -0.11451967805624008,
        0.9734165072441101
      ],
      "plane_d": -940.360595703125,
      "bbox_min": [
        -335.6023254394531,
        -2180.0986328125,
        642.21435546875
      ],
      "bbox_max": [
        -327.710693359375,
        -2169.56787109375,
        643.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999985992908478,
        0.8660261631011963,
        -1.1339979209878948e-05
      ],
      "plane_d": 1722.55517578125,
      "bbox_min": [
        -330.95050048828125,
        -2180.0986328125,
        642.21435546875
      ],
      "bbox_max": [
        -327.710693359375,
        -2178.228271484375,
        643.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999966025352478,
        0.8660274744033813,
        0.0
      ],
      "plane_d": 1722.55126953125,
      "bbox_min": [
        -331.3936767578125,
        -2180.3544921875,
        643.0
      ],
      "bbox_max": [
        -305.626953125,
        -2165.478271484375,
        643.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.0,
      "bbox_min": [
        -342.778076171875,
        -2181.378173828125,
        643.9998779296875
      ],
      "bbox_max": [
        -305.626953125,
        -2122.777099609375,
        657.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999966025352478,
        0.8660274744033813,
        0.0
      ],
      "plane_d": 1722.55126953125,
      "bbox_min": [
        -332.28009033203125,
        -2180.866455078125,
        643.9998779296875
      ],
      "bbox_max": [
        -305.626953125,
        -2155.951904296875,
        646.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8614603877067566,
        -0.5078188180923462,
        -0.0024450363125652075
      ],
      "plane_d": -1365.2818603515625,
      "bbox_min": [
        -320.6533203125,
        -2161.617919921875,
        643.9998779296875
      ],
      "bbox_max": [
        -311.126953125,
        -2155.951904296875,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999946057796478,
        0.866018533706665,
        0.004163676407188177
      ],
      "plane_d": 1708.8511962890625,
      "bbox_min": [
        -314.591064453125,
        -2158.800048828125,
        643.9998779296875
      ],
      "bbox_max": [
        -311.126953125,
        -2155.951904296875,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8480129241943359,
        -0.5299757122993469,
        -0.0
      ],
      "plane_d": -1410.4649658203125,
      "bbox_min": [
        -314.19110107421875,
        -2158.800048828125,
        643.9998779296875
      ],
      "bbox_max": [
        -314.0910949707031,
        -2158.64013671875,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5089324116706848,
        0.8608064651489258,
        0.0
      ],
      "plane_d": 1697.5146484375,
      "bbox_min": [
        -311.8197937011719,
        -2156.361572265625,
        643.9999389648438
      ],
      "bbox_max": [
        -311.126953125,
        -2155.951904296875,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4735405147075653,
        0.880772054195404,
        0.0
      ],
      "plane_d": 1751.9041748046875,
      "bbox_min": [
        -320.6533203125,
        -2161.617919921875,
        643.9998779296875
      ],
      "bbox_max": [
        -318.94091796875,
        -2160.800048828125,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.853207528591156,
        0.5215708017349243,
        -0.0009321668185293674
      ],
      "plane_d": 1400.159912109375,
      "bbox_min": [
        -319.4408874511719,
        -2161.617919921875,
        643.9998779296875
      ],
      "bbox_max": [
        -318.94091796875,
        -2160.800048828125,
        646.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4999966025352478,
        0.8660274744033813,
        0.0
      ],
      "plane_d": 1722.55126953125,
      "bbox_min": [
        -333.16650390625,
        -2181.378173828125,
        646.0
      ],
      "bbox_max": [
        -305.626953125,
        -2155.951904296875,
        657.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8480129241943359,
        -0.5299757122993469,
        -0.0
      ],
      "plane_d": -1410.4649658203125,
      "bbox_min": [
        -320.6533203125,
        -2161.6142578125,
        646.0
      ],
      "bbox_max": [
        -311.126953125,
        -2155.951904296875,
        657.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5089324116706848,
        0.8608064651489258,
        0.0
      ],
      "plane_d": 1697.5146484375,
      "bbox_min": [
        -314.5910949707031,
        -2158.64013671875,
        646.0
      ],
      "bbox_max": [
        -311.126953125,
        -2155.951904296875,
        657.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8614603877067566,
        -0.5078188180923462,
        -0.0024450363125652075
      ],
      "plane_d": -1365.2818603515625,
      "bbox_min": [
        -314.5910949707031,
        -2158.64013671875,
        646.0
      ],
      "bbox_max": [
        -314.19110107421875,
        -2157.989990234375,
        653.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999946057796478,
        0.866018533706665,
        0.004163676407188177
      ],
      "plane_d": 1708.8511962890625,
      "bbox_min": [
        -314.5910949707031,
        -2158.0,
        646.0
      ],
      "bbox_max": [
        -311.8197937011719,
        -2156.361572265625,
        653.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8614603877067566,
        -0.5078188180923462,
        -0.0024450363125652075
      ],
      "plane_d": -1365.2818603515625,
      "bbox_min": [
        -314.5910949707031,
        -2158.0,
        646.0
      ],
      "bbox_max": [
        -314.57427978515625,
        -2157.96142578125,
        653.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4735405147075653,
        0.880772054195404,
        0.0
      ],
      "plane_d": 1751.9041748046875,
      "bbox_min": [
        -320.6533203125,
        -2161.6142578125,
        646.0
      ],
      "bbox_max": [
        -318.9408874511719,
        -2160.800048828125,
        657.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8480129241943359,
        0.5299757122993469,
        0.0
      ],
      "plane_d": 1416.0615234375,
      "bbox_min": [
        -319.4408874511719,
        -2161.6142578125,
        646.0
      ],
      "bbox_max": [
        -318.9408874511719,
        -2160.800048828125,
        653.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.853207528591156,
        0.5215708017349243,
        -0.0009321668185293674
      ],
      "plane_d": 1400.159912109375,
      "bbox_min": [
        -319.34088134765625,
        -2161.6142578125,
        646.0
      ],
      "bbox_max": [
        -318.9408874511719,
        -2160.9599609375,
        653.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -337.492919921875,
        -2144.902587890625,
        667.9999389648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2131.132568359375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -337.492919921875,
        -2144.902587890625,
        667.9999389648438
      ],
      "bbox_max": [
        -333.12548828125,
        -2137.055419921875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8261845707893372,
        -0.47699832916259766,
        0.2998194098472595
      ],
      "plane_d": -1510.0537109375,
      "bbox_min": [
        -378.7044372558594,
        -2237.0,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2132.57275390625,
        667.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1983572542667389,
        -0.11451967805624008,
        0.9734165072441101
      ],
      "plane_d": -940.360595703125,
      "bbox_min": [
        -340.07177734375,
        -2182.478271484375,
        641.0
      ],
      "bbox_max": [
        -330.602294921875,
        -2171.2373046875,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999985992908478,
        0.8660261631011963,
        -1.1339979209878948e-05
      ],
      "plane_d": 1722.55517578125,
      "bbox_min": [
        -335.07177734375,
        -2182.478271484375,
        641.0
      ],
      "bbox_max": [
        -330.602294921875,
        -2179.897705078125,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5029279589653015,
        0.8643265962600708,
        -0.0017399279167875648
      ],
      "plane_d": 1754.99169921875,
      "bbox_min": [
        -378.7044372558594,
        -2237.0,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2132.57275390625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2234.0,
      "bbox_min": [
        -327.48822021484375,
        -2237.0,
        641.0
      ],
      "bbox_max": [
        -310.0,
        -2219.71875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -312.0,
      "bbox_min": [
        -312.0,
        -2237.0,
        641.0
      ],
      "bbox_max": [
        -312.0,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8480129241943359,
        0.5299757122993469,
        0.0
      ],
      "plane_d": 1454.111328125,
      "bbox_min": [
        -327.48822021484375,
        -2220.5,
        641.0
      ],
      "bbox_max": [
        -327.0,
        -2219.71875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4971730709075928,
        0.8676497936248779,
        -0.001646611955948174
      ],
      "plane_d": 1764.169921875,
      "bbox_min": [
        -378.7044372558594,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2132.57275390625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8480129241943359,
        0.5299757122993469,
        0.0
      ],
      "plane_d": 1454.111328125,
      "bbox_min": [
        -327.5,
        -2219.733642578125,
        641.0
      ],
      "bbox_max": [
        -327.4789733886719,
        -2219.699951171875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49997738003730774,
        0.8660385012626648,
        0.0
      ],
      "plane_d": 1673.58203125,
      "bbox_min": [
        -378.7044372558594,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2132.57275390625,
        667.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -369.964111328125,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2143.04296875,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5023818016052246,
        0.8646458983421326,
        3.431094697248227e-08
      ],
      "plane_d": 1754.7427978515625,
      "bbox_min": [
        -369.964111328125,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2143.04296875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49771302938461304,
        0.8673416972160339,
        0.0
      ],
      "plane_d": 1762.2373046875,
      "bbox_min": [
        -369.964111328125,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2143.04296875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8480129241943359,
        0.5299757122993469,
        0.0
      ],
      "plane_d": 1454.111328125,
      "bbox_min": [
        -327.5,
        -2219.7138671875,
        641.0
      ],
      "bbox_max": [
        -327.49127197265625,
        -2219.699951171875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5032658576965332,
        0.8641307353973389,
        0.0012059673899784684
      ],
      "plane_d": 1752.5428466796875,
      "bbox_min": [
        -349.763671875,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2188.67822265625,
        654.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49695202708244324,
        0.8677775263786316,
        0.0009954582201316953
      ],
      "plane_d": 1762.8157958984375,
      "bbox_min": [
        -349.763671875,
        -2223.655029296875,
        641.0
      ],
      "bbox_max": [
        -327.5,
        -2188.67822265625,
        654.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -349.763671875,
        -2191.826416015625,
        654.0
      ],
      "bbox_max": [
        -345.310546875,
        -2188.67822265625,
        654.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -360.263671875,
        -2173.639892578125,
        654.0
      ],
      "bbox_max": [
        -355.810546875,
        -2170.49169921875,
        654.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8608182072639465,
        0.4970272481441498,
        -0.10934361815452576
      ],
      "plane_d": 1455.2030029296875,
      "bbox_min": [
        -369.964111328125,
        -2146.908935546875,
        641.0
      ],
      "bbox_max": [
        -364.26806640625,
        -2143.04296875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8617133498191833,
        -0.4975441098213196,
        -0.09949872642755508
      ],
      "plane_d": -1316.80517578125,
      "bbox_min": [
        -369.011474609375,
        -2146.35888671875,
        641.0
      ],
      "bbox_max": [
        -364.26806640625,
        -2143.04296875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -369.011474609375,
        -2146.35888671875,
        651.0
      ],
      "bbox_max": [
        -365.134033203125,
        -2143.54296875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        0.5000061392784119,
        0.0
      ],
      "plane_d": 1397.33154296875,
      "bbox_min": [
        -378.7044372558594,
        -2146.992919921875,
        641.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2132.57275390625,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659176468849182,
        0.2588496804237366,
        0.0
      ],
      "plane_d": 203.8751220703125,
      "bbox_min": [
        -375.82666015625,
        -2146.992919921875,
        641.0
      ],
      "bbox_max": [
        -362.217041015625,
        -2139.140625,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.9999389648438,
      "bbox_min": [
        -375.82666015625,
        -2146.992919921875,
        652.0665893554688
      ],
      "bbox_max": [
        -362.94921875,
        -2139.140625,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6018846035003662,
        0.3474956154823303,
        -0.7190144658088684
      ],
      "plane_d": 1439.971923828125,
      "bbox_min": [
        -375.82666015625,
        -2146.992919921875,
        652.0665893554688
      ],
      "bbox_max": [
        -371.609375,
        -2143.656005859375,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -291.9776916503906,
        -2247.94970703125,
        637.5733642578125
      ],
      "bbox_max": [
        -143.8071746826172,
        -2068.09375,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -229.68516540527344,
        -2114.41748046875,
        638.0515747070312
      ],
      "bbox_max": [
        -194.23110961914062,
        -2078.007080078125,
        653.239990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -221.16416931152344,
        -2092.188232421875,
        638.0515747070312
      ],
      "bbox_max": [
        -194.23110961914062,
        -2078.007080078125,
        641.8828735351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25527524948120117,
        0.9336197376251221,
        0.25137388706207275
      ],
      "plane_d": 1895.1923828125,
      "bbox_min": [
        -240.39039611816406,
        -2247.94970703125,
        637.5733642578125
      ],
      "bbox_max": [
        -143.8071746826172,
        -2068.09375,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -235.50057983398438,
        -2247.94970703125,
        819.5764770507812
      ],
      "bbox_max": [
        -144.019287109375,
        -2186.518310546875,
        937.2014770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.011264197528362274,
        0.8631103038787842,
        0.5048899054527283
      ],
      "plane_d": 1468.667236328125,
      "bbox_min": [
        -147.6560516357422,
        -2247.94970703125,
        918.2081298828125
      ],
      "bbox_max": [
        -144.019287109375,
        -2236.791748046875,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0863649919629097,
        0.9781539440155029,
        0.18909214437007904
      ],
      "plane_d": 2005.18701171875,
      "bbox_min": [
        -240.39039611816406,
        -2237.2451171875,
        637.5733642578125
      ],
      "bbox_max": [
        -143.8071746826172,
        -2068.09375,
        918.9628295898438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.011264197528362274,
        0.8631103038787842,
        0.5048899054527283
      ],
      "plane_d": 1468.667236328125,
      "bbox_min": [
        -228.36341857910156,
        -2237.2451171875,
        819.7315063476562
      ],
      "bbox_max": [
        -146.74072265625,
        -2188.4384765625,
        918.9628295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -228.36341857910156,
        -2202.45751953125,
        819.7315063476562
      ],
      "bbox_max": [
        -170.35757446289062,
        -2188.4384765625,
        820.580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -215.482177734375,
        -2203.22607421875,
        861.0
      ],
      "bbox_max": [
        -155.07421875,
        -2198.721923828125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -240.39039611816406,
        -2202.723388671875,
        637.5733642578125
      ],
      "bbox_max": [
        -143.8071746826172,
        -2068.09375,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -230.1759490966797,
        -2202.723388671875,
        821.0
      ],
      "bbox_max": [
        -143.8071746826172,
        -2181.5,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -168.0985107421875,
        -2187.44677734375,
        857.0
      ],
      "bbox_max": [
        -143.8331298828125,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -210.3173370361328,
        -2081.2646484375,
        637.5733642578125
      ],
      "bbox_max": [
        -186.2097625732422,
        -2068.09375,
        640.4237670898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -199.1471405029297,
        -2073.826904296875,
        637.5733642578125
      ],
      "bbox_max": [
        -186.2097625732422,
        -2068.09375,
        638.921142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -261.32635498046875,
        -2213.743408203125,
        857.0
      ],
      "bbox_max": [
        -139.53794860839844,
        -2179.60009765625,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -146.0,
        -2181.5,
        861.0
      ],
      "bbox_max": [
        -139.53794860839844,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -146.0,
        -2181.5,
        861.0
      ],
      "bbox_max": [
        -140.26210021972656,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -146.0,
      "bbox_min": [
        -146.0,
        -2181.5,
        861.0
      ],
      "bbox_max": [
        -146.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -191.97613525390625,
        -2187.44677734375,
        857.0
      ],
      "bbox_max": [
        -140.847412109375,
        -2180.03857421875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -174.9040069580078,
        -2181.5,
        857.0
      ],
      "bbox_max": [
        -140.847412109375,
        -2180.03857421875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -146.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -140.847412109375,
        -2180.03857421875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -146.0,
      "bbox_min": [
        -146.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -146.0,
        -2180.03857421875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -367.9453430175781,
        -2233.3134765625,
        637.5899047851562
      ],
      "bbox_max": [
        -156.4415740966797,
        -2033.6297607421875,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -367.9453430175781,
        -2215.42236328125,
        637.5899047851562
      ],
      "bbox_max": [
        -162.62155151367188,
        -2065.7421875,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -367.9453430175781,
        -2215.42236328125,
        639.9999389648438
      ],
      "bbox_max": [
        -226.0362091064453,
        -2117.33349609375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -367.9453430175781,
        -2215.42236328125,
        639.9999389648438
      ],
      "bbox_max": [
        -226.91893005371094,
        -2117.33349609375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -367.9453430175781,
        -2213.27978515625,
        639.9999389648438
      ],
      "bbox_max": [
        -240.81251525878906,
        -2117.33349609375,
        854.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -367.9453430175781,
        -2213.27978515625,
        640.0
      ],
      "bbox_max": [
        -264.904296875,
        -2121.739501953125,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -367.9453430175781,
        -2144.74365234375,
        640.0
      ],
      "bbox_max": [
        -323.86419677734375,
        -2121.739501953125,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660219311714172,
        -0.5000061392784119,
        -0.0
      ],
      "plane_d": -1383.3314208984375,
      "bbox_min": [
        -367.9453430175781,
        -2137.500244140625,
        640.0
      ],
      "bbox_max": [
        -323.86419677734375,
        -2121.739501953125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.0,
      "bbox_min": [
        -342.916259765625,
        -2127.450439453125,
        646.0
      ],
      "bbox_max": [
        -323.86419677734375,
        -2121.739501953125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660251498222351,
        -0.500000536441803,
        -0.0
      ],
      "plane_d": -1343.4207763671875,
      "bbox_min": [
        -328.561767578125,
        -2127.450439453125,
        646.0
      ],
      "bbox_max": [
        -323.86419677734375,
        -2121.739501953125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123877763748169,
        -0.35356274247169495,
        -0.707088828086853
      ],
      "plane_d": -486.1158142089844,
      "bbox_min": [
        -328.561767578125,
        -2127.450439453125,
        646.0
      ],
      "bbox_max": [
        -323.86419677734375,
        -2121.739501953125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5196319818496704,
        -0.300010085105896,
        0.799985408782959
      ],
      "plane_d": -1324.0693359375,
      "bbox_min": [
        -328.561767578125,
        -2122.107177734375,
        646.0
      ],
      "bbox_max": [
        -326.04931640625,
        -2121.739501953125,
        647.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -639.9999389648438,
      "bbox_min": [
        -367.9453430175781,
        -2132.688232421875,
        640.0
      ],
      "bbox_max": [
        -366.3355712890625,
        -2132.05126953125,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -337.6019287109375,
        -2138.84716796875,
        667.9999389648438
      ],
      "bbox_max": [
        -336.4956359863281,
        -2136.859619140625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -278.0543212890625,
        -2213.27978515625,
        820.1755981445312
      ],
      "bbox_max": [
        -264.904296875,
        -2193.15966796875,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -270.5449523925781,
        -2195.120849609375,
        820.1755981445312
      ],
      "bbox_max": [
        -265.1891174316406,
        -2193.15966796875,
        820.2943115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -270.47674560546875,
        -2204.630126953125,
        836.5
      ],
      "bbox_max": [
        -270.3147277832031,
        -2203.69482421875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -265.3108215332031,
        -2193.313720703125,
        820.2849731445312
      ],
      "bbox_max": [
        -240.81251525878906,
        -2184.905517578125,
        820.7938842773438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -241.49510192871094,
        -2201.7578125,
        820.7827758789062
      ],
      "bbox_max": [
        -226.0362091064453,
        -2184.742431640625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -241.49510192871094,
        -2185.0888671875,
        820.7827758789062
      ],
      "bbox_max": [
        -240.39039611816406,
        -2184.742431640625,
        820.8037719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -292.8619384765625,
        -2201.450439453125,
        637.5899047851562
      ],
      "bbox_max": [
        -162.62155151367188,
        -2065.7421875,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -230.67520141601562,
        -2089.302490234375,
        640.4237670898438
      ],
      "bbox_max": [
        -210.3173370361328,
        -2077.50634765625,
        648.9296264648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -222.77908325195312,
        -2082.565673828125,
        640.4237670898438
      ],
      "bbox_max": [
        -210.3173370361328,
        -2077.50634765625,
        642.1300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -241.0248260498047,
        -2201.450439453125,
        637.5899047851562
      ],
      "bbox_max": [
        -162.62155151367188,
        -2065.7421875,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -171.36509704589844,
        -2181.5,
        861.0
      ],
      "bbox_max": [
        -162.62155151367188,
        -2181.5,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -241.0248260498047,
        -2187.44677734375,
        637.5899047851562
      ],
      "bbox_max": [
        -168.76278686523438,
        -2065.7421875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -177.39559936523438,
        -2181.5,
        857.0
      ],
      "bbox_max": [
        -168.76278686523438,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -241.0248260498047,
        -2184.946533203125,
        637.5899047851562
      ],
      "bbox_max": [
        -184.73155212402344,
        -2065.7421875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -241.0248260498047,
        -2184.946533203125,
        638.9210815429688
      ],
      "bbox_max": [
        -199.1468963623047,
        -2073.121826171875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -241.0248260498047,
        -2184.946533203125,
        820.7913818359375
      ],
      "bbox_max": [
        -224.03480529785156,
        -2181.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -231.6687774658203,
        -2181.5,
        821.0
      ],
      "bbox_max": [
        -224.03480529785156,
        -2181.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36162224411964417,
        0.8005647659301758,
        0.4778340458869934
      ],
      "plane_d": 1267.4736328125,
      "bbox_min": [
        -367.4245910644531,
        -2233.3134765625,
        637.5966796875
      ],
      "bbox_max": [
        -156.4415740966797,
        -2033.6297607421875,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -367.4245910644531,
        -2208.06396484375,
        637.5966796875
      ],
      "bbox_max": [
        -165.3345947265625,
        -2042.54248046875,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -367.4245910644531,
        -2208.06396484375,
        639.9999389648438
      ],
      "bbox_max": [
        -226.59629821777344,
        -2113.50927734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -367.4245910644531,
        -2208.06396484375,
        639.9999389648438
      ],
      "bbox_max": [
        -227.51258850097656,
        -2113.50927734375,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -367.4245910644531,
        -2197.30126953125,
        640.0
      ],
      "bbox_max": [
        -264.85723876953125,
        -2118.03857421875,
        827.468994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -367.4245910644531,
        -2144.662353515625,
        640.0
      ],
      "bbox_max": [
        -324.0661926269531,
        -2118.03857421875,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.0,
      "bbox_min": [
        -367.4245910644531,
        -2137.447021484375,
        640.0
      ],
      "bbox_max": [
        -324.0661926269531,
        -2118.03857421875,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660219311714172,
        -0.5000061392784119,
        -0.0
      ],
      "plane_d": -1383.3314208984375,
      "bbox_min": [
        -367.4245910644531,
        -2134.734375,
        640.0
      ],
      "bbox_max": [
        -364.83050537109375,
        -2131.93212890625,
        646.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -639.9999389648438,
      "bbox_min": [
        -367.4245910644531,
        -2132.42529296875,
        640.0
      ],
      "bbox_max": [
        -366.3796081542969,
        -2131.93212890625,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660251498222351,
        -0.500000536441803,
        -0.0
      ],
      "plane_d": -1343.4207763671875,
      "bbox_min": [
        -364.88812255859375,
        -2137.447021484375,
        646.0
      ],
      "bbox_max": [
        -324.0661926269531,
        -2118.03857421875,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660219311714172,
        -0.5000061392784119,
        -0.0
      ],
      "plane_d": -1383.3314208984375,
      "bbox_min": [
        -364.88812255859375,
        -2137.447021484375,
        646.0
      ],
      "bbox_max": [
        -324.0661926269531,
        -2118.03857421875,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5196319818496704,
        -0.300010085105896,
        0.799985408782959
      ],
      "plane_d": -1324.0693359375,
      "bbox_min": [
        -330.63897705078125,
        -2127.11962890625,
        646.0
      ],
      "bbox_max": [
        -324.0661926269531,
        -2118.03857421875,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123877763748169,
        -0.35356274247169495,
        -0.707088828086853
      ],
      "plane_d": -486.1158142089844,
      "bbox_min": [
        -327.359130859375,
        -2127.11962890625,
        656.0
      ],
      "bbox_max": [
        -324.0661926269531,
        -2122.0625,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -338.6816101074219,
        -2138.659423828125,
        667.9999389648438
      ],
      "bbox_max": [
        -336.6001281738281,
        -2134.919677734375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -270.5155944824219,
        -2197.30126953125,
        820.1851196289062
      ],
      "bbox_max": [
        -264.85723876953125,
        -2192.813720703125,
        827.468994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -265.5843200683594,
        -2208.06396484375,
        820.2943115234375
      ],
      "bbox_max": [
        -227.51258850097656,
        -2183.91552734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -265.5843200683594,
        -2193.15966796875,
        820.2943115234375
      ],
      "bbox_max": [
        -241.49510192871094,
        -2183.91552734375,
        820.8538208007812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -245.17408752441406,
        -2201.59521484375,
        820.7938842773438
      ],
      "bbox_max": [
        -226.59629821777344,
        -2183.623779296875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -229.84800720214844,
        -2201.59521484375,
        861.0
      ],
      "bbox_max": [
        -226.59629821777344,
        -2200.51904296875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -300.4163513183594,
        -2201.267333984375,
        637.5966796875
      ],
      "bbox_max": [
        -165.3345947265625,
        -2042.54248046875,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -240.01048278808594,
        -2088.1982421875,
        640.7882690429688
      ],
      "bbox_max": [
        -212.7891845703125,
        -2073.22412109375,
        648.7401123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -240.01048278808594,
        -2088.1982421875,
        642.1300048828125
      ],
      "bbox_max": [
        -222.7790985107422,
        -2074.9892578125,
        648.7401123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -244.50466918945312,
        -2201.267333984375,
        637.5966796875
      ],
      "bbox_max": [
        -165.3345947265625,
        -2042.54248046875,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -186.77857971191406,
        -2181.5,
        861.0
      ],
      "bbox_max": [
        -165.3345947265625,
        -2181.5,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -244.50466918945312,
        -2187.44677734375,
        637.6512451171875
      ],
      "bbox_max": [
        -167.5012969970703,
        -2042.54248046875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -244.50466918945312,
        -2187.44677734375,
        637.6512451171875
      ],
      "bbox_max": [
        -167.5012969970703,
        -2042.54248046875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -192.06399536132812,
        -2181.5,
        857.0
      ],
      "bbox_max": [
        -171.36509704589844,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -244.50466918945312,
        -2184.742431640625,
        637.6512451171875
      ],
      "bbox_max": [
        -167.5012969970703,
        -2042.54248046875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -244.50466918945312,
        -2184.742431640625,
        820.8037719726562
      ],
      "bbox_max": [
        -231.66876220703125,
        -2181.5,
        821.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -177.4660186767578,
        -2046.8643798828125,
        637.6512451171875
      ],
      "bbox_max": [
        -167.5012969970703,
        -2042.54248046875,
        642.7789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -355.803466796875,
        -2233.3134765625,
        638.5073852539062
      ],
      "bbox_max": [
        -156.4415740966797,
        -2033.6297607421875,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -352.2353210449219,
        -2186.9873046875,
        639.9999389648438
      ],
      "bbox_max": [
        -245.17381286621094,
        -2112.8984375,
        820.8655395507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -352.2353210449219,
        -2141.0419921875,
        646.0
      ],
      "bbox_max": [
        -317.154541015625,
        -2117.29345703125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.0,
      "bbox_min": [
        -352.2353210449219,
        -2141.0419921875,
        646.0
      ],
      "bbox_max": [
        -326.07415771484375,
        -2117.29345703125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -352.2353210449219,
        -2141.0419921875,
        646.0
      ],
      "bbox_max": [
        -326.07415771484375,
        -2117.29345703125,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6123877763748169,
        -0.35356274247169495,
        -0.707088828086853
      ],
      "plane_d": -486.1158142089844,
      "bbox_min": [
        -331.0054931640625,
        -2123.836669921875,
        646.0
      ],
      "bbox_max": [
        -326.07415771484375,
        -2117.29345703125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5196319818496704,
        -0.300010085105896,
        0.799985408782959
      ],
      "plane_d": -1324.0693359375,
      "bbox_min": [
        -331.0054931640625,
        -2118.15576171875,
        646.0
      ],
      "bbox_max": [
        -328.3973083496094,
        -2117.29345703125,
        647.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -338.995849609375,
        -2136.82763671875,
        667.9999389648438
      ],
      "bbox_max": [
        -337.6195983886719,
        -2134.35498046875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -252.21978759765625,
        -2186.9873046875,
        820.6679077148438
      ],
      "bbox_max": [
        -245.17381286621094,
        -2183.7216796875,
        820.8655395507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -303.77581787109375,
        -2123.153564453125,
        677.0691528320312
      ],
      "bbox_max": [
        -300.0645751953125,
        -2122.063720703125,
        677.6270751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -303.6487731933594,
        -2197.58935546875,
        638.5073852539062
      ],
      "bbox_max": [
        -156.4415740966797,
        -2033.6297607421875,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -243.7688446044922,
        -2077.787109375,
        643.9066162109375
      ],
      "bbox_max": [
        -233.93527221679688,
        -2071.70556640625,
        646.9533081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -243.7688446044922,
        -2077.787109375,
        644.346435546875
      ],
      "bbox_max": [
        -237.26171875,
        -2072.43505859375,
        646.9533081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -245.89480590820312,
        -2197.58935546875,
        638.5073852539062
      ],
      "bbox_max": [
        -156.4415740966797,
        -2033.6297607421875,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -245.89480590820312,
        -2197.58935546875,
        638.5073852539062
      ],
      "bbox_max": [
        -156.4415740966797,
        -2033.6297607421875,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -245.89480590820312,
        -2197.58935546875,
        643.493408203125
      ],
      "bbox_max": [
        -181.4931640625,
        -2071.04296875,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -192.43356323242188,
        -2181.5,
        861.0
      ],
      "bbox_max": [
        -181.4931640625,
        -2181.5,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -245.89480590820312,
        -2187.44677734375,
        643.493408203125
      ],
      "bbox_max": [
        -186.77857971191406,
        -2071.04296875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -197.3494873046875,
        -2181.5,
        857.0
      ],
      "bbox_max": [
        -186.77857971191406,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -245.89480590820312,
        -2183.91552734375,
        643.493408203125
      ],
      "bbox_max": [
        -230.81011962890625,
        -2071.04296875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -245.89480590820312,
        -2183.91552734375,
        820.8538208007812
      ],
      "bbox_max": [
        -234.34767150878906,
        -2181.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -245.89480590820312,
        -2183.91552734375,
        820.8538208007812
      ],
      "bbox_max": [
        -239.63287353515625,
        -2181.5,
        821.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -297.98779296875,
        -2233.3134765625,
        705.1073608398438
      ],
      "bbox_max": [
        -187.5176239013672,
        -2133.650634765625,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -252.1000518798828,
        -2186.925537109375,
        820.671630859375
      ],
      "bbox_max": [
        -245.89486694335938,
        -2183.703369140625,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1917705088853836,
        0.7642001509666443,
        0.615810215473175
      ],
      "plane_d": 1111.511474609375,
      "bbox_min": [
        -297.98779296875,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -272.43353271484375,
        -2218.526123046875,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.6274108886719,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -277.400146484375,
        -2218.526123046875,
        862.9825439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -278.0543212890625,
        -2219.421630859375,
        825.2794799804688
      ],
      "bbox_max": [
        -264.9940490722656,
        -2195.510009765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -375.0731201171875,
      "bbox_min": [
        -270.46417236328125,
        -2216.238037109375,
        825.2794799804688
      ],
      "bbox_max": [
        -264.9940490722656,
        -2195.510009765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -113.74404907226562,
      "bbox_min": [
        -270.46417236328125,
        -2216.238037109375,
        836.5
      ],
      "bbox_max": [
        -267.855712890625,
        -2203.28759765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 441.2032470703125,
      "bbox_min": [
        -270.46417236328125,
        -2213.961181640625,
        836.5
      ],
      "bbox_max": [
        -267.855712890625,
        -2203.28759765625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -270.46417236328125,
        -2204.5576171875,
        836.5
      ],
      "bbox_max": [
        -270.24420166015625,
        -2203.28759765625,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -278.0543212890625,
        -2219.5,
        820.1851196289062
      ],
      "bbox_max": [
        -232.66213989257812,
        -2181.356689453125,
        867.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8180076479911804,
        0.18297654390335083,
        0.5453283786773682
      ],
      "plane_d": -291.77178955078125,
      "bbox_min": [
        -277.4501953125,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -274.7591247558594,
        -2215.213134765625,
        867.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.4501953125,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -276.7727966308594,
        -2215.213134765625,
        863.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -278.0543212890625,
        -2218.526123046875,
        820.1851196289062
      ],
      "bbox_max": [
        -245.96267700195312,
        -2181.356689453125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -278.0543212890625,
        -2214.75,
        820.1851196289062
      ],
      "bbox_max": [
        -245.96267700195312,
        -2181.356689453125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -9.649078369140625,
      "bbox_min": [
        -270.5155944824219,
        -2214.75,
        820.1851196289062
      ],
      "bbox_max": [
        -245.96267700195312,
        -2181.356689453125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -270.5155944824219,
        -2214.75,
        820.1851196289062
      ],
      "bbox_max": [
        -245.96267700195312,
        -2181.356689453125,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 441.2032470703125,
      "bbox_min": [
        -269.774658203125,
        -2212.590576171875,
        854.5
      ],
      "bbox_max": [
        -267.05474853515625,
        -2207.480224609375,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -256.1170654296875,
        -2181.5,
        821.0
      ],
      "bbox_max": [
        -254.15232849121094,
        -2181.356689453125,
        821.8477172851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -255.54124450683594,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -254.735595703125,
        -2181.356689453125,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -255.25772094726562,
        -2200.954833984375,
        820.8655395507812
      ],
      "bbox_max": [
        -187.5176239013672,
        -2179.60009765625,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -210.04632568359375,
        -2181.5,
        861.0
      ],
      "bbox_max": [
        -187.5176239013672,
        -2181.5,
        865.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -255.25772094726562,
        -2187.44677734375,
        820.8655395507812
      ],
      "bbox_max": [
        -192.43356323242188,
        -2179.60009765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -214.6532745361328,
        -2181.5,
        857.0
      ],
      "bbox_max": [
        -192.43356323242188,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -255.25772094726562,
        -2183.7216796875,
        820.8655395507812
      ],
      "bbox_max": [
        -236.6760711669922,
        -2179.60009765625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -251.97039794921875,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 249.0,
      "bbox_min": [
        -251.7794189453125,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -251.7794189453125,
        -2179.60009765625,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -408.99609375,
        -2217.675048828125,
        639.9717407226562
      ],
      "bbox_max": [
        -127.98283386230469,
        -2000.7490234375,
        866.9991455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        639.9999389648438
      ],
      "bbox_max": [
        -241.4340362548828,
        -2058.64794921875,
        691.2015380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        639.9999389648438
      ],
      "bbox_max": [
        -241.4340362548828,
        -2070.70849609375,
        691.2015380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -401.4259033203125,
        -2160.501220703125,
        639.9999389648438
      ],
      "bbox_max": [
        -241.4340362548828,
        -2070.70849609375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -639.9998779296875,
      "bbox_min": [
        -401.4259033203125,
        -2160.501220703125,
        639.9999389648438
      ],
      "bbox_max": [
        -241.4340362548828,
        -2070.70849609375,
        667.9999389648438
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -401.4259033203125,
        -2160.501220703125,
        639.9999389648438
      ],
      "bbox_max": [
        -241.4340362548828,
        -2070.70849609375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -394.6380920410156,
        -2147.481689453125,
        639.9999389648438
      ],
      "bbox_max": [
        -241.4340362548828,
        -2070.70849609375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999973177909851,
        0.8660269379615784,
        0.0
      ],
      "plane_d": 1656.249755859375,
      "bbox_min": [
        -394.6380920410156,
        -2147.481689453125,
        639.9999389648438
      ],
      "bbox_max": [
        -326.6171875,
        -2106.3486328125,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660219311714172,
        -0.5000061392784119,
        -0.0
      ],
      "plane_d": -1383.3314208984375,
      "bbox_min": [
        -379.841552734375,
        -2147.481689453125,
        640.0
      ],
      "bbox_max": [
        -326.6171875,
        -2107.41064453125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -646.0,
      "bbox_min": [
        -349.0048828125,
        -2124.294189453125,
        645.9999389648438
      ],
      "bbox_max": [
        -326.6171875,
        -2107.41064453125,
        658.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6123877763748169,
        -0.35356274247169495,
        -0.707088828086853
      ],
      "plane_d": -486.1158142089844,
      "bbox_min": [
        -349.0048828125,
        -2122.92578125,
        645.9999389648438
      ],
      "bbox_max": [
        -326.6171875,
        -2107.41064453125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659804463386536,
        -0.5000780820846558,
        0.0
      ],
      "plane_d": -1349.5692138671875,
      "bbox_min": [
        -349.0048828125,
        -2114.132568359375,
        645.9999389648438
      ],
      "bbox_max": [
        -332.6826171875,
        -2107.41064453125,
        651.8984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8492258787155151,
        -0.49029940366744995,
        0.19601531326770782
      ],
      "plane_d": -1445.5511474609375,
      "bbox_min": [
        -340.408935546875,
        -2112.0166015625,
        645.9999389648438
      ],
      "bbox_max": [
        -332.6826171875,
        -2107.41064453125,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000298619270325,
        0.8660082221031189,
        0.0
      ],
      "plane_d": 1656.3995361328125,
      "bbox_min": [
        -340.408935546875,
        -2109.234130859375,
        645.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2107.41064453125,
        648.5309448242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -337.65106201171875,
        -2107.583984375,
        645.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2107.41064453125,
        648.5309448242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660598397254944,
        0.49994057416915894,
        -0.0
      ],
      "plane_d": 1355.305908203125,
      "bbox_min": [
        -349.0048828125,
        -2114.132568359375,
        645.9999389648438
      ],
      "bbox_max": [
        -344.554931640625,
        -2112.23388671875,
        651.2471923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999851882457733,
        0.8660340309143066,
        0.0
      ],
      "plane_d": 1656.46923828125,
      "bbox_min": [
        -349.0048828125,
        -2114.132568359375,
        645.9999389648438
      ],
      "bbox_max": [
        -345.604736328125,
        -2112.23388671875,
        647.5216064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112240076065,
        0.9704229831695557,
        0.0
      ],
      "plane_d": 1967.349365234375,
      "bbox_min": [
        -349.0048828125,
        -2114.132568359375,
        646.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2114.009765625,
        647.1196899414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -646.9999389648438,
      "bbox_min": [
        -349.0048828125,
        -2114.132568359375,
        646.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2114.009765625,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        0.5000061392784119,
        0.0
      ],
      "plane_d": 1397.33154296875,
      "bbox_min": [
        -379.841552734375,
        -2147.481689453125,
        640.0
      ],
      "bbox_max": [
        -363.5448913574219,
        -2128.060546875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.9999389648438,
      "bbox_min": [
        -379.32867431640625,
        -2147.481689453125,
        640.0
      ],
      "bbox_max": [
        -363.5448913574219,
        -2128.060546875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7709356546401978,
        -0.44509947299957275,
        -0.4555707275867462
      ],
      "plane_d": -932.5703735351562,
      "bbox_min": [
        -369.74945068359375,
        -2147.481689453125,
        662.3916015625
      ],
      "bbox_max": [
        -363.5448913574219,
        -2143.491455078125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7727664709091187,
        0.44615718722343445,
        -0.45141535997390747
      ],
      "plane_d": 1543.02392578125,
      "bbox_min": [
        -369.74945068359375,
        -2147.481689453125,
        663.162353515625
      ],
      "bbox_max": [
        -368.4404602050781,
        -2146.60888671875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6018846035003662,
        0.3474956154823303,
        -0.7190144658088684
      ],
      "plane_d": 1439.971923828125,
      "bbox_min": [
        -379.32867431640625,
        -2143.6884765625,
        640.0
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86605304479599,
        -0.49995216727256775,
        -0.0
      ],
      "plane_d": -1387.3282470703125,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        640.0
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        647.7724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86605304479599,
        0.49995216727256775,
        0.0
      ],
      "plane_d": 1393.328125,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        640.0
      ],
      "bbox_max": [
        -377.464111328125,
        -2131.060546875,
        647.1211547851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -645.9998779296875,
      "bbox_min": [
        -394.6380920410156,
        -2139.6162109375,
        639.9999389648438
      ],
      "bbox_max": [
        -337.65106201171875,
        -2106.3486328125,
        648.1759033203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.793363094329834,
        0.6087487936019897,
        0.0
      ],
      "plane_d": 1005.8189697265625,
      "bbox_min": [
        -394.6380920410156,
        -2139.6162109375,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2113.295166015625,
        645.5701293945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476871490479,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -394.6380920410156,
        -2139.6162109375,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2113.295166015625,
        642.0267944335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1305050551891327,
        0.9914476871490479,
        0.0
      ],
      "plane_d": 2069.815185546875,
      "bbox_min": [
        -394.6380920410156,
        -2139.6162109375,
        639.9999389648438
      ],
      "bbox_max": [
        -393.07666015625,
        -2139.41064453125,
        641.2273559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -338.2642822265625,
        -2107.41064453125,
        645.9999389648438
      ],
      "bbox_max": [
        -337.65106201171875,
        -2106.3486328125,
        648.1759033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -246.357421875,
        -2073.595458984375,
        645.012451171875
      ],
      "bbox_max": [
        -241.4340362548828,
        -2070.70849609375,
        646.2339477539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -246.357421875,
        -2073.595458984375,
        645.177001953125
      ],
      "bbox_max": [
        -242.68882751464844,
        -2070.70849609375,
        646.2339477539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -342.22515869140625,
        -2136.171142578125,
        667.9999389648438
      ],
      "bbox_max": [
        -318.2466735839844,
        -2120.220458984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -342.22515869140625,
        -2136.171142578125,
        667.9999389648438
      ],
      "bbox_max": [
        -318.2466735839844,
        -2120.220458984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -322.97540283203125,
        -2126.201904296875,
        667.9999389648438
      ],
      "bbox_max": [
        -318.2466735839844,
        -2120.220458984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -363.35614013671875,
        -2150.153564453125,
        655.7276611328125
      ],
      "bbox_max": [
        -301.4779357910156,
        -2092.2255859375,
        691.2015380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2629581093788147,
        0.5350224375724792,
        0.8028724193572998
      ],
      "plane_d": 510.412353515625,
      "bbox_min": [
        -363.35614013671875,
        -2150.153564453125,
        655.7276611328125
      ],
      "bbox_max": [
        -301.4779357910156,
        -2092.2255859375,
        680.5648193359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -363.35614013671875,
        -2150.153564453125,
        655.7276611328125
      ],
      "bbox_max": [
        -320.0271911621094,
        -2108.77880859375,
        680.5648193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -362.91778564453125,
        -2137.530517578125,
        655.7276611328125
      ],
      "bbox_max": [
        -320.0271911621094,
        -2108.77880859375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -362.91778564453125,
        -2137.530517578125,
        655.7276611328125
      ],
      "bbox_max": [
        -320.0271911621094,
        -2108.77880859375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -334.2977600097656,
        -2120.220458984375,
        655.7276611328125
      ],
      "bbox_max": [
        -322.97540283203125,
        -2108.77880859375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123877763748169,
        -0.35356274247169495,
        -0.707088828086853
      ],
      "plane_d": -486.1158142089844,
      "bbox_min": [
        -334.2977600097656,
        -2112.449951171875,
        656.2462158203125
      ],
      "bbox_max": [
        -333.3268737792969,
        -2109.992919921875,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35261744260787964,
        0.7099460363388062,
        0.6096206903457642
      ],
      "plane_d": 982.2940673828125,
      "bbox_min": [
        -362.8336181640625,
        -2137.530517578125,
        667.9999389648438
      ],
      "bbox_max": [
        -320.0271911621094,
        -2116.578857421875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -342.81622314453125,
        -2132.58642578125,
        667.9999389648438
      ],
      "bbox_max": [
        -320.0271911621094,
        -2118.36474609375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -342.81622314453125,
        -2132.58642578125,
        667.9999389648438
      ],
      "bbox_max": [
        -339.98004150390625,
        -2127.49072265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -343.5758361816406,
        -2130.181640625,
        667.9999389648438
      ],
      "bbox_max": [
        -322.56671142578125,
        -2116.578857421875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -343.5758361816406,
        -2130.181640625,
        667.9999389648438
      ],
      "bbox_max": [
        -341.31842041015625,
        -2126.1259765625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -361.8580322265625,
        -2136.80810546875,
        664.1937255859375
      ],
      "bbox_max": [
        -328.7745666503906,
        -2112.528076171875,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -329.0569152832031,
        -2112.88525390625,
        664.1937255859375
      ],
      "bbox_max": [
        -328.7745666503906,
        -2112.528076171875,
        664.5823364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -343.94171142578125,
        -2130.181640625,
        667.9999389648438
      ],
      "bbox_max": [
        -341.31842041015625,
        -2125.468505859375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -346.9906921386719,
        -2130.181640625,
        661.1591796875
      ],
      "bbox_max": [
        -301.4779357910156,
        -2092.2255859375,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -346.9906921386719,
        -2130.181640625,
        664.2921752929688
      ],
      "bbox_max": [
        -322.43695068359375,
        -2112.57177734375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -346.9906921386719,
        -2130.181640625,
        664.2921752929688
      ],
      "bbox_max": [
        -322.43695068359375,
        -2112.57177734375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -346.9906921386719,
        -2126.966796875,
        667.9999389648438
      ],
      "bbox_max": [
        -343.94171142578125,
        -2125.088623046875,
        667.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -279.2771301269531,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -246.357421875,
        -2058.64794921875,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -329.72320556640625,
        -2217.675048828125,
        639.9717407226562
      ],
      "bbox_max": [
        -127.98283386230469,
        -2000.7490234375,
        866.9991455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -156.26707458496094,
        -2019.826904296875,
        676.5550537109375
      ],
      "bbox_max": [
        -127.98283386230469,
        -2000.7490234375,
        689.8985595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -329.72320556640625,
        -2217.675048828125,
        639.9717407226562
      ],
      "bbox_max": [
        -150.82333374023438,
        -2024.114501953125,
        866.9991455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -266.4683837890625,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -220.62191772460938,
        -2028.4605712890625,
        645.9752807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -266.4683837890625,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -246.357421875,
        -2056.19580078125,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -329.72320556640625,
        -2217.675048828125,
        639.9717407226562
      ],
      "bbox_max": [
        -150.82333374023438,
        -2024.114501953125,
        866.9991455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -276.7945251464844,
        -2217.675048828125,
        861.0
      ],
      "bbox_max": [
        -205.43936157226562,
        -2181.5,
        866.9991455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8180076479911804,
        0.18297654390335083,
        0.5453283786773682
      ],
      "plane_d": -291.77178955078125,
      "bbox_min": [
        -276.7945251464844,
        -2217.675048828125,
        861.0
      ],
      "bbox_max": [
        -273.808837890625,
        -2210.028564453125,
        866.9991455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -276.7945251464844,
        -2216.75537109375,
        861.0
      ],
      "bbox_max": [
        -275.7684326171875,
        -2210.028564453125,
        863.6699829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -329.72320556640625,
        -2215.213134765625,
        644.8629150390625
      ],
      "bbox_max": [
        -210.04632568359375,
        -2070.70849609375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -305.860595703125,
        -2133.650634765625,
        644.8629150390625
      ],
      "bbox_max": [
        -240.29417419433594,
        -2070.70849609375,
        705.6890869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -305.860595703125,
        -2128.282470703125,
        677.6270751953125
      ],
      "bbox_max": [
        -298.57330322265625,
        -2121.553955078125,
        692.6574096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -246.357421875,
        -2071.70556640625,
        644.8629150390625
      ],
      "bbox_max": [
        -240.29417419433594,
        -2070.70849609375,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -305.860595703125,
        -2215.213134765625,
        677.8638305664062
      ],
      "bbox_max": [
        -210.04632568359375,
        -2121.553955078125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -305.860595703125,
        -2133.71826171875,
        677.8638305664062
      ],
      "bbox_max": [
        -294.1370849609375,
        -2121.553955078125,
        705.85302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -276.9884948730469,
        -2215.213134765625,
        820.6138916015625
      ],
      "bbox_max": [
        -210.04632568359375,
        -2179.60009765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -276.9884948730469,
        -2210.51708984375,
        820.6138916015625
      ],
      "bbox_max": [
        -210.04632568359375,
        -2179.60009765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -267.49652099609375,
        -2210.51708984375,
        857.0
      ],
      "bbox_max": [
        -210.04632568359375,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -113.74404907226562,
      "bbox_min": [
        -267.49652099609375,
        -2210.51708984375,
        857.0
      ],
      "bbox_max": [
        -265.8015441894531,
        -2200.732666015625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -276.9884948730469,
        -2207.967041015625,
        820.6138916015625
      ],
      "bbox_max": [
        -251.20370483398438,
        -2179.60009765625,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -9.649078369140625,
      "bbox_min": [
        -269.3399963378906,
        -2207.967041015625,
        820.6138916015625
      ],
      "bbox_max": [
        -251.20370483398438,
        -2179.60009765625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -269.24615478515625,
        -2181.5,
        822.250244140625
      ],
      "bbox_max": [
        -267.8680114746094,
        -2181.5,
        826.4645385742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -269.3399963378906,
        -2207.967041015625,
        820.6138916015625
      ],
      "bbox_max": [
        -251.20370483398438,
        -2179.60009765625,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9444968104362488,
        -0.0,
        0.32852062582969666
      ],
      "plane_d": -22.15460205078125,
      "bbox_min": [
        -269.1918640136719,
        -2187.879150390625,
        820.6138916015625
      ],
      "bbox_max": [
        -261.0785217285156,
        -2181.5,
        835.8590698242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -269.1918640136719,
        -2187.879150390625,
        820.6138916015625
      ],
      "bbox_max": [
        -262.04779052734375,
        -2181.5,
        821.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -262.10870361328125,
        -2184.3935546875,
        820.8248901367188
      ],
      "bbox_max": [
        -261.0785217285156,
        -2181.5,
        821.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -269.3399963378906,
        -2207.967041015625,
        820.8417358398438
      ],
      "bbox_max": [
        -256.1170654296875,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 441.2032470703125,
      "bbox_min": [
        -268.9704284667969,
        -2207.967041015625,
        820.8417358398438
      ],
      "bbox_max": [
        -256.1170654296875,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -261.4764099121094,
        -2184.11474609375,
        820.8417358398438
      ],
      "bbox_max": [
        -256.1170654296875,
        -2181.5,
        821.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -251.20370483398438,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -251.20370483398438,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -251.77947998046875,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -261.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -519.0640869140625,
        -2232.79736328125,
        635.0
      ],
      "bbox_max": [
        -133.99038696289062,
        -1920.0,
        866.7180786132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -294.5815734863281,
        -2212.589111328125,
        765.0
      ],
      "bbox_max": [
        -144.57403564453125,
        -1922.8343505859375,
        866.7180786132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -294.5815734863281,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -144.57403564453125,
        -1922.8343505859375,
        827.2785034179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -294.5815734863281,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1922.8343505859375,
        827.2785034179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -250.96910095214844,
        -1948.96728515625,
        765.0
      ],
      "bbox_max": [
        -245.4122314453125,
        -1947.1268310546875,
        768.314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -294.5815734863281,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1922.8343505859375,
        827.2785034179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1309.5618896484375,
      "bbox_min": [
        -294.5815734863281,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -2022.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -294.5815734863281,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -290.0,
        -2027.41845703125,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -170.0,
        -1944.15771484375,
        765.0
      ],
      "bbox_max": [
        -144.57403564453125,
        -1929.899169921875,
        825.8252563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -170.0,
        -1944.15771484375,
        765.0
      ],
      "bbox_max": [
        -156.3317413330078,
        -1934.9676513671875,
        781.1329956054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -275.79937744140625,
        -2212.589111328125,
        825.1123046875
      ],
      "bbox_max": [
        -228.59268188476562,
        -2179.60009765625,
        866.7180786132812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -275.79937744140625,
        -2212.589111328125,
        825.1123046875
      ],
      "bbox_max": [
        -236.746337890625,
        -2181.5,
        866.7180786132812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -275.79937744140625,
        -2212.589111328125,
        825.1123046875
      ],
      "bbox_max": [
        -236.746337890625,
        -2181.5,
        866.7180786132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8180076479911804,
        0.18297654390335083,
        0.5453283786773682
      ],
      "plane_d": -291.77178955078125,
      "bbox_min": [
        -275.79937744140625,
        -2212.589111328125,
        862.0
      ],
      "bbox_max": [
        -268.0,
        -2181.5,
        866.7180786132812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -275.4665832519531,
        -2203.78076171875,
        825.1123046875
      ],
      "bbox_max": [
        -236.746337890625,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -113.74404907226562,
      "bbox_min": [
        -266.32958984375,
        -2203.78076171875,
        857.0
      ],
      "bbox_max": [
        -263.5,
        -2187.44677734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -9.649078369140625,
      "bbox_min": [
        -275.4665832519531,
        -2200.732666015625,
        825.1123046875
      ],
      "bbox_max": [
        -263.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927337765693665,
        0.0,
        -0.12033136934041977
      ],
      "plane_d": 366.3939514160156,
      "bbox_min": [
        -275.4665832519531,
        -2193.83251953125,
        825.1123046875
      ],
      "bbox_max": [
        -264.28582763671875,
        -2181.5,
        856.0177001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390894770622253,
        0.19267703592777252,
        -0.2845814824104309
      ],
      "plane_d": 402.2903747558594,
      "bbox_min": [
        -275.4665832519531,
        -2193.83251953125,
        825.1123046875
      ],
      "bbox_max": [
        -269.24615478515625,
        -2181.5,
        837.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 741.12255859375,
      "bbox_min": [
        -267.5,
        -2187.44677734375,
        834.691162109375
      ],
      "bbox_max": [
        -264.28582763671875,
        -2181.5,
        856.0177001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 267.5,
      "bbox_min": [
        -267.5,
        -2187.44677734375,
        834.691162109375
      ],
      "bbox_max": [
        -266.870849609375,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9444968104362488,
        -0.0,
        0.32852062582969666
      ],
      "plane_d": -22.15460205078125,
      "bbox_min": [
        -267.5,
        -2186.3974609375,
        834.691162109375
      ],
      "bbox_max": [
        -266.870849609375,
        -2181.5,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 441.2032470703125,
      "bbox_min": [
        -267.8114929199219,
        -2200.732666015625,
        829.2872924804688
      ],
      "bbox_max": [
        -263.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 741.12255859375,
      "bbox_min": [
        -265.5,
        -2187.44677734375,
        854.5
      ],
      "bbox_max": [
        -263.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -375.0731201171875,
      "bbox_min": [
        -267.6134948730469,
        -2188.101806640625,
        835.8590698242188
      ],
      "bbox_max": [
        -267.2770690917969,
        -2187.44677734375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -267.8114929199219,
        -2189.244873046875,
        836.5
      ],
      "bbox_max": [
        -267.5,
        -2186.3974609375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 267.5,
      "bbox_min": [
        -267.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -267.5,
        -2186.3974609375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 249.0,
      "bbox_min": [
        -249.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -519.0640869140625,
        -2232.79736328125,
        635.0
      ],
      "bbox_max": [
        -133.99038696289062,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        675.0123901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        670.9380493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        665.296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -519.0640869140625,
        -2232.79736328125,
        635.0
      ],
      "bbox_max": [
        -133.99038696289062,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -2019.8985595703125,
        635.0
      ],
      "bbox_max": [
        -133.99038696289062,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -141.40330505371094,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -195.0,
        -1987.0,
        700.2202758789062
      ],
      "bbox_max": [
        -187.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -195.0,
        -1952.397216796875,
        754.0
      ],
      "bbox_max": [
        -187.0,
        -1920.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        700.2202758789062
      ],
      "bbox_max": [
        -187.0,
        -1951.765869140625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -195.0,
        -1987.0,
        700.2202758789062
      ],
      "bbox_max": [
        -187.0,
        -1979.346435546875,
        705.5827026367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -187.0,
        -1987.0,
        699.6279907226562
      ],
      "bbox_max": [
        -141.40330505371094,
        -1923.12744140625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -187.0,
        -1951.765869140625,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1923.12744140625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 184.0,
      "bbox_min": [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1924.322509765625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -187.0,
        -1987.0,
        699.6279907226562
      ],
      "bbox_max": [
        -141.40330505371094,
        -1945.2628173828125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 184.0,
      "bbox_min": [
        -187.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1945.2628173828125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -187.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -195.0,
        -2010.894287109375,
        683.0797119140625
      ],
      "bbox_max": [
        -133.99038696289062,
        -1987.0,
        700.32421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -195.0,
        -1990.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1987.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -519.0640869140625,
        -2232.79736328125,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -283.0,
        -1987.0,
        661.2224731445312
      ],
      "bbox_max": [
        -195.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        661.2224731445312
      ],
      "bbox_max": [
        -195.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        661.2224731445312
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        703.77734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        661.2224731445312
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        692.0352783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1952.3507080078125,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -198.0,
        -1952.164794921875,
        754.0
      ],
      "bbox_max": [
        -198.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -219.687744140625,
        -1986.3773193359375,
        700.760498046875
      ],
      "bbox_max": [
        -195.0,
        -1980.298828125,
        705.0193481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -519.0640869140625,
        -2232.79736328125,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1945.134521484375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -219.687744140625,
        -1988.702392578125,
        699.1314086914062
      ],
      "bbox_max": [
        -195.0,
        -1983.23779296875,
        703.2808227539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -519.0640869140625,
        -2232.79736328125,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1945.134521484375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -224.3616485595703,
        -1983.23779296875,
        703.2808227539062
      ],
      "bbox_max": [
        -195.0,
        -1945.134521484375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1952.634033203125,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1952.164794921875,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -198.0,
        -1954.02001953125,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1946.367919921875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1954.02001953125,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1952.397216796875,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -198.0,
        -1958.2298583984375,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1947.799072265625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1958.2298583984375,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1953.946044921875,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -519.0640869140625,
        -2232.79736328125,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1952.2310791015625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -416.1728515625,
        -2120.724853515625,
        639.28125
      ],
      "bbox_max": [
        -207.73861694335938,
        -2014.4228515625,
        650.3142700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -416.1728515625,
        -2120.724853515625,
        639.28125
      ],
      "bbox_max": [
        -214.79324340820312,
        -2023.7451171875,
        646.008056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05406983569264412,
        0.1127212643623352,
        0.9921544790267944
      ],
      "plane_d": -417.09210205078125,
      "bbox_min": [
        -380.9677734375,
        -2117.037841796875,
        639.28125
      ],
      "bbox_max": [
        -214.79324340820312,
        -2023.7451171875,
        646.008056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -359.504638671875,
        -2113.554443359375,
        639.9999389648438
      ],
      "bbox_max": [
        -337.2313537597656,
        -2096.781494140625,
        640.84716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476871490479,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -355.507568359375,
        -2113.554443359375,
        639.9999389648438
      ],
      "bbox_max": [
        -354.8399353027344,
        -2108.482421875,
        640.5779418945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -369.7836608886719,
        -2108.938232421875,
        639.9999389648438
      ],
      "bbox_max": [
        -214.79324340820312,
        -2023.7451171875,
        646.008056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -369.7836608886719,
        -2108.938232421875,
        639.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        641.7276000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -639.9998779296875,
      "bbox_min": [
        -369.7836608886719,
        -2108.938232421875,
        639.9999389648438
      ],
      "bbox_max": [
        -355.4948425292969,
        -2103.822265625,
        640.5810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -369.7836608886719,
        -2105.177978515625,
        639.9999389648438
      ],
      "bbox_max": [
        -367.435791015625,
        -2103.822265625,
        640.169189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087487936019897,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.20703125,
      "bbox_min": [
        -368.5411071777344,
        -2108.5791015625,
        639.9999389648438
      ],
      "bbox_max": [
        -355.4948425292969,
        -2104.755126953125,
        640.5810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        -0.8660230040550232,
        0.0
      ],
      "plane_d": -1640.2388916015625,
      "bbox_min": [
        -368.5411071777344,
        -2108.5791015625,
        639.9999389648438
      ],
      "bbox_max": [
        -355.4948425292969,
        -2105.55419921875,
        640.5810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476871490479,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -355.507568359375,
        -2108.5791015625,
        640.5662841796875
      ],
      "bbox_max": [
        -355.4948425292969,
        -2108.482421875,
        640.5810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -360.30859375,
        -2102.82275390625,
        639.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        641.7276000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -360.30859375,
        -2102.82275390625,
        639.9999389648438
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        641.6522827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -360.30859375,
        -2091.77294921875,
        639.9999389648438
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        641.6522827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2091.77294921875,
        639.9999389648438
      ],
      "bbox_max": [
        -357.18017578125,
        -2086.585205078125,
        641.346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        640.79150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -220.6219024658203,
        -2028.46044921875,
        645.5972290039062
      ],
      "bbox_max": [
        -214.79324340820312,
        -2023.7451171875,
        646.008056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -217.74951171875,
        -2024.864990234375,
        645.5972290039062
      ],
      "bbox_max": [
        -214.79324340820312,
        -2023.7451171875,
        646.008056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -416.1728515625,
        -2120.724853515625,
        639.28125
      ],
      "bbox_max": [
        -336.86126708984375,
        -2064.272216796875,
        642.3384399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05406983569264412,
        0.1127212643623352,
        0.9921544790267944
      ],
      "plane_d": -417.09210205078125,
      "bbox_min": [
        -383.708251953125,
        -2111.960693359375,
        639.28125
      ],
      "bbox_max": [
        -366.8480529785156,
        -2108.9384765625,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        -0.8660230040550232,
        0.0
      ],
      "plane_d": -1640.2388916015625,
      "bbox_min": [
        -374.1383361816406,
        -2113.751220703125,
        639.9999389648438
      ],
      "bbox_max": [
        -354.81402587890625,
        -2103.822265625,
        640.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -374.1383361816406,
        -2107.692138671875,
        639.9999389648438
      ],
      "bbox_max": [
        -367.435791015625,
        -2103.822265625,
        640.4285888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476871490479,
        0.0
      ],
      "plane_d": -2039.72509765625,
      "bbox_min": [
        -366.435791015625,
        -2113.751220703125,
        640.1516723632812
      ],
      "bbox_max": [
        -354.81402587890625,
        -2104.755126953125,
        640.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087487936019897,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.20703125,
      "bbox_min": [
        -360.365234375,
        -2113.751220703125,
        640.4176025390625
      ],
      "bbox_max": [
        -354.81402587890625,
        -2104.755126953125,
        640.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476871490479,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -355.507568359375,
        -2113.751220703125,
        640.4176025390625
      ],
      "bbox_max": [
        -354.81402587890625,
        -2108.482421875,
        640.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        640.5848999023438
      ],
      "bbox_max": [
        -345.68505859375,
        -2089.669677734375,
        641.8128662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -347.66058349609375,
        -2091.495361328125,
        641.7002563476562
      ],
      "bbox_max": [
        -345.68505859375,
        -2089.669677734375,
        641.8128662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -359.2350769042969,
        -2098.995361328125,
        640.79150390625
      ],
      "bbox_max": [
        -358.675537109375,
        -2096.520751953125,
        641.0206909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726341724395752,
        0.5366532206535339,
        0.7570648193359375
      ],
      "plane_d": 506.0691223144531,
      "bbox_min": [
        -386.3768615722656,
        -2112.560791015625,
        639.28125
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        642.3384399414062
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.05406983569264412,
        0.1127212643623352,
        0.9921544790267944
      ],
      "plane_d": -417.09210205078125,
      "bbox_min": [
        -384.4620666503906,
        -2111.99951171875,
        639.28125
      ],
      "bbox_max": [
        -380.9677734375,
        -2109.384765625,
        639.424560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -359.2350769042969,
        -2096.9013671875,
        640.859619140625
      ],
      "bbox_max": [
        -347.5388488769531,
        -2089.669677734375,
        641.7752685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -386.3768615722656,
        -2112.560791015625,
        639.28125
      ],
      "bbox_max": [
        -347.59619140625,
        -2086.4697265625,
        641.7741088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -360.30859375,
        -2096.72119140625,
        640.859619140625
      ],
      "bbox_max": [
        -347.59619140625,
        -2086.4697265625,
        641.7741088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -360.30859375,
        -2096.72119140625,
        640.859619140625
      ],
      "bbox_max": [
        -347.59619140625,
        -2086.4697265625,
        641.7741088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2089.729248046875,
        641.6522827148438
      ],
      "bbox_max": [
        -347.59619140625,
        -2086.4697265625,
        641.7741088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580712676048279,
        0.6098201870918274,
        0.7070391774177551
      ],
      "plane_d": 697.9349975585938,
      "bbox_min": [
        -386.3768615722656,
        -2112.560791015625,
        639.28125
      ],
      "bbox_max": [
        -380.7559814453125,
        -2109.384765625,
        639.6287231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -383.83221435546875,
        -2111.343994140625,
        639.28125
      ],
      "bbox_max": [
        -380.7559814453125,
        -2109.384765625,
        639.6287231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3261350691318512,
        0.5656665563583374,
        0.757401704788208
      ],
      "plane_d": 584.7686767578125,
      "bbox_min": [
        -383.73828125,
        -2111.20166015625,
        639.28125
      ],
      "bbox_max": [
        -380.7559814453125,
        -2109.384765625,
        639.6287231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -309.987548828125,
        -2066.27587890625,
        645.7384643554688
      ],
      "bbox_max": [
        -207.73861694335938,
        -2014.4228515625,
        650.3142700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -217.88108825683594,
        -2024.6243896484375,
        646.001708984375
      ],
      "bbox_max": [
        -207.73861694335938,
        -2020.9951171875,
        650.3142700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -217.74951171875,
        -2024.6243896484375,
        646.001708984375
      ],
      "bbox_max": [
        -213.13516235351562,
        -2023.7451171875,
        646.8789672851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -519.0640869140625,
        -2232.79736328125,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1952.2310791015625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -519.0640869140625,
        -2232.79736328125,
        639.28125
      ],
      "bbox_max": [
        -196.56898498535156,
        -2020.2633056640625,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        639.5712280273438
      ],
      "bbox_max": [
        -196.56898498535156,
        -2020.2633056640625,
        686.3023681640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.05406983569264412,
        0.1127212643623352,
        0.9921544790267944
      ],
      "plane_d": -417.09210205078125,
      "bbox_min": [
        -404.5234375,
        -2127.0107421875,
        639.5712280273438
      ],
      "bbox_max": [
        -371.88018798828125,
        -2111.352294921875,
        640.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000038743019104,
        0.8660233020782471,
        0.0
      ],
      "plane_d": 1656.2396240234375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -333.1905517578125,
        -2096.643798828125,
        659.3994750976562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -379.841552734375,
        -2137.623046875,
        643.0403442382812
      ],
      "bbox_max": [
        -333.1905517578125,
        -2107.410400390625,
        659.3994750976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123877763748169,
        -0.35356274247169495,
        -0.707088828086853
      ],
      "plane_d": -486.1158142089844,
      "bbox_min": [
        -335.894775390625,
        -2111.818603515625,
        652.5496826171875
      ],
      "bbox_max": [
        -333.1905517578125,
        -2108.052490234375,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660251498222351,
        -0.500000536441803,
        -0.0
      ],
      "plane_d": -1343.4207763671875,
      "bbox_min": [
        -334.162841796875,
        -2109.736572265625,
        652.5496826171875
      ],
      "bbox_max": [
        -333.1905517578125,
        -2108.052490234375,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112240076065,
        0.9704229831695557,
        0.0
      ],
      "plane_d": 1967.349365234375,
      "bbox_min": [
        -379.841552734375,
        -2137.623046875,
        643.0403442382812
      ],
      "bbox_max": [
        -337.551025390625,
        -2107.583984375,
        659.3994750976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 655.9999389648438,
      "bbox_min": [
        -345.07318115234375,
        -2114.052490234375,
        653.9999389648438
      ],
      "bbox_max": [
        -341.4305725097656,
        -2112.24853515625,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660598397254944,
        0.49994057416915894,
        -0.0
      ],
      "plane_d": 1355.305908203125,
      "bbox_min": [
        -345.07318115234375,
        -2114.052490234375,
        653.9999389648438
      ],
      "bbox_max": [
        -344.554931640625,
        -2113.15478515625,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86605304479599,
        0.49995216727256775,
        0.0
      ],
      "plane_d": 1393.328125,
      "bbox_min": [
        -379.841552734375,
        -2137.623046875,
        643.0403442382812
      ],
      "bbox_max": [
        -344.554931640625,
        -2113.15478515625,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6018846035003662,
        0.3474956154823303,
        -0.7190144658088684
      ],
      "plane_d": 1439.971923828125,
      "bbox_min": [
        -379.841552734375,
        -2137.623046875,
        650.2466430664062
      ],
      "bbox_max": [
        -377.1127624511719,
        -2134.00244140625,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        0.5000061392784119,
        0.0
      ],
      "plane_d": 1397.33154296875,
      "bbox_min": [
        -379.841552734375,
        -2137.623046875,
        650.2466430664062
      ],
      "bbox_max": [
        -379.32867431640625,
        -2136.734619140625,
        652.0665893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86605304479599,
        -0.49995216727256775,
        -0.0
      ],
      "plane_d": -1387.3282470703125,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        643.691650390625
      ],
      "bbox_max": [
        -344.554931640625,
        -2113.15478515625,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660598397254944,
        0.49994057416915894,
        -0.0
      ],
      "plane_d": 1355.305908203125,
      "bbox_min": [
        -367.717041015625,
        -2129.881103515625,
        649.4080810546875
      ],
      "bbox_max": [
        -344.554931640625,
        -2113.15478515625,
        653.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660219311714172,
        -0.5000061392784119,
        -0.0
      ],
      "plane_d": -1383.3314208984375,
      "bbox_min": [
        -367.717041015625,
        -2129.881103515625,
        651.766357421875
      ],
      "bbox_max": [
        -367.6324157714844,
        -2129.734619140625,
        652.0665893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 649.9999389648438,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        649.9999389648438
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        649.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999851882457733,
        0.8660340309143066,
        0.0
      ],
      "plane_d": 1656.46923828125,
      "bbox_min": [
        -349.51324462890625,
        -2114.259033203125,
        646.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2107.583984375,
        659.3994750976562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660598397254944,
        0.49994057416915894,
        -0.0
      ],
      "plane_d": 1355.305908203125,
      "bbox_min": [
        -345.604736328125,
        -2113.15478515625,
        647.5216064453125
      ],
      "bbox_max": [
        -339.35888671875,
        -2109.234130859375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 655.9999389648438,
      "bbox_min": [
        -345.604736328125,
        -2113.15478515625,
        655.9999389648438
      ],
      "bbox_max": [
        -339.35888671875,
        -2109.234130859375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -646.9999389648438,
      "bbox_min": [
        -349.51324462890625,
        -2114.259033203125,
        646.9999389648438
      ],
      "bbox_max": [
        -348.819091796875,
        -2113.868896484375,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -337.65118408203125,
        -2096.643798828125,
        659.1869506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1305050551891327,
        0.9914476871490479,
        0.0
      ],
      "plane_d": 2069.815185546875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -338.2642822265625,
        -2096.643798828125,
        658.900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087487936019897,
        0.793363094329834,
        0.0
      ],
      "plane_d": 1940.9437255859375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -338.2642822265625,
        -2096.643798828125,
        658.900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.0782470703125,
        -2137.482421875,
        639.9999389648438
      ],
      "bbox_max": [
        -405.737060546875,
        -2134.891357421875,
        649.1535034179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914476871490479,
        0.1305050551891327,
        0.0
      ],
      "plane_d": 679.3714599609375,
      "bbox_min": [
        -406.736328125,
        -2136.482421875,
        639.9999389648438
      ],
      "bbox_max": [
        -338.2642822265625,
        -2096.643798828125,
        658.900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        639.9999389648438
      ],
      "bbox_max": [
        -405.1450500488281,
        -2127.820556640625,
        641.7142333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476871490479,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -405.1450500488281,
        -2130.411865234375,
        639.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2100.23095703125,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476871490479,
        0.0
      ],
      "plane_d": -2039.72509765625,
      "bbox_min": [
        -405.1450500488281,
        -2130.411865234375,
        639.9999389648438
      ],
      "bbox_max": [
        -355.507568359375,
        -2100.23095703125,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -365.22308349609375,
        -2103.53076171875,
        640.5414428710938
      ],
      "bbox_max": [
        -359.0538635253906,
        -2100.23095703125,
        642.8467407226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        640.8154907226562
      ],
      "bbox_max": [
        -359.0538635253906,
        -2100.23095703125,
        642.8466186523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.8660218715667725,
        9.885159670375288e-06
      ],
      "plane_d": -1640.2420654296875,
      "bbox_min": [
        -405.1450500488281,
        -2130.411865234375,
        639.9999389648438
      ],
      "bbox_max": [
        -355.507568359375,
        -2104.755126953125,
        645.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -405.1450500488281,
        -2127.820556640625,
        639.9999389648438
      ],
      "bbox_max": [
        -375.095947265625,
        -2109.32568359375,
        641.4991455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -405.1450500488281,
        -2127.820556640625,
        639.9999389648438
      ],
      "bbox_max": [
        -391.3579406738281,
        -2119.150390625,
        641.11181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.07244873046875,
        -2120.05419921875,
        640.0
      ],
      "bbox_max": [
        -391.3579406738281,
        -2119.150390625,
        641.11181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087487936019897,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.20703125,
      "bbox_min": [
        -404.803955078125,
        -2130.411865234375,
        639.9999389648438
      ],
      "bbox_max": [
        -355.507568359375,
        -2104.755126953125,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.793363094329834,
        -0.6087487936019897,
        0.0
      ],
      "plane_d": -975.7291259765625,
      "bbox_min": [
        -404.803955078125,
        -2130.411865234375,
        639.9999389648438
      ],
      "bbox_max": [
        -401.07666015625,
        -2125.55419921875,
        643.2442626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112240076065,
        0.9704229831695557,
        0.0
      ],
      "plane_d": 1967.349365234375,
      "bbox_min": [
        -359.01434326171875,
        -2119.41064453125,
        645.9999389648438
      ],
      "bbox_max": [
        -348.83758544921875,
        -2102.363525390625,
        658.900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.793363094329834,
        0.6087487936019897,
        0.0
      ],
      "plane_d": 1005.8189697265625,
      "bbox_min": [
        -358.435791015625,
        -2119.41064453125,
        645.9999389648438
      ],
      "bbox_max": [
        -355.6556091308594,
        -2115.787353515625,
        658.6851196289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883978605270386,
        0.9659202694892883,
        -0.0
      ],
      "plane_d": 2134.30224609375,
      "bbox_min": [
        -359.01434326171875,
        -2115.787353515625,
        645.9999389648438
      ],
      "bbox_max": [
        -348.83758544921875,
        -2102.363525390625,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.793363094329834,
        0.6087487936019897,
        0.0
      ],
      "plane_d": 1005.8189697265625,
      "bbox_min": [
        -355.6556091308594,
        -2115.787353515625,
        645.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2114.552978515625,
        656.9193115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -649.599853515625,
      "bbox_min": [
        -359.01434326171875,
        -2115.07080078125,
        645.9999389648438
      ],
      "bbox_max": [
        -348.83758544921875,
        -2102.363525390625,
        657.1998901367188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6542752981185913,
        0.7562564611434937,
        0.0
      ],
      "plane_d": 1821.1064453125,
      "bbox_min": [
        -359.01434326171875,
        -2115.07080078125,
        645.9999389648438
      ],
      "bbox_max": [
        -348.83758544921875,
        -2102.363525390625,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -646.9999389648438,
      "bbox_min": [
        -359.01434326171875,
        -2115.07080078125,
        645.9999389648438
      ],
      "bbox_max": [
        -348.83758544921875,
        -2103.011962890625,
        649.5999145507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9914476871490479,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -359.01434326171875,
        -2114.552978515625,
        645.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2105.791748046875,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087487936019897,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.20703125,
      "bbox_min": [
        -359.01434326171875,
        -2108.482421875,
        645.9999389648438
      ],
      "bbox_max": [
        -355.507568359375,
        -2105.791748046875,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087487936019897,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.20703125,
      "bbox_min": [
        -358.2112731933594,
        -2114.552978515625,
        646.9999389648438
      ],
      "bbox_max": [
        -353.775390625,
        -2105.3818359375,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087978482246399,
        0.7933255434036255,
        0.0
      ],
      "plane_d": 1887.29736328125,
      "bbox_min": [
        -356.51251220703125,
        -2107.482421875,
        646.9999389648438
      ],
      "bbox_max": [
        -353.775390625,
        -2105.3818359375,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476871490479,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -355.507568359375,
        -2114.552978515625,
        646.9999389648438
      ],
      "bbox_max": [
        -354.70849609375,
        -2108.482421875,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.1998901367188,
      "bbox_min": [
        -353.59454345703125,
        -2115.07080078125,
        657.1998901367188
      ],
      "bbox_max": [
        -352.776123046875,
        -2114.40966796875,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -337.2130126953125,
        -2112.57177734375,
        645.7384643554688
      ],
      "bbox_max": [
        -196.56898498535156,
        -2020.2633056640625,
        664.2922973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -301.4779357910156,
        -2092.2255859375,
        645.7384643554688
      ],
      "bbox_max": [
        -201.66094970703125,
        -2021.447021484375,
        661.1591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -292.99835205078125,
        -2067.12646484375,
        645.7384643554688
      ],
      "bbox_max": [
        -201.66094970703125,
        -2021.447021484375,
        654.1831665039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -212.70021057128906,
        -2022.8599853515625,
        650.1068725585938
      ],
      "bbox_max": [
        -201.66094970703125,
        -2021.447021484375,
        654.1831665039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -337.2130126953125,
        -2112.57177734375,
        650.9353637695312
      ],
      "bbox_max": [
        -196.56898498535156,
        -2020.2633056640625,
        664.2922973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -210.8738555908203,
        -2021.757080078125,
        650.9353637695312
      ],
      "bbox_max": [
        -196.56898498535156,
        -2020.2633056640625,
        657.424560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        667.9998779296875
      ],
      "bbox_max": [
        -326.32373046875,
        -2112.11962890625,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -363.46234130859375,
        -2137.91748046875,
        667.9999389648438
      ],
      "bbox_max": [
        -326.32373046875,
        -2112.11962890625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -363.46234130859375,
        -2137.91748046875,
        667.9999389648438
      ],
      "bbox_max": [
        -326.32373046875,
        -2112.11962890625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -329.3799133300781,
        -2115.9853515625,
        667.9999389648438
      ],
      "bbox_max": [
        -326.32373046875,
        -2112.11962890625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35261744260787964,
        0.7099460363388062,
        0.6096206903457642
      ],
      "plane_d": 982.2940673828125,
      "bbox_min": [
        -363.46234130859375,
        -2137.91748046875,
        668.0
      ],
      "bbox_max": [
        -362.7071533203125,
        -2137.370361328125,
        668.1741943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -363.46234130859375,
        -2137.91748046875,
        668.0
      ],
      "bbox_max": [
        -362.8336181640625,
        -2137.530517578125,
        668.1741943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -519.0640869140625,
        -2202.2109375,
        639.28125
      ],
      "bbox_max": [
        -481.86572265625,
        -2172.58935546875,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -513.1190795898438,
        -2191.46484375,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1952.2310791015625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -513.1190795898438,
        -2191.46484375,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1952.2310791015625,
        765.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -432.43115234375,
        -2180.35791015625,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        686.3023681640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -432.43115234375,
        -2164.494384765625,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -299.1072692871094,
        -2066.11767578125,
        645.7384643554688
      ],
      "bbox_max": [
        -205.6908721923828,
        -2019.2060546875,
        653.2865600585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -297.43212890625,
        -2066.11767578125,
        645.7384643554688
      ],
      "bbox_max": [
        -205.6908721923828,
        -2019.2060546875,
        653.2865600585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -297.43212890625,
        -2066.11767578125,
        645.7384643554688
      ],
      "bbox_max": [
        -292.99835205078125,
        -2065.151123046875,
        646.0267333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -432.43115234375,
        -2164.494384765625,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580712676048279,
        0.6098201870918274,
        0.7070391774177551
      ],
      "plane_d": 697.9349975585938,
      "bbox_min": [
        -432.43115234375,
        -2164.494384765625,
        639.28125
      ],
      "bbox_max": [
        -337.551025390625,
        -2087.520751953125,
        667.9999389648438
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -406.736328125,
        -2152.732177734375,
        639.3878784179688
      ],
      "bbox_max": [
        -337.551025390625,
        -2095.707763671875,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05406983569264412,
        0.1127212643623352,
        0.9921544790267944
      ],
      "plane_d": -417.09210205078125,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.3878784179688
      ],
      "bbox_max": [
        -337.551025390625,
        -2095.707763671875,
        659.7159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.4366455078125
      ],
      "bbox_max": [
        -337.551025390625,
        -2095.707763671875,
        659.7159423828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -394.216796875,
        -2118.446533203125,
        639.4366455078125
      ],
      "bbox_max": [
        -375.3216247558594,
        -2106.90283203125,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3261350691318512,
        0.5656665563583374,
        0.757401704788208
      ],
      "plane_d": 584.7686767578125,
      "bbox_min": [
        -393.1123962402344,
        -2117.34912109375,
        639.4451904296875
      ],
      "bbox_max": [
        -375.3216247558594,
        -2106.90283203125,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726298213005066,
        0.536638617515564,
        0.7570772171020508
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -380.7559814453125,
        -2110.094482421875,
        639.6287231445312
      ],
      "bbox_max": [
        -375.3216247558594,
        -2106.90283203125,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2591370642185211,
        0.32625335454940796,
        0.9090691208839417
      ],
      "plane_d": 8.32012939453125,
      "bbox_min": [
        -376.5368957519531,
        -2107.5634765625,
        639.890625
      ],
      "bbox_max": [
        -375.3216247558594,
        -2106.90283203125,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999973177909851,
        0.8660269379615784,
        0.0
      ],
      "plane_d": 1656.249755859375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -337.551025390625,
        -2095.707763671875,
        659.7159423828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4999948740005493,
        0.866028368473053,
        -1.6667267118464224e-05
      ],
      "plane_d": 1656.46484375,
      "bbox_min": [
        -349.5128479003906,
        -2114.259033203125,
        658.9005126953125
      ],
      "bbox_max": [
        -337.551025390625,
        -2107.583984375,
        659.7159423828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2414112240076065,
        0.9704229831695557,
        0.0
      ],
      "plane_d": 1967.349365234375,
      "bbox_min": [
        -349.5128479003906,
        -2114.259033203125,
        658.9005126953125
      ],
      "bbox_max": [
        -348.809326171875,
        -2114.083984375,
        659.6204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -343.86737060546875,
        -2095.707763671875,
        659.4151000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -406.736328125,
        -2134.375732421875,
        639.9999389648438
      ],
      "bbox_max": [
        -343.86737060546875,
        -2096.488525390625,
        646.5729370117188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2134.375732421875,
        639.9999389648438
      ],
      "bbox_max": [
        -343.86737060546875,
        -2096.488525390625,
        646.5729370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476871490479,
        0.0
      ],
      "plane_d": -2039.72509765625,
      "bbox_min": [
        -406.736328125,
        -2134.375732421875,
        640.0
      ],
      "bbox_max": [
        -343.86737060546875,
        -2096.488525390625,
        646.5729370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.9999389648438,
      "bbox_min": [
        -367.435791015625,
        -2103.822265625,
        640.4286499023438
      ],
      "bbox_max": [
        -343.86737060546875,
        -2096.488525390625,
        646.5729370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -367.435791015625,
        -2103.822265625,
        640.4286499023438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        643.67578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        640.9283447265625
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        643.67578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        640.9821166992188
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        641.4857788085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6542752981185913,
        0.7562564611434937,
        0.0
      ],
      "plane_d": 1821.1064453125,
      "bbox_min": [
        -353.46258544921875,
        -2102.735107421875,
        645.9999389648438
      ],
      "bbox_max": [
        -352.90869140625,
        -2102.255859375,
        646.5729370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.8660218715667725,
        9.885159670375288e-06
      ],
      "plane_d": -1640.2420654296875,
      "bbox_min": [
        -406.736328125,
        -2134.375732421875,
        640.0
      ],
      "bbox_max": [
        -358.593505859375,
        -2104.755126953125,
        646.5239868164062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -392.550537109375,
        -2119.943115234375,
        640.0
      ],
      "bbox_max": [
        -375.3231506347656,
        -2108.822265625,
        642.5989379882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.550537109375,
        -2119.943115234375,
        640.0
      ],
      "bbox_max": [
        -391.15643310546875,
        -2118.259765625,
        642.2750854492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2134.375732421875,
        640.8773193359375
      ],
      "bbox_max": [
        -358.593505859375,
        -2104.755126953125,
        646.5239868164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914476871490479,
        0.1305050551891327,
        0.0
      ],
      "plane_d": 679.3714599609375,
      "bbox_min": [
        -404.803955078125,
        -2133.34912109375,
        643.2442626953125
      ],
      "bbox_max": [
        -358.593505859375,
        -2104.755126953125,
        646.5239868164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087487936019897,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.20703125,
      "bbox_min": [
        -360.365234375,
        -2106.114501953125,
        644.3177490234375
      ],
      "bbox_max": [
        -358.593505859375,
        -2104.755126953125,
        646.5239868164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530882596969604,
        -0.49248817563056946,
        -0.17232513427734375
      ],
      "plane_d": -1249.125,
      "bbox_min": [
        -392.9296875,
        -2118.322265625,
        639.9999389648438
      ],
      "bbox_max": [
        -358.7217712402344,
        -2098.379638671875,
        641.322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.8147888183594,
        -2098.790771484375,
        640.9859008789062
      ],
      "bbox_max": [
        -358.7217712402344,
        -2098.379638671875,
        641.322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -343.95709228515625,
        -2095.707763671875,
        659.4151000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -343.95709228515625,
        -2095.707763671875,
        659.4151000976562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6087487936019897,
        0.793363094329834,
        0.0
      ],
      "plane_d": 1940.9437255859375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        640.4264526367188
      ],
      "bbox_max": [
        -343.95709228515625,
        -2095.707763671875,
        659.4151000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        640.4264526367188
      ],
      "bbox_max": [
        -343.95709228515625,
        -2095.707763671875,
        659.4151000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914476871490479,
        0.1305050551891327,
        0.0
      ],
      "plane_d": 679.3714599609375,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        640.6255493164062
      ],
      "bbox_max": [
        -343.95709228515625,
        -2095.707763671875,
        659.4151000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -404.803955078125,
        -2130.411865234375,
        640.6255493164062
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.8660218715667725,
        9.885159670375288e-06
      ],
      "plane_d": -1640.2420654296875,
      "bbox_min": [
        -404.803955078125,
        -2130.411865234375,
        640.6255493164062
      ],
      "bbox_max": [
        -359.13616943359375,
        -2104.755126953125,
        645.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.44219970703125,
        -2119.826904296875,
        640.6255493164062
      ],
      "bbox_max": [
        -375.48980712890625,
        -2108.90625,
        643.2591552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -376.2871398925781,
        -2110.83935546875,
        640.96044921875
      ],
      "bbox_max": [
        -375.48980712890625,
        -2108.90625,
        643.2591552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.793363094329834,
        -0.6087487936019897,
        0.0
      ],
      "plane_d": -975.7291259765625,
      "bbox_min": [
        -404.803955078125,
        -2130.411865234375,
        642.070068359375
      ],
      "bbox_max": [
        -359.13616943359375,
        -2104.755126953125,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476871490479,
        0.0
      ],
      "plane_d": -2039.72509765625,
      "bbox_min": [
        -366.435791015625,
        -2105.6982421875,
        642.7860107421875
      ],
      "bbox_max": [
        -359.13616943359375,
        -2104.755126953125,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087487936019897,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.20703125,
      "bbox_min": [
        -360.365234375,
        -2105.6982421875,
        644.81298828125
      ],
      "bbox_max": [
        -359.13616943359375,
        -2104.755126953125,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        641.322265625
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        644.3175048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        641.322265625
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        641.6099853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.793363094329834,
        0.6087487936019897,
        0.0
      ],
      "plane_d": 1005.8189697265625,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        645.9999389648438
      ],
      "bbox_max": [
        -349.5128479003906,
        -2101.522216796875,
        659.4151000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112240076065,
        0.9704229831695557,
        0.0
      ],
      "plane_d": 1967.349365234375,
      "bbox_min": [
        -354.70849609375,
        -2115.07080078125,
        656.3178100585938
      ],
      "bbox_max": [
        -349.5128479003906,
        -2113.711669921875,
        659.4151000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.1998901367188,
      "bbox_min": [
        -354.70849609375,
        -2114.8515625,
        656.3178100585938
      ],
      "bbox_max": [
        -352.8631591796875,
        -2113.711669921875,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883978605270386,
        0.9659202694892883,
        -0.0
      ],
      "plane_d": 2134.30224609375,
      "bbox_min": [
        -354.70849609375,
        -2114.8515625,
        656.3178100585938
      ],
      "bbox_max": [
        -353.59454345703125,
        -2114.552978515625,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1305050551891327,
        0.9914476871490479,
        0.0
      ],
      "plane_d": 2069.815185546875,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        645.9999389648438
      ],
      "bbox_max": [
        -352.588623046875,
        -2101.522216796875,
        659.0458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087487936019897,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.20703125,
      "bbox_min": [
        -360.12744140625,
        -2108.010009765625,
        645.9999389648438
      ],
      "bbox_max": [
        -352.588623046875,
        -2101.522216796875,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6542752981185913,
        0.7562564611434937,
        0.0
      ],
      "plane_d": 1821.1064453125,
      "bbox_min": [
        -354.3105773925781,
        -2103.011962890625,
        645.9999389648438
      ],
      "bbox_max": [
        -352.5886535644531,
        -2101.522216796875,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087978482246399,
        0.7933255434036255,
        0.0
      ],
      "plane_d": 1887.29736328125,
      "bbox_min": [
        -357.55133056640625,
        -2108.010009765625,
        646.9999389648438
      ],
      "bbox_max": [
        -354.4248046875,
        -2104.584716796875,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -649.599853515625,
      "bbox_min": [
        -357.0457763671875,
        -2108.010009765625,
        649.5999145507812
      ],
      "bbox_max": [
        -354.4248046875,
        -2106.29248046875,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2591370642185211,
        0.32625335454940796,
        0.9090691208839417
      ],
      "plane_d": 8.32012939453125,
      "bbox_min": [
        -393.1123962402344,
        -2118.259765625,
        639.9999389648438
      ],
      "bbox_max": [
        -358.7217712402344,
        -2098.36474609375,
        641.41015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.8181457519531,
        -2098.790771484375,
        640.9934692382812
      ],
      "bbox_max": [
        -358.7217712402344,
        -2098.36474609375,
        641.41015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530882596969604,
        -0.49248817563056946,
        -0.17232513427734375
      ],
      "plane_d": -1249.125,
      "bbox_min": [
        -393.1123962402344,
        -2118.259765625,
        639.9999389648438
      ],
      "bbox_max": [
        -376.241455078125,
        -2107.728271484375,
        641.2645263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492053747177124,
        0.4903010427951813,
        -0.19610005617141724
      ],
      "plane_d": 1497.4755859375,
      "bbox_min": [
        -393.1123962402344,
        -2118.259765625,
        640.0
      ],
      "bbox_max": [
        -392.3555908203125,
        -2117.34912109375,
        641.1256103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26082277297973633,
        0.6026551723480225,
        0.7541738748550415
      ],
      "plane_d": 689.7371826171875,
      "bbox_min": [
        -398.08636474609375,
        -2152.732177734375,
        666.561279296875
      ],
      "bbox_max": [
        -396.3149719238281,
        -2150.560791015625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2591370642185211,
        0.32625335454940796,
        0.9090691208839417
      ],
      "plane_d": 8.32012939453125,
      "bbox_min": [
        -406.736328125,
        -2151.768798828125,
        639.6744995117188
      ],
      "bbox_max": [
        -337.551025390625,
        -2087.520751953125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -359.1490173339844,
        -2099.67724609375,
        640.9937133789062
      ],
      "bbox_max": [
        -345.68505859375,
        -2089.7822265625,
        642.9185180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -358.88433837890625,
        -2099.67724609375,
        641.6099853515625
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        642.0924072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -406.736328125,
        -2151.768798828125,
        639.6744995117188
      ],
      "bbox_max": [
        -337.551025390625,
        -2087.520751953125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.6744995117188
      ],
      "bbox_max": [
        -337.551025390625,
        -2087.520751953125,
        664.5289916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -348.1603698730469,
        -2096.264892578125,
        641.7626953125
      ],
      "bbox_max": [
        -341.914306640625,
        -2089.207763671875,
        649.2033081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -347.5960388183594,
        -2091.495361328125,
        641.774169921875
      ],
      "bbox_max": [
        -345.68505859375,
        -2089.729248046875,
        643.966552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -348.1603698730469,
        -2091.495361328125,
        641.7626953125
      ],
      "bbox_max": [
        -345.68505859375,
        -2089.207763671875,
        647.4327392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 663.9998779296875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.6744995117188
      ],
      "bbox_max": [
        -337.551025390625,
        -2087.520751953125,
        664.5289916992188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2414112240076065,
        0.9704229831695557,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -350.3255920410156,
        -2114.461181640625,
        663.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2113.50048828125,
        664.5289916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914959073066711,
        -0.13013865053653717,
        -0.0
      ],
      "plane_d": -620.967041015625,
      "bbox_min": [
        -348.8858947753906,
        -2114.083984375,
        663.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2113.50048828125,
        664.5289916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999973177909851,
        0.8660269379615784,
        0.0
      ],
      "plane_d": 1656.249755859375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.6744995117188
      ],
      "bbox_max": [
        -337.551025390625,
        -2087.520751953125,
        663.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4999948740005493,
        0.866028368473053,
        -1.6667267118464224e-05
      ],
      "plane_d": 1656.46484375,
      "bbox_min": [
        -349.5128479003906,
        -2114.259033203125,
        659.4151000976562
      ],
      "bbox_max": [
        -337.551025390625,
        -2107.583984375,
        663.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2414112240076065,
        0.9704229831695557,
        0.0
      ],
      "plane_d": 1967.349365234375,
      "bbox_min": [
        -349.5128479003906,
        -2114.259033203125,
        659.4151000976562
      ],
      "bbox_max": [
        -348.809326171875,
        -2114.083984375,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3123513460159302,
        0.5410122871398926,
        -0.7808600068092346
      ],
      "plane_d": 1550.036865234375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.6744995117188
      ],
      "bbox_max": [
        -344.4078369140625,
        -2087.520751953125,
        663.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2414112240076065,
        0.9704229831695557,
        0.0
      ],
      "plane_d": 1967.349365234375,
      "bbox_min": [
        -352.776123046875,
        -2115.07080078125,
        659.9999389648438
      ],
      "bbox_max": [
        -349.51275634765625,
        -2114.259033203125,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.6744995117188
      ],
      "bbox_max": [
        -344.4078369140625,
        -2087.520751953125,
        661.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914476871490479,
        0.1305050551891327,
        0.0
      ],
      "plane_d": 679.3714599609375,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        639.6744995117188
      ],
      "bbox_max": [
        -344.4078369140625,
        -2087.520751953125,
        661.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        639.6744995117188
      ],
      "bbox_max": [
        -344.4078369140625,
        -2087.520751953125,
        661.5947875976562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.793363094329834,
        -0.6087487936019897,
        0.0
      ],
      "plane_d": -975.7291259765625,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        641.12548828125
      ],
      "bbox_max": [
        -344.4078369140625,
        -2091.995361328125,
        661.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1305050551891327,
        0.9914476871490479,
        0.0
      ],
      "plane_d": 2069.815185546875,
      "bbox_min": [
        -401.07666015625,
        -2140.209716796875,
        641.12548828125
      ],
      "bbox_max": [
        -344.4078369140625,
        -2091.995361328125,
        661.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6542752981185913,
        0.7562564611434937,
        0.0
      ],
      "plane_d": 1821.1064453125,
      "bbox_min": [
        -401.07666015625,
        -2139.71044921875,
        641.12548828125
      ],
      "bbox_max": [
        -344.4078369140625,
        -2091.995361328125,
        661.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -401.07666015625,
        -2139.71044921875,
        641.12548828125
      ],
      "bbox_max": [
        -349.5128479003906,
        -2098.790771484375,
        661.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.8660218715667725,
        9.885159670375288e-06
      ],
      "plane_d": -1640.2420654296875,
      "bbox_min": [
        -401.07666015625,
        -2139.71044921875,
        641.12548828125
      ],
      "bbox_max": [
        -349.5128479003906,
        -2102.01806640625,
        661.5947875976562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -392.3555908203125,
        -2119.741455078125,
        641.12548828125
      ],
      "bbox_max": [
        -375.5898742675781,
        -2108.9326171875,
        646.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.3555908203125,
        -2119.741455078125,
        641.12548828125
      ],
      "bbox_max": [
        -390.5455017089844,
        -2117.94482421875,
        645.802001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087978482246399,
        0.7933255434036255,
        0.0
      ],
      "plane_d": 1887.29736328125,
      "bbox_min": [
        -395.35418701171875,
        -2139.71044921875,
        643.3367309570312
      ],
      "bbox_max": [
        -349.5128479003906,
        -2102.01806640625,
        661.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476871490479,
        0.0
      ],
      "plane_d": -2039.72509765625,
      "bbox_min": [
        -395.35418701171875,
        -2139.71044921875,
        643.3367309570312
      ],
      "bbox_max": [
        -349.5128479003906,
        -2103.208984375,
        661.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -649.599853515625,
      "bbox_min": [
        -360.365234375,
        -2104.755126953125,
        649.5999145507812
      ],
      "bbox_max": [
        -357.7739562988281,
        -2103.208984375,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087487936019897,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.20703125,
      "bbox_min": [
        -360.365234375,
        -2107.30224609375,
        645.72216796875
      ],
      "bbox_max": [
        -357.0457763671875,
        -2104.755126953125,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914476871490479,
        -0.1305050551891327,
        -0.0
      ],
      "plane_d": -627.634765625,
      "bbox_min": [
        -395.35418701171875,
        -2139.71044921875,
        657.0374145507812
      ],
      "bbox_max": [
        -349.5128479003906,
        -2108.516845703125,
        661.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.1998901367188,
      "bbox_min": [
        -355.3525390625,
        -2115.07080078125,
        657.0374145507812
      ],
      "bbox_max": [
        -349.5128479003906,
        -2108.516845703125,
        660.7428588867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112240076065,
        0.9704229831695557,
        0.0
      ],
      "plane_d": 1967.349365234375,
      "bbox_min": [
        -352.776123046875,
        -2115.07080078125,
        658.4627075195312
      ],
      "bbox_max": [
        -349.5128479003906,
        -2114.259033203125,
        660.7428588867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883978605270386,
        0.9659202694892883,
        -0.0
      ],
      "plane_d": 2134.30224609375,
      "bbox_min": [
        -354.70849609375,
        -2114.612060546875,
        657.0374145507812
      ],
      "bbox_max": [
        -354.48822021484375,
        -2114.552978515625,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.793363094329834,
        0.6087487936019897,
        0.0
      ],
      "plane_d": 1005.8189697265625,
      "bbox_min": [
        -395.35418701171875,
        -2139.71044921875,
        657.0374145507812
      ],
      "bbox_max": [
        -354.70849609375,
        -2112.7470703125,
        661.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4956435561180115,
        0.3802884817123413,
        -0.7808444499969482
      ],
      "plane_d": 1143.6883544921875,
      "bbox_min": [
        -395.35418701171875,
        -2139.71044921875,
        659.9998168945312
      ],
      "bbox_max": [
        -354.70849609375,
        -2112.7470703125,
        661.5947875976562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.08152861893177032,
        0.6193733811378479,
        -0.7808519601821899
      ],
      "plane_d": 1808.4093017578125,
      "bbox_min": [
        -395.35418701171875,
        -2139.71044921875,
        659.9998168945312
      ],
      "bbox_max": [
        -354.70849609375,
        -2112.7470703125,
        660.8111572265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6193848252296448,
        -0.0815301239490509,
        -0.780842661857605
      ],
      "plane_d": 123.25521850585938,
      "bbox_min": [
        -355.7687072753906,
        -2114.552978515625,
        659.9998168945312
      ],
      "bbox_max": [
        -354.70849609375,
        -2112.7470703125,
        660.8111572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -646.9998779296875,
      "bbox_min": [
        -359.847412109375,
        -2104.584716796875,
        646.9999389648438
      ],
      "bbox_max": [
        -353.51214599609375,
        -2102.01806640625,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -367.435791015625,
        -2103.822265625,
        641.8206787109375
      ],
      "bbox_max": [
        -353.7373352050781,
        -2098.790771484375,
        648.9978637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        641.8206787109375
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        642.8890380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        642.72119140625
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        646.4585571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.9999389648438,
      "bbox_min": [
        -357.809326171875,
        -2101.522216796875,
        645.9999389648438
      ],
      "bbox_max": [
        -344.4078369140625,
        -2091.995361328125,
        645.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37262701988220215,
        0.5366407632827759,
        0.7570772171020508
      ],
      "plane_d": 506.0376281738281,
      "bbox_min": [
        -380.0483703613281,
        -2109.301025390625,
        639.6744995117188
      ],
      "bbox_max": [
        -348.1603088378906,
        -2087.520751953125,
        646.2623291015625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.8530882596969604,
        -0.49248817563056946,
        -0.17232513427734375
      ],
      "plane_d": -1249.125,
      "bbox_min": [
        -376.84039306640625,
        -2108.932861328125,
        639.9999389648438
      ],
      "bbox_max": [
        -376.28753662109375,
        -2107.53271484375,
        641.2645263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -359.94158935546875,
        -2098.790771484375,
        641.0239868164062
      ],
      "bbox_max": [
        -348.1603088378906,
        -2087.520751953125,
        646.2623291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -349.9858703613281,
        -2089.207763671875,
        641.7257080078125
      ],
      "bbox_max": [
        -348.1603088378906,
        -2087.520751953125,
        644.1481323242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -347.24755859375,
        -2102.21142578125,
        641.796630859375
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        666.7268676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -347.24755859375,
        -2092.7470703125,
        641.796630859375
      ],
      "bbox_max": [
        -293.27459716796875,
        -2065.151123046875,
        652.1085205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -347.24755859375,
        -2092.7470703125,
        641.796630859375
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        645.3406982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2591370642185211,
        0.32625335454940796,
        0.9090691208839417
      ],
      "plane_d": 8.32012939453125,
      "bbox_min": [
        -347.20257568359375,
        -2089.92529296875,
        641.797119140625
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        642.3384399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -344.69561767578125,
        -2102.21142578125,
        642.3384399414062
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        666.7268676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -344.69561767578125,
        -2102.21142578125,
        642.3384399414062
      ],
      "bbox_max": [
        -329.42010498046875,
        -2084.468994140625,
        654.705810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -344.69561767578125,
        -2096.264892578125,
        642.3384399414062
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        649.2033081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -418.117919921875,
        -2180.35791015625,
        667.9998779296875
      ],
      "bbox_max": [
        -327.02294921875,
        -2107.64306640625,
        686.3023681640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -348.1908264160156,
        -2125.3564453125,
        667.9999389648438
      ],
      "bbox_max": [
        -344.00396728515625,
        -2117.833984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -460.3519287109375,
        -2150.557373046875,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1952.2310791015625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -309.987548828125,
        -2058.383056640625,
        645.7384643554688
      ],
      "bbox_max": [
        -287.60015869140625,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -460.3519287109375,
        -2150.557373046875,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1952.2310791015625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.4019775390625,
        -1987.0,
        691.2601318359375
      ],
      "bbox_max": [
        -195.0,
        -1952.2310791015625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.4019775390625,
        -1987.0,
        691.2601318359375
      ],
      "bbox_max": [
        -275.0,
        -1971.8126220703125,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -275.0,
        -1971.8126220703125,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -283.4019775390625,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -283.0,
        -1986.2734375,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -275.0,
        -1987.0,
        697.9608764648438
      ],
      "bbox_max": [
        -195.0,
        -1952.2310791015625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1958.0234375,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -275.0,
        -1987.0,
        697.9608764648438
      ],
      "bbox_max": [
        -202.6909942626953,
        -1966.3897705078125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -275.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1966.3897705078125,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -219.687744140625,
        -1987.0,
        697.9608764648438
      ],
      "bbox_max": [
        -202.6909942626953,
        -1983.23779296875,
        703.2808227539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -219.687744140625,
        -1987.0,
        697.9608764648438
      ],
      "bbox_max": [
        -211.06044006347656,
        -1983.23779296875,
        703.2808227539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -460.3519287109375,
        -2150.557373046875,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        641.0853271484375
      ],
      "bbox_max": [
        -195.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -211.06044006347656,
        -1994.003662109375,
        695.4171142578125
      ],
      "bbox_max": [
        -195.0,
        -1987.0,
        700.5327758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        641.0853271484375
      ],
      "bbox_max": [
        -195.0,
        -1987.0,
        765.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        641.0853271484375
      ],
      "bbox_max": [
        -332.9189147949219,
        -2086.4697265625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 663.9999389648438,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        641.0853271484375
      ],
      "bbox_max": [
        -338.2374267578125,
        -2086.4697265625,
        667.9999389648438
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        0.8660248517990112,
        4.552165592031088e-06
      ],
      "plane_d": 1638.2412109375,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        663.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        667.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        663.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2091.353271484375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -345.8387451171875,
        -2091.495361328125,
        664.0
      ],
      "bbox_max": [
        -345.68505859375,
        -2091.353271484375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -367.435791015625,
        -2115.07080078125,
        663.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2098.495361328125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.141819433949422e-06,
        -1.262466139451135e-05,
        -1.0
      ],
      "plane_d": 665.9722900390625,
      "bbox_min": [
        -359.847412109375,
        -2115.07080078125,
        663.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2098.495361328125,
        665.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6087978482246399,
        0.7933255434036255,
        0.0
      ],
      "plane_d": 1887.29736328125,
      "bbox_min": [
        -359.847412109375,
        -2115.07080078125,
        663.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2102.82275390625,
        665.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2414112240076065,
        0.9704229831695557,
        0.0
      ],
      "plane_d": 1967.34912109375,
      "bbox_min": [
        -352.776123046875,
        -2115.07080078125,
        663.9999389648438
      ],
      "bbox_max": [
        -348.809326171875,
        -2114.083984375,
        665.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -367.435791015625,
        -2103.822265625,
        664.0
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.79150390625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7216491699219,
        -2098.995361328125,
        664.0
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.79150390625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -360.30859375,
        -2098.79150390625,
        664.0
      ],
      "bbox_max": [
        -345.8387451171875,
        -2086.4697265625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -357.18017578125,
        -2086.585205078125,
        664.0
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -406.736328125,
        -2147.21240234375,
        641.0853271484375
      ],
      "bbox_max": [
        -338.2374267578125,
        -2086.4697265625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660277724266052,
        -0.49999603629112244,
        -0.0
      ],
      "plane_d": -1346.1121826171875,
      "bbox_min": [
        -406.736328125,
        -2147.21240234375,
        641.0853271484375
      ],
      "bbox_max": [
        -338.2374267578125,
        -2086.4697265625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -348.1603088378906,
        -2091.495361328125,
        644.1481323242188
      ],
      "bbox_max": [
        -345.68505859375,
        -2089.207763671875,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -406.736328125,
        -2147.21240234375,
        641.0853271484375
      ],
      "bbox_max": [
        -346.551025390625,
        -2086.4697265625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -406.736328125,
        -2147.21240234375,
        641.0853271484375
      ],
      "bbox_max": [
        -346.551025390625,
        -2086.585205078125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -406.736328125,
        -2147.21240234375,
        643.0118408203125
      ],
      "bbox_max": [
        -350.3255920410156,
        -2102.82275390625,
        664.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2147.21240234375,
        643.775146484375
      ],
      "bbox_max": [
        -350.3255920410156,
        -2102.82275390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3123505115509033,
        -0.5410104990005493,
        -0.7808616161346436
      ],
      "plane_d": -509.30206298828125,
      "bbox_min": [
        -405.737060546875,
        -2147.21240234375,
        643.775146484375
      ],
      "bbox_max": [
        -350.3255920410156,
        -2102.82275390625,
        664.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6087978482246399,
        0.7933255434036255,
        0.0
      ],
      "plane_d": 1887.29736328125,
      "bbox_min": [
        -359.847412109375,
        -2105.505615234375,
        660.74267578125
      ],
      "bbox_max": [
        -356.3513488769531,
        -2102.82275390625,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.8660218715667725,
        9.885159670375288e-06
      ],
      "plane_d": -1640.2420654296875,
      "bbox_min": [
        -405.737060546875,
        -2147.21240234375,
        643.775146484375
      ],
      "bbox_max": [
        -350.3255920410156,
        -2102.82275390625,
        664.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 655.9999389648438,
      "bbox_min": [
        -391.8966064453125,
        -2119.47412109375,
        643.775146484375
      ],
      "bbox_max": [
        -376.1389465332031,
        -2109.25146484375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -391.8966064453125,
        -2119.47412109375,
        643.775146484375
      ],
      "bbox_max": [
        -376.1389465332031,
        -2109.25146484375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8530478477478027,
        -0.49254071712493896,
        -0.17237460613250732
      ],
      "plane_d": -1249.1888427734375,
      "bbox_min": [
        -378.520751953125,
        -2111.9541015625,
        644.9042358398438
      ],
      "bbox_max": [
        -376.1389465332031,
        -2109.25146484375,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8382329940795898,
        -0.5453124642372131,
        -0.0
      ],
      "plane_d": -1505.697998046875,
      "bbox_min": [
        -405.737060546875,
        -2147.21240234375,
        645.0125122070312
      ],
      "bbox_max": [
        -350.3255920410156,
        -2102.82275390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3123541474342346,
        0.5410077571868896,
        -0.7808619737625122
      ],
      "plane_d": 1550.02734375,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        645.0125122070312
      ],
      "bbox_max": [
        -350.3255920410156,
        -2102.82275390625,
        664.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2414112240076065,
        0.9704229831695557,
        0.0
      ],
      "plane_d": 1967.349365234375,
      "bbox_min": [
        -352.776123046875,
        -2115.07080078125,
        663.1448974609375
      ],
      "bbox_max": [
        -350.3255920410156,
        -2114.461181640625,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.793363094329834,
        -0.6087487936019897,
        0.0
      ],
      "plane_d": -975.7291259765625,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        645.0125122070312
      ],
      "bbox_max": [
        -353.63916015625,
        -2102.82275390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914476871490479,
        0.1305050551891327,
        0.0
      ],
      "plane_d": 679.3714599609375,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        646.9889526367188
      ],
      "bbox_max": [
        -353.63916015625,
        -2102.82275390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087487936019897,
        0.793363094329834,
        0.0
      ],
      "plane_d": 1940.9437255859375,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        647.6098022460938
      ],
      "bbox_max": [
        -353.63916015625,
        -2102.82275390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6193733811378479,
        0.08152861893177032,
        -0.7808519601821899
      ],
      "plane_d": 939.776611328125,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        647.6098022460938
      ],
      "bbox_max": [
        -353.63916015625,
        -2102.82275390625,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38029617071151733,
        0.4956279993057251,
        -0.7808505296707153
      ],
      "plane_d": 1727.9033203125,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        647.6098022460938
      ],
      "bbox_max": [
        -353.63916015625,
        -2102.82275390625,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4956279993057251,
        -0.38029617071151733,
        -0.7808505296707153
      ],
      "plane_d": -94.1939697265625,
      "bbox_min": [
        -404.803955078125,
        -2140.209716796875,
        647.6098022460938
      ],
      "bbox_max": [
        -353.63916015625,
        -2102.82275390625,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6087978482246399,
        0.7933255434036255,
        0.0
      ],
      "plane_d": 1887.29736328125,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        647.6098022460938
      ],
      "bbox_max": [
        -353.63916015625,
        -2102.82275390625,
        664.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.1305050551891327,
        -0.9914476871490479,
        0.0
      ],
      "plane_d": -2039.72509765625,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        647.6098022460938
      ],
      "bbox_max": [
        -353.63916015625,
        -2102.82275390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 657.1998291015625,
      "bbox_min": [
        -360.365234375,
        -2104.755126953125,
        649.5999145507812
      ],
      "bbox_max": [
        -357.77392578125,
        -2102.82275390625,
        657.1998901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -649.599853515625,
      "bbox_min": [
        -360.0830078125,
        -2103.701904296875,
        649.5999145507812
      ],
      "bbox_max": [
        -359.34417724609375,
        -2102.82275390625,
        649.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08151417970657349,
        -0.6193829774856567,
        -0.7808458805084229
      ],
      "plane_d": -758.91650390625,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -353.63916015625,
        -2104.4140625,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3803032636642456,
        -0.4956372380256653,
        -0.7808413505554199
      ],
      "plane_d": -664.8878784179688,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -353.63916015625,
        -2104.4140625,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.08152861893177032,
        0.6193733811378479,
        -0.7808519601821899
      ],
      "plane_d": 1808.4093017578125,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -353.63916015625,
        -2104.4140625,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.1998901367188,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -353.63916015625,
        -2104.4140625,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6087487936019897,
        -0.793363094329834,
        -0.0
      ],
      "plane_d": -1889.20703125,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        657.1998901367188
      ],
      "bbox_max": [
        -354.94622802734375,
        -2104.755126953125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1305050551891327,
        0.9914476871490479,
        0.0
      ],
      "plane_d": 2069.815185546875,
      "bbox_min": [
        -399.147216796875,
        -2140.209716796875,
        658.305908203125
      ],
      "bbox_max": [
        -354.94622802734375,
        -2108.482421875,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4956435561180115,
        0.3802884817123413,
        -0.7808444499969482
      ],
      "plane_d": 1143.6883544921875,
      "bbox_min": [
        -361.797119140625,
        -2117.882568359375,
        659.9998168945312
      ],
      "bbox_max": [
        -354.94622802734375,
        -2108.482421875,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6193848252296448,
        -0.0815301239490509,
        -0.780842661857605
      ],
      "plane_d": 123.25521850585938,
      "bbox_min": [
        -360.194580078125,
        -2114.268798828125,
        659.9998168945312
      ],
      "bbox_max": [
        -354.94622802734375,
        -2108.482421875,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2102.82275390625,
        641.0853271484375
      ],
      "bbox_max": [
        -346.551025390625,
        -2086.585205078125,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6863763332366943,
        -0.7272465229034424,
        -0.0
      ],
      "plane_d": -1759.2607421875,
      "bbox_min": [
        -360.30859375,
        -2102.82275390625,
        641.0853271484375
      ],
      "bbox_max": [
        -346.551025390625,
        -2086.585205078125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -360.30859375,
        -2102.82275390625,
        641.0853271484375
      ],
      "bbox_max": [
        -346.551025390625,
        -2086.585205078125,
        664.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -646.9998779296875,
      "bbox_min": [
        -358.2016906738281,
        -2099.328369140625,
        646.523681640625
      ],
      "bbox_max": [
        -357.4365234375,
        -2098.495361328125,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6542752981185913,
        0.7562564611434937,
        0.0
      ],
      "plane_d": 1821.1064453125,
      "bbox_min": [
        -357.809326171875,
        -2098.81787109375,
        646.523681640625
      ],
      "bbox_max": [
        -357.43658447265625,
        -2098.495361328125,
        646.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0028568680863827467,
        -0.9999959468841553,
        0.0
      ],
      "plane_d": -2086.423583984375,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        650.9999389648438
      ],
      "bbox_max": [
        -351.3818359375,
        -2086.585205078125,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": -1352.66748046875,
      "bbox_min": [
        -357.70416259765625,
        -2087.4541015625,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2086.585205078125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 659.9999389648438,
      "bbox_min": [
        -357.70416259765625,
        -2087.4541015625,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2086.585205078125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 659.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        650.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        663.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.97299724817276,
        0.23081716895103455,
        -0.0
      ],
      "plane_d": 832.5162353515625,
      "bbox_min": [
        -359.342529296875,
        -2098.495361328125,
        659.9999389648438
      ],
      "bbox_max": [
        -357.809326171875,
        -2092.0322265625,
        663.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -654.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        650.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        659.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.97299724817276,
        0.23081716895103455,
        -0.0
      ],
      "plane_d": 832.5162353515625,
      "bbox_min": [
        -359.342529296875,
        -2098.495361328125,
        650.9999389648438
      ],
      "bbox_max": [
        -357.809326171875,
        -2092.0322265625,
        654.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.97299724817276,
        -0.23081716895103455,
        0.0
      ],
      "plane_d": -832.5162353515625,
      "bbox_min": [
        -359.342529296875,
        -2098.995361328125,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        659.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8645933270454407,
        0.5024722814559937,
        0.0
      ],
      "plane_d": 740.5030517578125,
      "bbox_min": [
        -359.342529296875,
        -2092.0322265625,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2087.451171875,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49991971254348755,
        0.866071879863739,
        0.0
      ],
      "plane_d": 1638.5718994140625,
      "bbox_min": [
        -358.675537109375,
        -2098.995361328125,
        654.9999389648438
      ],
      "bbox_max": [
        -357.809326171875,
        -2098.495361328125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        646.45849609375
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2121.331787109375,
        667.9999389648438
      ],
      "bbox_max": [
        -195.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -360.30859375,
        -2121.331787109375,
        667.9999389648438
      ],
      "bbox_max": [
        -330.4360656738281,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -360.30859375,
        -2110.78369140625,
        667.9999389648438
      ],
      "bbox_max": [
        -330.4360656738281,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        -0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        667.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        667.9999389648438
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2091.77294921875,
        667.9999389648438
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -357.18017578125,
        -2086.585205078125,
        667.9999389648438
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -286.0,
        -2014.0,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.41665470600128174,
        -0.9090648293495178
      ],
      "plane_d": -143.7080078125,
      "bbox_min": [
        -286.0,
        -2014.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -2014.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -285.0616455078125,
        -1990.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1987.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -198.0,
        -2014.0,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.41665470600128174,
        -0.9090648293495178
      ],
      "plane_d": -143.7080078125,
      "bbox_min": [
        -198.0,
        -2014.0,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1990.0,
        754.0
      ],
      "bbox_max": [
        -195.0,
        -1987.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879413485527039,
        0.423933207988739,
        0.6889162063598633
      ],
      "plane_d": 185.86029052734375,
      "bbox_min": [
        -691.2036743164062,
        -2399.99365234375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -563.0726928710938,
        -2243.481689453125,
        630.2252807617188
      ],
      "bbox_max": [
        -478.577392578125,
        -2180.527099609375,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -563.0726928710938,
        -2243.481689453125,
        630.2252807617188
      ],
      "bbox_max": [
        -560.1396484375,
        -2241.306640625,
        631.3899536132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -527.610107421875,
        -2209.01611328125,
        639.28125
      ],
      "bbox_max": [
        -507.0682067871094,
        -2180.527099609375,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -691.2036743164062,
        -2320.374755859375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4577594995498657,
        -0.8173955082893372,
        0.3497438430786133
      ],
      "plane_d": -1698.0321044921875,
      "bbox_min": [
        -601.920166015625,
        -2032.99267578125,
        716.4224243164062
      ],
      "bbox_max": [
        -299.8731384277344,
        -1894.5,
        970.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.476491779088974,
        -0.7905871868133545,
        0.3846135139465332
      ],
      "plane_d": -1664.8924560546875,
      "bbox_min": [
        -601.920166015625,
        -2000.3544921875,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        970.00341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5031259059906006,
        -0.8475584983825684,
        0.16884596645832062
      ],
      "plane_d": -2108.238037109375,
      "bbox_min": [
        -601.920166015625,
        -2000.3544921875,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        964.237060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -442.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        904.8359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1967.46337890625,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        871.3511352539062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -360.0,
        -1939.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        859.1947021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -360.0,
        -1939.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        796.7986450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1967.46337890625,
        766.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        862.8703002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -417.9999694824219,
        -1967.46337890625,
        766.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        837.8662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        800.2040405273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1967.46337890625,
        778.7999267578125
      ],
      "bbox_max": [
        -369.9740295410156,
        -1950.0,
        833.3432006835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1967.46337890625,
        778.7999267578125
      ],
      "bbox_max": [
        -369.9740295410156,
        -1950.0,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -398.9490661621094,
        -1950.0,
        842.9548950195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -406.8780822753906,
        -1972.0,
        788.1215209960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5634797811508179,
        -0.8261274099349976,
        -0.002011953853070736
      ],
      "plane_d": -1353.20361328125,
      "bbox_min": [
        -528.131103515625,
        -2000.3544921875,
        811.4334106445312
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        912.686767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -442.0,
        -1938.574951171875,
        880.78662109375
      ],
      "bbox_max": [
        -433.4656677246094,
        -1928.0,
        912.686767578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -442.0,
        -1928.3680419921875,
        912.0
      ],
      "bbox_max": [
        -441.5421447753906,
        -1928.0,
        912.686767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5680782794952393,
        -0.8229745030403137,
        0.0
      ],
      "plane_d": -1346.862060546875,
      "bbox_min": [
        -437.50244140625,
        -1938.574951171875,
        880.78662109375
      ],
      "bbox_max": [
        -435.84088134765625,
        -1937.4423828125,
        886.2202758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        880.78662109375
      ],
      "bbox_max": [
        -435.84088134765625,
        -1937.4423828125,
        886.2202758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -435.970703125,
        -1950.0,
        811.4334106445312
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        886.5997924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703570008277893,
        -0.7688688039779663,
        0.433133989572525
      ],
      "plane_d": -1666.133544921875,
      "bbox_min": [
        -435.970703125,
        -1950.0,
        833.343017578125
      ],
      "bbox_max": [
        -379.3593444824219,
        -1911.1502685546875,
        886.5997924804688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -435.970703125,
        -1950.0,
        833.343017578125
      ],
      "bbox_max": [
        -414.0,
        -1935.8154296875,
        881.0967407226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.4741516113281,
        -1939.0,
        871.3511352539062
      ],
      "bbox_max": [
        -430.0,
        -1935.8154296875,
        881.0967407226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1945.1715087890625,
        851.6968383789062
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        863.5264282226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1950.0,
        833.343017578125
      ],
      "bbox_max": [
        -414.0,
        -1942.0523681640625,
        858.1080932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -435.970703125,
        -1949.5477294921875,
        839.7249145507812
      ],
      "bbox_max": [
        -379.3593444824219,
        -1911.1502685546875,
        886.5997924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -435.970703125,
        -1949.5477294921875,
        844.8030395507812
      ],
      "bbox_max": [
        -422.5,
        -1935.8155517578125,
        886.5997924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1939.0,
        863.5264282226562
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        875.776123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        880.6350708007812
      ],
      "bbox_max": [
        -433.3038330078125,
        -1935.9715576171875,
        886.214111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5634797811508179,
        -0.8261274099349976,
        -0.002011953853070736
      ],
      "plane_d": -1353.20361328125,
      "bbox_min": [
        -550.4645385742188,
        -2000.3544921875,
        777.59326171875
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        970.00341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5031259059906006,
        -0.8475584983825684,
        0.16884596645832062
      ],
      "plane_d": -2108.238037109375,
      "bbox_min": [
        -550.4645385742188,
        -2000.3544921875,
        871.233154296875
      ],
      "bbox_max": [
        -433.4481201171875,
        -1928.0,
        970.00341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -441.5985107421875,
        -1940.653564453125,
        885.9445190429688
      ],
      "bbox_max": [
        -433.4481201171875,
        -1928.0,
        920.3319702148438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -441.5985107421875,
        -1932.1441650390625,
        912.0
      ],
      "bbox_max": [
        -436.4453125,
        -1928.0,
        920.3319702148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5680782794952393,
        -0.8229745030403137,
        0.0
      ],
      "plane_d": -1346.862060546875,
      "bbox_min": [
        -440.5136413574219,
        -1940.653564453125,
        885.9445190429688
      ],
      "bbox_max": [
        -435.5732116699219,
        -1937.287109375,
        897.4857177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        886.214111328125
      ],
      "bbox_max": [
        -435.5732116699219,
        -1937.287109375,
        897.4857177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -435.84088134765625,
        -1972.0,
        777.59326171875
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        898.0882568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -435.84088134765625,
        -1972.0,
        777.59326171875
      ],
      "bbox_max": [
        -348.0,
        -1907.9791259765625,
        898.0882568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -370.33819580078125,
        -1950.219482421875,
        777.59326171875
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        804.571044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -370.33819580078125,
        -1950.219482421875,
        778.7999267578125
      ],
      "bbox_max": [
        -369.37664794921875,
        -1950.0,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -435.84088134765625,
        -1972.0,
        778.6002197265625
      ],
      "bbox_max": [
        -366.1397705078125,
        -1926.0172119140625,
        898.0882568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -414.0011291503906,
        -1968.8211669921875,
        778.6002197265625
      ],
      "bbox_max": [
        -366.1397705078125,
        -1926.0172119140625,
        843.802490234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0011291503906,
        -1968.8211669921875,
        778.6002197265625
      ],
      "bbox_max": [
        -366.6462707519531,
        -1939.0,
        843.802490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -414.0011291503906,
        -1950.787353515625,
        778.7999267578125
      ],
      "bbox_max": [
        -366.6462707519531,
        -1939.0,
        843.802490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.787353515625,
        778.7999267578125
      ],
      "bbox_max": [
        -366.6462707519531,
        -1939.0,
        805.42919921875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.873046875
      ],
      "bbox_max": [
        -366.6462707519531,
        -1939.0,
        805.42919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        778.6002197265625
      ],
      "bbox_max": [
        -369.0,
        -1949.9139404296875,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1940.6357421875,
        802.5252685546875
      ],
      "bbox_max": [
        -366.1397705078125,
        -1939.0,
        806.3482666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1940.6357421875,
        802.5252685546875
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        806.3482666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -435.84088134765625,
        -1950.0,
        833.343017578125
      ],
      "bbox_max": [
        -414.0,
        -1935.8231201171875,
        898.0882568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        833.343017578125
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        850.6632080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -435.84088134765625,
        -1939.0,
        866.4844360351562
      ],
      "bbox_max": [
        -422.5,
        -1935.8231201171875,
        898.0882568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -435.84088134765625,
        -1939.0,
        875.776123046875
      ],
      "bbox_max": [
        -430.0,
        -1935.8231201171875,
        898.0882568359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.84088134765625,
        -1937.4423828125,
        886.0941162109375
      ],
      "bbox_max": [
        -433.3038330078125,
        -1935.9715576171875,
        897.5902099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5634797811508179,
        -0.8261274099349976,
        -0.002011953853070736
      ],
      "plane_d": -1353.20361328125,
      "bbox_min": [
        -547.708251953125,
        -2032.99267578125,
        716.4224243164062
      ],
      "bbox_max": [
        -299.8731384277344,
        -1894.5,
        970.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5031259059906006,
        -0.8475584983825684,
        0.16884596645832062
      ],
      "plane_d": -2108.238037109375,
      "bbox_min": [
        -547.708251953125,
        -2000.3544921875,
        871.233154296875
      ],
      "bbox_max": [
        -433.4440612792969,
        -1928.0,
        970.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -441.18359375,
        -1941.115966796875,
        896.0842895507812
      ],
      "bbox_max": [
        -433.4440612792969,
        -1928.0,
        921.8460083007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -437.4790954589844,
        -1932.863037109375,
        912.0
      ],
      "bbox_max": [
        -435.43597412109375,
        -1928.0,
        921.8460083007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5680782794952393,
        -0.8229745030403137,
        0.0
      ],
      "plane_d": -1346.862060546875,
      "bbox_min": [
        -441.18359375,
        -1941.115966796875,
        896.0842895507812
      ],
      "bbox_max": [
        -435.51080322265625,
        -1937.2509765625,
        900.1087646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        897.4674072265625
      ],
      "bbox_max": [
        -435.51080322265625,
        -1937.2509765625,
        900.1087646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -468.130615234375,
        -2032.99267578125,
        716.4224243164062
      ],
      "bbox_max": [
        -299.8731384277344,
        -1894.5,
        900.7529907226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -348.0,
        -1917.5384521484375,
        852.142822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -366.1394958496094,
        -1939.0,
        794.5689697265625
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        808.5042724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -366.1394958496094,
        -1939.0,
        794.5689697265625
      ],
      "bbox_max": [
        -360.0,
        -1939.0,
        802.6044311523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -361.63775634765625,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -361.63775634765625,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1940.63623046875,
        804.3279418945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -405.1983337402344,
        -1972.0,
        788.1215209960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -369.0,
        -1946.408447265625,
        789.0957641601562
      ],
      "bbox_max": [
        -361.63775634765625,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        800.2202758789062
      ],
      "bbox_max": [
        -361.63775634765625,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1920.0697021484375,
        765.0
      ],
      "bbox_max": [
        -299.8731384277344,
        -1920.0,
        765.1644287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -300.0,
        -1920.0697021484375,
        765.0
      ],
      "bbox_max": [
        -299.8731384277344,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -435.5732116699219,
        -1972.0,
        781.3281860351562
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        900.7529907226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        781.3281860351562
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        887.5716552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -414.0,
        -1972.0,
        781.3281860351562
      ],
      "bbox_max": [
        -359.96099853515625,
        -1907.083251953125,
        874.2081909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        781.3281860351562
      ],
      "bbox_max": [
        -407.1487121582031,
        -1972.0,
        790.2094116210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -435.5732116699219,
        -1950.0,
        839.5380249023438
      ],
      "bbox_max": [
        -414.0,
        -1935.8392333984375,
        900.7529907226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        839.5380249023438
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        853.15283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -435.5732116699219,
        -1939.0,
        876.3712768554688
      ],
      "bbox_max": [
        -422.5,
        -1935.8392333984375,
        900.7529907226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -435.5732116699219,
        -1939.0,
        886.1876220703125
      ],
      "bbox_max": [
        -430.0,
        -1935.8392333984375,
        900.7529907226562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.5732116699219,
        -1937.287109375,
        897.4857177734375
      ],
      "bbox_max": [
        -433.3038330078125,
        -1935.9715576171875,
        900.267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1926385760307312,
        -0.9812697768211365,
        0.0
      ],
      "plane_d": -1914.5927734375,
      "bbox_min": [
        -691.2036743164062,
        -2320.374755859375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -691.2036743164062,
        -2320.374755859375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -511.7373046875,
        -2133.08251953125,
        639.28125
      ],
      "bbox_max": [
        -404.1032409667969,
        -2032.99267578125,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -511.7373046875,
        -2133.08251953125,
        639.28125
      ],
      "bbox_max": [
        -404.1032409667969,
        -2032.99267578125,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -511.7373046875,
        -2133.08251953125,
        639.28125
      ],
      "bbox_max": [
        -460.3519287109375,
        -2096.0830078125,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5634797811508179,
        -0.8261274099349976,
        -0.002011953853070736
      ],
      "plane_d": -1353.20361328125,
      "bbox_min": [
        -691.2036743164062,
        -2320.374755859375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5031259059906006,
        -0.8475584983825684,
        0.16884596645832062
      ],
      "plane_d": -2108.238037109375,
      "bbox_min": [
        -547.5830078125,
        -2000.3544921875,
        871.233154296875
      ],
      "bbox_max": [
        -422.1824951171875,
        -1928.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -436.69482421875,
        -1935.8033447265625,
        900.9024658203125
      ],
      "bbox_max": [
        -422.1824951171875,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -436.69482421875,
        -1935.8033447265625,
        900.9024658203125
      ],
      "bbox_max": [
        -433.4872741699219,
        -1932.863037109375,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        900.07568359375
      ],
      "bbox_max": [
        -421.84124755859375,
        -1928.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -433.4873046875,
        -1935.858642578125,
        900.7529907226562
      ],
      "bbox_max": [
        -430.0,
        -1933.3961181640625,
        921.1699829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.4873046875,
        -1935.858642578125,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1933.3961181640625,
        921.1699829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.160947784781456,
        -0.9869629144668579,
        0.0
      ],
      "plane_d": -1824.285400390625,
      "bbox_min": [
        -691.2036743164062,
        -2320.374755859375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1894.5,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -360.0,
        -1907.0894775390625,
        862.4762573242188
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -360.0,
        -1907.0894775390625,
        912.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -691.2036743164062,
        -2320.374755859375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -691.2036743164062,
        -2260.86181640625,
        639.28125
      ],
      "bbox_max": [
        -598.208740234375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -689.3846435546875,
        -2260.86181640625,
        639.28125
      ],
      "bbox_max": [
        -598.208740234375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -689.3846435546875,
        -2260.676025390625,
        639.28125
      ],
      "bbox_max": [
        -598.208740234375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -600.715087890625,
        -2195.306396484375,
        639.2813110351562
      ],
      "bbox_max": [
        -598.208740234375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -690.06005859375,
        -2320.374755859375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02143726870417595,
        -0.8702447414398193,
        0.49215301871299744
      ],
      "plane_d": -2067.314453125,
      "bbox_min": [
        -300.0,
        -1952.92919921875,
        754.0
      ],
      "bbox_max": [
        -184.5933074951172,
        -1895.00830078125,
        862.176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -300.0,
        -1952.92919921875,
        754.0
      ],
      "bbox_max": [
        -193.1866455078125,
        -1905.971923828125,
        840.3576049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -300.0,
        -1952.92919921875,
        754.0
      ],
      "bbox_max": [
        -235.15554809570312,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1945.20947265625,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1952.92919921875,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -286.0,
        -1952.92919921875,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      "bbox_max": [
        -286.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -230.068359375,
        -1923.3104248046875,
        805.9156494140625
      ],
      "bbox_max": [
        -193.1866455078125,
        -1905.971923828125,
        840.3576049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -230.068359375,
        -1925.4093017578125,
        808.0923461914062
      ],
      "bbox_max": [
        -184.5933074951172,
        -1905.971923828125,
        840.3576049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -690.06005859375,
        -2320.374755859375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -361.63775634765625,
        -1939.0,
        798.0972900390625
      ],
      "bbox_max": [
        -348.0,
        -1905.1326904296875,
        871.5677490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -361.63775634765625,
        -1939.0,
        798.0972900390625
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        818.51708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -361.63775634765625,
        -1939.0,
        798.0972900390625
      ],
      "bbox_max": [
        -360.0,
        -1939.0,
        800.2202758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015454292297363,
        -0.8651313185691833,
        0.0
      ],
      "plane_d": -1457.548095703125,
      "bbox_min": [
        -690.06005859375,
        -2320.374755859375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1905.1326904296875,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -433.4440612792969,
        -1935.9715576171875,
        900.267578125
      ],
      "bbox_max": [
        -430.0,
        -1933.5428466796875,
        920.929931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.42694091796875,
        -1935.9715576171875,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1933.5428466796875,
        920.929931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794841408729553,
        -0.8249640464782715,
        0.4013371765613556
      ],
      "plane_d": -1778.3809814453125,
      "bbox_min": [
        -690.06005859375,
        -2320.374755859375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -407.1487121582031,
        -1972.0,
        710.3526000976562
      ],
      "bbox_max": [
        -334.72802734375,
        -1935.020751953125,
        811.334228515625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -407.1487121582031,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1946.408935546875,
        792.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -407.1487121582031,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1946.408935546875,
        792.2772827148438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -375.3886413574219,
        -1957.9095458984375,
        778.7999267578125
      ],
      "bbox_max": [
        -355.6589660644531,
        -1935.020751953125,
        811.334228515625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -360.0,
        -1939.0,
        799.3529052734375
      ],
      "bbox_max": [
        -355.6589660644531,
        -1935.020751953125,
        806.2855834960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -690.06005859375,
        -2320.374755859375,
        630.2252807617188
      ],
      "bbox_max": [
        -176.00677490234375,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5919927358627319,
        0.8059433102607727,
        0.0
      ],
      "plane_d": 1469.767333984375,
      "bbox_min": [
        -689.41552734375,
        -2314.935791015625,
        639.28125
      ],
      "bbox_max": [
        -463.44085693359375,
        -2101.66650390625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -525.5756225585938,
        -2209.88818359375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8059484362602234,
        0.5919858813285828,
        -0.0
      ],
      "plane_d": 1778.2655029296875,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -563.099609375,
        -2240.273681640625,
        639.28125
      ],
      "bbox_max": [
        -561.334716796875,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -563.099609375,
        -2239.679443359375,
        639.28125
      ],
      "bbox_max": [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8059484362602234,
        0.5919858813285828,
        -0.0
      ],
      "plane_d": 1778.2655029296875,
      "bbox_min": [
        -563.099609375,
        -2238.921875,
        639.28125
      ],
      "bbox_max": [
        -561.891357421875,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -689.41552734375,
        -2314.91064453125,
        639.28125
      ],
      "bbox_max": [
        -463.44085693359375,
        -2101.66650390625,
        641.6248779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -689.41552734375,
        -2260.6982421875,
        639.28125
      ],
      "bbox_max": [
        -525.8126831054688,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -599.257568359375,
        -2195.333251953125,
        639.2813110351562
      ],
      "bbox_max": [
        -598.18994140625,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -563.099609375,
        -2237.27685546875,
        639.28125
      ],
      "bbox_max": [
        -525.8126831054688,
        -2209.016357421875,
        641.351806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -561.7347412109375,
        -2295.365234375,
        641.6248779296875
      ],
      "bbox_max": [
        -176.00677490234375,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -561.7347412109375,
        -2295.365234375,
        641.6248779296875
      ],
      "bbox_max": [
        -176.00677490234375,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -433.3038024902344,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -176.00677490234375,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -433.3038024902344,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1928.0,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1938.9998779296875,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        912.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -404.59893798828125,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1954.8277587890625,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -433.3038024902344,
        -1950.0,
        842.1344604492188
      ],
      "bbox_max": [
        -414.0,
        -1928.0,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -433.3038024902344,
        -1950.0,
        853.15283203125
      ],
      "bbox_max": [
        -414.0,
        -1928.0,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -422.5,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -414.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -422.5,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -414.0,
        -1939.0,
        912.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -433.3038024902344,
        -1939.0,
        879.114990234375
      ],
      "bbox_max": [
        -422.5,
        -1929.708251953125,
        927.2046508789062
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -433.3038024902344,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -422.5,
        -1929.708251953125,
        927.2046508789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.3038024902344,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1934.0562744140625,
        920.0897216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -176.00677490234375,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.4103393554688
      ],
      "bbox_max": [
        -176.00677490234375,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        818.51708984375
      ],
      "bbox_max": [
        -348.0,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6160963773727417,
        -0.6721051335334778,
        0.41073092818260193
      ],
      "plane_d": -1456.00390625,
      "bbox_min": [
        -369.0,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -369.0,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -360.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -208.4437255859375,
        -1927.5064697265625,
        817.689208984375
      ],
      "bbox_max": [
        -176.00677490234375,
        -1914.585693359375,
        835.1259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -250.96913146972656,
        -1942.576416015625,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1942.576416015625,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.685392236249754e-06,
        2.4760717565186496e-07,
        -1.0
      ],
      "plane_d": 778.798095703125,
      "bbox_min": [
        -369.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -349.0,
        -1960.0,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1969.5,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 367.5,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.800000011920929,
        -0.0,
        0.6000000238418579
      ],
      "plane_d": -179.10000610351562,
      "bbox_min": [
        -369.0,
        -1962.0,
        788.5
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -335.0843811035156,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -272.0,
        -1946.173095703125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -286.0,
        -1972.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1947.136962890625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1972.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1951.9654541015625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -335.0843811035156,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -330.72119140625,
        -1971.594482421875,
        710.3526000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -335.0843811035156,
        -1972.0,
        709.7407836914062
      ],
      "bbox_max": [
        -334.4937744140625,
        -1971.594482421875,
        710.3526000976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -561.7347412109375,
        -2295.365234375,
        641.6248779296875
      ],
      "bbox_max": [
        -263.9230041503906,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      "bbox_max": [
        -478.577392578125,
        -2210.003173828125,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -366.0,
        -2030.6904296875,
        684.19091796875
      ],
      "bbox_max": [
        -263.9230041503906,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -300.0,
        -2030.6904296875,
        765.0
      ],
      "bbox_max": [
        -291.3095703125,
        -2022.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -366.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        2.303213477716781e-06,
        -8.291568519780412e-06,
        -1.0
      ],
      "plane_d": 778.7843627929688,
      "bbox_min": [
        -366.0,
        -1987.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.44721364974975586,
        0.0
      ],
      "plane_d": 1194.0604248046875,
      "bbox_min": [
        -349.0,
        -1977.0,
        778.7999267578125
      ],
      "bbox_max": [
        -346.5,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 768.4999389648438,
      "bbox_min": [
        -325.0,
        -1987.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -325.0,
      "bbox_min": [
        -325.0,
        -1987.0,
        768.5
      ],
      "bbox_max": [
        -323.0,
        -1977.0,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -324.0,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1977.400146484375,
        778.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1986.60009765625,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1978.400146484375,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1978.400146484375,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1978.400146484375,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 323.0,
      "bbox_min": [
        -323.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1985.60009765625,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 768.4999389648438,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1987.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1634.8309326171875,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1987.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -364.708251953125,
        -2011.9063720703125,
        684.19091796875
      ],
      "bbox_max": [
        -272.0,
        -1972.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -334.4937744140625,
        -2011.9063720703125,
        701.5845947265625
      ],
      "bbox_max": [
        -272.0,
        -1972.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -2000.741455078125,
        750.0411987304688
      ],
      "bbox_max": [
        -272.0,
        -1972.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -286.0,
        -2000.741455078125,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1972.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.41665470600128174,
        -0.9090648293495178
      ],
      "plane_d": -143.7080078125,
      "bbox_min": [
        -286.0,
        -2000.741455078125,
        754.0
      ],
      "bbox_max": [
        -285.0616455078125,
        -1990.0,
        758.9231567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1986.2734375,
        750.0411987304688
      ],
      "bbox_max": [
        -283.0,
        -1979.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -334.4937744140625,
        -1977.4061279296875,
        701.5845947265625
      ],
      "bbox_max": [
        -320.8838195800781,
        -1972.0,
        710.1063232421875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}